var Yu = Object.defineProperty, Zu = Object.defineProperties;
var Ku = Object.getOwnPropertyDescriptors;
var Fo = Object.getOwnPropertySymbols;
var zl = Object.prototype.hasOwnProperty, Ll = Object.prototype.propertyIsEnumerable;
var Rs = (t, e, i) => e in t ? Yu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i, Jt = (t, e) => {
  for (var i in e || (e = {}))
    zl.call(e, i) && Rs(t, i, e[i]);
  if (Fo)
    for (var i of Fo(e))
      Ll.call(e, i) && Rs(t, i, e[i]);
  return t;
}, en = (t, e) => Zu(t, Ku(e));
var Fs = (t, e) => {
  var i = {};
  for (var n in t)
    zl.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
  if (t != null && Fo)
    for (var n of Fo(t))
      e.indexOf(n) < 0 && Ll.call(t, n) && (i[n] = t[n]);
  return i;
};
var Us = (t, e, i) => (Rs(t, typeof e != "symbol" ? e + "" : e, i), i), Hs = (t, e, i) => {
  if (!e.has(t))
    throw TypeError("Cannot " + i);
};
var Di = (t, e, i) => (Hs(t, e, "read from private field"), i ? i.call(t) : e.get(t)), Be = (t, e, i) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, i);
}, jl = (t, e, i, n) => (Hs(t, e, "write to private field"), n ? n.call(t, i) : e.set(t, i), i);
var F = (t, e, i) => (Hs(t, e, "access private method"), i);
var Fi = (t, e, i) => new Promise((n, o) => {
  var s = (r) => {
    try {
      a(i.next(r));
    } catch (u) {
      o(u);
    }
  }, l = (r) => {
    try {
      a(i.throw(r));
    } catch (u) {
      o(u);
    }
  }, a = (r) => r.done ? n(r.value) : Promise.resolve(r.value).then(s, l);
  a((i = i.apply(t, e)).next());
});
/*! version:"0.2.15" */
function Q() {
}
const Gu = (t) => t;
function Ju(t, e) {
  for (const i in e)
    t[i] = e[i];
  return (
    /** @type {T & S} */
    t
  );
}
function fr(t) {
  return t();
}
function Dl() {
  return /* @__PURE__ */ Object.create(null);
}
function _t(t) {
  t.forEach(fr);
}
function Xn(t) {
  return typeof t == "function";
}
function pe(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
let Uo;
function Ni(t, e) {
  return t === e ? !0 : (Uo || (Uo = document.createElement("a")), Uo.href = e, t === Uo.href);
}
function Xu(t) {
  return Object.keys(t).length === 0;
}
function Qn(t, e, i, n) {
  if (t) {
    const o = mr(t, e, i, n);
    return t[0](o);
  }
}
function mr(t, e, i, n) {
  return t[1] && n ? Ju(i.ctx.slice(), t[1](n(e))) : i.ctx;
}
function $n(t, e, i, n) {
  if (t[2] && n) {
    const o = t[2](n(i));
    if (e.dirty === void 0)
      return o;
    if (typeof o == "object") {
      const s = [], l = Math.max(e.dirty.length, o.length);
      for (let a = 0; a < l; a += 1)
        s[a] = e.dirty[a] | o[a];
      return s;
    }
    return e.dirty | o;
  }
  return e.dirty;
}
function eo(t, e, i, n, o, s) {
  if (o) {
    const l = mr(e, i, n, s);
    t.p(l, o);
  }
}
function to(t) {
  if (t.ctx.length > 32) {
    const e = [], i = t.ctx.length / 32;
    for (let n = 0; n < i; n++)
      e[n] = -1;
    return e;
  }
  return -1;
}
function xl(t) {
  return t == null ? "" : t;
}
function Nl(t) {
  const e = typeof t == "string" && t.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return e ? [parseFloat(e[1]), e[2] || "px"] : [
    /** @type {number} */
    t,
    "px"
  ];
}
const hr = typeof window != "undefined";
let Qu = hr ? () => window.performance.now() : () => Date.now(), Ls = hr ? (t) => requestAnimationFrame(t) : Q;
const Zn = /* @__PURE__ */ new Set();
function _r(t) {
  Zn.forEach((e) => {
    e.c(t) || (Zn.delete(e), e.f());
  }), Zn.size !== 0 && Ls(_r);
}
function $u(t) {
  let e;
  return Zn.size === 0 && Ls(_r), {
    promise: new Promise((i) => {
      Zn.add(e = { c: t, f: i });
    }),
    abort() {
      Zn.delete(e);
    }
  };
}
const ec = typeof window != "undefined" ? window : typeof globalThis != "undefined" ? globalThis : (
  // @ts-ignore Node typings have this
  global
);
function h(t, e) {
  t.appendChild(e);
}
function Ar(t) {
  if (!t)
    return document;
  const e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && /** @type {ShadowRoot} */
  e.host ? (
    /** @type {ShadowRoot} */
    e
  ) : t.ownerDocument;
}
function tc(t) {
  const e = y("style");
  return e.textContent = "/* empty */", ic(Ar(t), e), e.sheet;
}
function ic(t, e) {
  return h(
    /** @type {Document} */
    t.head || t,
    e
  ), e.sheet;
}
function E(t, e, i) {
  t.insertBefore(e, i || null);
}
function M(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function Cn(t, e) {
  for (let i = 0; i < t.length; i += 1)
    t[i] && t[i].d(e);
}
function y(t) {
  return document.createElement(t);
}
function Se(t) {
  return document.createElementNS("http://www.w3.org/2000/svg", t);
}
function ie(t) {
  return document.createTextNode(t);
}
function J() {
  return ie(" ");
}
function Ei() {
  return ie("");
}
function Y(t, e, i, n) {
  return t.addEventListener(e, i, n), () => t.removeEventListener(e, i, n);
}
function Ie(t, e, i) {
  i == null ? t.removeAttribute(e) : t.getAttribute(e) !== i && t.setAttribute(e, i);
}
function nc(t) {
  return Array.from(t.childNodes);
}
function bi(t, e) {
  e = "" + e, t.data !== e && (t.data = /** @type {string} */
  e);
}
function H(t, e) {
  t.value = e == null ? "" : e;
}
function Zt(t, e, i, n) {
  i == null ? t.style.removeProperty(e) : t.style.setProperty(e, i, n ? "important" : "");
}
function We(t, e, i) {
  for (let n = 0; n < t.options.length; n += 1) {
    const o = t.options[n];
    if (o.__value === e) {
      o.selected = !0;
      return;
    }
  }
  (!i || e !== void 0) && (t.selectedIndex = -1);
}
function zt(t) {
  const e = t.querySelector(":checked");
  return e && e.__value;
}
function ne(t, e, i) {
  t.classList.toggle(e, !!i);
}
function oc(t, e, { bubbles: i = !1, cancelable: n = !1 } = {}) {
  return new CustomEvent(t, { detail: e, bubbles: i, cancelable: n });
}
const ls = /* @__PURE__ */ new Map();
let as = 0;
function sc(t) {
  let e = 5381, i = t.length;
  for (; i--; )
    e = (e << 5) - e ^ t.charCodeAt(i);
  return e >>> 0;
}
function lc(t, e) {
  const i = { stylesheet: tc(e), rules: {} };
  return ls.set(t, i), i;
}
function Rl(t, e, i, n, o, s, l, a = 0) {
  const r = 16.666 / n;
  let u = `{
`;
  for (let S = 0; S <= 1; S += r) {
    const T = e + (i - e) * s(S);
    u += S * 100 + `%{${l(T, 1 - T)}}
`;
  }
  const c = u + `100% {${l(i, 1 - i)}}
}`, g = `__svelte_${sc(c)}_${a}`, f = Ar(t), { stylesheet: A, rules: _ } = ls.get(f) || lc(f, t);
  _[g] || (_[g] = !0, A.insertRule(`@keyframes ${g} ${c}`, A.cssRules.length));
  const k = t.style.animation || "";
  return t.style.animation = `${k ? `${k}, ` : ""}${g} ${n}ms linear ${o}ms 1 both`, as += 1, g;
}
function ac(t, e) {
  const i = (t.style.animation || "").split(", "), n = i.filter(
    e ? (s) => s.indexOf(e) < 0 : (s) => s.indexOf("__svelte") === -1
    // remove all Svelte animations
  ), o = i.length - n.length;
  o && (t.style.animation = n.join(", "), as -= o, as || rc());
}
function rc() {
  Ls(() => {
    as || (ls.forEach((t) => {
      const { ownerNode: e } = t.stylesheet;
      e && M(e);
    }), ls.clear());
  });
}
let Ao;
function fo(t) {
  Ao = t;
}
function yr() {
  if (!Ao)
    throw new Error("Function called outside component initialization");
  return Ao;
}
function Vo(t) {
  yr().$$.on_mount.push(t);
}
function uc(t) {
  yr().$$.on_destroy.push(t);
}
const Fn = [], se = [];
let Kn = [];
const nl = [], vr = /* @__PURE__ */ Promise.resolve();
let ol = !1;
function br() {
  ol || (ol = !0, vr.then(d));
}
function kr() {
  return br(), vr;
}
function dt(t) {
  Kn.push(t);
}
function ve(t) {
  nl.push(t);
}
const qs = /* @__PURE__ */ new Set();
let Dn = 0;
function d() {
  if (Dn !== 0)
    return;
  const t = Ao;
  do {
    try {
      for (; Dn < Fn.length; ) {
        const e = Fn[Dn];
        Dn++, fo(e), cc(e.$$);
      }
    } catch (e) {
      throw Fn.length = 0, Dn = 0, e;
    }
    for (fo(null), Fn.length = 0, Dn = 0; se.length; )
      se.pop()();
    for (let e = 0; e < Kn.length; e += 1) {
      const i = Kn[e];
      qs.has(i) || (qs.add(i), i());
    }
    Kn.length = 0;
  } while (Fn.length);
  for (; nl.length; )
    nl.pop()();
  ol = !1, qs.clear(), fo(t);
}
function cc(t) {
  if (t.fragment !== null) {
    t.update(), _t(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(dt);
  }
}
function dc(t) {
  const e = [], i = [];
  Kn.forEach((n) => t.indexOf(n) === -1 ? e.push(n) : i.push(n)), i.forEach((n) => n()), Kn = e;
}
let so;
function gc() {
  return so || (so = Promise.resolve(), so.then(() => {
    so = null;
  })), so;
}
function Ys(t, e, i) {
  t.dispatchEvent(oc(`${e ? "intro" : "outro"}${i}`));
}
const ss = /* @__PURE__ */ new Set();
let cn;
function Fe() {
  cn = {
    r: 0,
    c: [],
    p: cn
    // parent group
  };
}
function Ue() {
  cn.r || _t(cn.c), cn = cn.p;
}
function V(t, e) {
  t && t.i && (ss.delete(t), t.i(e));
}
function z(t, e, i, n) {
  if (t && t.o) {
    if (ss.has(t))
      return;
    ss.add(t), cn.c.push(() => {
      ss.delete(t), n && (i && t.d(1), n());
    }), t.o(e);
  } else
    n && n();
}
const fc = { duration: 0 };
function Fl(t, e, i, n) {
  let s = e(t, i, { direction: "both" }), l = n ? 0 : 1, a = null, r = null, u = null, c;
  function g() {
    u && ac(t, u);
  }
  function f(_, k) {
    const S = (
      /** @type {Program['d']} */
      _.b - l
    );
    return k *= Math.abs(S), {
      a: l,
      b: _.b,
      d: S,
      duration: k,
      start: _.start,
      end: _.start + k,
      group: _.group
    };
  }
  function A(_) {
    const {
      delay: k = 0,
      duration: S = 300,
      easing: T = Gu,
      tick: v = Q,
      css: P
    } = s || fc, O = {
      start: Qu() + k,
      b: _
    };
    _ || (O.group = cn, cn.r += 1), "inert" in t && (_ ? c !== void 0 && (t.inert = c) : (c = /** @type {HTMLElement} */
    t.inert, t.inert = !0)), a || r ? r = O : (P && (g(), u = Rl(t, l, _, S, k, T, P)), _ && v(0, 1), a = f(O, S), dt(() => Ys(t, _, "start")), $u((D) => {
      if (r && D > r.start && (a = f(r, S), r = null, Ys(t, a.b, "start"), P && (g(), u = Rl(
        t,
        l,
        a.b,
        a.duration,
        0,
        T,
        s.css
      ))), a) {
        if (D >= a.end)
          v(l = a.b, 1 - l), Ys(t, a.b, "end"), r || (a.b ? g() : --a.group.r || _t(a.group.c)), a = null;
        else if (D >= a.start) {
          const p = D - a.start;
          l = a.a + a.d * T(p / a.duration), v(l, 1 - l);
        }
      }
      return !!(a || r);
    }));
  }
  return {
    run(_) {
      Xn(s) ? gc().then(() => {
        s = s({ direction: _ ? "in" : "out" }), A(_);
      }) : A(_);
    },
    end() {
      g(), a = r = null;
    }
  };
}
function ti(t) {
  return (t == null ? void 0 : t.length) !== void 0 ? t : Array.from(t);
}
function mc(t, e) {
  z(t, 1, 1, () => {
    e.delete(t.key);
  });
}
function hc(t, e, i, n, o, s, l, a, r, u, c, g) {
  let f = t.length, A = s.length, _ = f;
  const k = {};
  for (; _--; )
    k[t[_].key] = _;
  const S = [], T = /* @__PURE__ */ new Map(), v = /* @__PURE__ */ new Map(), P = [];
  for (_ = A; _--; ) {
    const C = g(o, s, _), Z = i(C);
    let q = l.get(Z);
    q ? n && P.push(() => q.p(C, e)) : (q = u(Z, C), q.c()), T.set(Z, S[_] = q), Z in k && v.set(Z, Math.abs(_ - k[Z]));
  }
  const O = /* @__PURE__ */ new Set(), D = /* @__PURE__ */ new Set();
  function p(C) {
    V(C, 1), C.m(a, c), l.set(C.key, C), c = C.first, A--;
  }
  for (; f && A; ) {
    const C = S[A - 1], Z = t[f - 1], q = C.key, x = Z.key;
    C === Z ? (c = C.first, f--, A--) : T.has(x) ? !l.has(q) || O.has(q) ? p(C) : D.has(x) ? f-- : v.get(q) > v.get(x) ? (D.add(q), p(C)) : (O.add(x), f--) : (r(Z, l), f--);
  }
  for (; f--; ) {
    const C = t[f];
    T.has(C.key) || r(C, l);
  }
  for (; A; )
    p(S[A - 1]);
  return _t(P), S;
}
function be(t, e, i) {
  const n = t.$$.props[e];
  n !== void 0 && (t.$$.bound[n] = i, i(t.$$.ctx[n]));
}
function me(t) {
  t && t.c();
}
function de(t, e, i) {
  const { fragment: n, after_update: o } = t.$$;
  n && n.m(e, i), dt(() => {
    const s = t.$$.on_mount.map(fr).filter(Xn);
    t.$$.on_destroy ? t.$$.on_destroy.push(...s) : _t(s), t.$$.on_mount = [];
  }), o.forEach(dt);
}
function ge(t, e) {
  const i = t.$$;
  i.fragment !== null && (dc(i.after_update), _t(i.on_destroy), i.fragment && i.fragment.d(e), i.on_destroy = i.fragment = null, i.ctx = []);
}
function _c(t, e) {
  t.$$.dirty[0] === -1 && (Fn.push(t), br(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function Pe(t, e, i, n, o, s, l = null, a = [-1]) {
  const r = Ao;
  fo(t);
  const u = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: s,
    update: Q,
    not_equal: o,
    bound: Dl(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (r ? r.$$.context : [])),
    // everything else
    callbacks: Dl(),
    dirty: a,
    skip_bound: !1,
    root: e.target || r.$$.root
  };
  l && l(u.root);
  let c = !1;
  if (u.ctx = i ? i(t, e.props || {}, (g, f, ...A) => {
    const _ = A.length ? A[0] : f;
    return u.ctx && o(u.ctx[g], u.ctx[g] = _) && (!u.skip_bound && u.bound[g] && u.bound[g](_), c && _c(t, g)), f;
  }) : [], u.update(), c = !0, _t(u.before_update), u.fragment = n ? n(u.ctx) : !1, e.target) {
    if (e.hydrate) {
      const g = nc(e.target);
      u.fragment && u.fragment.l(g), g.forEach(M);
    } else
      u.fragment && u.fragment.c();
    e.intro && V(t.$$.fragment), de(t, e.target, e.anchor), d();
  }
  fo(r);
}
class we {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Us(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    Us(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    ge(this, 1), this.$destroy = Q;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(e, i) {
    if (!Xn(i))
      return Q;
    const n = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return n.push(i), () => {
      const o = n.indexOf(i);
      o !== -1 && n.splice(o, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(e) {
    this.$$set && !Xu(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
const Ac = "4";
typeof window != "undefined" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Ac);
const yc = "@beyondwords/player", mo = "0.2.15", wi = (t, e) => {
  t = [t].flat().join(`
`);
  let i = `${yc}:

${t}`;
  if (e) {
    i += `
This context may be helpful:

`;
    for (const [n, o] of Object.entries(e))
      i += `  - ${n}: ${JSON.stringify(o)}
`;
  } else
    i += `
`;
  throw new Error(i);
};
let Ho;
const vc = new Uint8Array(16);
function bc() {
  if (!Ho && (Ho = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Ho))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ho(vc);
}
const kc = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function ho(t) {
  return typeof t == "string" && kc.test(t);
}
const ei = [];
for (let t = 0; t < 256; ++t)
  ei.push((t + 256).toString(16).slice(1));
function pc(t, e = 0) {
  return ei[t[e + 0]] + ei[t[e + 1]] + ei[t[e + 2]] + ei[t[e + 3]] + "-" + ei[t[e + 4]] + ei[t[e + 5]] + "-" + ei[t[e + 6]] + ei[t[e + 7]] + "-" + ei[t[e + 8]] + ei[t[e + 9]] + "-" + ei[t[e + 10]] + ei[t[e + 11]] + ei[t[e + 12]] + ei[t[e + 13]] + ei[t[e + 14]] + ei[t[e + 15]];
}
const Sc = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Ul = {
  randomUUID: Sc
};
function rs(t, e, i) {
  if (Ul.randomUUID && !e && !t)
    return Ul.randomUUID();
  t = t || {};
  const n = t.random || (t.rng || bc)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    i = i || 0;
    for (let o = 0; o < 16; ++o)
      e[i + o] = n[o];
    return e;
  }
  return pc(n);
}
const Il = ["user", "media", "browser", "media-session-api", "google-ima-sdk"], pr = ["inline-player", "bottom-widget", "segment", "segment-widget"], Pc = ["handled", "ignored-due-to-advert", "ignored-due-to-scrubbing", "ignored-due-to-precedence"], wc = ["load", "play", "play_progress", "ad_link_click"], Tc = ["phone", "tablet", "desktop", "ios", "android"], Cc = ["content", "ad"], Ic = (t) => {
  Ne(t, "type", (e) => Ol(e)), Ne(t, "description", (e) => e.length > 0), Ne(t, "initiatedBy", (e) => Il.includes(e));
}, Oc = (t) => {
  Ne(t, "type", (e) => Ol(e)), Ne(t, "description", (e) => e.length > 0), Ne(t, "initiatedBy", (e) => Il.includes(e)), Ne(t, "emittedFrom", (e) => pr.includes(e)), Ne(t, "id", (e) => ho(e)), Ne(t, "createdAt", (e) => sl(e)), Ne(t, "status", (e) => e === "pending");
}, Vc = (t) => {
  Ne(t, "type", (e) => Ol(e)), Ne(t, "description", (e) => e.length > 0), Ne(t, "initiatedBy", (e) => Il.includes(e)), Ne(t, "emittedFrom", (e) => pr.includes(e)), Ne(t, "id", (e) => ho(e)), Ne(t, "createdAt", (e) => sl(e)), Ne(t, "status", (e) => Pc.includes(e)), Ne(t, "changedProps", (e) => typeof e == "object"), Ne(t, "processedAt", (e) => sl(e));
}, Bc = (t) => {
  Ne(t, "event_type", (e) => wc.includes(e)), Ne(t, "device_type", (e) => Tc.includes(e)), Ne(t, "media_type", (e) => Cc.includes(e)), Ne(t, "content_id", (e) => !e || ho(e)), Ne(t, "project_id", (e) => !e || e > 0), Ne(t, "analytics_id", (e) => !e || e > 0), Ne(t, "ad_id", (e) => !e || e > 0), Ne(t, "media_id", (e) => !e || e > 0), Ne(t, "local_storage_id", (e) => !e || ho(e)), Ne(t, "listen_session_id", (e) => !e || ho(e)), Ne(t, "session_created_at", (e) => e >= 0), Ne(t, "duration", (e) => e >= 0), Ne(t, "listen_length_percent", (e) => e >= 0 && e <= 100), Ne(t, "listen_length_seconds", (e) => e >= 0), Ne(t, "speed", (e) => e >= 0), Ne(t, "location", (e) => e.length > 0), Ne(t, "referrer", (e) => typeof e == "string"), Ne(t, "player_version", (e) => e.length > 0), Ne(t, "player_npm_version", (e) => e.length > 0);
}, Ol = (t) => {
  t = t || "<invalid>";
  const e = t[0] === t[0].toUpperCase(), i = t.match(/[^a-zA-Z]/);
  return e && !i;
}, sl = (t) => {
  try {
    return new Date(Date.parse(t)).toISOString() === t;
  } catch (e) {
    return !1;
  }
}, Ne = (t, e, i) => {
  Object.prototype.hasOwnProperty.call(t, e) || wi(`Invalid event: missing a '${e}' property`, t), i(t[e]) || wi(`Invalid event: '${e}: ${t[e]}' is invalid`, t);
}, ke = (t) => {
  Ic(t);
  const e = rs(), i = (/* @__PURE__ */ new Date()).toISOString();
  return Jt({ id: e, createdAt: i, status: "pending" }, t);
}, Wc = (t, e = {}) => {
  let i;
  try {
    i = new URL(t);
  } catch (o) {
    return t;
  }
  const n = new URLSearchParams(i.search);
  for (const [o, s] of Object.entries(e))
    n.set(o, s);
  return i.search = n.toString(), i.toString();
}, Mc = (t) => {
  var o;
  const e = ll(t);
  if (!e)
    return "";
  let i = e, n = -1;
  for (const [s, l] of e.searchParams) {
    const a = ll(l);
    if (!a)
      continue;
    const r = Ec[s] || 0;
    r <= n || (i = a, n = r);
  }
  return ((o = i == null ? void 0 : i.hostname) == null ? void 0 : o.replace(/^www./, "")) || "";
}, ll = (t) => {
  try {
    return new URL(t);
  } catch (e) {
    return null;
  }
}, Ec = {
  destination: 11,
  dest: 10,
  dst: 9,
  redirect: 8,
  red: 7,
  link: 6,
  visit: 5,
  return: 4,
  d: 3,
  r: 2,
  l: 1
}, Hl = {
  nonPersonalizedDaisybit: "CQFZtsAQFZtsAAAAAAENDgCAAEIAAAAAAAAAg1NX_H__bW9r8X7_aft0eY1P9_j77sQxBhfJE-4F3LvW_JwXx2E5NF36tqoKmRoEu3ZBIUNlHJHUTVmwaogVryHsakWcoTNKJ6BkkFMRM2dYCF5vm4tjeQKY5_p_d3fx2D-t_dv839zzz8VHn3e5fue0-PCdU5-9Dfn9fRfb-9IP9_78v8v8_l_rk2_eT13_pcvr_D--f_87_XW-9_cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAA.Ig1NX_H__bX9v-X7_6ft0eY1f9_j77sQxBhfJs-4F3LvW_JwX32E7NF36tq4KmRoEu3ZBIUNtHJnUTVmxaogVrzHsakWcoTNKJ-BkkHMRe2dYCF5vm4tjeQKZ5_p_d3f52T_9_dv-39zz39Vnv3e9fuf1-Pjde5_9H_v_fRfb-_If9_7-_8v8_t_rk2_eT1__9evv__--________9_8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAE",
  personalizedDaisybit: "CQFZtsAQFZtsAAAAAAENDgCAAHIAAAAAAAAAg1NX_H__bW9r8X7_aft0eY1P9_j77sQxBhfJE-4F3LvW_JwXx2E5NF36tqoKmRoEu3ZBIUNlHJHUTVmwaogVryHsakWcoTNKJ6BkkFMRM2dYCF5vm4tjeQKY5_p_d3fx2D-t_dv839zzz8VHn3e5fue0-PCdU5-9Dfn9fRfb-9IP9_78v8v8_l_rk2_eT13_pcvr_D--f_87_XW-9_cAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAA.Ig1NX_H__bX9v-X7_6ft0eY1f9_j77sQxBhfJs-4F3LvW_JwX32E7NF36tq4KmRoEu3ZBIUNtHJnUTVmxaogVrzHsakWcoTNKJ-BkkHMRe2dYCF5vm4tjeQKZ5_p_d3f52T_9_dv-39zz39Vnv3e9fuf1-Pjde5_9H_v_fRfb-_If9_7-_8v8_t_rk2_eT1__9evv__--________9_8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAE"
}, zc = (t, e, i, n, o, s, l, a, r, u, c, g) => {
  const f = window.location.hostname === "localhost";
  return Lc(t) ? jc(f, i, g) : Sr(t) ? Dc(f, t, e, i, n, o, s, l, a, r, u, c) : {};
}, Lc = (t) => t == null ? void 0 : t.includes("pubads.g.doubleclick.net"), Sr = (t) => t == null ? void 0 : t.includes("geo.ads.audio.thisisdax.com"), jc = (t, e, i) => {
  const n = {};
  return n.vad_type = "linear", n.npa = e !== "personalized" ? 1 : 0, n.tfua = e === "under-the-age-of-consent" ? 1 : 0, n.ad_type = i ? "audio_video" : "audio", t && (n.url || (n.url = "https://googleads.github.io")), t && (n.description_url || (n.description_url = "https://googleads.github.io")), t || (n.description_url = window.location.href), n;
}, Dc = (t, e, i, n, o, s, l, a, r, u, c, g) => {
  var _, k;
  const f = {};
  e != null && e.includes("cid=") || console.warn("BeyondWords.Player: The DAX VAST URL does not contain the 'cid' parameter."), window.daxListenerId && (f.dax_listenerid = window.daxListenerId), n === "personalized" ? f.gdpr_consent = Hl.personalizedDaisybit : f.gdpr_consent = Hl.nonPersonalizedDaisybit, f.att = 0, c && (f.idfv = c);
  const A = (k = (_ = ll(window.location.href)) == null ? void 0 : _.hostname) == null ? void 0 : k.replace(/^www./, "");
  if (A && !t && (f.u = A), f.adc_min = 1, f.adc_max = 1, i === "pre-roll" ? f.sd = 0 : i === "mid-roll" ? f.sd = -1 : i === "post-roll" && (f.sd = -2), f.delivery_type = "streaming", g && (f.bi = g), f.content_language = r.split(/[_-]/)[0], f.collectionid = s ? `project-${s}` : "no-project", f.showid = l ? `playlist-${l}` : "no-playlist", f.episodeid = a ? `content-${a}` : "no-content", f.explicit = !1, f.dax_player = "BeyondWords Player", f.dax_version = mo, u === "ios" ? f.dax_platform = "iOS" : u === "android" ? f.dax_platform = "Android" : f.dax_platform = "web", f.isLoggedIn = !1, o > 0) {
    const S = o * (window.devicePixelRatio || 1);
    f.comp_size = `${S}x${S}`, f.is_comp_allowed = 1;
  } else
    f.is_comp_allowed = 0;
  return f.cb = Math.floor(Math.random() * 1e10), f;
}, xc = (t) => {
  if (!t)
    return !1;
  const e = window.innerHeight || document.documentElement.clientHeight, i = window.innerWidth || document.documentElement.clientWidth, { top: n, bottom: o, left: s, right: l } = t.getBoundingClientRect();
  return n < e && o > 0 && s < i && l > 0;
}, ql = (t, e, i) => Ie(t, e, e === "style" ? Rc(i) : i), Nc = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Rc = (t) => t.split(Nc).filter((e) => e).map((e) => e + " !important").join(";"), { document: Fc } = ec;
function Uc(t) {
  let e, i, n, o, s, l;
  return {
    c() {
      e = y("script"), e.innerHTML = "", n = J(), o = y("div"), Ni(e.src, i = "https://imasdk.googleapis.com/js/sdkloader/ima3.js") || ql(e, "src", i), ql(o, "class", "vast-container");
    },
    m(a, r) {
      h(Fc.head, e), E(a, n, r), E(a, o, r), t[22](o), s || (l = [
        Y(
          e,
          "load",
          /*initializeIMA*/
          t[1]
        ),
        Y(
          e,
          "error",
          /*onScriptError*/
          t[2]
        )
      ], s = !0);
    },
    p: Q,
    i: Q,
    o: Q,
    d(a) {
      a && (M(n), M(o)), M(e), t[22](null), s = !1, _t(l);
    }
  };
}
function Hc(t, e, i) {
  let n, o, { vastUrl: s } = e, { preloading: l } = e, { placement: a } = e, { advertConsent: r } = e, { maxImageSize: u } = e, { projectId: c } = e, { playlistId: g } = e, { contentId: f } = e, { contentLanguage: A } = e, { platform: _ } = e, { vendorIdentifier: k } = e, { bundleIdentifier: S } = e, { video: T } = e, { playbackState: v } = e, { duration: P } = e, { currentTime: O } = e, { onEvent: D = () => {
  } } = e, p, C, Z, q, x, X, oe;
  const ae = () => {
    google.ima.settings.setDisableCustomPlaybackForIOS10Plus(!0), C = new google.ima.AdDisplayContainer(p, T), Z = new google.ima.AdsLoader(C), Z.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, $, !1), Z.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, w, !1), q = new google.ima.AdsRequest(), q.adTagUrl = o, q.linearAdSlotWidth = T.clientWidth, q.linearAdSlotHeight = T.clientHeight, Z.requestAds(q);
  }, $ = (j) => {
    const he = new google.ima.AdsRenderingSettings();
    he.enablePreloading = !0, i(20, x = j.getAdsManager(T, he)), x.addEventListener(google.ima.AdEvent.Type.STARTED, ue), x.addEventListener(google.ima.AdEvent.Type.AD_PROGRESS, Ae), x.addEventListener(google.ima.AdEvent.Type.CLICK, ye), x.addEventListener(google.ima.AdEvent.Type.PAUSED, re), x.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, b), x.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, w);
  }, ee = () => {
    if (!X) {
      X = !0, T.pause(), T.load(), C.initialize();
      try {
        x.init(T.clientWidth, T.clientHeight, google.ima.ViewMode.NORMAL), x.start(), L(), Ve();
      } catch (j) {
        w(null, j);
      }
    }
  }, ue = (j) => {
    var Te, Je;
    const he = new google.ima.CompanionAdSelectionSettings();
    he.resourceType = google.ima.CompanionAdSelectionSettings.ResourceType.STATIC, he.creativeType = google.ima.CompanionAdSelectionSettings.CreativeType.IMAGE, he.sizeCriteria = google.ima.CompanionAdSelectionSettings.SizeCriteria.IGNORE;
    const Re = (Te = j.getAd().getCompanionAds(0, 0, he)[0]) == null ? void 0 : Te.data;
    if (!Re)
      return;
    const Ge = document.createElement("div");
    Ge.innerHTML = Re.content;
    const Me = (Je = Ge.firstChild) == null ? void 0 : Je.getAttribute("href"), nt = Re.resourceValue;
    D(ke({
      type: "CompanionAdvertChanged",
      description: "The companion advert associated with the VAST advert changed.",
      initiatedBy: "google-ima-sdk",
      clickThroughUrl: Me,
      imageUrl: nt
    }));
  }, Ae = (j) => {
    oe = j.getAdData(), oe.updatedAt = Date.now(), oe.minDuration = ce(oe), D(ke({
      type: "CurrentTimeUpdated",
      description: "The media's current time was updated.",
      initiatedBy: "media"
    })), P !== oe.minDuration && (i(4, P = oe.minDuration), D(ke({
      type: "DurationUpdated",
      description: "The media's duration was updated.",
      initiatedBy: "google-ima-sdk"
    })));
  }, ce = ({ duration: j, adBreakDuration: he }) => {
    const ze = Math.min(j || 1 / 0, he || 1 / 0);
    return ze === 1 / 0 ? 0 : ze;
  }, ye = () => {
    D(ke({
      type: "PressedAdvertVideo",
      description: "The video background was pressed to open the advert in a new tab.",
      initiatedBy: "user"
    }));
  }, re = () => {
    v !== "paused" && (i(3, v = "paused"), D(ke({
      type: "PlaybackPaused",
      description: "The media became paused at its current playback time.",
      initiatedBy: "google-ima-sdk"
    })));
  }, b = () => {
    D(ke({
      type: "PlaybackEnded",
      description: "The media finished playing because it reached the end.",
      initiatedBy: "google-ima-sdk"
    })), D(ke({
      type: "CompanionAdvertChanged",
      description: "The companion advert associated with the VAST advert changed.",
      initiatedBy: "google-ima-sdk",
      clickThroughUrl: null,
      imageUrl: null
    }));
  }, w = (j, he) => {
    he = he || j.getError(), x == null || x.destroy(), D(ke({
      type: "PlaybackErrored",
      description: "The media failed to play.",
      initiatedBy: "google-ima-sdk",
      mediaType: "VAST",
      mediaUrl: o,
      preloading: l,
      errorMessage: `${he.getMessage()} (code=${he.getErrorCode()})`
    }));
  }, R = () => {
    D(ke({
      type: "PlaybackErrored",
      description: "The media failed to play.",
      initiatedBy: "browser",
      mediaType: "VAST",
      mediaUrl: o,
      preloading: l,
      errorMessage: "The ima3.js script was blocked."
    }));
  }, L = () => {
    const j = document.createTreeWalker(p);
    let he;
    for (; he = j.nextNode(); ) {
      const ze = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Ge = he.style.cssText.split(ze).filter((Me) => Me).map((Me) => Me.includes("!important") ? Me : `${Me} !important`);
      he.style.cssText = Ge.join(";");
    }
  }, Ve = () => {
    p && (i(5, O = Le()), x.resize(T.clientWidth, T.clientHeight, google.ima.ViewMode.NORMAL), requestAnimationFrame(Ve));
  }, Le = () => {
    if (!oe)
      return 0;
    if (v === "playing") {
      const j = (Date.now() - oe.updatedAt) / 1e3;
      return oe.currentTime + j;
    } else
      return oe.updatedAt = Date.now(), O;
  };
  function Qe(j) {
    se[j ? "unshift" : "push"](() => {
      p = j, i(0, p);
    });
  }
  return t.$$set = (j) => {
    "vastUrl" in j && i(6, s = j.vastUrl), "preloading" in j && i(7, l = j.preloading), "placement" in j && i(8, a = j.placement), "advertConsent" in j && i(9, r = j.advertConsent), "maxImageSize" in j && i(10, u = j.maxImageSize), "projectId" in j && i(11, c = j.projectId), "playlistId" in j && i(12, g = j.playlistId), "contentId" in j && i(13, f = j.contentId), "contentLanguage" in j && i(14, A = j.contentLanguage), "platform" in j && i(15, _ = j.platform), "vendorIdentifier" in j && i(16, k = j.vendorIdentifier), "bundleIdentifier" in j && i(17, S = j.bundleIdentifier), "video" in j && i(18, T = j.video), "playbackState" in j && i(3, v = j.playbackState), "duration" in j && i(4, P = j.duration), "currentTime" in j && i(5, O = j.currentTime), "onEvent" in j && i(19, D = j.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*vastUrl, placement, advertConsent, maxImageSize, projectId, playlistId, contentId, contentLanguage, platform, vendorIdentifier, bundleIdentifier, video*/
    524096 && i(21, n = zc(s, a, r, u, c, g, f, A, _, k, S, xc(T))), t.$$.dirty[0] & /*vastUrl, adParams*/
    2097216 && (o = Wc(s, n)), t.$$.dirty[0] & /*adsManager, preloading, playbackState*/
    1048712 && x && !l && v === "playing" && ee(), t.$$.dirty[0] & /*adsManager, preloading, playbackState*/
    1048712 && !l && (v === "playing" ? x == null || x.resume() : x == null || x.pause());
  }, [
    p,
    ae,
    R,
    v,
    P,
    O,
    s,
    l,
    a,
    r,
    u,
    c,
    g,
    f,
    A,
    _,
    k,
    S,
    T,
    D,
    x,
    n,
    Qe
  ];
}
class qc extends we {
  constructor(e) {
    super(), Pe(
      this,
      e,
      Hc,
      Uc,
      pe,
      {
        vastUrl: 6,
        preloading: 7,
        placement: 8,
        advertConsent: 9,
        maxImageSize: 10,
        projectId: 11,
        playlistId: 12,
        contentId: 13,
        contentLanguage: 14,
        platform: 15,
        vendorIdentifier: 16,
        bundleIdentifier: 17,
        video: 18,
        playbackState: 3,
        duration: 4,
        currentTime: 5,
        onEvent: 19
      },
      null,
      [-1, -1]
    );
  }
  get vastUrl() {
    return this.$$.ctx[6];
  }
  set vastUrl(e) {
    this.$$set({ vastUrl: e }), d();
  }
  get preloading() {
    return this.$$.ctx[7];
  }
  set preloading(e) {
    this.$$set({ preloading: e }), d();
  }
  get placement() {
    return this.$$.ctx[8];
  }
  set placement(e) {
    this.$$set({ placement: e }), d();
  }
  get advertConsent() {
    return this.$$.ctx[9];
  }
  set advertConsent(e) {
    this.$$set({ advertConsent: e }), d();
  }
  get maxImageSize() {
    return this.$$.ctx[10];
  }
  set maxImageSize(e) {
    this.$$set({ maxImageSize: e }), d();
  }
  get projectId() {
    return this.$$.ctx[11];
  }
  set projectId(e) {
    this.$$set({ projectId: e }), d();
  }
  get playlistId() {
    return this.$$.ctx[12];
  }
  set playlistId(e) {
    this.$$set({ playlistId: e }), d();
  }
  get contentId() {
    return this.$$.ctx[13];
  }
  set contentId(e) {
    this.$$set({ contentId: e }), d();
  }
  get contentLanguage() {
    return this.$$.ctx[14];
  }
  set contentLanguage(e) {
    this.$$set({ contentLanguage: e }), d();
  }
  get platform() {
    return this.$$.ctx[15];
  }
  set platform(e) {
    this.$$set({ platform: e }), d();
  }
  get vendorIdentifier() {
    return this.$$.ctx[16];
  }
  set vendorIdentifier(e) {
    this.$$set({ vendorIdentifier: e }), d();
  }
  get bundleIdentifier() {
    return this.$$.ctx[17];
  }
  set bundleIdentifier(e) {
    this.$$set({ bundleIdentifier: e }), d();
  }
  get video() {
    return this.$$.ctx[18];
  }
  set video(e) {
    this.$$set({ video: e }), d();
  }
  get playbackState() {
    return this.$$.ctx[3];
  }
  set playbackState(e) {
    this.$$set({ playbackState: e }), d();
  }
  get duration() {
    return this.$$.ctx[4];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get currentTime() {
    return this.$$.ctx[5];
  }
  set currentTime(e) {
    this.$$set({ currentTime: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[19];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Yl = (t, e) => {
  const i = t.map((n, o) => [n, o]);
  return i.sort(([n, o], [s, l]) => {
    const a = e(n, s);
    return a === -1 ? -1 : a === 1 ? 1 : o < l ? -1 : o > l ? 1 : 0;
  }), i.map(([n, o]) => n);
}, Yc = (t, e, i) => {
  if (!t)
    return [];
  const n = (t.audio || []).map((r) => en(Jt({}, r), { format: "audio" })), o = (t.video || []).map((r) => en(Jt({}, r), { format: "video" })), s = Yl(n, Zl), l = Yl(o, Zl), a = e ? [...l, ...s] : s;
  if (i && Zc() || e && Kc()) {
    const r = a.filter((c) => !c.url.endsWith(".m3u8")), u = a.filter((c) => c.url.endsWith(".m3u8"));
    return [...r, ...u];
  }
  return a;
}, Zc = () => {
  var e, i;
  const t = ((i = (e = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : e.toLowerCase) == null ? void 0 : i.call(e)) || "";
  return t.includes("android") && t.includes("chrome");
}, Kc = () => {
  var i, n, o;
  const e = (o = (((n = (i = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : i.toLowerCase) == null ? void 0 : n.call(i)) || "").match(/android\s([0-9.]+)/i)) == null ? void 0 : o[1];
  return e && parseInt(e, 10) <= 13;
}, Zl = (t, e) => {
  const i = t.url.endsWith(".m3u8"), n = e.url.endsWith(".m3u8");
  return i && !n ? -1 : !i && n ? 1 : 0;
};
let Gn;
const Gc = (t, e) => Fi(void 0, null, function* () {
  return Pr(t, e) && (yield Jc()), Gn;
}), Pr = (t, e) => !(!(t && e) || !((t == null ? void 0 : t.contentType) === "application/x-mpegURL") || (e == null ? void 0 : e.canPlayType("application/vnd.apple.mpegurl")) || !(Gn ? Gn.isSupported() : !0)), Jc = () => Fi(void 0, null, function* () {
  Gn || (Gn || (Gn = (yield import("././././././hls.light.min.js")).default), Gn || (Gn = window.Hls));
}), wr = (t) => {
  let e;
  try {
    e = new URL(t);
  } catch (i) {
    return t;
  }
  return e.hash ? t == null ? void 0 : t.slice(0, -e.hash.length) : t;
}, Xc = () => {
  const t = {
    maxNumRetry: 1 / 0,
    retryDelayMs: 10,
    maxRetryDelayMs: 2e3,
    backoff: "exponential"
  }, i = {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 999999999,
      timeoutRetry: t,
      errorRetry: t
    }
  };
  return {
    fragLoadPolicy: i,
    keyLoadPolicy: i,
    certLoadPolicy: i,
    playlistLoadPolicy: i,
    manifestLoadPolicy: i,
    steeringManifestLoadPolicy: i
  };
}, Qc = (t, e, i, n, o, s, l) => {
  var c, g;
  if (window.disableMediaLoad || ((c = n == null ? void 0 : n.detachMedia) == null || c.call(n), (g = n == null ? void 0 : n.destroy) == null || g.call(n), n = null, !e || !t))
    return;
  const a = e.paused, r = e.playbackRate, u = e.currentSrc && wr(e.currentSrc) !== t.url;
  if (Pr(t, e)) {
    if (!i)
      return "pending";
    n = new i(Jt({
      enableWorker: !1,
      // Don't use web workers since it's not our website.
      autoStartLoad: !1,
      // Defer loading audio fragments until playback begins.
      maxBufferLength: 5
    }, Xc())), n.on(i.Events.ERROR, o), n.on(i.Events.MANIFEST_LOADED, () => {
      n.manifestLoaded = !0, s();
    }), n.loadSource(t.url), n.attachMedia(e);
  } else
    u ? (e.removeAttribute("src"), e.load()) : e.currentSrc && s();
  return a || l(), e.playbackRate = r, n || "not-used";
}, Tr = (t, e, i = 10) => {
  if (!(!t || t === "not-used" || t.loadMediaCalled)) {
    if (!t.manifestLoaded) {
      setTimeout(() => Tr(t, e, i * 2), i);
      return;
    }
    t.startLoad(e), t.loadMediaCalled = !0;
  }
}, _o = 1e-5, Kl = (t, e = 0, i) => t && e > 0 ? `#t=${e}` : i === "video" && $c() ? `#t=${_o}` : "", $c = () => {
  var e, i;
  const t = ((i = (e = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : e.toLowerCase) == null ? void 0 : i.call(e)) || "";
  return t.includes("safari") && !t.includes("chrome");
}, Cr = (t) => {
  const e = t == null ? void 0 : t.split(" ");
  if (e.length === 1)
    return { top: e[0], right: e[0], bottom: e[0], left: e[0] };
  if (e.length === 2)
    return { top: e[0], right: e[1], bottom: e[0], left: e[1] };
  if (e.length === 3)
    return { top: e[0], right: e[1], bottom: e[2], left: e[1] };
  if (e.length === 4)
    return { top: e[0], right: e[1], bottom: e[2], left: e[3] };
  wi(`Invalid widgetMargin: ${t}`);
}, ed = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Luister na hierdie artikel",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, td = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ed
}, Symbol.toStringTag, { value: "Module" })), id = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Tie asɛm yi",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, nd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: id
}, Symbol.toStringTag, { value: "Module" })), od = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ይህን ጽሑፍ ያዳምጡ",
  minutesSingularOrPlural: "{n} ቀ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: od
}, Symbol.toStringTag, { value: "Module" })), ld = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "استمع إلى هذا المقال",
  minutesSingularOrPlural: "{n} د",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, ad = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ld
}, Symbol.toStringTag, { value: "Module" })), rd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "এই লেখাটো শুনক",
  minutesSingularOrPlural: "{n} মিনিট",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, ud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rd
}, Symbol.toStringTag, { value: "Module" })), cd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Bu məqaləyə qulaq asın",
  minutesSingularOrPlural: "{n} dəq",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, dd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cd
}, Symbol.toStringTag, { value: "Module" })), gd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Слухайце гэты артыкул",
  minutesSingularOrPlural: "{n} хв",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, fd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gd
}, Symbol.toStringTag, { value: "Module" })), md = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Чуйте тази статия",
  minutesSingularOrPlural: "{n} мин",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, hd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: md
}, Symbol.toStringTag, { value: "Module" })), _d = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Aw ye nin barokun lamɛn",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Ad = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _d
}, Symbol.toStringTag, { value: "Module" })), yd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "এই নিবন্ধটি শুনুন",
  minutesSingularOrPlural: "{n} মি",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, vd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yd
}, Symbol.toStringTag, { value: "Module" })), bd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Poslušajte ovaj članak",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, kd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bd
}, Symbol.toStringTag, { value: "Module" })), pd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Escolta aquest article",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Sd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pd
}, Symbol.toStringTag, { value: "Module" })), Pd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "گوێ لەم بابەتە بگرن",
  minutesSingularOrPlural: "{n} خول",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, wd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pd
}, Symbol.toStringTag, { value: "Module" })), Td = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Poslechněte si tento článek",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Cd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Td
}, Symbol.toStringTag, { value: "Module" })), Id = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Gwrandewch ar yr erthygl hon",
  minutesSingularOrPlural: "{n} mun",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Od = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Id
}, Symbol.toStringTag, { value: "Module" })), Vd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Lyt til denne artikel",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Bd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vd
}, Symbol.toStringTag, { value: "Module" })), Wd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Hören Sie sich diesen Artikel an",
  minutesSingularOrPlural: "{n} Min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Md = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wd
}, Symbol.toStringTag, { value: "Module" })), Ed = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Se nyati sia ɖa",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ed
}, Symbol.toStringTag, { value: "Module" })), Ld = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Ακούστε αυτό το άρθρο",
  minutesSingularOrPlural: "{n} λεπ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, jd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ld
}, Symbol.toStringTag, { value: "Module" })), Dd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Listen to this article",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dd
}, Symbol.toStringTag, { value: "Module" })), Nd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Aŭskultu ĉi tiun artikolon",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Rd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nd
}, Symbol.toStringTag, { value: "Module" })), Fd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Escucha este artículo",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Ud = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fd
}, Symbol.toStringTag, { value: "Module" })), Hd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Kuulake seda artiklit",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, qd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hd
}, Symbol.toStringTag, { value: "Module" })), Yd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Entzun artikulu hau",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yd
}, Symbol.toStringTag, { value: "Module" })), Kd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "به این مقاله گوش دهید",
  minutesSingularOrPlural: "{n} دقیقه",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Gd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kd
}, Symbol.toStringTag, { value: "Module" })), Jd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Kuuntele tämä artikkeli",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jd
}, Symbol.toStringTag, { value: "Module" })), Qd = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Makinig sa artikulong ito",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, $d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qd
}, Symbol.toStringTag, { value: "Module" })), eg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Écoutez cet article",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, tg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eg
}, Symbol.toStringTag, { value: "Module" })), ig = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Éist leis an alt seo",
  minutesSingularOrPlural: "{n} nóim",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, ng = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ig
}, Symbol.toStringTag, { value: "Module" })), og = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Èist ris an artaigil seo",
  minutesSingularOrPlural: "{n} mion",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: og
}, Symbol.toStringTag, { value: "Module" })), lg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Escoita este artigo",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, ag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lg
}, Symbol.toStringTag, { value: "Module" })), rg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "આ લેખ સાંભળો",
  minutesSingularOrPlural: "{n} મિનિટ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, ug = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rg
}, Symbol.toStringTag, { value: "Module" })), cg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Saurari wannan labarin",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, dg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cg
}, Symbol.toStringTag, { value: "Module" })), gg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "E hoʻolohe i kēia ʻatikala",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, fg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gg
}, Symbol.toStringTag, { value: "Module" })), mg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "האזינו למאמר הזה",
  minutesSingularOrPlural: "{n} דק",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, hg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mg
}, Symbol.toStringTag, { value: "Module" })), _g = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "इस लेख को सुनें",
  minutesSingularOrPlural: "{n} मि",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Ag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _g
}, Symbol.toStringTag, { value: "Module" })), yg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Poslušajte ovaj članak",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, vg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yg
}, Symbol.toStringTag, { value: "Module" })), bg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Hallgassa meg ezt a cikket",
  minutesSingularOrPlural: "{n} p",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, kg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bg
}, Symbol.toStringTag, { value: "Module" })), pg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Լսեք այս հոդվածը",
  minutesSingularOrPlural: "{n} ր",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pg
}, Symbol.toStringTag, { value: "Module" })), Pg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Dengarkan artikel ini",
  minutesSingularOrPlural: "{n} mnt",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pg
}, Symbol.toStringTag, { value: "Module" })), Tg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Gee akụkọ a",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tg
}, Symbol.toStringTag, { value: "Module" })), Ig = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Hlustaðu á þessa grein",
  minutesSingularOrPlural: "{n} mín",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Og = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ig
}, Symbol.toStringTag, { value: "Module" })), Vg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Ascolta questo articolo",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Bg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Vg
}, Symbol.toStringTag, { value: "Module" })), Wg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "האזינו למאמר הזה",
  minutesSingularOrPlural: "{n} דק",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Mg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wg
}, Symbol.toStringTag, { value: "Module" })), Eg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "この記事を聞く",
  minutesSingularOrPlural: "{n} 分",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, zg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eg
}, Symbol.toStringTag, { value: "Module" })), Lg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "მოუსმინეთ ამ სტატიას",
  minutesSingularOrPlural: "{n} წთ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, jg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Lg
}, Symbol.toStringTag, { value: "Module" })), Dg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Бұл мақаланы тыңдаңыз",
  minutesSingularOrPlural: "{n} мин",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, xg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dg
}, Symbol.toStringTag, { value: "Module" })), Ng = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "សូមស្តាប់អត្ថបទនេះ។",
  minutesSingularOrPlural: "{n} នាទី",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Rg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ng
}, Symbol.toStringTag, { value: "Module" })), Fg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ಈ ಲೇಖನವನ್ನು ಆಲಿಸಿ",
  minutesSingularOrPlural: "{n} ನಿಮಿಷ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Ug = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fg
}, Symbol.toStringTag, { value: "Module" })), Hg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "기사를 들어보세요.",
  minutesSingularOrPlural: "{n} 분",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, qg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hg
}, Symbol.toStringTag, { value: "Module" })), Yg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Бул макаланы уккула",
  minutesSingularOrPlural: "{n} мүн",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Zg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yg
}, Symbol.toStringTag, { value: "Module" })), Kg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Lauschtert dësen Artikel",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Gg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kg
}, Symbol.toStringTag, { value: "Module" })), Jg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Wuliriza ekitundu kino",
  minutesSingularOrPlural: "{n} ddk",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Xg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jg
}, Symbol.toStringTag, { value: "Module" })), Qg = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Yoká lisolo oyo",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, $g = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qg
}, Symbol.toStringTag, { value: "Module" })), ef = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ຟັງບົດຄວາມນີ້",
  minutesSingularOrPlural: "{n} ນາທີ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, tf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ef
}, Symbol.toStringTag, { value: "Module" })), nf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Klausykite šio straipsnio",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, of = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nf
}, Symbol.toStringTag, { value: "Module" })), sf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Klausieties šo rakstu",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, lf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sf
}, Symbol.toStringTag, { value: "Module" })), af = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Henoy ity lahatsoratra ity",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, rf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: af
}, Symbol.toStringTag, { value: "Module" })), uf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Слушајте ја оваа статија",
  minutesSingularOrPlural: "{n} мин",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, cf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uf
}, Symbol.toStringTag, { value: "Module" })), df = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ഈ ലേഖനം ശ്രദ്ധിക്കുക",
  minutesSingularOrPlural: "{n} മിനിറ്റ്",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, gf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: df
}, Symbol.toStringTag, { value: "Module" })), ff = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Энэ нийтлэлийг сонсоорой",
  minutesSingularOrPlural: "{n} мин",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, mf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ff
}, Symbol.toStringTag, { value: "Module" })), hf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "हा लेख ऐका",
  minutesSingularOrPlural: "{n} मि",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, _f = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hf
}, Symbol.toStringTag, { value: "Module" })), Af = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Dengar artikel ini",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, yf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Af
}, Symbol.toStringTag, { value: "Module" })), vf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Isma' dan l-artiklu",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vf
}, Symbol.toStringTag, { value: "Module" })), kf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ဒီဆောင်းပါးကို နားထောင်ပါ။",
  minutesSingularOrPlural: "{n} မိနစ်",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, pf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kf
}, Symbol.toStringTag, { value: "Module" })), Sf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Hør denne artikkelen",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video spilles av i widget",
  // These translations are used by aria-label.
  playAudio: "Spill av lyd",
  pauseAudio: "Sett lyden på pause",
  playbackTime: "Playback time",
  secondsSingular: "1 sekund",
  secondsPlural: "{n} sekunder",
  minutesSingular: "1 minutt",
  minutesPlural: "{n} minutter",
  outOfTotalTime: "av total tid",
  visitAdvert: "Besøk annonsen",
  visitBeyondWords: "Besøk BeyondWords",
  closeWidget: "Lukk widget",
  seekBack: "Søk tilbake",
  seekAhead: "Søk fremover",
  previousSegment: "Forrige segment",
  nextSegment: "Neste segment",
  previousTrack: "Forrige spor",
  nextTrack: "Neste spor",
  togglePlaylist: "Bytt spilleliste",
  visitSourceArticle: "Besøk kildeartikkelen",
  maximizeVideo: "Maksimer videoen",
  changePlaybackRate: "Endre avspillingshastighet",
  downloadAudio: "Last ned lyd"
}, Pf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sf
}, Symbol.toStringTag, { value: "Module" })), wf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "यो लेख सुन्नुहोस्",
  minutesSingularOrPlural: "{n} मिनेट",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Tf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wf
}, Symbol.toStringTag, { value: "Module" })), Cf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Luister naar dit artikel",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, If = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cf
}, Symbol.toStringTag, { value: "Module" })), Of = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Hør denne artikkelen",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video spilles av i widget",
  // These translations are used by aria-label.
  playAudio: "Spill av lyd",
  pauseAudio: "Sett lyden på pause",
  playbackTime: "Playback time",
  secondsSingular: "1 sekund",
  secondsPlural: "{n} sekunder",
  minutesSingular: "1 minutt",
  minutesPlural: "{n} minutter",
  outOfTotalTime: "av total tid",
  visitAdvert: "Besøk annonsen",
  visitBeyondWords: "Besøk BeyondWords",
  closeWidget: "Lukk widget",
  seekBack: "Søk tilbake",
  seekAhead: "Søk fremover",
  previousSegment: "Forrige segment",
  nextSegment: "Neste segment",
  previousTrack: "Forrige spor",
  nextTrack: "Neste spor",
  togglePlaylist: "Bytt spilleliste",
  visitSourceArticle: "Besøk kildeartikkelen",
  maximizeVideo: "Maksimer videoen",
  changePlaybackRate: "Endre avspillingshastighet",
  downloadAudio: "Last ned lyd"
}, Vf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Of
}, Symbol.toStringTag, { value: "Module" })), Bf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Hør denne artikkelen",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video spilles av i widget",
  // These translations are used by aria-label.
  playAudio: "Spill av lyd",
  pauseAudio: "Sett lyden på pause",
  playbackTime: "Playback time",
  secondsSingular: "1 sekund",
  secondsPlural: "{n} sekunder",
  minutesSingular: "1 minutt",
  minutesPlural: "{n} minutter",
  outOfTotalTime: "av total tid",
  visitAdvert: "Besøk annonsen",
  visitBeyondWords: "Besøk BeyondWords",
  closeWidget: "Lukk widget",
  seekBack: "Søk tilbake",
  seekAhead: "Søk fremover",
  previousSegment: "Forrige segment",
  nextSegment: "Neste segment",
  previousTrack: "Forrige spor",
  nextTrack: "Neste spor",
  togglePlaylist: "Bytt spilleliste",
  visitSourceArticle: "Besøk kildeartikkelen",
  maximizeVideo: "Maksimer videoen",
  changePlaybackRate: "Endre avspillingshastighet",
  downloadAudio: "Last ned lyd"
}, Wf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bf
}, Symbol.toStringTag, { value: "Module" })), Mf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Barreeffama kana dhaggeeffadhaa",
  minutesSingularOrPlural: "{n} daqiiqaa",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Ef = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mf
}, Symbol.toStringTag, { value: "Module" })), zf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ଏହି ଲେଖା ଶୁଣ |",
  minutesSingularOrPlural: "{n} ମିନିଟ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Lf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zf
}, Symbol.toStringTag, { value: "Module" })), jf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ਇਸ ਲੇਖ ਨੂੰ ਸੁਣੋ",
  minutesSingularOrPlural: "{n} ਮਿੰਟ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Df = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jf
}, Symbol.toStringTag, { value: "Module" })), xf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Posłuchaj tego artykułu",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Nf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xf
}, Symbol.toStringTag, { value: "Module" })), Rf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "دا لیکنه واورئ",
  minutesSingularOrPlural: "{n} دقيقه",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Ff = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rf
}, Symbol.toStringTag, { value: "Module" })), Uf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Ouça este artigo",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Hf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uf
}, Symbol.toStringTag, { value: "Module" })), qf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Kay qillqasqata uyariy",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Yf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qf
}, Symbol.toStringTag, { value: "Module" })), Zf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Ascultă acest articol",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Kf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zf
}, Symbol.toStringTag, { value: "Module" })), Gf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Прослушать эту статью",
  minutesSingularOrPlural: "{n} мин",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Jf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gf
}, Symbol.toStringTag, { value: "Module" })), Xf = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Umva iyi ngingo",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Qf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xf
}, Symbol.toStringTag, { value: "Module" })), $f = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "මෙම ලිපියට සවන් දෙන්න",
  minutesSingularOrPlural: "{n} මිනිත්තු",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, e1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $f
}, Symbol.toStringTag, { value: "Module" })), t1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Vypočujte si tento článok",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, i1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t1
}, Symbol.toStringTag, { value: "Module" })), n1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Poslušajte ta članek",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, o1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n1
}, Symbol.toStringTag, { value: "Module" })), s1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Teerera kuchinyorwa ichi",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, l1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: s1
}, Symbol.toStringTag, { value: "Module" })), a1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Dhageyso maqaalkan",
  minutesSingularOrPlural: "{n} daq",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, r1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a1
}, Symbol.toStringTag, { value: "Module" })), u1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Dëgjoni këtë artikull",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, c1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u1
}, Symbol.toStringTag, { value: "Module" })), d1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Слушајте овај чланак",
  minutesSingularOrPlural: "{n} мин",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, g1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d1
}, Symbol.toStringTag, { value: "Module" })), f1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Lyssna på den här artikeln",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, m1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: f1
}, Symbol.toStringTag, { value: "Module" })), h1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Sikiliza makala hii",
  minutesSingularOrPlural: "{n} dak",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, _1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: h1
}, Symbol.toStringTag, { value: "Module" })), A1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "இந்தக் கட்டுரையைக் கேளுங்கள்",
  minutesSingularOrPlural: "{n} நிமி",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, y1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: A1
}, Symbol.toStringTag, { value: "Module" })), v1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ఈ కథనాన్ని వినండి",
  minutesSingularOrPlural: "{n} ని",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, b1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v1
}, Symbol.toStringTag, { value: "Module" })), k1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Ин мақоларо гӯш кунед",
  minutesSingularOrPlural: "{n} дақ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, p1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: k1
}, Symbol.toStringTag, { value: "Module" })), S1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ฟังบทความนี้",
  minutesSingularOrPlural: "{n} นาที",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, P1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S1
}, Symbol.toStringTag, { value: "Module" })), w1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "ነዚ ጽሑፍ ስምዑዎ።",
  minutesSingularOrPlural: "{n} ደቂቃ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, T1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w1
}, Symbol.toStringTag, { value: "Module" })), C1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Bu makaleyi dinle",
  minutesSingularOrPlural: "{n} dk",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, I1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: C1
}, Symbol.toStringTag, { value: "Module" })), O1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Бу мәкаләне тыңлагыз",
  minutesSingularOrPlural: "{n} мин",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, V1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: O1
}, Symbol.toStringTag, { value: "Module" })), B1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "بۇ ماقالىنى ئاڭلاڭ",
  minutesSingularOrPlural: "{n} مىنۇت",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, W1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B1
}, Symbol.toStringTag, { value: "Module" })), M1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Послухайте цю статтю",
  minutesSingularOrPlural: "{n} хв",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, E1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M1
}, Symbol.toStringTag, { value: "Module" })), z1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "اس مضمون کو سنیں۔",
  minutesSingularOrPlural: "{n} منٹ",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, L1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z1
}, Symbol.toStringTag, { value: "Module" })), j1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Ushbu maqolani tinglang",
  minutesSingularOrPlural: "{n} daq",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, D1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j1
}, Symbol.toStringTag, { value: "Module" })), x1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Nghe bài viết này",
  minutesSingularOrPlural: "{n} phút",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, N1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: x1
}, Symbol.toStringTag, { value: "Module" })), R1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "הערן צו דעם אַרטיקל",
  minutesSingularOrPlural: "{n} מין",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, F1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: R1
}, Symbol.toStringTag, { value: "Module" })), U1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Gbọ nkan yii",
  minutesSingularOrPlural: "{n} iṣẹju",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, H1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U1
}, Symbol.toStringTag, { value: "Module" })), q1 = {
  listenToThisArticle: "聽這篇文章",
  minutesSingularOrPlural: "{n} 分鐘",
  videoInWidget: "Video is playing in widget",
  playAudio: "Play audio",
  // These translations are used by aria-label.
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Y1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q1
}, Symbol.toStringTag, { value: "Module" })), Z1 = {
  listenToThisArticle: "聽這篇文章",
  minutesSingularOrPlural: "{n} 分鐘",
  videoInWidget: "Video is playing in widget",
  playAudio: "Play audio",
  // These translations are used by aria-label.
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, K1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z1
}, Symbol.toStringTag, { value: "Module" })), G1 = {
  listenToThisArticle: "聽這篇文章",
  minutesSingularOrPlural: "{n} 分鐘",
  videoInWidget: "Video is playing in widget",
  playAudio: "Play audio",
  // These translations are used by aria-label.
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, J1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G1
}, Symbol.toStringTag, { value: "Module" })), X1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "听这篇文章",
  minutesSingularOrPlural: "{n} 分钟",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, Q1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: X1
}, Symbol.toStringTag, { value: "Module" })), $1 = {
  isDefaultForLanguage: !0,
  listenToThisArticle: "Lalela lesi sihloko",
  minutesSingularOrPlural: "{n} min",
  videoInWidget: "Video is playing in widget",
  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio"
}, em = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $1
}, Symbol.toStringTag, { value: "Module" })), tm = (t) => t.split("/").pop().split(".")[0], im = (t, e) => {
  nm(t, e), om(t), sm(t);
}, nm = (t, e) => {
  for (const i of Object.keys(t)) {
    const n = i.split("-")[0];
    e[n] || wi([
      `The language '${n}' has no default locale set. Should it be '${i}' ?`,
      `If so, please set 'isDefaultForLanguage: true' in src/translations/${i}.ts`
    ]);
  }
}, om = (t) => {
  const e = {};
  for (const [i, n] of Object.entries(t)) {
    const o = i.split("-")[0];
    n.isDefaultForLanguage && (e[o] || (e[o] = []), e[o].push(i));
  }
  for (const [i, n] of Object.entries(e))
    n.length !== 1 && wi([
      `The language '${i}' has more than one default locale: ${n.map((o) => `'${o}'`).join(", ")}`,
      "Please ensure 'isDefaultForLanguage: true' is set in exactly one file."
    ]);
}, sm = (t) => {
  const e = Object.values(t).map(Object.keys).flat(), i = new Set(e.filter((n) => n !== "isDefaultForLanguage"));
  for (const [n, o] of Object.entries(t))
    for (const s of i)
      o[s] || wi([
        `The locale '${n}' is missing the translation key '${s}'.`,
        `Please set '${s}: "something"' in src/translations/${n}.ts`
      ]);
}, lm = /* @__PURE__ */ Object.assign({ "../translations/af.ts": td, "../translations/ak.ts": nd, "../translations/am.ts": sd, "../translations/ar.ts": ad, "../translations/as.ts": ud, "../translations/az.ts": dd, "../translations/be.ts": fd, "../translations/bg.ts": hd, "../translations/bm.ts": Ad, "../translations/bn.ts": vd, "../translations/bs.ts": kd, "../translations/ca.ts": Sd, "../translations/ckb.ts": wd, "../translations/cs.ts": Cd, "../translations/cy.ts": Od, "../translations/da.ts": Bd, "../translations/de.ts": Md, "../translations/ee.ts": zd, "../translations/el.ts": jd, "../translations/en.ts": xd, "../translations/eo.ts": Rd, "../translations/es.ts": Ud, "../translations/et.ts": qd, "../translations/eu.ts": Zd, "../translations/fa.ts": Gd, "../translations/fi.ts": Xd, "../translations/fil.ts": $d, "../translations/fr.ts": tg, "../translations/ga.ts": ng, "../translations/gd.ts": sg, "../translations/gl.ts": ag, "../translations/gu.ts": ug, "../translations/ha.ts": dg, "../translations/haw.ts": fg, "../translations/he.ts": hg, "../translations/hi.ts": Ag, "../translations/hr.ts": vg, "../translations/hu.ts": kg, "../translations/hy.ts": Sg, "../translations/id.ts": wg, "../translations/ig.ts": Cg, "../translations/is.ts": Og, "../translations/it.ts": Bg, "../translations/iw.ts": Mg, "../translations/ja.ts": zg, "../translations/ka.ts": jg, "../translations/kk.ts": xg, "../translations/km.ts": Rg, "../translations/kn.ts": Ug, "../translations/ko.ts": qg, "../translations/ky.ts": Zg, "../translations/lb.ts": Gg, "../translations/lg.ts": Xg, "../translations/ln.ts": $g, "../translations/lo.ts": tf, "../translations/lt.ts": of, "../translations/lv.ts": lf, "../translations/mg.ts": rf, "../translations/mk.ts": cf, "../translations/ml.ts": gf, "../translations/mn.ts": mf, "../translations/mr.ts": _f, "../translations/ms.ts": yf, "../translations/mt.ts": bf, "../translations/my.ts": pf, "../translations/nb.ts": Pf, "../translations/ne.ts": Tf, "../translations/nl.ts": If, "../translations/nn.ts": Vf, "../translations/no.ts": Wf, "../translations/om.ts": Ef, "../translations/or.ts": Lf, "../translations/pa.ts": Df, "../translations/pl.ts": Nf, "../translations/ps.ts": Ff, "../translations/pt.ts": Hf, "../translations/qu.ts": Yf, "../translations/ro.ts": Kf, "../translations/ru.ts": Jf, "../translations/rw.ts": Qf, "../translations/si.ts": e1, "../translations/sk.ts": i1, "../translations/sl.ts": o1, "../translations/sn.ts": l1, "../translations/so.ts": r1, "../translations/sq.ts": c1, "../translations/sr.ts": g1, "../translations/sv.ts": m1, "../translations/sw.ts": _1, "../translations/ta.ts": y1, "../translations/te.ts": b1, "../translations/tg.ts": p1, "../translations/th.ts": P1, "../translations/ti.ts": T1, "../translations/tr.ts": I1, "../translations/tt.ts": V1, "../translations/ug.ts": W1, "../translations/uk.ts": E1, "../translations/ur.ts": L1, "../translations/uz.ts": D1, "../translations/vi.ts": N1, "../translations/yi.ts": F1, "../translations/yo.ts": H1, "../translations/zh-HK.ts": Y1, "../translations/zh-MO.ts": K1, "../translations/zh-TW.ts": J1, "../translations/zh.ts": Q1, "../translations/zu.ts": em }), Ir = Object.entries(lm).map(([t, e]) => [tm(t), e.default]), al = Object.fromEntries(Ir.filter(([t, e]) => t.includes("-"))), rl = Object.fromEntries(Ir.filter(([t, e]) => e.isDefaultForLanguage).map(([t, e]) => [t.split("-")[0], e]));
im(al, rl);
const gt = (t, { locale: e } = {}) => {
  const i = am(e);
  return i[t] || wi([
    `No translations found for the '${t}' translation key.`,
    `Please ensure '${t}: "something"' is set in src/translations/`
  ]), i[t];
}, am = (t = null) => {
  const e = [t, ...navigator.languages, "en"].filter((i) => i);
  for (const i of e) {
    const n = i.split("-")[0];
    if (al[i])
      return al[i];
    if (rl[n])
      return rl[n];
  }
}, ai = (t) => {
  t.detail !== 0 && t.currentTarget.blur();
}, rm = () => {
  var n, o;
  const t = ((o = (n = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : n.toLowerCase) == null ? void 0 : o.call(n)) || "", e = t.match(/iphone|ipad|ipod/i) && (navigator == null ? void 0 : navigator.maxTouchPoints), i = t.match(/safari|applewebkit/i);
  return e && i;
}, um = ["article", "summary"], cm = (t) => um.indexOf(t) !== -1, Or = (t, e) => t === "article" && (e === "title" || e === "body") || t === "summary" && e === "summary", Vl = (t, e, i) => {
  const n = t.filter((u) => Or(i, u.section)), o = n.findIndex((u) => u.startTime > e), s = o === -1, l = o - 1, a = l === -1;
  let r;
  return a ? r = 0 : s ? r = n.length - 1 : r = l, t.indexOf(n[r]);
}, Gl = (t, e) => {
  const i = wr(e == null ? void 0 : e.currentSrc), n = t.find((o) => {
    var a;
    const s = o.url && i === dm(o.url), l = ((a = o.url) == null ? void 0 : a.endsWith(".m3u8")) && (i == null ? void 0 : i.startsWith("blob:"));
    return s || l;
  });
  return t.length > 0 && !n && console.warn("BeyondWords.Player: media was loaded but failed to set loadedMedia"), n;
}, dm = (t) => {
  const e = document.createElement("a");
  return e.href = t, e.href;
};
var uo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function gm(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function fm(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var i = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    i.prototype = e.prototype;
  } else
    i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(i, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), i;
}
var Vr = { exports: {} };
function mm(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Zs = { exports: {} };
const hm = {}, _m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hm
}, Symbol.toStringTag, { value: "Module" })), Am = /* @__PURE__ */ fm(_m);
var Jl;
function ym() {
  return Jl || (Jl = 1, function(t, e) {
    (function(i, n) {
      t.exports = n();
    })(uo, function() {
      var i = i || function(n, o) {
        var s;
        if (typeof window != "undefined" && window.crypto && (s = window.crypto), typeof self != "undefined" && self.crypto && (s = self.crypto), typeof globalThis != "undefined" && globalThis.crypto && (s = globalThis.crypto), !s && typeof window != "undefined" && window.msCrypto && (s = window.msCrypto), !s && typeof uo != "undefined" && uo.crypto && (s = uo.crypto), !s && typeof mm == "function")
          try {
            s = Am;
          } catch (v) {
          }
        var l = function() {
          if (s) {
            if (typeof s.getRandomValues == "function")
              try {
                return s.getRandomValues(new Uint32Array(1))[0];
              } catch (v) {
              }
            if (typeof s.randomBytes == "function")
              try {
                return s.randomBytes(4).readInt32LE();
              } catch (v) {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, a = Object.create || /* @__PURE__ */ function() {
          function v() {
          }
          return function(P) {
            var O;
            return v.prototype = P, O = new v(), v.prototype = null, O;
          };
        }(), r = {}, u = r.lib = {}, c = u.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(v) {
              var P = a(this);
              return v && P.mixIn(v), (!P.hasOwnProperty("init") || this.init === P.init) && (P.init = function() {
                P.$super.init.apply(this, arguments);
              }), P.init.prototype = P, P.$super = this, P;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var v = this.extend();
              return v.init.apply(v, arguments), v;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(v) {
              for (var P in v)
                v.hasOwnProperty(P) && (this[P] = v[P]);
              v.hasOwnProperty("toString") && (this.toString = v.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), g = u.WordArray = c.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(v, P) {
            v = this.words = v || [], P != o ? this.sigBytes = P : this.sigBytes = v.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(v) {
            return (v || A).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(v) {
            var P = this.words, O = v.words, D = this.sigBytes, p = v.sigBytes;
            if (this.clamp(), D % 4)
              for (var C = 0; C < p; C++) {
                var Z = O[C >>> 2] >>> 24 - C % 4 * 8 & 255;
                P[D + C >>> 2] |= Z << 24 - (D + C) % 4 * 8;
              }
            else
              for (var q = 0; q < p; q += 4)
                P[D + q >>> 2] = O[q >>> 2];
            return this.sigBytes += p, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var v = this.words, P = this.sigBytes;
            v[P >>> 2] &= 4294967295 << 32 - P % 4 * 8, v.length = n.ceil(P / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var v = c.clone.call(this);
            return v.words = this.words.slice(0), v;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(v) {
            for (var P = [], O = 0; O < v; O += 4)
              P.push(l());
            return new g.init(P, v);
          }
        }), f = r.enc = {}, A = f.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(v) {
            for (var P = v.words, O = v.sigBytes, D = [], p = 0; p < O; p++) {
              var C = P[p >>> 2] >>> 24 - p % 4 * 8 & 255;
              D.push((C >>> 4).toString(16)), D.push((C & 15).toString(16));
            }
            return D.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(v) {
            for (var P = v.length, O = [], D = 0; D < P; D += 2)
              O[D >>> 3] |= parseInt(v.substr(D, 2), 16) << 24 - D % 8 * 4;
            return new g.init(O, P / 2);
          }
        }, _ = f.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(v) {
            for (var P = v.words, O = v.sigBytes, D = [], p = 0; p < O; p++) {
              var C = P[p >>> 2] >>> 24 - p % 4 * 8 & 255;
              D.push(String.fromCharCode(C));
            }
            return D.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(v) {
            for (var P = v.length, O = [], D = 0; D < P; D++)
              O[D >>> 2] |= (v.charCodeAt(D) & 255) << 24 - D % 4 * 8;
            return new g.init(O, P);
          }
        }, k = f.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(v) {
            try {
              return decodeURIComponent(escape(_.stringify(v)));
            } catch (P) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(v) {
            return _.parse(unescape(encodeURIComponent(v)));
          }
        }, S = u.BufferedBlockAlgorithm = c.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new g.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(v) {
            typeof v == "string" && (v = k.parse(v)), this._data.concat(v), this._nDataBytes += v.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(v) {
            var P, O = this._data, D = O.words, p = O.sigBytes, C = this.blockSize, Z = C * 4, q = p / Z;
            v ? q = n.ceil(q) : q = n.max((q | 0) - this._minBufferSize, 0);
            var x = q * C, X = n.min(x * 4, p);
            if (x) {
              for (var oe = 0; oe < x; oe += C)
                this._doProcessBlock(D, oe);
              P = D.splice(0, x), O.sigBytes -= X;
            }
            return new g.init(P, X);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var v = c.clone.call(this);
            return v._data = this._data.clone(), v;
          },
          _minBufferSize: 0
        });
        u.Hasher = S.extend({
          /**
           * Configuration options.
           */
          cfg: c.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(v) {
            this.cfg = this.cfg.extend(v), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            S.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(v) {
            return this._append(v), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(v) {
            v && this._append(v);
            var P = this._doFinalize();
            return P;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(v) {
            return function(P, O) {
              return new v.init(O).finalize(P);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(v) {
            return function(P, O) {
              return new T.HMAC.init(v, O).finalize(P);
            };
          }
        });
        var T = r.algo = {};
        return r;
      }(Math);
      return i;
    });
  }(Zs)), Zs.exports;
}
(function(t, e) {
  (function(i, n) {
    t.exports = n(ym());
  })(uo, function(i) {
    return function(n) {
      var o = i, s = o.lib, l = s.WordArray, a = s.Hasher, r = o.algo, u = [];
      (function() {
        for (var k = 0; k < 64; k++)
          u[k] = n.abs(n.sin(k + 1)) * 4294967296 | 0;
      })();
      var c = r.MD5 = a.extend({
        _doReset: function() {
          this._hash = new l.init([
            1732584193,
            4023233417,
            2562383102,
            271733878
          ]);
        },
        _doProcessBlock: function(k, S) {
          for (var T = 0; T < 16; T++) {
            var v = S + T, P = k[v];
            k[v] = (P << 8 | P >>> 24) & 16711935 | (P << 24 | P >>> 8) & 4278255360;
          }
          var O = this._hash.words, D = k[S + 0], p = k[S + 1], C = k[S + 2], Z = k[S + 3], q = k[S + 4], x = k[S + 5], X = k[S + 6], oe = k[S + 7], ae = k[S + 8], $ = k[S + 9], ee = k[S + 10], ue = k[S + 11], Ae = k[S + 12], ce = k[S + 13], ye = k[S + 14], re = k[S + 15], b = O[0], w = O[1], R = O[2], L = O[3];
          b = g(b, w, R, L, D, 7, u[0]), L = g(L, b, w, R, p, 12, u[1]), R = g(R, L, b, w, C, 17, u[2]), w = g(w, R, L, b, Z, 22, u[3]), b = g(b, w, R, L, q, 7, u[4]), L = g(L, b, w, R, x, 12, u[5]), R = g(R, L, b, w, X, 17, u[6]), w = g(w, R, L, b, oe, 22, u[7]), b = g(b, w, R, L, ae, 7, u[8]), L = g(L, b, w, R, $, 12, u[9]), R = g(R, L, b, w, ee, 17, u[10]), w = g(w, R, L, b, ue, 22, u[11]), b = g(b, w, R, L, Ae, 7, u[12]), L = g(L, b, w, R, ce, 12, u[13]), R = g(R, L, b, w, ye, 17, u[14]), w = g(w, R, L, b, re, 22, u[15]), b = f(b, w, R, L, p, 5, u[16]), L = f(L, b, w, R, X, 9, u[17]), R = f(R, L, b, w, ue, 14, u[18]), w = f(w, R, L, b, D, 20, u[19]), b = f(b, w, R, L, x, 5, u[20]), L = f(L, b, w, R, ee, 9, u[21]), R = f(R, L, b, w, re, 14, u[22]), w = f(w, R, L, b, q, 20, u[23]), b = f(b, w, R, L, $, 5, u[24]), L = f(L, b, w, R, ye, 9, u[25]), R = f(R, L, b, w, Z, 14, u[26]), w = f(w, R, L, b, ae, 20, u[27]), b = f(b, w, R, L, ce, 5, u[28]), L = f(L, b, w, R, C, 9, u[29]), R = f(R, L, b, w, oe, 14, u[30]), w = f(w, R, L, b, Ae, 20, u[31]), b = A(b, w, R, L, x, 4, u[32]), L = A(L, b, w, R, ae, 11, u[33]), R = A(R, L, b, w, ue, 16, u[34]), w = A(w, R, L, b, ye, 23, u[35]), b = A(b, w, R, L, p, 4, u[36]), L = A(L, b, w, R, q, 11, u[37]), R = A(R, L, b, w, oe, 16, u[38]), w = A(w, R, L, b, ee, 23, u[39]), b = A(b, w, R, L, ce, 4, u[40]), L = A(L, b, w, R, D, 11, u[41]), R = A(R, L, b, w, Z, 16, u[42]), w = A(w, R, L, b, X, 23, u[43]), b = A(b, w, R, L, $, 4, u[44]), L = A(L, b, w, R, Ae, 11, u[45]), R = A(R, L, b, w, re, 16, u[46]), w = A(w, R, L, b, C, 23, u[47]), b = _(b, w, R, L, D, 6, u[48]), L = _(L, b, w, R, oe, 10, u[49]), R = _(R, L, b, w, ye, 15, u[50]), w = _(w, R, L, b, x, 21, u[51]), b = _(b, w, R, L, Ae, 6, u[52]), L = _(L, b, w, R, Z, 10, u[53]), R = _(R, L, b, w, ee, 15, u[54]), w = _(w, R, L, b, p, 21, u[55]), b = _(b, w, R, L, ae, 6, u[56]), L = _(L, b, w, R, re, 10, u[57]), R = _(R, L, b, w, X, 15, u[58]), w = _(w, R, L, b, ce, 21, u[59]), b = _(b, w, R, L, q, 6, u[60]), L = _(L, b, w, R, ue, 10, u[61]), R = _(R, L, b, w, C, 15, u[62]), w = _(w, R, L, b, $, 21, u[63]), O[0] = O[0] + b | 0, O[1] = O[1] + w | 0, O[2] = O[2] + R | 0, O[3] = O[3] + L | 0;
        },
        _doFinalize: function() {
          var k = this._data, S = k.words, T = this._nDataBytes * 8, v = k.sigBytes * 8;
          S[v >>> 5] |= 128 << 24 - v % 32;
          var P = n.floor(T / 4294967296), O = T;
          S[(v + 64 >>> 9 << 4) + 15] = (P << 8 | P >>> 24) & 16711935 | (P << 24 | P >>> 8) & 4278255360, S[(v + 64 >>> 9 << 4) + 14] = (O << 8 | O >>> 24) & 16711935 | (O << 24 | O >>> 8) & 4278255360, k.sigBytes = (S.length + 1) * 4, this._process();
          for (var D = this._hash, p = D.words, C = 0; C < 4; C++) {
            var Z = p[C];
            p[C] = (Z << 8 | Z >>> 24) & 16711935 | (Z << 24 | Z >>> 8) & 4278255360;
          }
          return D;
        },
        clone: function() {
          var k = a.clone.call(this);
          return k._hash = this._hash.clone(), k;
        }
      });
      function g(k, S, T, v, P, O, D) {
        var p = k + (S & T | ~S & v) + P + D;
        return (p << O | p >>> 32 - O) + S;
      }
      function f(k, S, T, v, P, O, D) {
        var p = k + (S & v | T & ~v) + P + D;
        return (p << O | p >>> 32 - O) + S;
      }
      function A(k, S, T, v, P, O, D) {
        var p = k + (S ^ T ^ v) + P + D;
        return (p << O | p >>> 32 - O) + S;
      }
      function _(k, S, T, v, P, O, D) {
        var p = k + (T ^ (S | ~v)) + P + D;
        return (p << O | p >>> 32 - O) + S;
      }
      o.MD5 = a._createHelper(c), o.HmacMD5 = a._createHmacHelper(c);
    }(Math), i.MD5;
  });
})(Vr);
var vm = Vr.exports;
const bm = /* @__PURE__ */ gm(vm), km = (t, e) => {
  if (t === e)
    return !0;
  if (!t || !e)
    return !1;
  const i = t.split("/"), n = e.split("/");
  if (i.length !== n.length)
    return !1;
  for (let o = 0; o < i.length; o += 1)
    if (i[o] !== n[o] && !i[o].startsWith(`${n[o]}[`) && !n[o].startsWith(`${i[o]}[`))
      return !1;
  return !0;
}, Br = (t) => {
  const e = BeyondWords.Player.instances(), i = [...e.entries()], n = i.map(([l, a]) => ({ p: l, player: a })), o = pm(i);
  let s = t;
  for (; s && !ul(s) && !(o.size === 0 || cl(s)); )
    Ks(Sm, s, e, n, o), Ks(Pm, s, e, n, o), s = s.parentNode;
  for (s = t; s && !ul(s) && !(o.size === 0 || cl(s)); )
    Ks(wm, s, e, n, o), s = s.parentNode;
  return Tm(n), Cm(n), n;
}, pm = (t) => {
  const e = /* @__PURE__ */ new Set();
  for (const [i, n] of t)
    n.content.some((s) => {
      var l;
      return (l = s.segments) == null ? void 0 : l.length;
    }) && e.add(i);
  return e;
}, ul = (t) => t === document || t === document.body || t === document.head, cl = (t) => {
  const e = t.nodeName.toLowerCase();
  if (e === "a" || t.onclick || t.onmousedown || e === "img" || e === "audio" || e === "input" || e === "textarea" || t.isContentEditable || !!t.closest(".beyondwords-player"))
    return !0;
}, Ks = (t, e, i, n, o) => {
  if (o.size === 0)
    return;
  const s = t(e);
  if (s)
    for (const l of o) {
      const a = !!n[l].segment;
      let r = !1, u = -1 / 0;
      for (const [c, g] of i[l].content.entries())
        for (const [f, A] of g.segments.entries())
          if (cm(i[l].contentVariant) && Or(i[l].contentVariant, A.section) && s(A)) {
            const _ = i[l].contentIndex === c ? 1 : 0;
            if (_ < u || _ === u && n[l].segment)
              continue;
            u = _, n[l].segment = A, n[l].contentIndex = c, n[l].segmentIndex = f, n[l].segmentElement = e, r = !0;
          }
      a && (!r || ul(e.parentNode)) && o.delete(l);
    }
}, Sm = (t) => {
  const e = t.getAttribute("data-beyondwords-marker");
  return e ? (i) => i.marker === e : null;
}, Pm = (t) => {
  const e = us(() => dl(t)), i = us(() => js(t));
  return (n) => km(n.xpath, e()) && n.md5 === i();
}, wm = (t) => {
  const e = us(() => {
    var n;
    return (n = t.textContent) == null ? void 0 : n.trim();
  }), i = us(() => js(t));
  return (n) => {
    var o;
    return ((o = e()) == null ? void 0 : o.length) > 0 && n.md5 === i();
  };
}, us = (t) => {
  let e, i;
  return () => (i || (e = t(), i = !0), e);
}, dl = (t) => {
  const e = t == null ? void 0 : t.parentNode;
  if (!t || !e)
    return "";
  const i = t.nodeName.toLowerCase(), n = [...e.children].filter((s) => s.nodeName.toLowerCase() === i);
  return n.length === 1 ? `${dl(e)}/${i}` : `${dl(e)}/${i}[${n.indexOf(t) + 1}]`;
}, qo = /* @__PURE__ */ new WeakMap(), js = (t) => {
  var i, n;
  if (qo.has(t))
    return qo.get(t);
  let e = (n = (i = t.textContent) == null ? void 0 : i.replaceAll(/\s+/g, " ")) == null ? void 0 : n.trim();
  return (!e || e === " ") && (e = ""), qo.set(t, bm(e).toString()), qo.get(t);
}, Tm = (t) => {
  const e = t.filter((i) => i.segment);
  e.sort((i, n) => {
    const o = Xl[i.player.playbackState] || 0, s = Xl[n.player.playbackState] || 0;
    if (o > s)
      return -1;
    if (o < s)
      return 1;
    const l = i.segmentElement.getBoundingClientRect().top, a = n.segmentElement.getBoundingClientRect().top, r = i.player.userInterface ? i.player.target.getBoundingClientRect().top : 1 / 0, u = n.player.userInterface ? n.player.target.getBoundingClientRect().top : 1 / 0, c = Math.abs(l - r), g = Math.abs(a - u);
    return c < g ? -1 : c > g ? 1 : 0;
  });
  for (const [i, n] of e.entries())
    n.precedence = i;
}, Xl = { playing: 2, paused: 1, stopped: 0 }, Cm = (t) => {
  for (const { player: e, segment: i, segmentElement: n } of t) {
    if (!n)
      continue;
    i.matchedElement = n;
    const s = [...n.parentNode.children].filter((a) => a !== n).filter((a) => !cl(a)), l = new Map(s.map((a) => [js(a), a]));
    for (const a of e.content)
      for (const r of a.segments)
        r.matchedElement || (r.matchedElement = l.get(r.md5));
  }
}, Im = (t) => {
  if (!t)
    return;
  if (t.matchedElement)
    return t.matchedElement;
  const e = Om(t.marker);
  if (e.length === 1)
    return e[0];
  const i = Vm(t.xpath, t.md5);
  if (e.length === 0)
    return i[0];
  const n = e.filter((o) => i.includes(o));
  return n.length !== 0 ? n[0] : e[0];
}, Om = (t) => t ? [...document.querySelectorAll(`[data-beyondwords-marker="${t}"]`)] : [], Vm = (t, e) => {
  if (!t || !e)
    return [];
  const i = document.evaluate(t, document), n = [];
  for (; ; ) {
    const o = i.iterateNext();
    if (o && js(o) === e)
      n.push(o);
    else
      return n;
  }
}, ii = (t, e, i) => Ie(t, e, e === "style" ? Wm(i) : i), Bm = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Wm = (t) => t.split(Bm).filter((e) => e).map((e) => e + " !important").join(";");
function Ql(t, e, i) {
  const n = t.slice();
  return n[88] = e[i].url, n[89] = e[i].contentType, n[90] = e[i].format, n[92] = i, n;
}
function $l(t) {
  let e, i, n = (
    /*platform*/
    t[12] === "ios" && /*sources*/
    t[20].map(la).join("")
  ), o, s, l, a, r = ia(t), u = (
    /*vastUrl*/
    (t[21] || /*preloadVastUrl*/
    t[28]) && na(t)
  ), c = (
    /*customUrl*/
    t[29] && sa(t)
  );
  return {
    c() {
      e = y("div"), i = y("div"), r.c(), o = J(), u && u.c(), s = J(), c && c.c(), ii(i, "class", "inner svelte-8cyxi7"), ii(e, "class", l = "media-element " + /*position*/
      t[26] + " svelte-8cyxi7"), ii(
        e,
        "style",
        /*style*/
        t[25]
      ), ne(
        e,
        "animating",
        /*timeout*/
        t[24]
      ), ne(
        e,
        "behind-static",
        /*videoBehindStatic*/
        t[16] || /*videoBehindStaticWidget*/
        t[27]
      ), ne(
        e,
        "behind-sliding-widget",
        /*videoBehindSlidingWidget*/
        t[22]
      ), ne(e, "headless", !/*showUserInterface*/
      t[15]);
    },
    m(g, f) {
      E(g, e, f), h(e, i), r.m(i, null), h(i, o), u && u.m(i, null), h(i, s), c && c.m(i, null), a = !0;
    },
    p(g, f) {
      f[0] & /*platform, sources*/
      1052672 && pe(n, n = /*platform*/
      g[12] === "ios" && /*sources*/
      g[20].map(la).join("")) ? (r.d(1), r = ia(g), r.c(), r.m(i, o)) : r.p(g, f), /*vastUrl*/
      g[21] || /*preloadVastUrl*/
      g[28] ? u ? (u.p(g, f), f[0] & /*vastUrl, preloadVastUrl*/
      270532608 && V(u, 1)) : (u = na(g), u.c(), V(u, 1), u.m(i, s)) : u && (Fe(), z(u, 1, 1, () => {
        u = null;
      }), Ue()), /*customUrl*/
      g[29] ? c ? c.p(g, f) : (c = sa(g), c.c(), c.m(i, null)) : c && (c.d(1), c = null), (!a || f[0] & /*position*/
      67108864 && l !== (l = "media-element " + /*position*/
      g[26] + " svelte-8cyxi7")) && ii(e, "class", l), (!a || f[0] & /*style*/
      33554432) && ii(
        e,
        "style",
        /*style*/
        g[25]
      ), (!a || f[0] & /*position, timeout*/
      83886080) && ne(
        e,
        "animating",
        /*timeout*/
        g[24]
      ), (!a || f[0] & /*position, videoBehindStatic, videoBehindStaticWidget*/
      201392128) && ne(
        e,
        "behind-static",
        /*videoBehindStatic*/
        g[16] || /*videoBehindStaticWidget*/
        g[27]
      ), (!a || f[0] & /*position, videoBehindSlidingWidget*/
      71303168) && ne(
        e,
        "behind-sliding-widget",
        /*videoBehindSlidingWidget*/
        g[22]
      ), (!a || f[0] & /*position, showUserInterface*/
      67141632) && ne(e, "headless", !/*showUserInterface*/
      g[15]);
    },
    i(g) {
      a || (V(u), a = !0);
    },
    o(g) {
      z(u), a = !1;
    },
    d(g) {
      g && M(e), r.d(g), u && u.d(), c && c.d();
    }
  };
}
function ea(t) {
  let e, i = ti(
    /*sources*/
    t[20]
  ), n = [];
  for (let o = 0; o < i.length; o += 1)
    n[o] = ta(Ql(t, i, o));
  return {
    c() {
      for (let o = 0; o < n.length; o += 1)
        n[o].c();
      e = Ei();
    },
    m(o, s) {
      for (let l = 0; l < n.length; l += 1)
        n[l] && n[l].m(o, s);
      E(o, e, s);
    },
    p(o, s) {
      if (s[0] & /*sources, isFirstLoad*/
      9437184 | s[1] & /*initialTime, handleSourceError*/
      2049) {
        i = ti(
          /*sources*/
          o[20]
        );
        let l;
        for (l = 0; l < i.length; l += 1) {
          const a = Ql(o, i, l);
          n[l] ? n[l].p(a, s) : (n[l] = ta(a), n[l].c(), n[l].m(e.parentNode, e));
        }
        for (; l < n.length; l += 1)
          n[l].d(1);
        n.length = i.length;
      }
    },
    d(o) {
      o && M(e), Cn(n, o);
    }
  };
}
function ta(t) {
  let e, i, n, o, s;
  return {
    c() {
      e = y("source"), Ni(e.src, i = `${/*url*/
      t[88]}${Kl(
        /*isFirstLoad*/
        t[23],
        /*initialTime*/
        t[31],
        /*format*/
        t[90]
      )}`) || ii(e, "src", i), ii(e, "type", n = /*contentType*/
      t[89]);
    },
    m(l, a) {
      E(l, e, a), o || (s = Y(
        e,
        "error",
        /*handleSourceError*/
        t[42](
          /*i*/
          t[92]
        )
      ), o = !0);
    },
    p(l, a) {
      t = l, a[0] & /*sources, isFirstLoad*/
      9437184 && !Ni(e.src, i = `${/*url*/
      t[88]}${Kl(
        /*isFirstLoad*/
        t[23],
        /*initialTime*/
        t[31],
        /*format*/
        t[90]
      )}`) && ii(e, "src", i), a[0] & /*sources*/
      1048576 && n !== (n = /*contentType*/
      t[89]) && ii(e, "type", n);
    },
    d(l) {
      l && M(e), o = !1, s();
    }
  };
}
function ia(t) {
  let e, i = !1, n, o, s, l = (
    /*hls*/
    t[18] !== "pending" && !window.disableMediaLoad && ea(t)
  );
  function a() {
    cancelAnimationFrame(n), e.paused || (n = Ls(a), i = !0), t[71].call(e);
  }
  return {
    c() {
      e = y("video"), l && l.c(), ii(e, "preload", "metadata"), e.playsInline = !0, ii(e, "disablepictureinpicture", ""), ii(e, "class", "svelte-8cyxi7"), /*duration*/
      t[3] === void 0 && dt(() => (
        /*video_1_durationchange_handler*/
        t[70].call(e)
      ));
    },
    m(r, u) {
      E(r, e, u), l && l.m(e, null), t[69](e), isNaN(
        /*playbackRate*/
        t[4]
      ) || (e.playbackRate = /*playbackRate*/
      t[4]), o || (s = [
        Y(
          e,
          "durationchange",
          /*video_1_durationchange_handler*/
          t[70]
        ),
        Y(e, "timeupdate", a),
        Y(
          e,
          "ratechange",
          /*video_1_ratechange_handler*/
          t[72]
        ),
        Y(
          e,
          "play",
          /*handlePlay*/
          t[32]
        ),
        Y(
          e,
          "pause",
          /*handlePause*/
          t[33]
        ),
        Y(
          e,
          "ended",
          /*handleEnded*/
          t[34]
        ),
        Y(
          e,
          "playing",
          /*handlePlaying*/
          t[35]
        ),
        Y(
          e,
          "durationchange",
          /*handleDurationChange*/
          t[36]
        ),
        Y(
          e,
          "loadedmetadata",
          /*handleLoadedMetadata*/
          t[37]
        ),
        Y(
          e,
          "loadeddata",
          /*handleLoadedData*/
          t[38]
        ),
        Y(
          e,
          "timeupdate",
          /*handleTimeUpdate*/
          t[39]
        ),
        Y(
          e,
          "seeked",
          /*handleSeeked*/
          t[40]
        ),
        Y(
          e,
          "ratechange",
          /*handleRateChange*/
          t[41]
        )
      ], o = !0);
    },
    p(r, u) {
      /*hls*/
      r[18] !== "pending" && !window.disableMediaLoad ? l ? l.p(r, u) : (l = ea(r), l.c(), l.m(e, null)) : l && (l.d(1), l = null), !i && u[0] & /*time*/
      524288 && !isNaN(
        /*time*/
        r[19]
      ) && (e.currentTime = /*time*/
      r[19]), i = !1, u[0] & /*playbackRate*/
      16 && !isNaN(
        /*playbackRate*/
        r[4]
      ) && (e.playbackRate = /*playbackRate*/
      r[4]);
    },
    d(r) {
      r && M(e), l && l.d(), t[69](null), o = !1, _t(s);
    }
  };
}
function na(t) {
  let e = (
    /*vastUrl*/
    t[21] || /*preloadVastUrl*/
    t[28]
  ), i, n, o = oa(t);
  return {
    c() {
      o.c(), i = Ei();
    },
    m(s, l) {
      o.m(s, l), E(s, i, l), n = !0;
    },
    p(s, l) {
      l[0] & /*vastUrl, preloadVastUrl*/
      270532608 && pe(e, e = /*vastUrl*/
      s[21] || /*preloadVastUrl*/
      s[28]) ? (Fe(), z(o, 1, 1, Q), Ue(), o = oa(s), o.c(), V(o, 1), o.m(i.parentNode, i)) : o.p(s, l);
    },
    i(s) {
      n || (V(o), n = !0);
    },
    o(s) {
      z(o), n = !1;
    },
    d(s) {
      s && M(i), o.d(s);
    }
  };
}
function oa(t) {
  let e, i, n, o, s;
  function l(c) {
    t[73](c);
  }
  function a(c) {
    t[74](c);
  }
  function r(c) {
    t[75](c);
  }
  let u = {
    vastUrl: (
      /*vastUrl*/
      t[21] || /*preloadVastUrl*/
      t[28]
    ),
    preloading: !!/*preloadVastUrl*/
    t[28] && !/*vastUrl*/
    t[21],
    onEvent: (
      /*onEvent*/
      t[17]
    ),
    placement: (
      /*placement*/
      t[30]
    ),
    advertConsent: (
      /*advertConsent*/
      t[6]
    ),
    maxImageSize: (
      /*maxImageSize*/
      t[7]
    ),
    projectId: (
      /*projectId*/
      t[8]
    ),
    playlistId: (
      /*playlistId*/
      t[9]
    ),
    contentId: (
      /*contentId*/
      t[10]
    ),
    contentLanguage: (
      /*contentLanguage*/
      t[11]
    ),
    platform: (
      /*platform*/
      t[12]
    ),
    vendorIdentifier: (
      /*vendorIdentifier*/
      t[13]
    ),
    bundleIdentifier: (
      /*bundleIdentifier*/
      t[14]
    ),
    video: (
      /*video*/
      t[2]
    )
  };
  return (
    /*playbackState*/
    t[0] !== void 0 && (u.playbackState = /*playbackState*/
    t[0]), /*duration*/
    t[3] !== void 0 && (u.duration = /*duration*/
    t[3]), /*currentTime*/
    t[1] !== void 0 && (u.currentTime = /*currentTime*/
    t[1]), e = new qc({ props: u }), se.push(() => be(e, "playbackState", l)), se.push(() => be(e, "duration", a)), se.push(() => be(e, "currentTime", r)), {
      c() {
        me(e.$$.fragment);
      },
      m(c, g) {
        de(e, c, g), s = !0;
      },
      p(c, g) {
        const f = {};
        g[0] & /*vastUrl, preloadVastUrl*/
        270532608 && (f.vastUrl = /*vastUrl*/
        c[21] || /*preloadVastUrl*/
        c[28]), g[0] & /*preloadVastUrl, vastUrl*/
        270532608 && (f.preloading = !!/*preloadVastUrl*/
        c[28] && !/*vastUrl*/
        c[21]), g[0] & /*onEvent*/
        131072 && (f.onEvent = /*onEvent*/
        c[17]), g[0] & /*placement*/
        1073741824 && (f.placement = /*placement*/
        c[30]), g[0] & /*advertConsent*/
        64 && (f.advertConsent = /*advertConsent*/
        c[6]), g[0] & /*maxImageSize*/
        128 && (f.maxImageSize = /*maxImageSize*/
        c[7]), g[0] & /*projectId*/
        256 && (f.projectId = /*projectId*/
        c[8]), g[0] & /*playlistId*/
        512 && (f.playlistId = /*playlistId*/
        c[9]), g[0] & /*contentId*/
        1024 && (f.contentId = /*contentId*/
        c[10]), g[0] & /*contentLanguage*/
        2048 && (f.contentLanguage = /*contentLanguage*/
        c[11]), g[0] & /*platform*/
        4096 && (f.platform = /*platform*/
        c[12]), g[0] & /*vendorIdentifier*/
        8192 && (f.vendorIdentifier = /*vendorIdentifier*/
        c[13]), g[0] & /*bundleIdentifier*/
        16384 && (f.bundleIdentifier = /*bundleIdentifier*/
        c[14]), g[0] & /*video*/
        4 && (f.video = /*video*/
        c[2]), !i && g[0] & /*playbackState*/
        1 && (i = !0, f.playbackState = /*playbackState*/
        c[0], ve(() => i = !1)), !n && g[0] & /*duration*/
        8 && (n = !0, f.duration = /*duration*/
        c[3], ve(() => n = !1)), !o && g[0] & /*currentTime*/
        2 && (o = !0, f.currentTime = /*currentTime*/
        c[1], ve(() => o = !1)), e.$set(f);
      },
      i(c) {
        s || (V(e.$$.fragment, c), s = !0);
      },
      o(c) {
        z(e.$$.fragment, c), s = !1;
      },
      d(c) {
        ge(e, c);
      }
    }
  );
}
function sa(t) {
  let e, i, n, o;
  return {
    c() {
      e = y("a"), i = ie(" "), ii(e, "class", "custom-advert-link svelte-8cyxi7"), ii(
        e,
        "href",
        /*customUrl*/
        t[29]
      ), ii(e, "target", "_blank"), ii(e, "aria-label", gt("visitAdvert"));
    },
    m(s, l) {
      E(s, e, l), h(e, i), n || (o = Y(e, "mouseup", ai), n = !0);
    },
    p(s, l) {
      l[0] & /*customUrl*/
      536870912 && ii(
        e,
        "href",
        /*customUrl*/
        s[29]
      );
    },
    d(s) {
      s && M(e), n = !1, o();
    }
  };
}
function Mm(t) {
  let e, i, n = (
    /*content*/
    t[5].length > 0 && $l(t)
  );
  return {
    c() {
      n && n.c(), e = Ei();
    },
    m(o, s) {
      n && n.m(o, s), E(o, e, s), i = !0;
    },
    p(o, s) {
      /*content*/
      o[5].length > 0 ? n ? (n.p(o, s), s[0] & /*content*/
      32 && V(n, 1)) : (n = $l(o), n.c(), V(n, 1), n.m(e.parentNode, e)) : n && (Fe(), z(n, 1, 1, () => {
        n = null;
      }), Ue());
    },
    i(o) {
      i || (V(n), i = !0);
    },
    o(o) {
      z(n), i = !1;
    },
    d(o) {
      o && M(e), n && n.d(o);
    }
  };
}
const la = ({ url: t }) => t;
function Em(t, e, i) {
  let n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, { content: C } = e, { contentIndex: Z } = e, { contentVariant: q } = e, { introOrOutro: x } = e, { activeAdvert: X } = e, { preloadAdvert: oe } = e, { advertConsent: ae } = e, { maxImageSize: $ } = e, { projectId: ee } = e, { playlistId: ue } = e, { contentId: Ae } = e, { contentLanguage: ce } = e, { platform: ye } = e, { vendorIdentifier: re } = e, { bundleIdentifier: b } = e, { playbackState: w } = e, { duration: R } = e, { currentTime: L } = e, { playbackRate: Ve } = e, { prevPercentage: Le } = e, { showUserInterface: Qe } = e, { videoBehindWidget: j } = e, { videoBehindStatic: he } = e, { videoMightBeShown: ze } = e, { widgetPosition: Re } = e, { widgetWidth: Ge } = e, { widgetMargin: Me } = e, { widgetTarget: nt } = e, { onEvent: Te = () => {
  } } = e, { metadataLoaded: Je } = e, { video: Ce = void 0 } = e, Lt, Ee, ft, Oe = 0, qe = 0, Nt = L, De, St;
  const Ye = (U) => i(19, Oe = U), At = () => ze, $e = () => u.some((U) => U.format === "video"), mt = () => {
    var U;
    return (Ce == null ? void 0 : Ce.paused) && ((U = Ce == null ? void 0 : Ce.play()) == null ? void 0 : U.catch(at));
  }, Ze = () => !(Ce != null && Ce.paused) && (Ce == null ? void 0 : Ce.pause()), xe = () => {
    ft && clearTimeout(ft), i(24, ft = setTimeout(() => i(24, ft = null), 500));
  }, yt = () => {
    Te(ke({
      type: "PlaybackPlaying",
      description: "The media began playing from its current playback time.",
      initiatedBy: "media"
    }));
  }, et = () => {
    Te(ke({
      type: "PlaybackPaused",
      description: "The media became paused at its current playback time.",
      initiatedBy: "media"
    }));
  }, lt = () => {
    Te(ke({
      type: "PlaybackEnded",
      description: "The media finished playing because it reached the end.",
      initiatedBy: "media"
    }));
  }, ot = () => {
    clearTimeout(St), St = setTimeout(
      () => {
        Ye(Ce.currentTime - 0.1);
      },
      3e3
    );
  }, Pt = () => {
    Te(ke({
      type: "DurationUpdated",
      description: "The media's duration was updated.",
      initiatedBy: "media"
    }));
  }, Xe = () => {
    Je || (i(43, Je = !0), i(58, De = Gl(u, Ce)), Te(ke({
      type: "MetadataLoaded",
      description: "The media finished loading its metadata.",
      initiatedBy: "media",
      loadedMedia: De
    })));
  }, Ot = () => {
    i(58, De = Gl(u, Ce)), Te(ke({
      type: "MediaLoaded",
      description: "The media finished loading its first frame of data.",
      initiatedBy: "media",
      loadedMedia: De
    }));
  }, vt = () => {
    c || (clearTimeout(St), St = void 0, Te(ke({
      type: "CurrentTimeUpdated",
      description: "The media's current time was updated.",
      initiatedBy: "media"
    })));
  }, Vt = () => {
    Te(ke({
      type: "MediaSeeked",
      description: "The media completed the seek operation.",
      initiatedBy: "media"
    }));
  }, wt = () => {
    const U = s[p], ut = Im(U);
    Te(ke({
      type: "CurrentSegmentUpdated",
      description: "The media's current segment was updated.",
      initiatedBy: "media",
      segment: U,
      contentIndex: Z,
      segmentIndex: p,
      segmentElement: ut,
      precedence: 0
    }));
  }, tt = () => {
    Te(ke({
      type: "PlaybackRateUpdated",
      description: "The media's playback rate was updated.",
      initiatedBy: "media"
    }));
  }, at = (U) => {
    if ((U == null ? void 0 : U.name) === "AbortError") {
      mt();
      return;
    }
    if ((U == null ? void 0 : U.name) !== "NotAllowedError")
      throw U;
    Te(ke({
      type: "PlaybackNotAllowed",
      description: "The media cannot play because there was no user event.",
      initiatedBy: "media"
    }));
  }, Bt = () => {
    console.warn("BeyondWords.Player: error while loading media"), Te(ke({
      type: "PlaybackErrored",
      description: "The media failed to play.",
      initiatedBy: "media",
      mediaType: "native",
      errorMessage: "The video tag does not contains any sources."
    }));
  }, bt = (U) => () => {
    var te;
    console.warn(`BeyondWords.Player: error while loading ${(te = u[U]) == null ? void 0 : te.contentType} source`), U === u.length - 1 && Te(ke({
      type: "PlaybackErrored",
      description: "The media failed to play.",
      initiatedBy: "media",
      mediaType: "native",
      mediaUrl: u[0].url,
      errorMessage: "The video tag contains sources but none are playable."
    }));
  }, kt = (U, ut) => Fi(this, null, function* () {
    var te, I;
    ut.fatal && ((te = Ee == null ? void 0 : Ee.detachMedia) == null || te.call(Ee), (I = Ee == null ? void 0 : Ee.destroy) == null || I.call(Ee), Te(ke({
      type: "PlaybackErrored",
      description: "The media failed to play.",
      initiatedBy: "media",
      mediaType: "HLS",
      mediaUrl: u[0].url,
      errorMessage: `${ut.type} ${ut.details}`
    })));
  }), Ke = () => {
    Te(ke({
      type: "FullScreenModeUpdated",
      description: "The browser entered or exited full screen mode.",
      initiatedBy: "browser"
    }));
  };
  Vo(() => {
    const U = addEventListener("fullscreenchange", Ke), ut = addEventListener("webkitfullscreenchange", Ke);
    return () => {
      removeEventListener("fullscreenchange", U), removeEventListener("fullscreenchange", ut);
    };
  });
  function rt(U) {
    se[U ? "unshift" : "push"](() => {
      Ce = U, i(2, Ce);
    });
  }
  function pt() {
    R = this.duration, i(3, R);
  }
  function st() {
    Oe = this.currentTime, i(19, Oe);
  }
  function it() {
    Ve = this.playbackRate, i(4, Ve);
  }
  function He(U) {
    w = U, i(0, w);
  }
  function ht(U) {
    R = U, i(3, R);
  }
  function Tt(U) {
    L = U, i(1, L), i(19, Oe);
  }
  return t.$$set = (U) => {
    "content" in U && i(5, C = U.content), "contentIndex" in U && i(45, Z = U.contentIndex), "contentVariant" in U && i(46, q = U.contentVariant), "introOrOutro" in U && i(47, x = U.introOrOutro), "activeAdvert" in U && i(48, X = U.activeAdvert), "preloadAdvert" in U && i(49, oe = U.preloadAdvert), "advertConsent" in U && i(6, ae = U.advertConsent), "maxImageSize" in U && i(7, $ = U.maxImageSize), "projectId" in U && i(8, ee = U.projectId), "playlistId" in U && i(9, ue = U.playlistId), "contentId" in U && i(10, Ae = U.contentId), "contentLanguage" in U && i(11, ce = U.contentLanguage), "platform" in U && i(12, ye = U.platform), "vendorIdentifier" in U && i(13, re = U.vendorIdentifier), "bundleIdentifier" in U && i(14, b = U.bundleIdentifier), "playbackState" in U && i(0, w = U.playbackState), "duration" in U && i(3, R = U.duration), "currentTime" in U && i(1, L = U.currentTime), "playbackRate" in U && i(4, Ve = U.playbackRate), "prevPercentage" in U && i(44, Le = U.prevPercentage), "showUserInterface" in U && i(15, Qe = U.showUserInterface), "videoBehindWidget" in U && i(50, j = U.videoBehindWidget), "videoBehindStatic" in U && i(16, he = U.videoBehindStatic), "videoMightBeShown" in U && i(51, ze = U.videoMightBeShown), "widgetPosition" in U && i(52, Re = U.widgetPosition), "widgetWidth" in U && i(53, Ge = U.widgetWidth), "widgetMargin" in U && i(54, Me = U.widgetMargin), "widgetTarget" in U && i(55, nt = U.widgetTarget), "onEvent" in U && i(17, Te = U.onEvent), "metadataLoaded" in U && i(43, Je = U.metadataLoaded), "video" in U && i(2, Ce = U.video);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*content, videoBehindStatic*/
    65568 | t.$$.dirty[1] & /*videoBehindWidget*/
    524288 && i(68, n = C.length > 0 && (he || j)), t.$$.dirty[2] & /*stylesNeeded*/
    64 && n && import("./././././././././style.js"), t.$$.dirty[0] & /*time*/
    524288 && i(1, L = Oe), t.$$.dirty[0] & /*currentTime*/
    2 | t.$$.dirty[1] & /*activeAdvert*/
    131072 && !X && kr().then(() => Ye(L)), t.$$.dirty[0] & /*content*/
    32 | t.$$.dirty[1] & /*contentIndex*/
    16384 && i(67, o = C[Z]), t.$$.dirty[2] & /*contentItem*/
    32 && i(60, s = (o == null ? void 0 : o.segments) || []), t.$$.dirty[1] & /*contentIndex, introOrOutro, activeAdvert, loadCount*/
    67321856 && i(57, qe += 1), t.$$.dirty[1] & /*loadCount*/
    67108864 && i(23, l = qe === 1), t.$$.dirty[0] & /*isFirstLoad*/
    8388608 && i(66, a = l && Nt), t.$$.dirty[1] & /*introOrOutro*/
    65536 && i(61, r = x), t.$$.dirty[1] & /*introOrOutro, activeAdvert*/
    196608 && !x && i(61, r = X), t.$$.dirty[1] & /*introOrOutro, activeAdvert, contentVariant*/
    229376 | t.$$.dirty[2] & /*contentItem*/
    32 && !x && !X && q === "article" && i(61, r = o), t.$$.dirty[1] & /*introOrOutro, activeAdvert, contentVariant*/
    229376 | t.$$.dirty[2] & /*contentItem*/
    32 && !x && !X && q === "summary" && i(61, r = o == null ? void 0 : o.summarization), t.$$.dirty[0] & /*playbackState, currentTime*/
    3 && i(62, D = w !== "playing" && L <= _o), t.$$.dirty[1] & /*videoMightBeShown, loadedMedia, mediaObject*/
    1209008128 | t.$$.dirty[2] & /*atTheStart*/
    1 && ze && (De == null ? void 0 : De.format) === "audio" && $e() && D && (i(61, r), i(47, x), i(48, X), i(46, q), i(67, o), i(51, ze), i(58, De), i(62, D), i(5, C), i(45, Z), i(0, w), i(1, L), i(19, Oe)), t.$$.dirty[1] & /*mediaObject*/
    1073741824 | t.$$.dirty[2] & /*startPosition*/
    16 && i(20, u = Yc(r, At(), a)), t.$$.dirty[0] & /*sources*/
    1048576 && i(43, Je = !1), t.$$.dirty[0] & /*sources*/
    1048576 && i(44, Le = 0), t.$$.dirty[0] & /*sources, video*/
    1048580 && Gc(u[0], Ce).then((U) => i(56, Lt = U)), t.$$.dirty[0] & /*sources, video, hls*/
    1310724 | t.$$.dirty[1] & /*Hls*/
    33554432 && i(18, Ee = Qc(u[0], Ce, Lt, Ee, kt, Xe, mt)), t.$$.dirty[0] & /*playbackState, hls*/
    262145 | t.$$.dirty[2] & /*startPosition*/
    16 && (w === "playing" || At()) && Tr(Ee, a), t.$$.dirty[1] & /*activeAdvert*/
    131072 && i(21, c = X == null ? void 0 : X.vastUrl), t.$$.dirty[1] & /*activeAdvert*/
    131072 && i(30, g = X == null ? void 0 : X.placement), t.$$.dirty[1] & /*activeAdvert*/
    131072 && i(29, f = X == null ? void 0 : X.clickThroughUrl), t.$$.dirty[1] & /*preloadAdvert*/
    262144 && i(28, A = oe == null ? void 0 : oe.vastUrl), t.$$.dirty[0] & /*vastUrl*/
    2097152 | t.$$.dirty[1] & /*metadataLoaded*/
    4096 && i(65, _ = !c && (Je || rm())), t.$$.dirty[0] & /*playbackState*/
    1 | t.$$.dirty[2] & /*controlPlayback*/
    8 && _ && (w === "playing" ? mt() : Ze()), t.$$.dirty[1] & /*videoBehindWidget, widgetTarget*/
    17301504 && i(27, k = j && nt), t.$$.dirty[1] & /*videoBehindWidget, widgetTarget*/
    17301504 && i(22, S = j && !nt), t.$$.dirty[1] & /*widgetMargin*/
    8388608 && i(64, T = Cr(Me)), t.$$.dirty[2] & /*margin*/
    4 && i(63, v = `calc(${T.left} + ${T.right})`), t.$$.dirty[0] & /*videoBehindSlidingWidget*/
    4194304 | t.$$.dirty[1] & /*widgetPosition*/
    2097152 && i(26, P = S && Re !== "auto" ? `fixed-${Re}` : ""), t.$$.dirty[0] & /*videoBehindSlidingWidget*/
    4194304 | t.$$.dirty[1] & /*widgetWidth, widgetMargin*/
    12582912 | t.$$.dirty[2] & /*marginWidth*/
    2 && i(25, O = S ? `width: ${Ge}; --margin: ${Me}; --margin-width: ${v}` : ""), t.$$.dirty[0] & /*currentTime*/
    2 | t.$$.dirty[1] & /*introOrOutro, activeAdvert, segments, contentVariant*/
    537100288 | t.$$.dirty[2] & /*atTheStart*/
    1 && i(59, p = x || X || D ? -1 : Vl(s, L, q)), t.$$.dirty[1] & /*segmentIndex*/
    268435456 && wt(), t.$$.dirty[0] & /*videoBehindSlidingWidget*/
    4194304 && S && xe(), t.$$.dirty[0] & /*sources, vastUrl*/
    3145728 | t.$$.dirty[1] & /*mediaObject*/
    1073741824 && r && u.length === 0 && !c && Bt();
  }, [
    w,
    L,
    Ce,
    R,
    Ve,
    C,
    ae,
    $,
    ee,
    ue,
    Ae,
    ce,
    ye,
    re,
    b,
    Qe,
    he,
    Te,
    Ee,
    Oe,
    u,
    c,
    S,
    l,
    ft,
    O,
    P,
    k,
    A,
    f,
    g,
    Nt,
    yt,
    et,
    lt,
    ot,
    Pt,
    Xe,
    Ot,
    vt,
    Vt,
    tt,
    bt,
    Je,
    Le,
    Z,
    q,
    x,
    X,
    oe,
    j,
    ze,
    Re,
    Ge,
    Me,
    nt,
    Lt,
    qe,
    De,
    p,
    s,
    r,
    D,
    v,
    T,
    _,
    a,
    o,
    n,
    rt,
    pt,
    st,
    it,
    He,
    ht,
    Tt
  ];
}
class zm extends we {
  constructor(e) {
    super(), Pe(
      this,
      e,
      Em,
      Mm,
      pe,
      {
        content: 5,
        contentIndex: 45,
        contentVariant: 46,
        introOrOutro: 47,
        activeAdvert: 48,
        preloadAdvert: 49,
        advertConsent: 6,
        maxImageSize: 7,
        projectId: 8,
        playlistId: 9,
        contentId: 10,
        contentLanguage: 11,
        platform: 12,
        vendorIdentifier: 13,
        bundleIdentifier: 14,
        playbackState: 0,
        duration: 3,
        currentTime: 1,
        playbackRate: 4,
        prevPercentage: 44,
        showUserInterface: 15,
        videoBehindWidget: 50,
        videoBehindStatic: 16,
        videoMightBeShown: 51,
        widgetPosition: 52,
        widgetWidth: 53,
        widgetMargin: 54,
        widgetTarget: 55,
        onEvent: 17,
        metadataLoaded: 43,
        video: 2
      },
      null,
      [-1, -1, -1]
    );
  }
  get content() {
    return this.$$.ctx[5];
  }
  set content(e) {
    this.$$set({ content: e }), d();
  }
  get contentIndex() {
    return this.$$.ctx[45];
  }
  set contentIndex(e) {
    this.$$set({ contentIndex: e }), d();
  }
  get contentVariant() {
    return this.$$.ctx[46];
  }
  set contentVariant(e) {
    this.$$set({ contentVariant: e }), d();
  }
  get introOrOutro() {
    return this.$$.ctx[47];
  }
  set introOrOutro(e) {
    this.$$set({ introOrOutro: e }), d();
  }
  get activeAdvert() {
    return this.$$.ctx[48];
  }
  set activeAdvert(e) {
    this.$$set({ activeAdvert: e }), d();
  }
  get preloadAdvert() {
    return this.$$.ctx[49];
  }
  set preloadAdvert(e) {
    this.$$set({ preloadAdvert: e }), d();
  }
  get advertConsent() {
    return this.$$.ctx[6];
  }
  set advertConsent(e) {
    this.$$set({ advertConsent: e }), d();
  }
  get maxImageSize() {
    return this.$$.ctx[7];
  }
  set maxImageSize(e) {
    this.$$set({ maxImageSize: e }), d();
  }
  get projectId() {
    return this.$$.ctx[8];
  }
  set projectId(e) {
    this.$$set({ projectId: e }), d();
  }
  get playlistId() {
    return this.$$.ctx[9];
  }
  set playlistId(e) {
    this.$$set({ playlistId: e }), d();
  }
  get contentId() {
    return this.$$.ctx[10];
  }
  set contentId(e) {
    this.$$set({ contentId: e }), d();
  }
  get contentLanguage() {
    return this.$$.ctx[11];
  }
  set contentLanguage(e) {
    this.$$set({ contentLanguage: e }), d();
  }
  get platform() {
    return this.$$.ctx[12];
  }
  set platform(e) {
    this.$$set({ platform: e }), d();
  }
  get vendorIdentifier() {
    return this.$$.ctx[13];
  }
  set vendorIdentifier(e) {
    this.$$set({ vendorIdentifier: e }), d();
  }
  get bundleIdentifier() {
    return this.$$.ctx[14];
  }
  set bundleIdentifier(e) {
    this.$$set({ bundleIdentifier: e }), d();
  }
  get playbackState() {
    return this.$$.ctx[0];
  }
  set playbackState(e) {
    this.$$set({ playbackState: e }), d();
  }
  get duration() {
    return this.$$.ctx[3];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get currentTime() {
    return this.$$.ctx[1];
  }
  set currentTime(e) {
    this.$$set({ currentTime: e }), d();
  }
  get playbackRate() {
    return this.$$.ctx[4];
  }
  set playbackRate(e) {
    this.$$set({ playbackRate: e }), d();
  }
  get prevPercentage() {
    return this.$$.ctx[44];
  }
  set prevPercentage(e) {
    this.$$set({ prevPercentage: e }), d();
  }
  get showUserInterface() {
    return this.$$.ctx[15];
  }
  set showUserInterface(e) {
    this.$$set({ showUserInterface: e }), d();
  }
  get videoBehindWidget() {
    return this.$$.ctx[50];
  }
  set videoBehindWidget(e) {
    this.$$set({ videoBehindWidget: e }), d();
  }
  get videoBehindStatic() {
    return this.$$.ctx[16];
  }
  set videoBehindStatic(e) {
    this.$$set({ videoBehindStatic: e }), d();
  }
  get videoMightBeShown() {
    return this.$$.ctx[51];
  }
  set videoMightBeShown(e) {
    this.$$set({ videoMightBeShown: e }), d();
  }
  get widgetPosition() {
    return this.$$.ctx[52];
  }
  set widgetPosition(e) {
    this.$$set({ widgetPosition: e }), d();
  }
  get widgetWidth() {
    return this.$$.ctx[53];
  }
  set widgetWidth(e) {
    this.$$set({ widgetWidth: e }), d();
  }
  get widgetMargin() {
    return this.$$.ctx[54];
  }
  set widgetMargin(e) {
    this.$$set({ widgetMargin: e }), d();
  }
  get widgetTarget() {
    return this.$$.ctx[55];
  }
  set widgetTarget(e) {
    this.$$set({ widgetTarget: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[17];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
  get metadataLoaded() {
    return this.$$.ctx[43];
  }
  set metadataLoaded(e) {
    this.$$set({ metadataLoaded: e }), d();
  }
  get video() {
    return this.$$.ctx[2];
  }
  set video(e) {
    this.$$set({ video: e }), d();
  }
}
function Lm(t) {
  const e = t - 1;
  return e * e * e + 1;
}
function jm(t, { delay: e = 0, duration: i = 400, easing: n = Lm, x: o = 0, y: s = 0, opacity: l = 0 } = {}) {
  const a = getComputedStyle(t), r = +a.opacity, u = a.transform === "none" ? "" : a.transform, c = r * (1 - l), [g, f] = Nl(o), [A, _] = Nl(s);
  return {
    delay: e,
    duration: i,
    easing: n,
    css: (k, S) => `
			transform: ${u} translate(${(1 - k) * g}${f}, ${(1 - k) * A}${_});
			opacity: ${r - c * S}`
  };
}
var Wr = function() {
  if (typeof Map != "undefined")
    return Map;
  function t(e, i) {
    var n = -1;
    return e.some(function(o, s) {
      return o[0] === i ? (n = s, !0) : !1;
    }), n;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(i) {
        var n = t(this.__entries__, i), o = this.__entries__[n];
        return o && o[1];
      }, e.prototype.set = function(i, n) {
        var o = t(this.__entries__, i);
        ~o ? this.__entries__[o][1] = n : this.__entries__.push([i, n]);
      }, e.prototype.delete = function(i) {
        var n = this.__entries__, o = t(n, i);
        ~o && n.splice(o, 1);
      }, e.prototype.has = function(i) {
        return !!~t(this.__entries__, i);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(i, n) {
        n === void 0 && (n = null);
        for (var o = 0, s = this.__entries__; o < s.length; o++) {
          var l = s[o];
          i.call(n, l[1], l[0]);
        }
      }, e;
    }()
  );
}(), gl = typeof window != "undefined" && typeof document != "undefined" && window.document === document, cs = function() {
  return typeof global != "undefined" && global.Math === Math ? global : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
}(), Dm = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(cs) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), xm = 2;
function Nm(t, e) {
  var i = !1, n = !1, o = 0;
  function s() {
    i && (i = !1, t()), n && a();
  }
  function l() {
    Dm(s);
  }
  function a() {
    var r = Date.now();
    if (i) {
      if (r - o < xm)
        return;
      n = !0;
    } else
      i = !0, n = !1, setTimeout(l, e);
    o = r;
  }
  return a;
}
var Rm = 20, Fm = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Um = typeof MutationObserver != "undefined", Hm = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Nm(this.refresh.bind(this), Rm);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var i = this.observers_, n = i.indexOf(e);
      ~n && i.splice(n, 1), !i.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(i) {
        return i.gatherActive(), i.hasActive();
      });
      return e.forEach(function(i) {
        return i.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !gl || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Um ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !gl || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var i = e.propertyName, n = i === void 0 ? "" : i, o = Fm.some(function(s) {
        return !!~n.indexOf(s);
      });
      o && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), Mr = function(t, e) {
  for (var i = 0, n = Object.keys(e); i < n.length; i++) {
    var o = n[i];
    Object.defineProperty(t, o, {
      value: e[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, Jn = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || cs;
}, Er = Ds(0, 0, 0, 0);
function ds(t) {
  return parseFloat(t) || 0;
}
function aa(t) {
  for (var e = [], i = 1; i < arguments.length; i++)
    e[i - 1] = arguments[i];
  return e.reduce(function(n, o) {
    var s = t["border-" + o + "-width"];
    return n + ds(s);
  }, 0);
}
function qm(t) {
  for (var e = ["top", "right", "bottom", "left"], i = {}, n = 0, o = e; n < o.length; n++) {
    var s = o[n], l = t["padding-" + s];
    i[s] = ds(l);
  }
  return i;
}
function Ym(t) {
  var e = t.getBBox();
  return Ds(0, 0, e.width, e.height);
}
function Zm(t) {
  var e = t.clientWidth, i = t.clientHeight;
  if (!e && !i)
    return Er;
  var n = Jn(t).getComputedStyle(t), o = qm(n), s = o.left + o.right, l = o.top + o.bottom, a = ds(n.width), r = ds(n.height);
  if (n.boxSizing === "border-box" && (Math.round(a + s) !== e && (a -= aa(n, "left", "right") + s), Math.round(r + l) !== i && (r -= aa(n, "top", "bottom") + l)), !Gm(t)) {
    var u = Math.round(a + s) - e, c = Math.round(r + l) - i;
    Math.abs(u) !== 1 && (a -= u), Math.abs(c) !== 1 && (r -= c);
  }
  return Ds(o.left, o.top, a, r);
}
var Km = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement != "undefined" ? function(t) {
    return t instanceof Jn(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof Jn(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function Gm(t) {
  return t === Jn(t).document.documentElement;
}
function Jm(t) {
  return gl ? Km(t) ? Ym(t) : Zm(t) : Er;
}
function Xm(t) {
  var e = t.x, i = t.y, n = t.width, o = t.height, s = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, l = Object.create(s.prototype);
  return Mr(l, {
    x: e,
    y: i,
    width: n,
    height: o,
    top: i,
    right: e + n,
    bottom: o + i,
    left: e
  }), l;
}
function Ds(t, e, i, n) {
  return { x: t, y: e, width: i, height: n };
}
var Qm = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Ds(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = Jm(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), $m = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, i) {
      var n = Xm(i);
      Mr(this, { target: e, contentRect: n });
    }
    return t;
  }()
), eh = (
  /** @class */
  function() {
    function t(e, i, n) {
      if (this.activeObservations_ = [], this.observations_ = new Wr(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = i, this.callbackCtx_ = n;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(e instanceof Jn(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var i = this.observations_;
        i.has(e) || (i.set(e, new Qm(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(e instanceof Jn(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var i = this.observations_;
        i.has(e) && (i.delete(e), i.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(i) {
        i.isActive() && e.activeObservations_.push(i);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, i = this.activeObservations_.map(function(n) {
          return new $m(n.target, n.broadcastRect());
        });
        this.callback_.call(e, i, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), zr = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new Wr(), Lr = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var i = Hm.getInstance(), n = new eh(e, i, this);
      zr.set(this, n);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  Lr.prototype[t] = function() {
    var e;
    return (e = zr.get(this))[t].apply(e, arguments);
  };
});
var th = function() {
  return typeof cs.ResizeObserver != "undefined" ? cs.ResizeObserver : Lr;
}();
const Ui = (t, e, i) => Ie(t, e, e === "style" ? nh(i) : i), ih = /;(?!([^()]*\([^()]*\))*[^()]*\))/, nh = (t) => t.split(ih).filter((e) => e).map((e) => e + " !important").join(";");
function oh(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Ui(
        i,
        "fill",
        /*color*/
        t[1]
      ), Ui(i, "d", "M14 0.666748C6.63996 0.666748 0.666626 6.64008 0.666626 14.0001C0.666626 21.3601 6.63996 27.3334 14 27.3334C21.36 27.3334 27.3333 21.3601 27.3333 14.0001C27.3333 6.64008 21.36 0.666748 14 0.666748ZM11.3333 18.6667V9.33341C11.3333 8.78675 11.96 8.46675 12.4 8.80008L18.6266 13.4667C18.9866 13.7334 18.9866 14.2667 18.6266 14.5334L12.4 19.2001C11.96 19.5334 11.3333 19.2134 11.3333 18.6667Z"), Ui(e, "width", n = 40 * /*scale*/
      t[0]), Ui(e, "height", o = 40 * /*scale*/
      t[0]), Ui(e, "viewBox", "0.6667 0.6667 26.6667 26.6667"), Ui(e, "fill", "none"), Ui(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && Ui(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 40 * /*scale*/
      s[0]) && Ui(e, "width", n), l & /*scale*/
      1 && o !== (o = 40 * /*scale*/
      s[0]) && Ui(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function sh(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class lh extends we {
  constructor(e) {
    super(), Pe(this, e, sh, oh, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Hi = (t, e, i) => Ie(t, e, e === "style" ? rh(i) : i), ah = /;(?!([^()]*\([^()]*\))*[^()]*\))/, rh = (t) => t.split(ah).filter((e) => e).map((e) => e + " !important").join(";");
function uh(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Hi(
        i,
        "fill",
        /*color*/
        t[1]
      ), Hi(i, "d", "M14 0.666748C6.63996 0.666748 0.666626 6.64008 0.666626 14.0001C0.666626 21.3601 6.63996 27.3334 14 27.3334C21.36 27.3334 27.3333 21.3601 27.3333 14.0001C27.3333 6.64008 21.36 0.666748 14 0.666748ZM11.3333 19.3334C10.6 19.3334 9.99996 18.7334 9.99996 18.0001V10.0001C9.99996 9.26675 10.6 8.66675 11.3333 8.66675C12.0666 8.66675 12.6666 9.26675 12.6666 10.0001V18.0001C12.6666 18.7334 12.0666 19.3334 11.3333 19.3334ZM16.6666 19.3334C15.9333 19.3334 15.3333 18.7334 15.3333 18.0001V10.0001C15.3333 9.26675 15.9333 8.66675 16.6666 8.66675C17.4 8.66675 18 9.26675 18 10.0001V18.0001C18 18.7334 17.4 19.3334 16.6666 19.3334Z"), Hi(e, "width", n = 40 * /*scale*/
      t[0]), Hi(e, "height", o = 40 * /*scale*/
      t[0]), Hi(e, "viewBox", "0.6667 0.6667 26.6667 26.6667"), Hi(e, "fill", "none"), Hi(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && Hi(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 40 * /*scale*/
      s[0]) && Hi(e, "width", n), l & /*scale*/
      1 && o !== (o = 40 * /*scale*/
      s[0]) && Hi(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function ch(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class dh extends we {
  constructor(e) {
    super(), Pe(this, e, ch, uh, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const ra = (t, e, i) => Zt(t, e, i, 1), xn = (t, e, i) => Ie(t, e, e === "style" ? fh(i) : i), gh = /;(?!([^()]*\([^()]*\))*[^()]*\))/, fh = (t) => t.split(gh).filter((e) => e).map((e) => e + " !important").join(";");
function mh(t) {
  let e, i;
  return e = new lh({
    props: {
      scale: (
        /*scale*/
        t[2]
      ),
      color: (
        /*color*/
        t[3]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      4 && (s.scale = /*scale*/
      n[2]), o & /*color*/
      8 && (s.color = /*color*/
      n[3]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function hh(t) {
  let e, i;
  return e = new dh({
    props: {
      scale: (
        /*scale*/
        t[2]
      ),
      color: (
        /*color*/
        t[3]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      4 && (s.scale = /*scale*/
      n[2]), o & /*color*/
      8 && (s.color = /*color*/
      n[3]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function _h(t) {
  let e, i, n, o, s, l;
  const a = [hh, mh], r = [];
  function u(c, g) {
    return (
      /*isPlaying*/
      c[0] ? 0 : 1
    );
  }
  return i = u(t), n = r[i] = a[i](t), {
    c() {
      e = y("button"), n.c(), xn(e, "type", "button"), xn(e, "class", "play-pause-button svelte-1dxzkq6"), xn(
        e,
        "tabindex",
        /*tabindex*/
        t[1]
      ), ra(e, "outline-offset", 3.2 * /*scale*/
      t[2] + "px"), xn(
        e,
        "aria-label",
        /*ariaLabel*/
        t[4]
      );
    },
    m(c, g) {
      E(c, e, g), r[i].m(e, null), o = !0, s || (l = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[5]
        ),
        Y(e, "mouseup", ai)
      ], s = !0);
    },
    p(c, [g]) {
      let f = i;
      i = u(c), i === f ? r[i].p(c, g) : (Fe(), z(r[f], 1, 1, () => {
        r[f] = null;
      }), Ue(), n = r[i], n ? n.p(c, g) : (n = r[i] = a[i](c), n.c()), V(n, 1), n.m(e, null)), (!o || g & /*tabindex*/
      2) && xn(
        e,
        "tabindex",
        /*tabindex*/
        c[1]
      ), (!o || g & /*scale*/
      4) && ra(e, "outline-offset", 3.2 * /*scale*/
      c[2] + "px"), (!o || g & /*ariaLabel*/
      16) && xn(
        e,
        "aria-label",
        /*ariaLabel*/
        c[4]
      );
    },
    i(c) {
      o || (V(n), o = !0);
    },
    o(c) {
      z(n), o = !1;
    },
    d(c) {
      c && M(e), r[i].d(), s = !1, _t(l);
    }
  };
}
function Ah(t, e, i) {
  let n, { isPlaying: o = !1 } = e, { tabindex: s = 0 } = e, { scale: l = 1 } = e, { color: a = "#323232" } = e, { onEvent: r = () => {
  } } = e;
  const u = (c) => {
    c.preventDefault();
    const g = o ? "Pause" : "Play";
    r(ke({
      type: `Pressed${g}`,
      description: `The ${g.toLowerCase()} button was pressed.`,
      initiatedBy: "user"
    }));
  };
  return t.$$set = (c) => {
    "isPlaying" in c && i(0, o = c.isPlaying), "tabindex" in c && i(1, s = c.tabindex), "scale" in c && i(2, l = c.scale), "color" in c && i(3, a = c.color), "onEvent" in c && i(6, r = c.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*isPlaying*/
    1 && i(4, n = gt(o ? "pauseAudio" : "playAudio"));
  }, [o, s, l, a, n, u, r];
}
class yh extends we {
  constructor(e) {
    super(), Pe(this, e, Ah, _h, pe, {
      isPlaying: 0,
      tabindex: 1,
      scale: 2,
      color: 3,
      onEvent: 6
    });
  }
  get isPlaying() {
    return this.$$.ctx[0];
  }
  set isPlaying(e) {
    this.$$set({ isPlaying: e }), d();
  }
  get tabindex() {
    return this.$$.ctx[1];
  }
  set tabindex(e) {
    this.$$set({ tabindex: e }), d();
  }
  get scale() {
    return this.$$.ctx[2];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[3];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[6];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const vn = (t, e, i) => Zt(t, e, i, 1), mi = (t, e, i) => Ie(t, e, e === "style" ? bh(i) : i), vh = /;(?!([^()]*\([^()]*\))*[^()]*\))/, bh = (t) => t.split(vh).filter((e) => e).map((e) => e + " !important").join(";");
function kh(t) {
  let e, i, n, o, s, l, a;
  return {
    c() {
      e = y("div"), i = y("span"), n = ie(
        /*rate*/
        t[0]
      ), o = ie("x"), vn(
        i,
        "font-size",
        /*fontSize*/
        t[4]
      ), vn(
        i,
        "color",
        /*color*/
        t[1]
      ), mi(i, "class", "svelte-a8vvsg"), mi(e, "type", "button"), mi(e, "tabindex", "0"), mi(e, "role", "spinbutton"), mi(e, "class", "playback-rate-button svelte-a8vvsg"), vn(
        e,
        "width",
        /*size*/
        t[5]
      ), vn(
        e,
        "height",
        /*size*/
        t[5]
      ), mi(e, "aria-label", gt("changePlaybackRate")), mi(e, "aria-valuetext", s = `${/*rate*/
      t[0]}x`), mi(
        e,
        "aria-valuenow",
        /*rate*/
        t[0]
      ), mi(
        e,
        "aria-valuemin",
        /*minRate*/
        t[3]
      ), mi(
        e,
        "aria-valuemax",
        /*maxRate*/
        t[2]
      );
    },
    m(r, u) {
      E(r, e, u), h(e, i), h(i, n), h(i, o), l || (a = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[6]
        ),
        Y(e, "mouseup", ai),
        Y(
          e,
          "keydown",
          /*handleKeyDown*/
          t[7]
        )
      ], l = !0);
    },
    p(r, [u]) {
      u & /*rate*/
      1 && bi(
        n,
        /*rate*/
        r[0]
      ), u & /*fontSize*/
      16 && vn(
        i,
        "font-size",
        /*fontSize*/
        r[4]
      ), u & /*color*/
      2 && vn(
        i,
        "color",
        /*color*/
        r[1]
      ), u & /*size*/
      32 && vn(
        e,
        "width",
        /*size*/
        r[5]
      ), u & /*size*/
      32 && vn(
        e,
        "height",
        /*size*/
        r[5]
      ), u & /*rate*/
      1 && s !== (s = `${/*rate*/
      r[0]}x`) && mi(e, "aria-valuetext", s), u & /*rate*/
      1 && mi(
        e,
        "aria-valuenow",
        /*rate*/
        r[0]
      ), u & /*minRate*/
      8 && mi(
        e,
        "aria-valuemin",
        /*minRate*/
        r[3]
      ), u & /*maxRate*/
      4 && mi(
        e,
        "aria-valuemax",
        /*maxRate*/
        r[2]
      );
    },
    i: Q,
    o: Q,
    d(r) {
      r && M(e), l = !1, _t(a);
    }
  };
}
function ph(t, e, i) {
  let n, o, s, l, { rates: a = [] } = e, { rate: r = 1 } = e, { scale: u = 1 } = e, { color: c = "#323232" } = e, { onEvent: g = () => {
  } } = e;
  const f = () => {
    g(ke({
      type: "PressedChangeRate",
      description: "The change playback rate button was pressed.",
      initiatedBy: "user"
    }));
  }, A = (_) => {
    let k;
    _.key === "ArrowLeft" && (k = "Left"), _.key === "ArrowRight" && (k = "Right"), _.key === "ArrowDown" && (k = "Down"), _.key === "ArrowUp" && (k = "Up"), _.key === " " && (k = "Space"), _.key === "Enter" && (k = "Enter"), k && (_.preventDefault(), g(ke({
      type: `Pressed${k}OnChangeRate`,
      description: `The ${k.toLowerCase()} key was pressed while change playback rate was focussed.`,
      initiatedBy: "user"
    })));
  };
  return t.$$set = (_) => {
    "rates" in _ && i(8, a = _.rates), "rate" in _ && i(0, r = _.rate), "scale" in _ && i(9, u = _.scale), "color" in _ && i(1, c = _.color), "onEvent" in _ && i(10, g = _.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*scale*/
    512 && i(5, n = `${40 * u}px`), t.$$.dirty & /*scale*/
    512 && i(4, o = `${12 * u}px`), t.$$.dirty & /*rates*/
    256 && i(3, s = a.length === 0 ? 0 : Math.min(...a)), t.$$.dirty & /*rates*/
    256 && i(2, l = a.length === 0 ? 1 : Math.max(...a));
  }, [
    r,
    c,
    l,
    s,
    o,
    n,
    f,
    A,
    a,
    u,
    g
  ];
}
class Sh extends we {
  constructor(e) {
    super(), Pe(this, e, ph, kh, pe, {
      rates: 8,
      rate: 0,
      scale: 9,
      color: 1,
      onEvent: 10
    });
  }
  get rates() {
    return this.$$.ctx[8];
  }
  set rates(e) {
    this.$$set({ rates: e }), d();
  }
  get rate() {
    return this.$$.ctx[0];
  }
  set rate(e) {
    this.$$set({ rate: e }), d();
  }
  get scale() {
    return this.$$.ctx[9];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[10];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Xt = (t, e, i) => Ie(t, e, e === "style" ? wh(i) : i), Ph = /;(?!([^()]*\([^()]*\))*[^()]*\))/, wh = (t) => t.split(Ph).filter((e) => e).map((e) => e + " !important").join(";");
function Th(t) {
  let e, i, n, o, s, l;
  return {
    c() {
      e = Se("svg"), i = Se("path"), n = Se("text"), o = ie(
        /*seconds*/
        t[2]
      ), Xt(
        i,
        "fill",
        /*color*/
        t[1]
      ), Xt(i, "d", "M12.3035 28.3333C9.12574 28.3333 6.39796 27.2778 4.12019 25.1667C1.84241 23.0556 0.581297 20.4444 0.336852 17.3333C0.31463 17.0667 0.397963 16.8333 0.586852 16.6333C0.775741 16.4333 1.01463 16.3333 1.30352 16.3333C1.57019 16.3333 1.79796 16.4278 1.98685 16.6167C2.17574 16.8056 2.29241 17.0444 2.33685 17.3333C2.5813 19.8889 3.64796 22.0278 5.53685 23.75C7.42574 25.4722 9.6813 26.3333 12.3035 26.3333C15.0813 26.3333 17.4424 25.3611 19.3869 23.4167C21.3313 21.4722 22.3035 19.1111 22.3035 16.3333C22.3035 13.5556 21.3591 11.1944 19.4702 9.25C17.5813 7.30555 15.248 6.33333 12.4702 6.33333H11.7369L13.4702 8.06666C13.6702 8.26666 13.7702 8.5 13.7702 8.76666C13.7702 9.03333 13.6702 9.26666 13.4702 9.46666C13.2702 9.66666 13.0369 9.76666 12.7702 9.76666C12.5035 9.76666 12.2702 9.66666 12.0702 9.46666L8.57019 5.96666C8.45907 5.85555 8.3813 5.74444 8.33685 5.63333C8.29241 5.52222 8.27019 5.4 8.27019 5.26666C8.27019 5.13333 8.29241 5.01111 8.33685 4.9C8.3813 4.78889 8.45907 4.67777 8.57019 4.56666L12.1035 1.03333C12.2813 0.855551 12.5035 0.766663 12.7702 0.766663C13.0369 0.766663 13.2702 0.855551 13.4702 1.03333C13.648 1.23333 13.7369 1.46666 13.7369 1.73333C13.7369 2 13.648 2.22222 13.4702 2.4L11.5369 4.33333H12.3035C13.9702 4.33333 15.5313 4.64444 16.9869 5.26666C18.4424 5.88889 19.7146 6.74444 20.8035 7.83333C21.8924 8.92222 22.748 10.1944 23.3702 11.65C23.9924 13.1056 24.3035 14.6667 24.3035 16.3333C24.3035 18 23.9924 19.5611 23.3702 21.0167C22.748 22.4722 21.8924 23.7444 20.8035 24.8333C19.7146 25.9222 18.4424 26.7778 16.9869 27.4C15.5313 28.0222 13.9702 28.3333 12.3035 28.3333Z"), Xt(
        n,
        "fill",
        /*color*/
        t[1]
      ), Xt(n, "x", "36%"), Xt(n, "y", "46%"), Xt(n, "dominant-baseline", "middle"), Xt(n, "text-anchor", "middle"), Xt(n, "class", "svelte-1xysf6z"), Xt(e, "width", s = 40 * /*scale*/
      t[0]), Xt(e, "height", l = 40 * /*scale*/
      t[0]), Xt(e, "viewBox", "-5 -5 35 39"), Xt(e, "fill", "none"), Xt(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(a, r) {
      E(a, e, r), h(e, i), h(e, n), h(n, o);
    },
    p(a, [r]) {
      r & /*color*/
      2 && Xt(
        i,
        "fill",
        /*color*/
        a[1]
      ), r & /*seconds*/
      4 && bi(
        o,
        /*seconds*/
        a[2]
      ), r & /*color*/
      2 && Xt(
        n,
        "fill",
        /*color*/
        a[1]
      ), r & /*scale*/
      1 && s !== (s = 40 * /*scale*/
      a[0]) && Xt(e, "width", s), r & /*scale*/
      1 && l !== (l = 40 * /*scale*/
      a[0]) && Xt(e, "height", l);
    },
    i: Q,
    o: Q,
    d(a) {
      a && M(e);
    }
  };
}
function Ch(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e, { seconds: s = 10 } = e;
  return t.$$set = (l) => {
    "scale" in l && i(0, n = l.scale), "color" in l && i(1, o = l.color), "seconds" in l && i(2, s = l.seconds);
  }, [n, o, s];
}
class Ih extends we {
  constructor(e) {
    super(), Pe(this, e, Ch, Th, pe, { scale: 0, color: 1, seconds: 2 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get seconds() {
    return this.$$.ctx[2];
  }
  set seconds(e) {
    this.$$set({ seconds: e }), d();
  }
}
const qi = (t, e, i) => Ie(t, e, e === "style" ? Vh(i) : i), Oh = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Vh = (t) => t.split(Oh).filter((e) => e).map((e) => e + " !important").join(";");
function Bh(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), qi(
        i,
        "fill",
        /*color*/
        t[1]
      ), qi(i, "d", "M1.25 7.29901C0.249999 6.72166 0.250001 5.27828 1.25 4.70093L8.75 0.370802C9.75 -0.206548 11 0.51514 11 1.66984V10.3301C11 11.4848 9.75 12.2065 8.75 11.6291L1.25 7.29901Z"), qi(e, "width", n = 40 * /*scale*/
      t[0]), qi(e, "height", o = 40 * /*scale*/
      t[0]), qi(e, "viewBox", "-12 -12 35 36"), qi(e, "fill", "none"), qi(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && qi(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 40 * /*scale*/
      s[0]) && qi(e, "width", n), l & /*scale*/
      1 && o !== (o = 40 * /*scale*/
      s[0]) && qi(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function Wh(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class Mh extends we {
  constructor(e) {
    super(), Pe(this, e, Wh, Bh, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const pi = (t, e, i) => Ie(t, e, e === "style" ? zh(i) : i), Eh = /;(?!([^()]*\([^()]*\))*[^()]*\))/, zh = (t) => t.split(Eh).filter((e) => e).map((e) => e + " !important").join(";");
function Lh(t) {
  let e, i, n, o, s;
  return {
    c() {
      e = Se("svg"), i = Se("path"), n = Se("path"), pi(
        i,
        "fill",
        /*color*/
        t[1]
      ), pi(i, "d", "M0 1C0 0.447716 0.447715 0 1 0C1.55228 0 2 0.447715 2 1V13C2 13.5523 1.55228 14 1 14C0.447715 14 0 13.5523 0 13V1Z"), pi(
        n,
        "fill",
        /*color*/
        t[1]
      ), pi(n, "d", "M7.25 8.29904C6.25 7.72169 6.25 6.27831 7.25 5.70096L14.75 1.37083C15.75 0.793484 17 1.51517 17 2.66987V11.3301C17 12.4848 15.75 13.2065 14.75 12.6292L7.25 8.29904Z"), pi(e, "width", o = 40 * /*scale*/
      t[0]), pi(e, "height", s = 40 * /*scale*/
      t[0]), pi(e, "viewBox", "-10 -10 37 34"), pi(e, "fill", "none"), pi(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(l, a) {
      E(l, e, a), h(e, i), h(e, n);
    },
    p(l, [a]) {
      a & /*color*/
      2 && pi(
        i,
        "fill",
        /*color*/
        l[1]
      ), a & /*color*/
      2 && pi(
        n,
        "fill",
        /*color*/
        l[1]
      ), a & /*scale*/
      1 && o !== (o = 40 * /*scale*/
      l[0]) && pi(e, "width", o), a & /*scale*/
      1 && s !== (s = 40 * /*scale*/
      l[0]) && pi(e, "height", s);
    },
    i: Q,
    o: Q,
    d(l) {
      l && M(e);
    }
  };
}
function jh(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class Dh extends we {
  constructor(e) {
    super(), Pe(this, e, jh, Lh, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Yo = (t, e, i) => Ie(t, e, e === "style" ? Nh(i) : i), xh = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Nh = (t) => t.split(xh).filter((e) => e).map((e) => e + " !important").join(";");
function Rh(t) {
  let e, i;
  return e = new Dh({
    props: {
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      1 && (s.scale = /*scale*/
      n[0]), o & /*color*/
      2 && (s.color = /*color*/
      n[1]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Fh(t) {
  let e, i;
  return e = new Mh({
    props: {
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      1 && (s.scale = /*scale*/
      n[0]), o & /*color*/
      2 && (s.color = /*color*/
      n[1]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Uh(t) {
  let e, i;
  return e = new Ih({
    props: {
      seconds: (
        /*backwardsSeconds*/
        t[6]
      ),
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*backwardsSeconds*/
      64 && (s.seconds = /*backwardsSeconds*/
      n[6]), o & /*scale*/
      1 && (s.scale = /*scale*/
      n[0]), o & /*color*/
      2 && (s.color = /*color*/
      n[1]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Hh(t) {
  let e, i, n, o, s, l;
  const a = [Uh, Fh, Rh], r = [];
  function u(c, g) {
    return (
      /*isSeconds*/
      c[3] ? 0 : (
        /*isSegments*/
        c[4] ? 1 : (
          /*isTracks*/
          c[2] ? 2 : -1
        )
      )
    );
  }
  return ~(i = u(t)) && (n = r[i] = a[i](t)), {
    c() {
      e = y("button"), n && n.c(), Yo(e, "type", "button"), Yo(e, "class", "prev-button svelte-tawm7k"), Yo(
        e,
        "aria-label",
        /*ariaLabel*/
        t[5]
      );
    },
    m(c, g) {
      E(c, e, g), ~i && r[i].m(e, null), o = !0, s || (l = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[7]
        ),
        Y(e, "mouseup", ai)
      ], s = !0);
    },
    p(c, [g]) {
      let f = i;
      i = u(c), i === f ? ~i && r[i].p(c, g) : (n && (Fe(), z(r[f], 1, 1, () => {
        r[f] = null;
      }), Ue()), ~i ? (n = r[i], n ? n.p(c, g) : (n = r[i] = a[i](c), n.c()), V(n, 1), n.m(e, null)) : n = null), (!o || g & /*ariaLabel*/
      32) && Yo(
        e,
        "aria-label",
        /*ariaLabel*/
        c[5]
      );
    },
    i(c) {
      o || (V(n), o = !0);
    },
    o(c) {
      z(n), o = !1;
    },
    d(c) {
      c && M(e), ~i && r[i].d(), s = !1, _t(l);
    }
  };
}
function qh(t, e, i) {
  let n, o, s, l, { style: a = "segments" } = e, { scale: r = 1 } = e, { color: u = "#323232" } = e, { onEvent: c = () => {
  } } = e, g;
  const f = () => {
    let A, _, k;
    o ? (A = "PressedPrevSegment", _ = "The previous segment button was pressed.") : s ? (A = "PressedSeekBack", _ = "The seek backward button was pressed.", k = { seconds: n }) : l && (A = "PressedPrevTrack", _ = "The previous track button was pressed."), c(ke(Jt({
      type: A,
      description: _,
      initiatedBy: "user"
    }, k)));
  };
  return t.$$set = (A) => {
    "style" in A && i(8, a = A.style), "scale" in A && i(0, r = A.scale), "color" in A && i(1, u = A.color), "onEvent" in A && i(9, c = A.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*style*/
    256 && i(6, n = a.split("-")[1] || 10), t.$$.dirty & /*style*/
    256 && i(4, o = a === "segments"), t.$$.dirty & /*style*/
    256 && i(3, s = a.startsWith("seconds")), t.$$.dirty & /*style*/
    256 && i(2, l = a === "tracks"), t.$$.dirty & /*isSeconds, isSegments, isTracks*/
    28 && (s ? i(5, g = gt("seekBack")) : o ? i(5, g = gt("previousSegment")) : l && i(5, g = gt("previousTrack")));
  }, [
    r,
    u,
    l,
    s,
    o,
    g,
    n,
    f,
    a,
    c
  ];
}
class Yh extends we {
  constructor(e) {
    super(), Pe(this, e, qh, Hh, pe, { style: 8, scale: 0, color: 1, onEvent: 9 });
  }
  get style() {
    return this.$$.ctx[8];
  }
  set style(e) {
    this.$$set({ style: e }), d();
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[9];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Qt = (t, e, i) => Ie(t, e, e === "style" ? Kh(i) : i), Zh = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Kh = (t) => t.split(Zh).filter((e) => e).map((e) => e + " !important").join(";");
function Gh(t) {
  let e, i, n, o, s, l;
  return {
    c() {
      e = Se("svg"), i = Se("path"), n = Se("text"), o = ie(
        /*seconds*/
        t[2]
      ), Qt(
        i,
        "fill",
        /*color*/
        t[1]
      ), Qt(i, "d", "M12.5 28.3333C10.8333 28.3333 9.27222 28.0167 7.81667 27.3833C6.36111 26.75 5.09444 25.8944 4.01667 24.8167C2.93889 23.7389 2.08333 22.4722 1.45 21.0167C0.816667 19.5611 0.5 18 0.5 16.3333C0.5 14.6667 0.816667 13.1056 1.45 11.65C2.08333 10.1944 2.93889 8.92777 4.01667 7.85C5.09444 6.77222 6.36111 5.91666 7.81667 5.28333C9.27222 4.65 10.8333 4.33333 12.5 4.33333H13.2667L11.3333 2.4C11.1556 2.22222 11.0722 1.99444 11.0833 1.71666C11.0944 1.43888 11.1889 1.21111 11.3667 1.03333C11.5444 0.855551 11.7722 0.766663 12.05 0.766663C12.3278 0.766663 12.5556 0.855551 12.7333 1.03333L16.2333 4.56666C16.4333 4.76666 16.5333 5 16.5333 5.26666C16.5333 5.53333 16.4333 5.76666 16.2333 5.96666L12.7333 9.46666C12.5333 9.66666 12.2944 9.76666 12.0167 9.76666C11.7389 9.76666 11.5111 9.66666 11.3333 9.46666C11.1333 9.26666 11.0389 9.03333 11.05 8.76666C11.0611 8.5 11.1667 8.26666 11.3667 8.06666L13.1 6.33333H12.3333C9.57778 6.33333 7.25 7.30555 5.35 9.25C3.45 11.1944 2.5 13.5556 2.5 16.3333C2.5 19.1111 3.47222 21.4722 5.41667 23.4167C7.36111 25.3611 9.72222 26.3333 12.5 26.3333C15.0778 26.3333 17.3222 25.4722 19.2333 23.75C21.1444 22.0278 22.2222 19.8889 22.4667 17.3333C22.5111 17.0444 22.6278 16.8056 22.8167 16.6167C23.0056 16.4278 23.2333 16.3333 23.5 16.3333C23.7889 16.3333 24.0278 16.4333 24.2167 16.6333C24.4056 16.8333 24.4889 17.0667 24.4667 17.3333C24.2222 20.4667 22.95 23.0833 20.65 25.1833C18.35 27.2833 15.6333 28.3333 12.5 28.3333Z"), Qt(
        n,
        "fill",
        /*color*/
        t[1]
      ), Qt(n, "x", "36%"), Qt(n, "y", "46%"), Qt(n, "dominant-baseline", "middle"), Qt(n, "text-anchor", "middle"), Qt(n, "class", "svelte-1xysf6z"), Qt(e, "width", s = 40 * /*scale*/
      t[0]), Qt(e, "height", l = 40 * /*scale*/
      t[0]), Qt(e, "viewBox", "-5 -5 35 39"), Qt(e, "fill", "none"), Qt(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(a, r) {
      E(a, e, r), h(e, i), h(e, n), h(n, o);
    },
    p(a, [r]) {
      r & /*color*/
      2 && Qt(
        i,
        "fill",
        /*color*/
        a[1]
      ), r & /*seconds*/
      4 && bi(
        o,
        /*seconds*/
        a[2]
      ), r & /*color*/
      2 && Qt(
        n,
        "fill",
        /*color*/
        a[1]
      ), r & /*scale*/
      1 && s !== (s = 40 * /*scale*/
      a[0]) && Qt(e, "width", s), r & /*scale*/
      1 && l !== (l = 40 * /*scale*/
      a[0]) && Qt(e, "height", l);
    },
    i: Q,
    o: Q,
    d(a) {
      a && M(e);
    }
  };
}
function Jh(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e, { seconds: s = 10 } = e;
  return t.$$set = (l) => {
    "scale" in l && i(0, n = l.scale), "color" in l && i(1, o = l.color), "seconds" in l && i(2, s = l.seconds);
  }, [n, o, s];
}
class Xh extends we {
  constructor(e) {
    super(), Pe(this, e, Jh, Gh, pe, { scale: 0, color: 1, seconds: 2 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get seconds() {
    return this.$$.ctx[2];
  }
  set seconds(e) {
    this.$$set({ seconds: e }), d();
  }
}
const Yi = (t, e, i) => Ie(t, e, e === "style" ? $h(i) : i), Qh = /;(?!([^()]*\([^()]*\))*[^()]*\))/, $h = (t) => t.split(Qh).filter((e) => e).map((e) => e + " !important").join(";");
function e0(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Yi(
        i,
        "fill",
        /*color*/
        t[1]
      ), Yi(i, "d", "M9.75 4.70093C10.75 5.27828 10.75 6.72166 9.75 7.29901L2.25 11.6291C1.25 12.2065 0 11.4848 0 10.3301V1.66984C0 0.515139 1.25 -0.206548 2.25 0.370802L9.75 4.70093Z"), Yi(e, "width", n = 40 * /*scale*/
      t[0]), Yi(e, "height", o = 40 * /*scale*/
      t[0]), Yi(e, "viewBox", "-12 -12 35 36"), Yi(e, "fill", "none"), Yi(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && Yi(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 40 * /*scale*/
      s[0]) && Yi(e, "width", n), l & /*scale*/
      1 && o !== (o = 40 * /*scale*/
      s[0]) && Yi(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function t0(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class i0 extends we {
  constructor(e) {
    super(), Pe(this, e, t0, e0, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Si = (t, e, i) => Ie(t, e, e === "style" ? o0(i) : i), n0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, o0 = (t) => t.split(n0).filter((e) => e).map((e) => e + " !important").join(";");
function s0(t) {
  let e, i, n, o, s;
  return {
    c() {
      e = Se("svg"), i = Se("path"), n = Se("path"), Si(
        i,
        "fill",
        /*color*/
        t[1]
      ), Si(i, "d", "M17 13C17 13.5523 16.5523 14 16 14C15.4477 14 15 13.5523 15 13V1C15 0.447716 15.4477 0 16 0C16.5523 0 17 0.447715 17 1V13Z"), Si(
        n,
        "fill",
        /*color*/
        t[1]
      ), Si(n, "d", "M9.75 5.70096C10.75 6.27831 10.75 7.72169 9.75 8.29904L2.25 12.6292C1.25 13.2065 0 12.4848 0 11.3301V2.66987C0 1.51517 1.25 0.793485 2.25 1.37083L9.75 5.70096Z"), Si(e, "width", o = 40 * /*scale*/
      t[0]), Si(e, "height", s = 40 * /*scale*/
      t[0]), Si(e, "viewBox", "-10 -10 37 34"), Si(e, "fill", "none"), Si(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(l, a) {
      E(l, e, a), h(e, i), h(e, n);
    },
    p(l, [a]) {
      a & /*color*/
      2 && Si(
        i,
        "fill",
        /*color*/
        l[1]
      ), a & /*color*/
      2 && Si(
        n,
        "fill",
        /*color*/
        l[1]
      ), a & /*scale*/
      1 && o !== (o = 40 * /*scale*/
      l[0]) && Si(e, "width", o), a & /*scale*/
      1 && s !== (s = 40 * /*scale*/
      l[0]) && Si(e, "height", s);
    },
    i: Q,
    o: Q,
    d(l) {
      l && M(e);
    }
  };
}
function l0(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class a0 extends we {
  constructor(e) {
    super(), Pe(this, e, l0, s0, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Zo = (t, e, i) => Ie(t, e, e === "style" ? u0(i) : i), r0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, u0 = (t) => t.split(r0).filter((e) => e).map((e) => e + " !important").join(";");
function c0(t) {
  let e, i;
  return e = new a0({
    props: {
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      1 && (s.scale = /*scale*/
      n[0]), o & /*color*/
      2 && (s.color = /*color*/
      n[1]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function d0(t) {
  let e, i;
  return e = new i0({
    props: {
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      1 && (s.scale = /*scale*/
      n[0]), o & /*color*/
      2 && (s.color = /*color*/
      n[1]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function g0(t) {
  let e, i;
  return e = new Xh({
    props: {
      seconds: (
        /*forwardsSeconds*/
        t[6]
      ),
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*forwardsSeconds*/
      64 && (s.seconds = /*forwardsSeconds*/
      n[6]), o & /*scale*/
      1 && (s.scale = /*scale*/
      n[0]), o & /*color*/
      2 && (s.color = /*color*/
      n[1]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function f0(t) {
  let e, i, n, o, s, l;
  const a = [g0, d0, c0], r = [];
  function u(c, g) {
    return (
      /*isSeconds*/
      c[3] ? 0 : (
        /*isSegments*/
        c[4] ? 1 : (
          /*isTracks*/
          c[2] ? 2 : -1
        )
      )
    );
  }
  return ~(i = u(t)) && (n = r[i] = a[i](t)), {
    c() {
      e = y("button"), n && n.c(), Zo(e, "type", "button"), Zo(e, "class", "next-button svelte-1ukrri8"), Zo(
        e,
        "aria-label",
        /*ariaLabel*/
        t[5]
      );
    },
    m(c, g) {
      E(c, e, g), ~i && r[i].m(e, null), o = !0, s || (l = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[7]
        ),
        Y(e, "mouseup", ai)
      ], s = !0);
    },
    p(c, [g]) {
      let f = i;
      i = u(c), i === f ? ~i && r[i].p(c, g) : (n && (Fe(), z(r[f], 1, 1, () => {
        r[f] = null;
      }), Ue()), ~i ? (n = r[i], n ? n.p(c, g) : (n = r[i] = a[i](c), n.c()), V(n, 1), n.m(e, null)) : n = null), (!o || g & /*ariaLabel*/
      32) && Zo(
        e,
        "aria-label",
        /*ariaLabel*/
        c[5]
      );
    },
    i(c) {
      o || (V(n), o = !0);
    },
    o(c) {
      z(n), o = !1;
    },
    d(c) {
      c && M(e), ~i && r[i].d(), s = !1, _t(l);
    }
  };
}
function m0(t, e, i) {
  let n, o, s, l, a, { style: r = "segments" } = e, { scale: u = 1 } = e, { color: c = "#323232" } = e, { onEvent: g = () => {
  } } = e, f;
  const A = () => {
    let _, k, S;
    s ? (_ = "PressedNextSegment", k = "The next segment button was pressed.") : l ? (_ = "PressedSeekAhead", k = "The seek ahead button was pressed.", S = { seconds: o }) : a && (_ = "PressedNextTrack", k = "The next track button was pressed."), g(ke(Jt({
      type: _,
      description: k,
      initiatedBy: "user"
    }, S)));
  };
  return t.$$set = (_) => {
    "style" in _ && i(8, r = _.style), "scale" in _ && i(0, u = _.scale), "color" in _ && i(1, c = _.color), "onEvent" in _ && i(9, g = _.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*style*/
    256 && i(10, n = parseFloat(r.split("-")[1] || 10)), t.$$.dirty & /*style, backwardsSeconds*/
    1280 && i(6, o = parseFloat(r.split("-")[2] || n)), t.$$.dirty & /*style*/
    256 && i(4, s = r === "segments"), t.$$.dirty & /*style*/
    256 && i(3, l = r.startsWith("seconds")), t.$$.dirty & /*style*/
    256 && i(2, a = r === "tracks"), t.$$.dirty & /*isSeconds, isSegments, isTracks*/
    28 && (l ? i(5, f = gt("seekAhead")) : s ? i(5, f = gt("nextSegment")) : a && i(5, f = gt("nextTrack")));
  }, [
    u,
    c,
    a,
    l,
    s,
    f,
    o,
    A,
    r,
    g,
    n
  ];
}
class h0 extends we {
  constructor(e) {
    super(), Pe(this, e, m0, f0, pe, { style: 8, scale: 0, color: 1, onEvent: 9 });
  }
  get style() {
    return this.$$.ctx[8];
  }
  set style(e) {
    this.$$set({ style: e }), d();
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[9];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const hi = (t, e, i) => Ie(t, e, e === "style" ? A0(i) : i), _0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, A0 = (t) => t.split(_0).filter((e) => e).map((e) => e + " !important").join(";");
function y0(t) {
  let e, i, n, o, s, l;
  return {
    c() {
      e = Se("svg"), i = Se("path"), n = Se("g"), o = Se("path"), hi(
        i,
        "fill",
        /*color*/
        t[1]
      ), hi(i, "d", "M1.33332 1.33333C1.14443 1.33333 0.986101 1.26944 0.858323 1.14167C0.730545 1.01389 0.666656 0.855556 0.666656 0.666667C0.666656 0.477778 0.730545 0.319444 0.858323 0.191667C0.986101 0.0638889 1.14443 0 1.33332 0H7.99999C8.18888 0 8.34721 0.0638889 8.47499 0.191667C8.60277 0.319444 8.66666 0.477778 8.66666 0.666667C8.66666 0.855556 8.60277 1.01389 8.47499 1.14167C8.34721 1.26944 8.18888 1.33333 7.99999 1.33333H1.33332ZM1.33332 4C1.14443 4 0.986101 3.93611 0.858323 3.80833C0.730545 3.68056 0.666656 3.52222 0.666656 3.33333C0.666656 3.14444 0.730545 2.98611 0.858323 2.85833C0.986101 2.73056 1.14443 2.66667 1.33332 2.66667H7.99999C8.18888 2.66667 8.34721 2.73056 8.47499 2.85833C8.60277 2.98611 8.66666 3.14444 8.66666 3.33333C8.66666 3.52222 8.60277 3.68056 8.47499 3.80833C8.34721 3.93611 8.18888 4 7.99999 4H1.33332ZM1.33332 6.66667C1.14443 6.66667 0.986101 6.60278 0.858323 6.475C0.730545 6.34722 0.666656 6.18889 0.666656 6C0.666656 5.81111 0.730545 5.65278 0.858323 5.525C0.986101 5.39722 1.14443 5.33333 1.33332 5.33333H5.33332C5.52221 5.33333 5.68055 5.39722 5.80832 5.525C5.9361 5.65278 5.99999 5.81111 5.99999 6C5.99999 6.18889 5.9361 6.34722 5.80832 6.475C5.68055 6.60278 5.52221 6.66667 5.33332 6.66667H1.33332Z"), hi(
        o,
        "fill",
        /*color*/
        t[1]
      ), hi(o, "d", "M10.3667 9.31667C10.1444 9.47222 9.91666 9.48333 9.68332 9.35C9.44999 9.21667 9.33332 9.01667 9.33332 8.75V5.91667C9.33332 5.65 9.44999 5.45 9.68332 5.31667C9.91666 5.18333 10.1444 5.19444 10.3667 5.35L12.5 6.78333C12.7 6.91667 12.8 7.1 12.8 7.33333C12.8 7.56667 12.7 7.75 12.5 7.88333L10.3667 9.31667Z"), hi(n, "transform", "scale(1.05) translate(-1.7 0)"), hi(e, "width", s = 20 * /*scale*/
      t[0]), hi(e, "height", l = 20 * /*scale*/
      t[0]), hi(e, "viewBox", "-0.6 -0.3 12 8"), hi(e, "fill", "none"), hi(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(a, r) {
      E(a, e, r), h(e, i), h(e, n), h(n, o);
    },
    p(a, [r]) {
      r & /*color*/
      2 && hi(
        i,
        "fill",
        /*color*/
        a[1]
      ), r & /*color*/
      2 && hi(
        o,
        "fill",
        /*color*/
        a[1]
      ), r & /*scale*/
      1 && s !== (s = 20 * /*scale*/
      a[0]) && hi(e, "width", s), r & /*scale*/
      1 && l !== (l = 20 * /*scale*/
      a[0]) && hi(e, "height", l);
    },
    i: Q,
    o: Q,
    d(a) {
      a && M(e);
    }
  };
}
function v0(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class b0 extends we {
  constructor(e) {
    super(), Pe(this, e, v0, y0, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const _i = (t, e, i) => Ie(t, e, e === "style" ? p0(i) : i), k0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, p0 = (t) => t.split(k0).filter((e) => e).map((e) => e + " !important").join(";");
function S0(t) {
  let e, i, n, o, s, l;
  return {
    c() {
      e = Se("svg"), i = Se("path"), n = Se("g"), o = Se("path"), _i(
        i,
        "fill",
        /*color*/
        t[1]
      ), _i(i, "d", "M1.33332 1.33333C1.14443 1.33333 0.986101 1.26944 0.858323 1.14167C0.730545 1.01389 0.666656 0.855556 0.666656 0.666667C0.666656 0.477778 0.730545 0.319444 0.858323 0.191667C0.986101 0.0638889 1.14443 0 1.33332 0H7.99999C8.18888 0 8.34721 0.0638889 8.47499 0.191667C8.60277 0.319444 8.66666 0.477778 8.66666 0.666667C8.66666 0.855556 8.60277 1.01389 8.47499 1.14167C8.34721 1.26944 8.18888 1.33333 7.99999 1.33333H1.33332ZM1.33332 4C1.14443 4 0.986101 3.93611 0.858323 3.80833C0.730545 3.68056 0.666656 3.52222 0.666656 3.33333C0.666656 3.14444 0.730545 2.98611 0.858323 2.85833C0.986101 2.73056 1.14443 2.66667 1.33332 2.66667H7.99999C8.18888 2.66667 8.34721 2.73056 8.47499 2.85833C8.60277 2.98611 8.66666 3.14444 8.66666 3.33333C8.66666 3.52222 8.60277 3.68056 8.47499 3.80833C8.34721 3.93611 8.18888 4 7.99999 4H1.33332ZM1.33332 6.66667C1.14443 6.66667 0.986101 6.60278 0.858323 6.475C0.730545 6.34722 0.666656 6.18889 0.666656 6C0.666656 5.81111 0.730545 5.65278 0.858323 5.525C0.986101 5.39722 1.14443 5.33333 1.33332 5.33333H5.33332C5.52221 5.33333 5.68055 5.39722 5.80832 5.525C5.9361 5.65278 5.99999 5.81111 5.99999 6C5.99999 6.18889 5.9361 6.34722 5.80832 6.475C5.68055 6.60278 5.52221 6.66667 5.33332 6.66667H1.33332Z"), _i(
        o,
        "fill",
        /*color*/
        t[1]
      ), _i(o, "d", "M7.13333 10.2C7.01111 10.0778 6.95 9.92222 6.95 9.73333C6.95 9.54444 7.01111 9.38889 7.13333 9.26667L8.4 8L7.13333 6.73333C7.01111 6.61111 6.95 6.45555 6.95 6.26667C6.95 6.07778 7.01111 5.92222 7.13333 5.8C7.25556 5.67778 7.41111 5.61667 7.6 5.61667C7.78889 5.61667 7.94444 5.67778 8.06667 5.8L9.33333 7.06667L10.6 5.8C10.7222 5.67778 10.8778 5.61667 11.0667 5.61667C11.2556 5.61667 11.4111 5.67778 11.5333 5.8C11.6556 5.92222 11.7167 6.07778 11.7167 6.26667C11.7167 6.45555 11.6556 6.61111 11.5333 6.73333L10.2667 8L11.5333 9.26667C11.6556 9.38889 11.7167 9.54444 11.7167 9.73333C11.7167 9.92222 11.6556 10.0778 11.5333 10.2C11.4111 10.3222 11.2556 10.3833 11.0667 10.3833C10.8778 10.3833 10.7222 10.3222 10.6 10.2L9.33333 8.93333L8.06667 10.2C7.94444 10.3222 7.78889 10.3833 7.6 10.3833C7.41111 10.3833 7.25556 10.3222 7.13333 10.2Z"), _i(n, "transform", "translate(0.3 0)"), _i(e, "width", s = 20 * /*scale*/
      t[0]), _i(e, "height", l = 20 * /*scale*/
      t[0]), _i(e, "viewBox", "-0.6 -0.3 12 8"), _i(e, "fill", "none"), _i(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(a, r) {
      E(a, e, r), h(e, i), h(e, n), h(n, o);
    },
    p(a, [r]) {
      r & /*color*/
      2 && _i(
        i,
        "fill",
        /*color*/
        a[1]
      ), r & /*color*/
      2 && _i(
        o,
        "fill",
        /*color*/
        a[1]
      ), r & /*scale*/
      1 && s !== (s = 20 * /*scale*/
      a[0]) && _i(e, "width", s), r & /*scale*/
      1 && l !== (l = 20 * /*scale*/
      a[0]) && _i(e, "height", l);
    },
    i: Q,
    o: Q,
    d(a) {
      a && M(e);
    }
  };
}
function P0(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class w0 extends we {
  constructor(e) {
    super(), Pe(this, e, P0, S0, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const ua = (t, e, i) => Zt(t, e, i, 1), Ko = (t, e, i) => Ie(t, e, e === "style" ? C0(i) : i), T0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, C0 = (t) => t.split(T0).filter((e) => e).map((e) => e + " !important").join(";");
function I0(t) {
  let e, i;
  return e = new b0({
    props: {
      scale: (
        /*scale*/
        t[2]
      ),
      color: (
        /*color*/
        t[3]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      4 && (s.scale = /*scale*/
      n[2]), o & /*color*/
      8 && (s.color = /*color*/
      n[3]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function O0(t) {
  let e, i;
  return e = new w0({
    props: {
      scale: (
        /*scale*/
        t[2]
      ),
      color: (
        /*color*/
        t[3]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*scale*/
      4 && (s.scale = /*scale*/
      n[2]), o & /*color*/
      8 && (s.color = /*color*/
      n[3]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function V0(t) {
  let e, i, n, o, s, l, a;
  const r = [O0, I0], u = [];
  function c(g, f) {
    return (
      /*playlistShowing*/
      g[0] ? 0 : 1
    );
  }
  return i = c(t), n = u[i] = r[i](t), {
    c() {
      e = y("button"), n.c(), Ko(e, "type", "button"), Ko(e, "class", o = "playlist-button " + /*playerStyle*/
      t[1] + " svelte-xhif6r"), ua(e, "outline-offset", 5 * /*scale*/
      t[2] + "px"), Ko(e, "aria-label", gt("togglePlaylist"));
    },
    m(g, f) {
      E(g, e, f), u[i].m(e, null), s = !0, l || (a = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[4]
        ),
        Y(e, "mouseup", ai)
      ], l = !0);
    },
    p(g, [f]) {
      let A = i;
      i = c(g), i === A ? u[i].p(g, f) : (Fe(), z(u[A], 1, 1, () => {
        u[A] = null;
      }), Ue(), n = u[i], n ? n.p(g, f) : (n = u[i] = r[i](g), n.c()), V(n, 1), n.m(e, null)), (!s || f & /*playerStyle*/
      2 && o !== (o = "playlist-button " + /*playerStyle*/
      g[1] + " svelte-xhif6r")) && Ko(e, "class", o), (!s || f & /*scale*/
      4) && ua(e, "outline-offset", 5 * /*scale*/
      g[2] + "px");
    },
    i(g) {
      s || (V(n), s = !0);
    },
    o(g) {
      z(n), s = !1;
    },
    d(g) {
      g && M(e), u[i].d(), l = !1, _t(a);
    }
  };
}
function B0(t, e, i) {
  let { playlistShowing: n } = e, { playerStyle: o } = e, { scale: s = 1 } = e, { color: l = "#323232" } = e, { onEvent: a = () => {
  } } = e;
  const r = () => {
    a(ke({
      type: "PressedTogglePlaylist",
      description: "The toggle playlist button was pressed.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (u) => {
    "playlistShowing" in u && i(0, n = u.playlistShowing), "playerStyle" in u && i(1, o = u.playerStyle), "scale" in u && i(2, s = u.scale), "color" in u && i(3, l = u.color), "onEvent" in u && i(5, a = u.onEvent);
  }, [n, o, s, l, r, a];
}
class W0 extends we {
  constructor(e) {
    super(), Pe(this, e, B0, V0, pe, {
      playlistShowing: 0,
      playerStyle: 1,
      scale: 2,
      color: 3,
      onEvent: 5
    });
  }
  get playlistShowing() {
    return this.$$.ctx[0];
  }
  set playlistShowing(e) {
    this.$$set({ playlistShowing: e }), d();
  }
  get playerStyle() {
    return this.$$.ctx[1];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get scale() {
    return this.$$.ctx[2];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[3];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[5];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const ca = (t, e, i) => Zt(t, e, i, 1), da = (t, e, i) => Ie(t, e, e === "style" ? E0(i) : i), M0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, E0 = (t) => t.split(M0).filter((e) => e).map((e) => e + " !important").join(";");
function z0(t) {
  let e, i, n;
  const o = (
    /*#slots*/
    t[7].default
  ), s = Qn(
    o,
    t,
    /*$$scope*/
    t[6],
    null
  );
  return {
    c() {
      e = y("div"), s && s.c(), da(e, "class", i = "secondary-buttons " + /*playerStyle*/
      t[0] + " " + /*controlsOrder*/
      t[5] + " svelte-1s4l1fa"), ca(
        e,
        "--scale",
        /*scale*/
        t[4]
      ), ne(
        e,
        "mobile",
        /*isMobile*/
        t[1]
      ), ne(
        e,
        "advert_",
        /*isAdvert*/
        t[2]
      ), ne(
        e,
        "fixed",
        /*fixedPosition*/
        t[3]
      );
    },
    m(l, a) {
      E(l, e, a), s && s.m(e, null), n = !0;
    },
    p(l, [a]) {
      s && s.p && (!n || a & /*$$scope*/
      64) && eo(
        s,
        o,
        l,
        /*$$scope*/
        l[6],
        n ? $n(
          o,
          /*$$scope*/
          l[6],
          a,
          null
        ) : to(
          /*$$scope*/
          l[6]
        ),
        null
      ), (!n || a & /*playerStyle, controlsOrder*/
      33 && i !== (i = "secondary-buttons " + /*playerStyle*/
      l[0] + " " + /*controlsOrder*/
      l[5] + " svelte-1s4l1fa")) && da(e, "class", i), (!n || a & /*scale*/
      16) && ca(
        e,
        "--scale",
        /*scale*/
        l[4]
      ), (!n || a & /*playerStyle, controlsOrder, isMobile*/
      35) && ne(
        e,
        "mobile",
        /*isMobile*/
        l[1]
      ), (!n || a & /*playerStyle, controlsOrder, isAdvert*/
      37) && ne(
        e,
        "advert_",
        /*isAdvert*/
        l[2]
      ), (!n || a & /*playerStyle, controlsOrder, fixedPosition*/
      41) && ne(
        e,
        "fixed",
        /*fixedPosition*/
        l[3]
      );
    },
    i(l) {
      n || (V(s, l), n = !0);
    },
    o(l) {
      z(s, l), n = !1;
    },
    d(l) {
      l && M(e), s && s.d(l);
    }
  };
}
function L0(t, e, i) {
  let { $$slots: n = {}, $$scope: o } = e, { playerStyle: s } = e, { isMobile: l } = e, { isAdvert: a } = e, { fixedPosition: r } = e, { scale: u } = e, { controlsOrder: c } = e;
  return t.$$set = (g) => {
    "playerStyle" in g && i(0, s = g.playerStyle), "isMobile" in g && i(1, l = g.isMobile), "isAdvert" in g && i(2, a = g.isAdvert), "fixedPosition" in g && i(3, r = g.fixedPosition), "scale" in g && i(4, u = g.scale), "controlsOrder" in g && i(5, c = g.controlsOrder), "$$scope" in g && i(6, o = g.$$scope);
  }, [
    s,
    l,
    a,
    r,
    u,
    c,
    o,
    n
  ];
}
class j0 extends we {
  constructor(e) {
    super(), Pe(this, e, L0, z0, pe, {
      playerStyle: 0,
      isMobile: 1,
      isAdvert: 2,
      fixedPosition: 3,
      scale: 4,
      controlsOrder: 5
    });
  }
  get playerStyle() {
    return this.$$.ctx[0];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get isMobile() {
    return this.$$.ctx[1];
  }
  set isMobile(e) {
    this.$$set({ isMobile: e }), d();
  }
  get isAdvert() {
    return this.$$.ctx[2];
  }
  set isAdvert(e) {
    this.$$set({ isAdvert: e }), d();
  }
  get fixedPosition() {
    return this.$$.ctx[3];
  }
  set fixedPosition(e) {
    this.$$set({ fixedPosition: e }), d();
  }
  get scale() {
    return this.$$.ctx[4];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get controlsOrder() {
    return this.$$.ctx[5];
  }
  set controlsOrder(e) {
    this.$$set({ controlsOrder: e }), d();
  }
}
const Zi = (t, e, i) => Ie(t, e, e === "style" ? x0(i) : i), D0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, x0 = (t) => t.split(D0).filter((e) => e).map((e) => e + " !important").join(";");
function N0(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Zi(
        i,
        "fill",
        /*color*/
        t[1]
      ), Zi(i, "d", "M6.33334 5.76668L5.73334 5.18334C5.60001 5.06112 5.44168 5.00279 5.25834 5.00834C5.07501 5.0139 4.92223 5.07779 4.80001 5.20001C4.67779 5.32223 4.61668 5.47779 4.61668 5.66668C4.61668 5.85557 4.67779 6.01112 4.80001 6.13334L6.53334 7.86668C6.65557 7.9889 6.81112 8.05001 7.00001 8.05001C7.1889 8.05001 7.34445 7.9889 7.46668 7.86668L9.21668 6.11668C9.3389 5.99445 9.39723 5.84168 9.39168 5.65834C9.38612 5.47501 9.32223 5.32223 9.20001 5.20001C9.07779 5.07779 8.92223 5.0139 8.73334 5.00834C8.54445 5.00279 8.3889 5.06668 8.26668 5.20001L7.66668 5.76668V3.65001C7.66668 3.46112 7.60279 3.30557 7.47501 3.18334C7.34723 3.06112 7.1889 3.00001 7.00001 3.00001C6.81112 3.00001 6.65279 3.0639 6.52501 3.19168C6.39723 3.31945 6.33334 3.47779 6.33334 3.66668V5.76668ZM4.33334 10.3333H9.68334C9.87223 10.3333 10.0278 10.2695 10.15 10.1417C10.2722 10.0139 10.3333 9.85557 10.3333 9.66668C10.3333 9.47779 10.2695 9.31945 10.1417 9.19168C10.0139 9.0639 9.85557 9.00001 9.66668 9.00001H4.31668C4.12779 9.00001 3.97223 9.0639 3.85001 9.19168C3.72779 9.31945 3.66668 9.47779 3.66668 9.66668C3.66668 9.85557 3.73057 10.0139 3.85834 10.1417C3.98612 10.2695 4.14445 10.3333 4.33334 10.3333ZM7.00001 13.6667C6.07779 13.6667 5.21112 13.4917 4.40001 13.1417C3.5889 12.7917 2.88334 12.3167 2.28334 11.7167C1.68334 11.1167 1.20834 10.4111 0.858343 9.60001C0.508343 8.7889 0.333344 7.92223 0.333344 7.00001C0.333344 6.07779 0.508343 5.21112 0.858343 4.40001C1.20834 3.5889 1.68334 2.88334 2.28334 2.28334C2.88334 1.68334 3.5889 1.20834 4.40001 0.858343C5.21112 0.508343 6.07779 0.333344 7.00001 0.333344C7.92223 0.333344 8.7889 0.508343 9.60001 0.858343C10.4111 1.20834 11.1167 1.68334 11.7167 2.28334C12.3167 2.88334 12.7917 3.5889 13.1417 4.40001C13.4917 5.21112 13.6667 6.07779 13.6667 7.00001C13.6667 7.92223 13.4917 8.7889 13.1417 9.60001C12.7917 10.4111 12.3167 11.1167 11.7167 11.7167C11.1167 12.3167 10.4111 12.7917 9.60001 13.1417C8.7889 13.4917 7.92223 13.6667 7.00001 13.6667Z"), Zi(e, "width", n = 17 * /*scale*/
      t[0]), Zi(e, "height", o = 17 * /*scale*/
      t[0]), Zi(e, "viewBox", "0 0 14 14"), Zi(e, "fill", "none"), Zi(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && Zi(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 17 * /*scale*/
      s[0]) && Zi(e, "width", n), l & /*scale*/
      1 && o !== (o = 17 * /*scale*/
      s[0]) && Zi(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function R0(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class F0 extends we {
  constructor(e) {
    super(), Pe(this, e, R0, N0, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Go = (t, e, i) => Zt(t, e, i, 1), Gs = (t, e, i) => Ie(t, e, e === "style" ? H0(i) : i), U0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, H0 = (t) => t.split(U0).filter((e) => e).map((e) => e + " !important").join(";");
function ga(t) {
  let e, i, n, o, s;
  return i = new F0({
    props: {
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      e = y("button"), me(i.$$.fragment), Gs(e, "type", "button"), Gs(e, "class", "download-button svelte-1r5l0am"), Go(e, "outline-offset", 4.8 * /*scale*/
      t[0] + "px"), Go(
        e,
        "padding",
        /*padding*/
        t[2] + "px"
      ), Gs(e, "aria-label", gt("downloadAudio"));
    },
    m(l, a) {
      E(l, e, a), de(i, e, null), n = !0, o || (s = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[5]
        ),
        Y(e, "mouseup", ai)
      ], o = !0);
    },
    p(l, a) {
      const r = {};
      a & /*scale*/
      1 && (r.scale = /*scale*/
      l[0]), a & /*color*/
      2 && (r.color = /*color*/
      l[1]), i.$set(r), (!n || a & /*scale*/
      1) && Go(e, "outline-offset", 4.8 * /*scale*/
      l[0] + "px"), (!n || a & /*padding*/
      4) && Go(
        e,
        "padding",
        /*padding*/
        l[2] + "px"
      );
    },
    i(l) {
      n || (V(i.$$.fragment, l), n = !0);
    },
    o(l) {
      z(i.$$.fragment, l), n = !1;
    },
    d(l) {
      l && M(e), ge(i), o = !1, _t(s);
    }
  };
}
function q0(t) {
  let e, i, n = (
    /*audioIndex*/
    (t[3] !== -1 || /*videoIndex*/
    t[4] !== -1) && ga(t)
  );
  return {
    c() {
      n && n.c(), e = Ei();
    },
    m(o, s) {
      n && n.m(o, s), E(o, e, s), i = !0;
    },
    p(o, [s]) {
      /*audioIndex*/
      o[3] !== -1 || /*videoIndex*/
      o[4] !== -1 ? n ? (n.p(o, s), s & /*audioIndex, videoIndex*/
      24 && V(n, 1)) : (n = ga(o), n.c(), V(n, 1), n.m(e.parentNode, e)) : n && (Fe(), z(n, 1, 1, () => {
        n = null;
      }), Ue());
    },
    i(o) {
      i || (V(n), i = !0);
    },
    o(o) {
      z(n), i = !1;
    },
    d(o) {
      o && M(e), n && n.d(o);
    }
  };
}
function Y0(t, e, i) {
  let { downloadFormats: n } = e, { contentIndex: o } = e, { audio: s } = e, { video: l } = e, { scale: a = 1 } = e, { color: r = "#323232" } = e, { padding: u = 0 } = e, { isVisible: c } = e, { onEvent: g = () => {
  } } = e;
  const f = (S, T, v) => {
    var P, O;
    for (const D of S) {
      for (const [p, C] of (T || []).entries())
        if ((P = C.url) != null && P.endsWith(`.${D}`))
          return [p, -1];
      for (const [p, C] of (v || []).entries())
        if ((O = C.url) != null && O.endsWith(`.${D}`))
          return [-1, p];
    }
    return [-1, -1];
  };
  let A, _;
  const k = (S) => {
    S.stopPropagation(), g(ke({
      type: "PressedDownload",
      description: "The download button next to a playlist item was pressed.",
      initiatedBy: "user",
      contentIndex: o,
      audioIndex: A,
      videoIndex: _
    }));
  };
  return t.$$set = (S) => {
    "downloadFormats" in S && i(7, n = S.downloadFormats), "contentIndex" in S && i(8, o = S.contentIndex), "audio" in S && i(9, s = S.audio), "video" in S && i(10, l = S.video), "scale" in S && i(0, a = S.scale), "color" in S && i(1, r = S.color), "padding" in S && i(2, u = S.padding), "isVisible" in S && i(6, c = S.isVisible), "onEvent" in S && i(11, g = S.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*downloadFormats, audio, video*/
    1664 && i(3, [A, _] = f(n, s, l), A, (i(4, _), i(7, n), i(9, s), i(10, l))), t.$$.dirty & /*audioIndex, videoIndex*/
    24 && i(6, c = A !== -1 || _ !== -1);
  }, [
    a,
    r,
    u,
    A,
    _,
    k,
    c,
    n,
    o,
    s,
    l,
    g
  ];
}
class jr extends we {
  constructor(e) {
    super(), Pe(this, e, Y0, q0, pe, {
      downloadFormats: 7,
      contentIndex: 8,
      audio: 9,
      video: 10,
      scale: 0,
      color: 1,
      padding: 2,
      isVisible: 6,
      onEvent: 11
    });
  }
  get downloadFormats() {
    return this.$$.ctx[7];
  }
  set downloadFormats(e) {
    this.$$set({ downloadFormats: e }), d();
  }
  get contentIndex() {
    return this.$$.ctx[8];
  }
  set contentIndex(e) {
    this.$$set({ contentIndex: e }), d();
  }
  get audio() {
    return this.$$.ctx[9];
  }
  set audio(e) {
    this.$$set({ audio: e }), d();
  }
  get video() {
    return this.$$.ctx[10];
  }
  set video(e) {
    this.$$set({ video: e }), d();
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get padding() {
    return this.$$.ctx[2];
  }
  set padding(e) {
    this.$$set({ padding: e }), d();
  }
  get isVisible() {
    return this.$$.ctx[6];
  }
  set isVisible(e) {
    this.$$set({ isVisible: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[11];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Ki = (t, e, i) => Ie(t, e, e === "style" ? K0(i) : i), Z0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, K0 = (t) => t.split(Z0).filter((e) => e).map((e) => e + " !important").join(";");
function G0(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Ki(
        i,
        "fill",
        /*color*/
        t[1]
      ), Ki(i, "d", "M1.28571 24C0.914286 24 0.607143 23.8786 0.364286 23.6357C0.121429 23.3929 0 23.0857 0 22.7143V17.0143C0 16.6429 0.121429 16.3357 0.364286 16.0929C0.607143 15.85 0.914286 15.7286 1.28571 15.7286C1.65714 15.7286 1.96429 15.85 2.20714 16.0929C2.45 16.3357 2.57143 16.6429 2.57143 17.0143V21.4286H6.98571C7.35714 21.4286 7.66429 21.55 7.90714 21.7929C8.15 22.0357 8.27143 22.3429 8.27143 22.7143C8.27143 23.0857 8.15 23.3929 7.90714 23.6357C7.66429 23.8786 7.35714 24 6.98571 24H1.28571ZM1.28571 8.27143C0.914286 8.27143 0.607143 8.15 0.364286 7.90714C0.121429 7.66429 0 7.35714 0 6.98571V1.28571C0 0.914286 0.121429 0.607143 0.364286 0.364286C0.607143 0.121429 0.914286 0 1.28571 0H6.98571C7.35714 0 7.66429 0.121429 7.90714 0.364286C8.15 0.607143 8.27143 0.914286 8.27143 1.28571C8.27143 1.65714 8.15 1.96429 7.90714 2.20714C7.66429 2.45 7.35714 2.57143 6.98571 2.57143H2.57143V6.98571C2.57143 7.35714 2.45 7.66429 2.20714 7.90714C1.96429 8.15 1.65714 8.27143 1.28571 8.27143ZM17.0143 24C16.6429 24 16.3357 23.8786 16.0929 23.6357C15.85 23.3929 15.7286 23.0857 15.7286 22.7143C15.7286 22.3429 15.85 22.0357 16.0929 21.7929C16.3357 21.55 16.6429 21.4286 17.0143 21.4286H21.4286V17.0143C21.4286 16.6429 21.55 16.3357 21.7929 16.0929C22.0357 15.85 22.3429 15.7286 22.7143 15.7286C23.0857 15.7286 23.3929 15.85 23.6357 16.0929C23.8786 16.3357 24 16.6429 24 17.0143V22.7143C24 23.0857 23.8786 23.3929 23.6357 23.6357C23.3929 23.8786 23.0857 24 22.7143 24H17.0143ZM22.7143 8.27143C22.3429 8.27143 22.0357 8.15 21.7929 7.90714C21.55 7.66429 21.4286 7.35714 21.4286 6.98571V2.57143H17.0143C16.6429 2.57143 16.3357 2.45 16.0929 2.20714C15.85 1.96429 15.7286 1.65714 15.7286 1.28571C15.7286 0.914286 15.85 0.607143 16.0929 0.364286C16.3357 0.121429 16.6429 0 17.0143 0H22.7143C23.0857 0 23.3929 0.121429 23.6357 0.364286C23.8786 0.607143 24 0.914286 24 1.28571V6.98571C24 7.35714 23.8786 7.66429 23.6357 7.90714C23.3929 8.15 23.0857 8.27143 22.7143 8.27143Z"), Ki(e, "width", n = 24 * /*scale*/
      t[0]), Ki(e, "height", o = 24 * /*scale*/
      t[0]), Ki(e, "viewBox", "0 0 24 24"), Ki(e, "fill", "none"), Ki(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && Ki(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 24 * /*scale*/
      s[0]) && Ki(e, "width", n), l & /*scale*/
      1 && o !== (o = 24 * /*scale*/
      s[0]) && Ki(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function J0(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class X0 extends we {
  constructor(e) {
    super(), Pe(this, e, J0, G0, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const fa = (t, e, i) => Zt(t, e, i, 1), Js = (t, e, i) => Ie(t, e, e === "style" ? $0(i) : i), Q0 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, $0 = (t) => t.split(Q0).filter((e) => e).map((e) => e + " !important").join(";");
function e2(t) {
  let e, i, n, o, s;
  return i = new X0({
    props: {
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      e = y("button"), me(i.$$.fragment), Js(e, "type", "button"), Js(e, "class", "maximize-button svelte-fk321i"), fa(e, "outline-offset", 6.4 * /*scale*/
      t[0] + "px"), Js(e, "aria-label", gt("maximizeVideo"));
    },
    m(l, a) {
      E(l, e, a), de(i, e, null), n = !0, o || (s = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[2]
        ),
        Y(e, "mouseup", ai)
      ], o = !0);
    },
    p(l, [a]) {
      const r = {};
      a & /*scale*/
      1 && (r.scale = /*scale*/
      l[0]), a & /*color*/
      2 && (r.color = /*color*/
      l[1]), i.$set(r), (!n || a & /*scale*/
      1) && fa(e, "outline-offset", 6.4 * /*scale*/
      l[0] + "px");
    },
    i(l) {
      n || (V(i.$$.fragment, l), n = !0);
    },
    o(l) {
      z(i.$$.fragment, l), n = !1;
    },
    d(l) {
      l && M(e), ge(i), o = !1, _t(s);
    }
  };
}
function t2(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e, { onEvent: s = () => {
  } } = e;
  const l = () => {
    s(ke({
      type: "PressedMaximize",
      description: "The maximize button was pressed.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (a) => {
    "scale" in a && i(0, n = a.scale), "color" in a && i(1, o = a.color), "onEvent" in a && i(3, s = a.onEvent);
  }, [n, o, l, s];
}
class i2 extends we {
  constructor(e) {
    super(), Pe(this, e, t2, e2, pe, { scale: 0, color: 1, onEvent: 3 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[3];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Gi = (t, e, i) => Ie(t, e, e === "style" ? o2(i) : i), n2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, o2 = (t) => t.split(n2).filter((e) => e).map((e) => e + " !important").join(";");
function s2(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Gi(
        i,
        "fill",
        /*color*/
        t[1]
      ), Gi(i, "d", "M1.66873 11.1188L0.881226 10.3313L5.21248 6.00001L0.881226 1.66876L1.66873 0.881256L5.99998 5.21251L10.3312 0.881256L11.1187 1.66876L6.78748 6.00001L11.1187 10.3313L10.3312 11.1188L5.99998 6.78751L1.66873 11.1188Z"), Gi(e, "width", n = 12 * /*scale*/
      t[0]), Gi(e, "height", o = 12 * /*scale*/
      t[0]), Gi(e, "viewBox", "0 0 12 12"), Gi(e, "fill", "none"), Gi(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && Gi(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 12 * /*scale*/
      s[0]) && Gi(e, "width", n), l & /*scale*/
      1 && o !== (o = 12 * /*scale*/
      s[0]) && Gi(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function l2(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class a2 extends we {
  constructor(e) {
    super(), Pe(this, e, l2, s2, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Jo = (t, e, i) => Zt(t, e, i, 1), Xs = (t, e, i) => Ie(t, e, e === "style" ? u2(i) : i), r2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, u2 = (t) => t.split(r2).filter((e) => e).map((e) => e + " !important").join(";");
function c2(t) {
  let e, i, n, o, s;
  return i = new a2({
    props: {
      scale: (
        /*scale*/
        t[0]
      ),
      color: (
        /*color*/
        t[1]
      )
    }
  }), {
    c() {
      e = y("button"), me(i.$$.fragment), Xs(e, "type", "button"), Xs(e, "class", "close-widget-button svelte-1bnl89m"), Jo(
        e,
        "margin",
        /*margin*/
        t[2]
      ), Jo(e, "outline-offset", 4.8 * /*scale*/
      t[0] + "px"), Xs(e, "aria-label", gt("closeWidget"));
    },
    m(l, a) {
      E(l, e, a), de(i, e, null), n = !0, o || (s = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[3]
        ),
        Y(e, "mouseup", ai)
      ], o = !0);
    },
    p(l, [a]) {
      const r = {};
      a & /*scale*/
      1 && (r.scale = /*scale*/
      l[0]), a & /*color*/
      2 && (r.color = /*color*/
      l[1]), i.$set(r), (!n || a & /*margin*/
      4) && Jo(
        e,
        "margin",
        /*margin*/
        l[2]
      ), (!n || a & /*scale*/
      1) && Jo(e, "outline-offset", 4.8 * /*scale*/
      l[0] + "px");
    },
    i(l) {
      n || (V(i.$$.fragment, l), n = !0);
    },
    o(l) {
      z(i.$$.fragment, l), n = !1;
    },
    d(l) {
      l && M(e), ge(i), o = !1, _t(s);
    }
  };
}
function d2(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e, { margin: s = "auto" } = e, { onEvent: l = () => {
  } } = e;
  const a = () => {
    l(ke({
      type: "PressedCloseWidget",
      description: "The close widget button was pressed.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (r) => {
    "scale" in r && i(0, n = r.scale), "color" in r && i(1, o = r.color), "margin" in r && i(2, s = r.margin), "onEvent" in r && i(4, l = r.onEvent);
  }, [n, o, s, a, l];
}
class g2 extends we {
  constructor(e) {
    super(), Pe(this, e, d2, c2, pe, {
      scale: 0,
      color: 1,
      margin: 2,
      onEvent: 4
    });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get margin() {
    return this.$$.ctx[2];
  }
  set margin(e) {
    this.$$set({ margin: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[4];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const tn = (t, e, i) => Ie(t, e, e === "style" ? m2(i) : i), f2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, m2 = (t) => t.split(f2).filter((e) => e).map((e) => e + " !important").join(";");
function h2(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), tn(
        i,
        "fill",
        /*color*/
        t[1]
      ), tn(i, "d", "M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8zm-1 2h-6v4h6v-4zM6.707 6.293l2.25 2.25L11 6.5V12H5.5l2.043-2.043-2.25-2.25 1.414-1.414z"), tn(e, "width", n = 64 * /*scale*/
      t[0]), tn(e, "height", o = 64 * /*scale*/
      t[0]), tn(e, "viewBox", "0 0 24 24"), tn(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, [l]) {
      l & /*color*/
      2 && tn(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 64 * /*scale*/
      s[0]) && tn(e, "width", n), l & /*scale*/
      1 && o !== (o = 64 * /*scale*/
      s[0]) && tn(e, "height", o);
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e);
    }
  };
}
function _2(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e;
  return t.$$set = (s) => {
    "scale" in s && i(0, n = s.scale), "color" in s && i(1, o = s.color);
  }, [n, o];
}
class A2 extends we {
  constructor(e) {
    super(), Pe(this, e, _2, h2, pe, { scale: 0, color: 1 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Dr = (t) => !t || t != null && t.startsWith("http") ? t : `https://${t}`, Bn = (t, e, i) => Ie(t, e, e === "style" ? v2(i) : i), y2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, v2 = (t) => t.split(y2).filter((e) => e).map((e) => e + " !important").join(";");
function b2(t) {
  let e, i, n, o, s;
  return {
    c() {
      e = y("a"), i = ie(
        /*displayText*/
        t[7]
      ), Bn(e, "class", n = "advert-link " + /*playerStyle*/
      t[0] + " " + /*controlsOrder*/
      t[1] + " svelte-eat709"), Bn(
        e,
        "href",
        /*hrefWithProtocol*/
        t[5]
      ), Bn(
        e,
        "style",
        /*style*/
        t[6]
      ), Bn(e, "target", "_blank"), ne(e, "no-image", !/*largeImage*/
      t[2]), ne(e, "no-end", !/*endVisible*/
      t[4]), ne(
        e,
        "mobile",
        /*isMobile*/
        t[3]
      );
    },
    m(l, a) {
      E(l, e, a), h(e, i), o || (s = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[8]
        ),
        Y(e, "mouseup", ai)
      ], o = !0);
    },
    p(l, [a]) {
      a & /*displayText*/
      128 && bi(
        i,
        /*displayText*/
        l[7]
      ), a & /*playerStyle, controlsOrder*/
      3 && n !== (n = "advert-link " + /*playerStyle*/
      l[0] + " " + /*controlsOrder*/
      l[1] + " svelte-eat709") && Bn(e, "class", n), a & /*hrefWithProtocol*/
      32 && Bn(
        e,
        "href",
        /*hrefWithProtocol*/
        l[5]
      ), a & /*style*/
      64 && Bn(
        e,
        "style",
        /*style*/
        l[6]
      ), a & /*playerStyle, controlsOrder, largeImage*/
      7 && ne(e, "no-image", !/*largeImage*/
      l[2]), a & /*playerStyle, controlsOrder, endVisible*/
      19 && ne(e, "no-end", !/*endVisible*/
      l[4]), a & /*playerStyle, controlsOrder, isMobile*/
      11 && ne(
        e,
        "mobile",
        /*isMobile*/
        l[3]
      );
    },
    i: Q,
    o: Q,
    d(l) {
      l && M(e), o = !1, _t(s);
    }
  };
}
function k2(t, e, i) {
  let n, o, s, { href: l } = e, { scale: a = 1 } = e, { color: r = "#323232" } = e, { playerStyle: u } = e, { controlsOrder: c } = e, { largeImage: g } = e, { isMobile: f } = e, { endVisible: A } = e, { onEvent: _ = () => {
  } } = e;
  const k = () => {
    _(ke({
      type: "PressedAdvertLink",
      description: "The advert link was pressed to open the click-through URL in a new tab.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (S) => {
    "href" in S && i(9, l = S.href), "scale" in S && i(10, a = S.scale), "color" in S && i(11, r = S.color), "playerStyle" in S && i(0, u = S.playerStyle), "controlsOrder" in S && i(1, c = S.controlsOrder), "largeImage" in S && i(2, g = S.largeImage), "isMobile" in S && i(3, f = S.isMobile), "endVisible" in S && i(4, A = S.endVisible), "onEvent" in S && i(12, _ = S.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*href*/
    512 && i(5, n = Dr(l)), t.$$.dirty & /*hrefWithProtocol*/
    32 && i(7, o = Mc(n)), t.$$.dirty & /*scale, color*/
    3072 && i(6, s = `font-size: ${12 * a}px; color: ${r}; border-color: ${r}`);
  }, [
    u,
    c,
    g,
    f,
    A,
    n,
    s,
    o,
    k,
    l,
    a,
    r,
    _
  ];
}
class p2 extends we {
  constructor(e) {
    super(), Pe(this, e, k2, b2, pe, {
      href: 9,
      scale: 10,
      color: 11,
      playerStyle: 0,
      controlsOrder: 1,
      largeImage: 2,
      isMobile: 3,
      endVisible: 4,
      onEvent: 12
    });
  }
  get href() {
    return this.$$.ctx[9];
  }
  set href(e) {
    this.$$set({ href: e }), d();
  }
  get scale() {
    return this.$$.ctx[10];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[11];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get playerStyle() {
    return this.$$.ctx[0];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get controlsOrder() {
    return this.$$.ctx[1];
  }
  set controlsOrder(e) {
    this.$$set({ controlsOrder: e }), d();
  }
  get largeImage() {
    return this.$$.ctx[2];
  }
  set largeImage(e) {
    this.$$set({ largeImage: e }), d();
  }
  get isMobile() {
    return this.$$.ctx[3];
  }
  set isMobile(e) {
    this.$$set({ isMobile: e }), d();
  }
  get endVisible() {
    return this.$$.ctx[4];
  }
  set endVisible(e) {
    this.$$set({ endVisible: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[12];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Ut = (t, e, i) => Ie(t, e, e === "style" ? P2(i) : i), S2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, P2 = (t) => t.split(S2).filter((e) => e).map((e) => e + " !important").join(";");
function w2(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Ut(
        i,
        "fill",
        /*color*/
        t[1]
      ), Ut(i, "d", "M30 32H6C4.9 32 4 31.1 4 30V6C4 4.9 4.9 4 6 4H16C17.1 4 18 3.1 18 2C18 0.9 17.1 0 16 0H4C1.78 0 0 1.8 0 4V32C0 34.2 1.8 36 4 36H32C34.2 36 36 34.2 36 32V20C36 18.9 35.1 18 34 18C32.9 18 32 18.9 32 20V30C32 31.1 31.1 32 30 32ZM22 2C22 3.1 22.9 4 24 4H29.18L10.92 22.26C10.14 23.04 10.14 24.3 10.92 25.08C11.7 25.86 12.96 25.86 13.74 25.08L32 6.82V12C32 13.1 32.9 14 34 14C35.1 14 36 13.1 36 12V2C36 0.9 35.1 0 34 0H24C22.9 0 22 0.9 22 2Z"), Ut(e, "width", n = 14 * /*scale*/
      t[0]), Ut(e, "height", o = 14 * /*scale*/
      t[0]), Ut(e, "viewBox", "0 0 36 36"), Ut(e, "fill", "none"), Ut(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, l) {
      l & /*color*/
      2 && Ut(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 14 * /*scale*/
      s[0]) && Ut(e, "width", n), l & /*scale*/
      1 && o !== (o = 14 * /*scale*/
      s[0]) && Ut(e, "height", o);
    },
    d(s) {
      s && M(e);
    }
  };
}
function T2(t) {
  let e, i, n, o;
  return {
    c() {
      e = Se("svg"), i = Se("path"), Ut(
        i,
        "fill",
        /*color*/
        t[1]
      ), Ut(i, "d", "M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM23.76 19.08L15.26 27.58C14.48 28.36 13.22 28.36 12.44 27.58C11.66 26.8 11.66 25.54 12.44 24.76L20.94 16.26L18.4 13.72C17.76 13.08 18.22 12 19.1 12H26.98C27.54 12 27.98 12.44 27.98 13V20.88C27.98 21.78 26.9 22.22 26.28 21.58L23.76 19.08Z"), Ut(e, "width", n = 40 * /*scale*/
      t[0]), Ut(e, "height", o = 40 * /*scale*/
      t[0]), Ut(e, "viewBox", "0 0 40 40"), Ut(e, "fill", "none"), Ut(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(s, l) {
      E(s, e, l), h(e, i);
    },
    p(s, l) {
      l & /*color*/
      2 && Ut(
        i,
        "fill",
        /*color*/
        s[1]
      ), l & /*scale*/
      1 && n !== (n = 40 * /*scale*/
      s[0]) && Ut(e, "width", n), l & /*scale*/
      1 && o !== (o = 40 * /*scale*/
      s[0]) && Ut(e, "height", o);
    },
    d(s) {
      s && M(e);
    }
  };
}
function C2(t) {
  let e;
  function i(s, l) {
    return (
      /*circular*/
      s[2] ? T2 : w2
    );
  }
  let n = i(t), o = n(t);
  return {
    c() {
      o.c(), e = Ei();
    },
    m(s, l) {
      o.m(s, l), E(s, e, l);
    },
    p(s, [l]) {
      n === (n = i(s)) && o ? o.p(s, l) : (o.d(1), o = n(s), o && (o.c(), o.m(e.parentNode, e)));
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e), o.d(s);
    }
  };
}
function I2(t, e, i) {
  let { scale: n = 1 } = e, { color: o = "#323232" } = e, { circular: s = !0 } = e;
  return t.$$set = (l) => {
    "scale" in l && i(0, n = l.scale), "color" in l && i(1, o = l.color), "circular" in l && i(2, s = l.circular);
  }, [n, o, s];
}
class xr extends we {
  constructor(e) {
    super(), Pe(this, e, I2, C2, pe, { scale: 0, color: 1, circular: 2 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get circular() {
    return this.$$.ctx[2];
  }
  set circular(e) {
    this.$$set({ circular: e }), d();
  }
}
const ma = (t, e, i) => Zt(t, e, i, 1), Nn = (t, e, i) => Ie(t, e, e === "style" ? V2(i) : i), O2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, V2 = (t) => t.split(O2).filter((e) => e).map((e) => e + " !important").join(";");
function B2(t) {
  let e;
  return {
    c() {
      e = y("div");
    },
    m(i, n) {
      E(i, e, n);
    },
    p: Q,
    i: Q,
    o: Q,
    d(i) {
      i && M(e);
    }
  };
}
function W2(t) {
  let e, i, n, o, s, l;
  return i = new xr({
    props: {
      color: (
        /*color*/
        t[1]
      ),
      scale: (
        /*scale*/
        t[0]
      )
    }
  }), {
    c() {
      e = y("a"), me(i.$$.fragment), Nn(e, "class", n = "advert-button " + /*playerStyle*/
      t[2] + " " + /*controlsOrder*/
      t[3] + " svelte-17nxso5"), Nn(
        e,
        "href",
        /*hrefWithProtocol*/
        t[4]
      ), Nn(e, "target", "_blank"), ma(e, "outline-offset", 3.2 * /*scale*/
      t[0] + "px"), Nn(e, "aria-label", gt("visitAdvert"));
    },
    m(a, r) {
      E(a, e, r), de(i, e, null), o = !0, s || (l = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[5]
        ),
        Y(e, "mouseup", ai)
      ], s = !0);
    },
    p(a, r) {
      const u = {};
      r & /*color*/
      2 && (u.color = /*color*/
      a[1]), r & /*scale*/
      1 && (u.scale = /*scale*/
      a[0]), i.$set(u), (!o || r & /*playerStyle, controlsOrder*/
      12 && n !== (n = "advert-button " + /*playerStyle*/
      a[2] + " " + /*controlsOrder*/
      a[3] + " svelte-17nxso5")) && Nn(e, "class", n), (!o || r & /*hrefWithProtocol*/
      16) && Nn(
        e,
        "href",
        /*hrefWithProtocol*/
        a[4]
      ), (!o || r & /*scale*/
      1) && ma(e, "outline-offset", 3.2 * /*scale*/
      a[0] + "px");
    },
    i(a) {
      o || (V(i.$$.fragment, a), o = !0);
    },
    o(a) {
      z(i.$$.fragment, a), o = !1;
    },
    d(a) {
      a && M(e), ge(i), s = !1, _t(l);
    }
  };
}
function M2(t) {
  let e, i, n, o;
  const s = [W2, B2], l = [];
  function a(r, u) {
    return (
      /*hrefWithProtocol*/
      r[4] ? 0 : 1
    );
  }
  return e = a(t), i = l[e] = s[e](t), {
    c() {
      i.c(), n = Ei();
    },
    m(r, u) {
      l[e].m(r, u), E(r, n, u), o = !0;
    },
    p(r, [u]) {
      let c = e;
      e = a(r), e === c ? l[e].p(r, u) : (Fe(), z(l[c], 1, 1, () => {
        l[c] = null;
      }), Ue(), i = l[e], i ? i.p(r, u) : (i = l[e] = s[e](r), i.c()), V(i, 1), i.m(n.parentNode, n));
    },
    i(r) {
      o || (V(i), o = !0);
    },
    o(r) {
      z(i), o = !1;
    },
    d(r) {
      r && M(n), l[e].d(r);
    }
  };
}
function E2(t, e, i) {
  let n, { href: o } = e, { scale: s = 1 } = e, { color: l = "#323232" } = e, { playerStyle: a } = e, { controlsOrder: r } = e, { onEvent: u = () => {
  } } = e;
  const c = () => {
    n && u(ke({
      type: "PressedAdvertButton",
      description: "The advert button was pressed to open the click-through URL in a new tab.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (g) => {
    "href" in g && i(6, o = g.href), "scale" in g && i(0, s = g.scale), "color" in g && i(1, l = g.color), "playerStyle" in g && i(2, a = g.playerStyle), "controlsOrder" in g && i(3, r = g.controlsOrder), "onEvent" in g && i(7, u = g.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*href*/
    64 && i(4, n = Dr(o));
  }, [
    s,
    l,
    a,
    r,
    n,
    c,
    o,
    u
  ];
}
class z2 extends we {
  constructor(e) {
    super(), Pe(this, e, E2, M2, pe, {
      href: 6,
      scale: 0,
      color: 1,
      playerStyle: 2,
      controlsOrder: 3,
      onEvent: 7
    });
  }
  get href() {
    return this.$$.ctx[6];
  }
  set href(e) {
    this.$$set({ href: e }), d();
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[1];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get playerStyle() {
    return this.$$.ctx[2];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get controlsOrder() {
    return this.$$.ctx[3];
  }
  set controlsOrder(e) {
    this.$$set({ controlsOrder: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[7];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Dt = (t, e, i) => Ie(t, e, e === "style" ? j2(i) : i), L2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, j2 = (t) => t.split(L2).filter((e) => e).map((e) => e + " !important").join(";");
function D2(t) {
  let e, i, n, o, s, l, a, r, u;
  return {
    c() {
      e = Se("svg"), i = Se("path"), n = Se("path"), o = Se("defs"), s = Se("linearGradient"), l = Se("stop"), a = Se("stop"), Dt(i, "fill", "url(#" + /*gradientId*/
      t[3] + ")"), Dt(i, "d", "M4.51819 0C3.20323 0.00414605 2.06058 0.402167 1.23154 1.23171C0.401171 2.06225 0.00315099 3.20622 0 4.52301V4.55435C0.00613614 7.21612 1.61729 10.5771 4.523 13.4826C6.55223 15.5125 8.90619 16.989 11.1512 17.6401C11.9816 17.8809 12.7653 18 13.4871 18C14.8315 18 15.9609 17.5859 16.7732 16.7738C18.0215 15.5255 18.3298 13.5286 17.6401 11.1512C16.9891 8.90638 15.5126 6.55259 13.4826 4.52284C10.5769 1.61679 7.2161 0.00597031 4.55417 0H4.51819ZM11.5084 16.4099C9.46706 15.818 7.30764 14.4566 5.42849 12.577C1.70684 8.85563 0.199673 4.07507 2.13703 2.13737C2.7125 1.56207 3.53856 1.29058 4.51354 1.29058C6.82123 1.29058 9.9611 2.81235 12.5771 5.42851C14.4569 7.308 15.8176 9.46709 16.41 11.5083C16.9634 13.4166 16.7709 14.9649 15.8677 15.8681C15.302 16.4331 14.4843 16.72 13.4841 16.72C12.8859 16.72 12.222 16.6172 11.5084 16.4099Z"), Dt(n, "fill", "url(#" + /*gradientId*/
      t[3] + ")"), Dt(n, "d", "M11.1483 0.360687C8.90517 1.01235 6.55252 2.48946 4.52328 4.5188C0.166276 8.87725 -1.28019 14.2587 1.23026 16.7697C2.06293 17.6026 3.21138 18 4.5339 18C7.19718 18 10.5655 16.3873 13.4767 13.4752C17.8334 9.11694 19.28 3.73601 16.7702 1.22481C15.9583 0.413305 14.8303 0 13.4865 0C12.7642 0 11.9795 0.11951 11.1483 0.360687ZM2.14341 15.856C1.24354 14.9563 1.05288 13.4115 1.60627 11.5066C2.19817 9.468 3.55852 7.31101 5.43692 5.43222C7.31433 3.55376 9.47084 2.19334 11.5085 1.60093C12.2231 1.39362 12.8867 1.29071 13.4845 1.29071C14.4808 1.29071 15.2947 1.57604 15.8566 2.13856C16.7563 3.0382 16.947 4.5832 16.3937 6.48756C15.8018 8.52586 14.4415 10.683 12.5632 12.562C9.94941 15.1771 6.8127 16.6998 4.50967 16.6998C3.53911 16.6998 2.71639 16.4293 2.14341 15.856Z"), Dt(
        l,
        "stop-color",
        /*color1*/
        t[1]
      ), Dt(a, "offset", "1"), Dt(
        a,
        "stop-color",
        /*color2*/
        t[2]
      ), Dt(
        s,
        "id",
        /*gradientId*/
        t[3]
      ), Dt(s, "x1", "0"), Dt(s, "y1", "9"), Dt(s, "x2", "18"), Dt(s, "y2", "9"), Dt(s, "gradientUnits", "userSpaceOnUse"), Dt(e, "width", r = 16 * /*scale*/
      t[0]), Dt(e, "height", u = 16 * /*scale*/
      t[0]), Dt(e, "viewBox", "0 0 18 18"), Dt(e, "fill", "none"), Dt(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(c, g) {
      E(c, e, g), h(e, i), h(e, n), h(e, o), h(o, s), h(s, l), h(s, a);
    },
    p(c, [g]) {
      g & /*color1*/
      2 && Dt(
        l,
        "stop-color",
        /*color1*/
        c[1]
      ), g & /*color2*/
      4 && Dt(
        a,
        "stop-color",
        /*color2*/
        c[2]
      ), g & /*scale*/
      1 && r !== (r = 16 * /*scale*/
      c[0]) && Dt(e, "width", r), g & /*scale*/
      1 && u !== (u = 16 * /*scale*/
      c[0]) && Dt(e, "height", u);
    },
    i: Q,
    o: Q,
    d(c) {
      c && M(e);
    }
  };
}
function x2(t, e, i) {
  let { scale: n = 1 } = e, { color1: o = "#933afb" } = e, { color2: s = "#fb3a41" } = e, l = `gradient-${Math.random()}`;
  return t.$$set = (a) => {
    "scale" in a && i(0, n = a.scale), "color1" in a && i(1, o = a.color1), "color2" in a && i(2, s = a.color2);
  }, [n, o, s, l];
}
class N2 extends we {
  constructor(e) {
    super(), Pe(this, e, x2, D2, pe, { scale: 0, color1: 1, color2: 2 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color1() {
    return this.$$.ctx[1];
  }
  set color1(e) {
    this.$$set({ color1: e }), d();
  }
  get color2() {
    return this.$$.ctx[2];
  }
  set color2(e) {
    this.$$set({ color2: e }), d();
  }
}
const ha = (t, e, i) => Zt(t, e, i, 1), Xo = (t, e, i) => Ie(t, e, e === "style" ? F2(i) : i), R2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, F2 = (t) => t.split(R2).filter((e) => e).map((e) => e + " !important").join(";");
function U2(t) {
  let e, i, n, o, s;
  return i = new N2({ props: { scale: (
    /*scale*/
    t[0]
  ) } }), {
    c() {
      e = y("a"), me(i.$$.fragment), Xo(e, "class", "beyondwords svelte-vl0esb"), Xo(e, "href", "https://beyondwords.io/"), Xo(e, "target", "_blank"), ha(e, "outline-offset", 6.4 * /*scale*/
      t[0] + "px"), Xo(e, "aria-label", gt("visitBeyondWords")), ne(
        e,
        "visible",
        /*visible*/
        t[1]
      );
    },
    m(l, a) {
      E(l, e, a), de(i, e, null), n = !0, o || (s = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[2]
        ),
        Y(e, "mouseup", ai)
      ], o = !0);
    },
    p(l, [a]) {
      const r = {};
      a & /*scale*/
      1 && (r.scale = /*scale*/
      l[0]), i.$set(r), (!n || a & /*scale*/
      1) && ha(e, "outline-offset", 6.4 * /*scale*/
      l[0] + "px"), (!n || a & /*visible*/
      2) && ne(
        e,
        "visible",
        /*visible*/
        l[1]
      );
    },
    i(l) {
      n || (V(i.$$.fragment, l), n = !0);
    },
    o(l) {
      z(i.$$.fragment, l), n = !1;
    },
    d(l) {
      l && M(e), ge(i), o = !1, _t(s);
    }
  };
}
function H2(t, e, i) {
  let { scale: n = 1 } = e, { visible: o = !0 } = e, { onEvent: s = () => {
  } } = e;
  const l = () => {
    s(ke({
      type: "PressedBeyondWords",
      description: "The BeyondWords logo was pressed to open the BeyondWords website in a new tab.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (a) => {
    "scale" in a && i(0, n = a.scale), "visible" in a && i(1, o = a.visible), "onEvent" in a && i(3, s = a.onEvent);
  }, [n, o, l, s];
}
let Nr = class extends we {
  constructor(e) {
    super(), Pe(this, e, H2, U2, pe, { scale: 0, visible: 1, onEvent: 3 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get visible() {
    return this.$$.ctx[1];
  }
  set visible(e) {
    this.$$set({ visible: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[3];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
};
const lo = (t, e, i) => Ie(t, e, e === "style" ? Y2(i) : i), q2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Y2 = (t) => t.split(q2).filter((e) => e).map((e) => e + " !important").join(";");
function Z2(t) {
  let e, i, n, o, s;
  return i = new xr({
    props: {
      scale: (
        /*scale*/
        t[1]
      ),
      color: (
        /*color*/
        t[2]
      ),
      circular: !1
    }
  }), {
    c() {
      e = y("a"), me(i.$$.fragment), lo(e, "class", "source-url-button svelte-1umb4uf"), lo(
        e,
        "href",
        /*href*/
        t[0]
      ), lo(e, "target", "_blank"), lo(e, "aria-label", gt("visitSourceArticle"));
    },
    m(l, a) {
      E(l, e, a), de(i, e, null), n = !0, o || (s = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[3]
        ),
        Y(e, "mouseup", ai)
      ], o = !0);
    },
    p(l, [a]) {
      const r = {};
      a & /*scale*/
      2 && (r.scale = /*scale*/
      l[1]), a & /*color*/
      4 && (r.color = /*color*/
      l[2]), i.$set(r), (!n || a & /*href*/
      1) && lo(
        e,
        "href",
        /*href*/
        l[0]
      );
    },
    i(l) {
      n || (V(i.$$.fragment, l), n = !0);
    },
    o(l) {
      z(i.$$.fragment, l), n = !1;
    },
    d(l) {
      l && M(e), ge(i), o = !1, _t(s);
    }
  };
}
function K2(t, e, i) {
  let { href: n } = e, { scale: o = 1 } = e, { color: s = "#323232" } = e, { onEvent: l = () => {
  } } = e;
  const a = () => {
    l(ke({
      type: "PressedSourceUrl",
      description: "The source URL button was pressed to open the source article in a new tab.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (r) => {
    "href" in r && i(0, n = r.href), "scale" in r && i(1, o = r.scale), "color" in r && i(2, s = r.color), "onEvent" in r && i(4, l = r.onEvent);
  }, [n, o, s, a, l];
}
class G2 extends we {
  constructor(e) {
    super(), Pe(this, e, K2, Z2, pe, { href: 0, scale: 1, color: 2, onEvent: 4 });
  }
  get href() {
    return this.$$.ctx[0];
  }
  set href(e) {
    this.$$set({ href: e }), d();
  }
  get scale() {
    return this.$$.ctx[1];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[2];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[4];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Wi = (t, e, i) => Zt(t, e, i, 1), yi = (t, e, i) => Ie(t, e, e === "style" ? X2(i) : i), J2 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, X2 = (t) => t.split(J2).filter((e) => e).map((e) => e + " !important").join(";");
function Q2(t) {
  let e, i;
  return {
    c() {
      e = y("img"), yi(e, "class", "large-image svelte-lbzabl"), Ni(e.src, i = /*src*/
      t[0]) || yi(e, "src", i), yi(
        e,
        "alt",
        /*alt*/
        t[2]
      ), Wi(
        e,
        "width",
        /*size*/
        t[3] + "px"
      ), Wi(
        e,
        "height",
        /*size*/
        t[3] + "px"
      );
    },
    m(n, o) {
      E(n, e, o);
    },
    p(n, o) {
      o & /*src*/
      1 && !Ni(e.src, i = /*src*/
      n[0]) && yi(e, "src", i), o & /*alt*/
      4 && yi(
        e,
        "alt",
        /*alt*/
        n[2]
      ), o & /*size*/
      8 && Wi(
        e,
        "width",
        /*size*/
        n[3] + "px"
      ), o & /*size*/
      8 && Wi(
        e,
        "height",
        /*size*/
        n[3] + "px"
      );
    },
    d(n) {
      n && M(e);
    }
  };
}
function $2(t) {
  let e, i, n, o, s;
  return {
    c() {
      e = y("a"), i = y("img"), Ni(i.src, n = /*src*/
      t[0]) || yi(i, "src", n), yi(
        i,
        "alt",
        /*alt*/
        t[2]
      ), Wi(
        i,
        "width",
        /*size*/
        t[3] + "px"
      ), Wi(
        i,
        "height",
        /*size*/
        t[3] + "px"
      ), yi(e, "class", "large-image svelte-lbzabl"), yi(
        e,
        "href",
        /*href*/
        t[1]
      ), yi(e, "target", "_blank"), Wi(
        e,
        "width",
        /*size*/
        t[3] + "px"
      ), Wi(
        e,
        "height",
        /*size*/
        t[3] + "px"
      ), yi(e, "aria-label", gt("visitAdvert"));
    },
    m(l, a) {
      E(l, e, a), h(e, i), o || (s = [
        Y(
          e,
          "click",
          /*handleClick*/
          t[4]
        ),
        Y(e, "mouseup", ai)
      ], o = !0);
    },
    p(l, a) {
      a & /*src*/
      1 && !Ni(i.src, n = /*src*/
      l[0]) && yi(i, "src", n), a & /*alt*/
      4 && yi(
        i,
        "alt",
        /*alt*/
        l[2]
      ), a & /*size*/
      8 && Wi(
        i,
        "width",
        /*size*/
        l[3] + "px"
      ), a & /*size*/
      8 && Wi(
        i,
        "height",
        /*size*/
        l[3] + "px"
      ), a & /*href*/
      2 && yi(
        e,
        "href",
        /*href*/
        l[1]
      ), a & /*size*/
      8 && Wi(
        e,
        "width",
        /*size*/
        l[3] + "px"
      ), a & /*size*/
      8 && Wi(
        e,
        "height",
        /*size*/
        l[3] + "px"
      );
    },
    d(l) {
      l && M(e), o = !1, _t(s);
    }
  };
}
function e_(t) {
  let e;
  function i(s, l) {
    return (
      /*href*/
      s[1] ? $2 : Q2
    );
  }
  let n = i(t), o = n(t);
  return {
    c() {
      o.c(), e = Ei();
    },
    m(s, l) {
      o.m(s, l), E(s, e, l);
    },
    p(s, [l]) {
      n === (n = i(s)) && o ? o.p(s, l) : (o.d(1), o = n(s), o && (o.c(), o.m(e.parentNode, e)));
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e), o.d(s);
    }
  };
}
function t_(t, e, i) {
  let { src: n } = e, { href: o } = e, { alt: s = "Player Image" } = e, { size: l = 80 } = e, { onEvent: a = () => {
  } } = e;
  const r = () => {
    o && a(ke({
      type: "PressedAdvertImage",
      description: "The advert image was pressed to open the click-through URL in a new tab.",
      initiatedBy: "user"
    }));
  };
  return t.$$set = (u) => {
    "src" in u && i(0, n = u.src), "href" in u && i(1, o = u.href), "alt" in u && i(2, s = u.alt), "size" in u && i(3, l = u.size), "onEvent" in u && i(5, a = u.onEvent);
  }, [n, o, s, l, r, a];
}
class i_ extends we {
  constructor(e) {
    super(), Pe(this, e, t_, e_, pe, {
      src: 0,
      href: 1,
      alt: 2,
      size: 3,
      onEvent: 5
    });
  }
  get src() {
    return this.$$.ctx[0];
  }
  set src(e) {
    this.$$set({ src: e }), d();
  }
  get href() {
    return this.$$.ctx[1];
  }
  set href(e) {
    this.$$set({ href: e }), d();
  }
  get alt() {
    return this.$$.ctx[2];
  }
  set alt(e) {
    this.$$set({ alt: e }), d();
  }
  get size() {
    return this.$$.ctx[3];
  }
  set size(e) {
    this.$$set({ size: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[5];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Qo = (t, e, i) => Ie(t, e, e === "style" ? o_(i) : i), n_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, o_ = (t) => t.split(n_).filter((e) => e).map((e) => e + " !important").join(";");
function s_(t) {
  var o;
  let e, i = (
    /*title*/
    (((o = t[0]) == null ? void 0 : o.replaceAll(/<[^>]+>/gi, "")) || "") + ""
  ), n;
  return {
    c() {
      e = y("div"), Qo(e, "class", n = "player-title " + /*playerStyle*/
      t[1] + " svelte-q4tohi"), Qo(
        e,
        "style",
        /*style*/
        t[3]
      );
    },
    m(s, l) {
      E(s, e, l), e.innerHTML = i, t[10](e);
    },
    p(s, [l]) {
      var a;
      l & /*title*/
      1 && i !== (i = /*title*/
      (((a = s[0]) == null ? void 0 : a.replaceAll(/<[^>]+>/gi, "")) || "") + "") && (e.innerHTML = i), l & /*playerStyle*/
      2 && n !== (n = "player-title " + /*playerStyle*/
      s[1] + " svelte-q4tohi") && Qo(e, "class", n), l & /*style*/
      8 && Qo(
        e,
        "style",
        /*style*/
        s[3]
      );
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e), t[10](null);
    }
  };
}
function l_(t, e, i) {
  let n, o, { title: s } = e, { playerStyle: l } = e, { scale: a = 1 } = e, { visible: r = !0 } = e, { collapsible: u = !1 } = e, { collapsed: c = !1 } = e, { color: g = "#111" } = e, f;
  function A(_) {
    se[_ ? "unshift" : "push"](() => {
      f = _, i(2, f);
    });
  }
  return t.$$set = (_) => {
    "title" in _ && i(0, s = _.title), "playerStyle" in _ && i(1, l = _.playerStyle), "scale" in _ && i(4, a = _.scale), "visible" in _ && i(5, r = _.visible), "collapsible" in _ && i(6, u = _.collapsible), "collapsed" in _ && i(7, c = _.collapsed), "color" in _ && i(8, g = _.color);
  }, t.$$.update = () => {
    t.$$.dirty & /*collapsed, collapsible, element*/
    196 && i(9, n = c ? 0 : u && f ? `${f.scrollWidth}px` : "auto"), t.$$.dirty & /*scale, visible, width, collapsed, color*/
    944 && i(3, o = `font-size: ${12 * a}px; visibility: ${r ? "visible" : "hidden"}; width: ${n}; opacity: ${c ? 0 : 1}; color: ${g}`);
  }, [
    s,
    l,
    f,
    o,
    a,
    r,
    u,
    c,
    g,
    n,
    A
  ];
}
class Rr extends we {
  constructor(e) {
    super(), Pe(this, e, l_, s_, pe, {
      title: 0,
      playerStyle: 1,
      scale: 4,
      visible: 5,
      collapsible: 6,
      collapsed: 7,
      color: 8
    });
  }
  get title() {
    return this.$$.ctx[0];
  }
  set title(e) {
    this.$$set({ title: e }), d();
  }
  get playerStyle() {
    return this.$$.ctx[1];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get scale() {
    return this.$$.ctx[4];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get visible() {
    return this.$$.ctx[5];
  }
  set visible(e) {
    this.$$set({ visible: e }), d();
  }
  get collapsible() {
    return this.$$.ctx[6];
  }
  set collapsible(e) {
    this.$$set({ collapsible: e }), d();
  }
  get collapsed() {
    return this.$$.ctx[7];
  }
  set collapsed(e) {
    this.$$set({ collapsed: e }), d();
  }
  get color() {
    return this.$$.ctx[8];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const Qs = (t, e, i) => Ie(t, e, e === "style" ? r_(i) : i), a_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, r_ = (t) => t.split(a_).filter((e) => e).map((e) => e + " !important").join(";");
function u_(t) {
  var n;
  let e, i = (
    /*title*/
    (((n = t[0]) == null ? void 0 : n.replaceAll(/<[^>]+>/gi, "")) || "") + ""
  );
  return {
    c() {
      e = y("div"), Qs(e, "class", "content-title svelte-mtaayt"), Qs(
        e,
        "style",
        /*style*/
        t[4]
      ), ne(
        e,
        "bold",
        /*bold*/
        t[3]
      ), ne(
        e,
        "one-line",
        /*maxLines*/
        t[1] === 1
      ), ne(
        e,
        "center",
        /*center*/
        t[2]
      ), ne(
        e,
        "n-lines",
        /*maxLines*/
        t[1] > 1
      );
    },
    m(o, s) {
      E(o, e, s), e.innerHTML = i;
    },
    p(o, [s]) {
      var l;
      s & /*title*/
      1 && i !== (i = /*title*/
      (((l = o[0]) == null ? void 0 : l.replaceAll(/<[^>]+>/gi, "")) || "") + "") && (e.innerHTML = i), s & /*style*/
      16 && Qs(
        e,
        "style",
        /*style*/
        o[4]
      ), s & /*bold*/
      8 && ne(
        e,
        "bold",
        /*bold*/
        o[3]
      ), s & /*maxLines*/
      2 && ne(
        e,
        "one-line",
        /*maxLines*/
        o[1] === 1
      ), s & /*center*/
      4 && ne(
        e,
        "center",
        /*center*/
        o[2]
      ), s & /*maxLines*/
      2 && ne(
        e,
        "n-lines",
        /*maxLines*/
        o[1] > 1
      );
    },
    i: Q,
    o: Q,
    d(o) {
      o && M(e);
    }
  };
}
function c_(t, e, i) {
  let n, o, s, l, { title: a } = e, { maxLines: r = 1 } = e, { maxWidth: u = void 0 } = e, { center: c = !1 } = e, { bold: g = !1 } = e, { flex: f = "0 1 auto" } = e, { scale: A = 1 } = e, { color: _ = "#111" } = e;
  return t.$$set = (k) => {
    "title" in k && i(0, a = k.title), "maxLines" in k && i(1, r = k.maxLines), "maxWidth" in k && i(5, u = k.maxWidth), "center" in k && i(2, c = k.center), "bold" in k && i(3, g = k.bold), "flex" in k && i(6, f = k.flex), "scale" in k && i(7, A = k.scale), "color" in k && i(8, _ = k.color);
  }, t.$$.update = () => {
    t.$$.dirty & /*scale*/
    128 && i(11, n = `${10 * A}px`), t.$$.dirty & /*scale, maxLines*/
    130 && i(10, o = `${10 * A * 1.2 * r}px`), t.$$.dirty & /*maxWidth*/
    32 && i(9, s = u ? `max-width: ${u}px` : ""), t.$$.dirty & /*maxLines, fontSize, maxHeight, flex, maxWidthCss, color*/
    3906 && i(4, l = `--n: ${r}; font-size: ${n}; max-height: ${o}; flex: ${f}; ${s}; color: ${_}`);
  }, [
    a,
    r,
    c,
    g,
    l,
    u,
    f,
    A,
    _,
    s,
    o,
    n
  ];
}
class Bl extends we {
  constructor(e) {
    super(), Pe(this, e, c_, u_, pe, {
      title: 0,
      maxLines: 1,
      maxWidth: 5,
      center: 2,
      bold: 3,
      flex: 6,
      scale: 7,
      color: 8
    });
  }
  get title() {
    return this.$$.ctx[0];
  }
  set title(e) {
    this.$$set({ title: e }), d();
  }
  get maxLines() {
    return this.$$.ctx[1];
  }
  set maxLines(e) {
    this.$$set({ maxLines: e }), d();
  }
  get maxWidth() {
    return this.$$.ctx[5];
  }
  set maxWidth(e) {
    this.$$set({ maxWidth: e }), d();
  }
  get center() {
    return this.$$.ctx[2];
  }
  set center(e) {
    this.$$set({ center: e }), d();
  }
  get bold() {
    return this.$$.ctx[3];
  }
  set bold(e) {
    this.$$set({ bold: e }), d();
  }
  get flex() {
    return this.$$.ctx[6];
  }
  set flex(e) {
    this.$$set({ flex: e }), d();
  }
  get scale() {
    return this.$$.ctx[7];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[8];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const gs = (t, e, i = () => {
}) => (n) => {
  let o;
  n.key === "ArrowLeft" && (o = "Left"), n.key === "ArrowRight" && (o = "Right"), n.key === " " && (o = "Space"), n.key === "Enter" && (o = "Enter"), o && (n.preventDefault(), t(ke({
    type: `Pressed${o}OnProgress${e}`,
    description: `The ${o.toLowerCase()} key was pressed while the progress ${e.toLowerCase()} was focussed.`,
    initiatedBy: "user"
  })), (o === "Left" || o === "Right") && i());
}, Rn = (t, e, i) => Zt(t, e, i, 1), Ai = (t, e, i) => Ie(t, e, e === "style" ? g_(i) : i), d_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, g_ = (t) => t.split(d_).filter((e) => e).map((e) => e + " !important").join(";");
function f_(t) {
  let e, i, n, o, s, l, a;
  return {
    c() {
      e = y("div"), i = y("div"), n = J(), o = y("div"), Ai(i, "class", "background svelte-1ubgowb"), Rn(
        i,
        "background",
        /*color*/
        t[4]
      ), Ai(o, "class", "progress svelte-1ubgowb"), Rn(
        o,
        "background",
        /*color*/
        t[4]
      ), Rn(
        o,
        "width",
        /*progress*/
        t[0] * 100 + "%"
      ), Ai(e, "type", "button"), Ai(e, "tabindex", "0"), Ai(e, "role", "slider"), Ai(e, "class", "progress-bar svelte-1ubgowb"), Ai(e, "aria-label", gt("playbackTime")), Ai(
        e,
        "aria-valuetext",
        /*ariaText*/
        t[9]
      ), Ai(
        e,
        "aria-valuenow",
        /*stickySeconds*/
        t[6]
      ), Ai(e, "aria-valuemin", 0), Ai(e, "aria-valuemax", s = Math.floor(
        /*duration*/
        t[1]
      )), ne(
        e,
        "full-width",
        /*fullWidth*/
        t[2]
      ), ne(
        e,
        "readonly",
        /*readonly*/
        t[3]
      ), ne(
        e,
        "mouse-down",
        /*mouseDown*/
        t[8]
      );
    },
    m(r, u) {
      E(r, e, u), h(e, i), h(e, n), h(e, o), t[17](e), l || (a = [
        Y(
          e,
          "mousedown",
          /*handleMouseDown*/
          t[12]
        ),
        Y(
          e,
          "touchstart",
          /*handleMouseDown*/
          t[12]
        ),
        Y(e, "keydown", function() {
          Xn(gs(
            /*onEvent*/
            t[5],
            "Bar",
            /*handleLeftOrRight*/
            t[11]
          )) && gs(
            /*onEvent*/
            t[5],
            "Bar",
            /*handleLeftOrRight*/
            t[11]
          ).apply(this, arguments);
        }),
        Y(e, "mouseup", ai),
        Y(
          e,
          "focus",
          /*handleFocus*/
          t[10]
        )
      ], l = !0);
    },
    p(r, [u]) {
      t = r, u & /*color*/
      16 && Rn(
        i,
        "background",
        /*color*/
        t[4]
      ), u & /*color*/
      16 && Rn(
        o,
        "background",
        /*color*/
        t[4]
      ), u & /*progress*/
      1 && Rn(
        o,
        "width",
        /*progress*/
        t[0] * 100 + "%"
      ), u & /*ariaText*/
      512 && Ai(
        e,
        "aria-valuetext",
        /*ariaText*/
        t[9]
      ), u & /*stickySeconds*/
      64 && Ai(
        e,
        "aria-valuenow",
        /*stickySeconds*/
        t[6]
      ), u & /*duration*/
      2 && s !== (s = Math.floor(
        /*duration*/
        t[1]
      )) && Ai(e, "aria-valuemax", s), u & /*fullWidth*/
      4 && ne(
        e,
        "full-width",
        /*fullWidth*/
        t[2]
      ), u & /*readonly*/
      8 && ne(
        e,
        "readonly",
        /*readonly*/
        t[3]
      ), u & /*mouseDown*/
      256 && ne(
        e,
        "mouse-down",
        /*mouseDown*/
        t[8]
      );
    },
    i: Q,
    o: Q,
    d(r) {
      r && M(e), t[17](null), l = !1, _t(a);
    }
  };
}
function m_(t, e, i) {
  let n, o, s, l, { progress: a = 0 } = e, { duration: r = 0 } = e, { fullWidth: u = !1 } = e, { readonly: c = !1 } = e, { color: g = "#323232" } = e, { onEvent: f = () => {
  } } = e, A, _, k = !0, S = !0;
  const T = () => {
    i(13, k = !0), i(14, S = !0);
  }, v = () => {
    i(13, k = !0), i(14, S = !1);
  }, P = (x) => {
    i(8, _ = !0), f(ke({
      type: "PressedProgressBar",
      description: "The progress bar was pressed at some ratio.",
      initiatedBy: "user",
      ratio: p(x)
    }));
  }, O = (x) => {
    if (_) {
      if (!A) {
        D();
        return;
      }
      f(ke({
        type: "ScrubbedProgressBar",
        description: "The user pressed on the progress bar then dragged.",
        initiatedBy: "user",
        ratio: p(x)
      }));
    }
  }, D = () => {
    _ && (i(8, _ = !1), f(ke({
      type: "FinishedScrubbingProgressBar",
      description: "The user let go after scrubbing the progress bar.",
      initiatedBy: "user"
    })));
  }, p = (x) => {
    var ee, ue;
    const X = x.clientX || ((ue = (ee = x.touches) == null ? void 0 : ee[0]) == null ? void 0 : ue.clientX) || 0, { x: oe, width: ae } = A.getBoundingClientRect(), $ = (X - oe) / ae;
    return Math.max(0, Math.min(1, $));
  }, C = (x) => {
    const X = Math.floor(x);
    if (X === 0)
      return gt("secondsPlural").replace("{n}", 0);
    const oe = Math.floor(X / 60), ae = X % 60;
    return [Z(oe, "minutes"), Z(ae, "seconds")].filter(($) => $).join(" ");
  }, Z = (x, X) => {
    if (x === 0)
      return;
    const oe = x === 1 ? `${X}Singular` : `${X}Plural`;
    return gt(oe).replace("{n}", x);
  };
  Vo(() => {
    const x = addEventListener("mouseup", D), X = addEventListener("mousemove", O), oe = addEventListener("touchend", D), ae = addEventListener("touchmove", O);
    return () => {
      removeEventListener("mouseup", x), removeEventListener("mousemove", X), removeEventListener("touchend", oe), removeEventListener("touchmove", ae);
    };
  });
  function q(x) {
    se[x ? "unshift" : "push"](() => {
      A = x, i(7, A);
    });
  }
  return t.$$set = (x) => {
    "progress" in x && i(0, a = x.progress), "duration" in x && i(1, r = x.duration), "fullWidth" in x && i(2, u = x.fullWidth), "readonly" in x && i(3, c = x.readonly), "color" in x && i(4, g = x.color), "onEvent" in x && i(5, f = x.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*updateSticky*/
    8192 && setTimeout(() => i(13, k = !1), 0), t.$$.dirty & /*updateSticky, progress, stickyProgress*/
    73729 && i(16, n = k ? Math.max(0, Math.min(a, 1)) : n), t.$$.dirty & /*stickyProgress, duration*/
    65538 && i(6, o = n * r), t.$$.dirty & /*readFullTime, duration*/
    16386 && i(15, s = S ? `${gt("outOfTotalTime")} ${C(r)}` : ""), t.$$.dirty & /*stickySeconds, outOf*/
    32832 && i(9, l = `${C(o)} ${s}`);
  }, [
    a,
    r,
    u,
    c,
    g,
    f,
    o,
    A,
    _,
    l,
    T,
    v,
    P,
    k,
    S,
    s,
    n,
    q
  ];
}
class h_ extends we {
  constructor(e) {
    super(), Pe(this, e, m_, f_, pe, {
      progress: 0,
      duration: 1,
      fullWidth: 2,
      readonly: 3,
      color: 4,
      onEvent: 5
    });
  }
  get progress() {
    return this.$$.ctx[0];
  }
  set progress(e) {
    this.$$set({ progress: e }), d();
  }
  get duration() {
    return this.$$.ctx[1];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get fullWidth() {
    return this.$$.ctx[2];
  }
  set fullWidth(e) {
    this.$$set({ fullWidth: e }), d();
  }
  get readonly() {
    return this.$$.ctx[3];
  }
  set readonly(e) {
    this.$$set({ readonly: e }), d();
  }
  get color() {
    return this.$$.ctx[4];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[5];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const $o = (t, e, i) => Zt(t, e, i, 1), xt = (t, e, i) => Ie(t, e, e === "style" ? A_(i) : i), __ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, A_ = (t) => t.split(__).filter((e) => e).map((e) => e + " !important").join(";");
function y_(t) {
  let e;
  const i = (
    /*#slots*/
    t[13].default
  ), n = Qn(
    i,
    t,
    /*$$scope*/
    t[12],
    null
  );
  return {
    c() {
      n && n.c();
    },
    m(o, s) {
      n && n.m(o, s), e = !0;
    },
    p(o, s) {
      n && n.p && (!e || s & /*$$scope*/
      4096) && eo(
        n,
        i,
        o,
        /*$$scope*/
        o[12],
        e ? $n(
          i,
          /*$$scope*/
          o[12],
          s,
          null
        ) : to(
          /*$$scope*/
          o[12]
        ),
        null
      );
    },
    i(o) {
      e || (V(n, o), e = !0);
    },
    o(o) {
      z(n, o), e = !1;
    },
    d(o) {
      n && n.d(o);
    }
  };
}
function v_(t) {
  let e, i, n, o, s, l, a, r;
  const u = (
    /*#slots*/
    t[13].default
  ), c = Qn(
    u,
    t,
    /*$$scope*/
    t[12],
    null
  );
  return {
    c() {
      e = y("div"), i = Se("svg"), n = Se("circle"), s = J(), c && c.c(), xt(n, "cx", "50%"), xt(n, "cy", "50%"), xt(
        n,
        "r",
        /*radius*/
        t[5]
      ), xt(
        n,
        "stroke",
        /*color*/
        t[2]
      ), xt(
        n,
        "stroke-width",
        /*strokeWidth*/
        t[6]
      ), xt(n, "stroke-dasharray", o = /*circumference*/
      t[4] + " " + /*circumference*/
      t[4]), xt(
        n,
        "stroke-dashoffset",
        /*dashOffset*/
        t[7]
      ), xt(i, "fill", "none"), xt(
        i,
        "width",
        /*size*/
        t[8]
      ), xt(
        i,
        "height",
        /*size*/
        t[8]
      ), xt(i, "xmlns", "http://www.w3.org/2000/svg"), xt(i, "class", "svelte-niuvgx"), xt(e, "class", "progress-circle svelte-niuvgx"), xt(e, "role", "none"), $o(
        e,
        "width",
        /*scale*/
        t[1] * 40 + "px"
      ), $o(
        e,
        "height",
        /*scale*/
        t[1] * 40 + "px"
      );
    },
    m(g, f) {
      E(g, e, f), h(e, i), h(i, n), h(e, s), c && c.m(e, null), l = !0, a || (r = Y(e, "keydown", function() {
        Xn(gs(
          /*onEvent*/
          t[3],
          "Circle"
        )) && gs(
          /*onEvent*/
          t[3],
          "Circle"
        ).apply(this, arguments);
      }), a = !0);
    },
    p(g, f) {
      t = g, (!l || f & /*radius*/
      32) && xt(
        n,
        "r",
        /*radius*/
        t[5]
      ), (!l || f & /*color*/
      4) && xt(
        n,
        "stroke",
        /*color*/
        t[2]
      ), (!l || f & /*strokeWidth*/
      64) && xt(
        n,
        "stroke-width",
        /*strokeWidth*/
        t[6]
      ), (!l || f & /*circumference*/
      16 && o !== (o = /*circumference*/
      t[4] + " " + /*circumference*/
      t[4])) && xt(n, "stroke-dasharray", o), (!l || f & /*dashOffset*/
      128) && xt(
        n,
        "stroke-dashoffset",
        /*dashOffset*/
        t[7]
      ), (!l || f & /*size*/
      256) && xt(
        i,
        "width",
        /*size*/
        t[8]
      ), (!l || f & /*size*/
      256) && xt(
        i,
        "height",
        /*size*/
        t[8]
      ), c && c.p && (!l || f & /*$$scope*/
      4096) && eo(
        c,
        u,
        t,
        /*$$scope*/
        t[12],
        l ? $n(
          u,
          /*$$scope*/
          t[12],
          f,
          null
        ) : to(
          /*$$scope*/
          t[12]
        ),
        null
      ), (!l || f & /*scale*/
      2) && $o(
        e,
        "width",
        /*scale*/
        t[1] * 40 + "px"
      ), (!l || f & /*scale*/
      2) && $o(
        e,
        "height",
        /*scale*/
        t[1] * 40 + "px"
      );
    },
    i(g) {
      l || (V(c, g), l = !0);
    },
    o(g) {
      z(c, g), l = !1;
    },
    d(g) {
      g && M(e), c && c.d(g), a = !1, r();
    }
  };
}
function b_(t) {
  let e, i, n, o;
  const s = [v_, y_], l = [];
  function a(r, u) {
    return (
      /*enabled*/
      r[0] ? 0 : 1
    );
  }
  return e = a(t), i = l[e] = s[e](t), {
    c() {
      i.c(), n = Ei();
    },
    m(r, u) {
      l[e].m(r, u), E(r, n, u), o = !0;
    },
    p(r, [u]) {
      let c = e;
      e = a(r), e === c ? l[e].p(r, u) : (Fe(), z(l[c], 1, 1, () => {
        l[c] = null;
      }), Ue(), i = l[e], i ? i.p(r, u) : (i = l[e] = s[e](r), i.c()), V(i, 1), i.m(n.parentNode, n));
    },
    i(r) {
      o || (V(i), o = !0);
    },
    o(r) {
      z(i), o = !1;
    },
    d(r) {
      r && M(n), l[e].d(r);
    }
  };
}
function k_(t, e, i) {
  let n, o, s, l, a, r, { $$slots: u = {}, $$scope: c } = e, { progress: g = 0 } = e, { enabled: f = !1 } = e, { bold: A } = e, { scale: _ = 1 } = e, { color: k = "#323232" } = e, { onEvent: S = () => {
  } } = e;
  return t.$$set = (T) => {
    "progress" in T && i(9, g = T.progress), "enabled" in T && i(0, f = T.enabled), "bold" in T && i(10, A = T.bold), "scale" in T && i(1, _ = T.scale), "color" in T && i(2, k = T.color), "onEvent" in T && i(3, S = T.onEvent), "$$scope" in T && i(12, c = T.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*scale, bold*/
    1026 && i(6, n = _ * (A ? 2.5 : 1.667)), t.$$.dirty & /*scale, strokeWidth, bold*/
    1090 && i(5, o = 20 * _ + n * (A ? 1 : 1.5)), t.$$.dirty & /*radius, strokeWidth*/
    96 && i(8, s = 2 * o + n), t.$$.dirty & /*radius*/
    32 && i(4, l = o * 2 * Math.PI), t.$$.dirty & /*progress*/
    512 && i(11, a = Math.max(0, Math.min(1, g))), t.$$.dirty & /*circumference, clamped*/
    2064 && i(7, r = l * (1 - a));
  }, [
    f,
    _,
    k,
    S,
    l,
    o,
    n,
    r,
    s,
    g,
    A,
    a,
    c,
    u
  ];
}
class p_ extends we {
  constructor(e) {
    super(), Pe(this, e, k_, b_, pe, {
      progress: 9,
      enabled: 0,
      bold: 10,
      scale: 1,
      color: 2,
      onEvent: 3
    });
  }
  get progress() {
    return this.$$.ctx[9];
  }
  set progress(e) {
    this.$$set({ progress: e }), d();
  }
  get enabled() {
    return this.$$.ctx[0];
  }
  set enabled(e) {
    this.$$set({ enabled: e }), d();
  }
  get bold() {
    return this.$$.ctx[10];
  }
  set bold(e) {
    this.$$set({ bold: e }), d();
  }
  get scale() {
    return this.$$.ctx[1];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[2];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[3];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const qn = (t) => {
  t < 0 && (t = Math.max(0, t));
  const e = Math.floor(t / 3600).toString();
  let i = Math.floor(t % 3600 / 60).toString(), n = Math.floor(t % 60).toString();
  return n.length < 2 && (n = `0${n}`), t < 3600 ? `${i}:${n}` : (i.length < 2 && (i = `0${i}`), `${e}:${i}:${n}`);
}, es = (t, e, i) => Zt(t, e, i, 1), S_ = (t, e, i) => Ie(t, e, e === "style" ? w_(i) : i), P_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, w_ = (t) => t.split(P_).filter((e) => e).map((e) => e + " !important").join(";");
function T_(t) {
  let e, i, n, o = qn(
    /*remaining*/
    t[1]
  ) + "", s;
  return {
    c() {
      e = y("span"), i = ie(
        /*text*/
        t[0]
      ), n = ie(" • "), s = ie(o), S_(e, "class", "countdown-time svelte-mmsohq"), es(e, "font-size", 10 * /*scale*/
      t[2] + "px"), es(
        e,
        "color",
        /*color*/
        t[3]
      );
    },
    m(l, a) {
      E(l, e, a), h(e, i), h(e, n), h(e, s);
    },
    p(l, [a]) {
      a & /*text*/
      1 && bi(
        i,
        /*text*/
        l[0]
      ), a & /*remaining*/
      2 && o !== (o = qn(
        /*remaining*/
        l[1]
      ) + "") && bi(s, o), a & /*scale*/
      4 && es(e, "font-size", 10 * /*scale*/
      l[2] + "px"), a & /*color*/
      8 && es(
        e,
        "color",
        /*color*/
        l[3]
      );
    },
    i: Q,
    o: Q,
    d(l) {
      l && M(e);
    }
  };
}
function C_(t, e, i) {
  let { text: n } = e, { remaining: o } = e, { scale: s = 1 } = e, { color: l = "#323232" } = e;
  return t.$$set = (a) => {
    "text" in a && i(0, n = a.text), "remaining" in a && i(1, o = a.remaining), "scale" in a && i(2, s = a.scale), "color" in a && i(3, l = a.color);
  }, [n, o, s, l];
}
class I_ extends we {
  constructor(e) {
    super(), Pe(this, e, C_, T_, pe, {
      text: 0,
      remaining: 1,
      scale: 2,
      color: 3
    });
  }
  get text() {
    return this.$$.ctx[0];
  }
  set text(e) {
    this.$$set({ text: e }), d();
  }
  get remaining() {
    return this.$$.ctx[1];
  }
  set remaining(e) {
    this.$$set({ remaining: e }), d();
  }
  get scale() {
    return this.$$.ctx[2];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[3];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const ts = (t, e, i) => Zt(t, e, i, 1), O_ = (t, e, i) => Ie(t, e, e === "style" ? B_(i) : i), V_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, B_ = (t) => t.split(V_).filter((e) => e).map((e) => e + " !important").join(";");
function W_(t) {
  let e = gt("minutesSingularOrPlural").replace(
    "{n}",
    /*minutes*/
    t[5]
  ) + "", i;
  return {
    c() {
      i = ie(e);
    },
    m(n, o) {
      E(n, i, o);
    },
    p(n, o) {
      o & /*minutes*/
      32 && e !== (e = gt("minutesSingularOrPlural").replace(
        "{n}",
        /*minutes*/
        n[5]
      ) + "") && bi(i, e);
    },
    d(n) {
      n && M(i);
    }
  };
}
function M_(t) {
  let e = (
    /*durationFormat*/
    t[0](
      /*minutes*/
      t[5],
      /*seconds*/
      t[4],
      gt
    ) + ""
  ), i;
  return {
    c() {
      i = ie(e);
    },
    m(n, o) {
      E(n, i, o);
    },
    p(n, o) {
      o & /*durationFormat, minutes, seconds*/
      49 && e !== (e = /*durationFormat*/
      n[0](
        /*minutes*/
        n[5],
        /*seconds*/
        n[4],
        gt
      ) + "") && bi(i, e);
    },
    d(n) {
      n && M(i);
    }
  };
}
function E_(t) {
  let e;
  function i(s, l) {
    return (
      /*durationFormat*/
      s[0] ? M_ : W_
    );
  }
  let n = i(t), o = n(t);
  return {
    c() {
      e = y("div"), o.c(), O_(e, "class", "duration-in-mins svelte-121qsze"), ts(e, "font-size", 10 * /*scale*/
      t[2] + "px"), ts(
        e,
        "color",
        /*color*/
        t[3]
      ), ne(
        e,
        "bold",
        /*bold*/
        t[1]
      );
    },
    m(s, l) {
      E(s, e, l), o.m(e, null);
    },
    p(s, [l]) {
      n === (n = i(s)) && o ? o.p(s, l) : (o.d(1), o = n(s), o && (o.c(), o.m(e, null))), l & /*scale*/
      4 && ts(e, "font-size", 10 * /*scale*/
      s[2] + "px"), l & /*color*/
      8 && ts(
        e,
        "color",
        /*color*/
        s[3]
      ), l & /*bold*/
      2 && ne(
        e,
        "bold",
        /*bold*/
        s[1]
      );
    },
    i: Q,
    o: Q,
    d(s) {
      s && M(e), o.d();
    }
  };
}
function z_(t, e, i) {
  let n, o, { duration: s = 0 } = e, { durationFormat: l = void 0 } = e, { bold: a = !1 } = e, { scale: r = 1 } = e, { color: u = "#323232" } = e;
  return t.$$set = (c) => {
    "duration" in c && i(6, s = c.duration), "durationFormat" in c && i(0, l = c.durationFormat), "bold" in c && i(1, a = c.bold), "scale" in c && i(2, r = c.scale), "color" in c && i(3, u = c.color);
  }, t.$$.update = () => {
    t.$$.dirty & /*duration*/
    64 && i(5, n = Math.max(1, Math.round((s || 0) / 60))), t.$$.dirty & /*duration*/
    64 && i(4, o = Math.round(s || 0) % 60);
  }, [l, a, r, u, o, n, s];
}
class Fr extends we {
  constructor(e) {
    super(), Pe(this, e, z_, E_, pe, {
      duration: 6,
      durationFormat: 0,
      bold: 1,
      scale: 2,
      color: 3
    });
  }
  get duration() {
    return this.$$.ctx[6];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get durationFormat() {
    return this.$$.ctx[0];
  }
  set durationFormat(e) {
    this.$$set({ durationFormat: e }), d();
  }
  get bold() {
    return this.$$.ctx[1];
  }
  set bold(e) {
    this.$$set({ bold: e }), d();
  }
  get scale() {
    return this.$$.ctx[2];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[3];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const is = (t, e, i) => Zt(t, e, i, 1), L_ = (t, e, i) => Ie(t, e, e === "style" ? D_(i) : i), j_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, D_ = (t) => t.split(j_).filter((e) => e).map((e) => e + " !important").join(";");
function x_(t) {
  let e, i = qn(
    /*currentTime*/
    t[0]
  ) + "", n, o, s = qn(
    /*duration*/
    t[1]
  ) + "", l;
  return {
    c() {
      e = y("span"), n = ie(i), o = ie(" / "), l = ie(s), L_(e, "class", "playback-time svelte-17necdw"), is(e, "font-size", 10 * /*scale*/
      t[2] + "px"), is(
        e,
        "color",
        /*color*/
        t[3]
      );
    },
    m(a, r) {
      E(a, e, r), h(e, n), h(e, o), h(e, l);
    },
    p(a, [r]) {
      r & /*currentTime*/
      1 && i !== (i = qn(
        /*currentTime*/
        a[0]
      ) + "") && bi(n, i), r & /*duration*/
      2 && s !== (s = qn(
        /*duration*/
        a[1]
      ) + "") && bi(l, s), r & /*scale*/
      4 && is(e, "font-size", 10 * /*scale*/
      a[2] + "px"), r & /*color*/
      8 && is(
        e,
        "color",
        /*color*/
        a[3]
      );
    },
    i: Q,
    o: Q,
    d(a) {
      a && M(e);
    }
  };
}
function N_(t, e, i) {
  let { currentTime: n = 0 } = e, { duration: o = 0 } = e, { scale: s = 1 } = e, { color: l = "#323232" } = e;
  return t.$$set = (a) => {
    "currentTime" in a && i(0, n = a.currentTime), "duration" in a && i(1, o = a.duration), "scale" in a && i(2, s = a.scale), "color" in a && i(3, l = a.color);
  }, [n, o, s, l];
}
class R_ extends we {
  constructor(e) {
    super(), Pe(this, e, N_, x_, pe, {
      currentTime: 0,
      duration: 1,
      scale: 2,
      color: 3
    });
  }
  get currentTime() {
    return this.$$.ctx[0];
  }
  set currentTime(e) {
    this.$$set({ currentTime: e }), d();
  }
  get duration() {
    return this.$$.ctx[1];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get scale() {
    return this.$$.ctx[2];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get color() {
    return this.$$.ctx[3];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const ao = (t, e, i) => Ie(t, e, e === "style" ? U_(i) : i), F_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, U_ = (t) => t.split(F_).filter((e) => e).map((e) => e + " !important").join(";");
function H_(t) {
  let e, i;
  return e = new R_({
    props: {
      duration: (
        /*duration*/
        t[0]
      ),
      currentTime: (
        /*currentTime*/
        t[2]
      ),
      scale: (
        /*scale*/
        t[13]
      ),
      color: (
        /*color*/
        t[10]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*duration*/
      1 && (s.duration = /*duration*/
      n[0]), o & /*currentTime*/
      4 && (s.currentTime = /*currentTime*/
      n[2]), o & /*scale*/
      8192 && (s.scale = /*scale*/
      n[13]), o & /*color*/
      1024 && (s.color = /*color*/
      n[10]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function q_(t) {
  let e, i;
  return e = new Fr({
    props: {
      duration: (
        /*duration*/
        t[0]
      ),
      durationFormat: (
        /*durationFormat*/
        t[1]
      ),
      scale: (
        /*scale*/
        t[13]
      ),
      color: (
        /*color*/
        t[10]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*duration*/
      1 && (s.duration = /*duration*/
      n[0]), o & /*durationFormat*/
      2 && (s.durationFormat = /*durationFormat*/
      n[1]), o & /*scale*/
      8192 && (s.scale = /*scale*/
      n[13]), o & /*color*/
      1024 && (s.color = /*color*/
      n[10]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Y_(t) {
  let e, i;
  return e = new I_({
    props: {
      text: "Ad",
      remaining: (
        /*remaining*/
        t[14]
      ),
      scale: (
        /*scale*/
        t[13]
      ),
      color: (
        /*color*/
        t[10]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o & /*remaining*/
      16384 && (s.remaining = /*remaining*/
      n[14]), o & /*scale*/
      8192 && (s.scale = /*scale*/
      n[13]), o & /*color*/
      1024 && (s.color = /*color*/
      n[10]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Z_(t) {
  return {
    c: Q,
    m: Q,
    p: Q,
    i: Q,
    o: Q,
    d: Q
  };
}
function K_(t) {
  let e, i, n, o, s, l;
  const a = [Z_, Y_, q_, H_], r = [];
  function u(c, g) {
    return (
      /*isAdvert*/
      c[6] && /*currentTime*/
      c[2] === 0 ? 0 : (
        /*isAdvert*/
        c[6] ? 1 : (
          /*isStopped*/
          c[7] ? 2 : 3
        )
      )
    );
  }
  return n = u(t), o = r[n] = a[n](t), {
    c() {
      e = y("div"), i = y("div"), o.c(), ao(i, "class", "inner svelte-pvh6ay"), ao(e, "class", s = "time-indicator " + /*playerStyle*/
      t[3] + " " + /*positionClasses*/
      t[4] + " svelte-pvh6ay"), ao(
        e,
        "style",
        /*opacityCss*/
        t[12]
      ), ne(
        e,
        "mobile",
        /*isMobile*/
        t[5]
      ), ne(
        e,
        "advert_",
        /*isAdvert*/
        t[6]
      ), ne(
        e,
        "stopped",
        /*isStopped*/
        t[7]
      ), ne(e, "no-image", !/*largeImage*/
      t[8]), ne(e, "no-logo", !/*showBeyondWords*/
      t[9]), ne(
        e,
        "no-transition",
        /*noTransition*/
        t[11]
      );
    },
    m(c, g) {
      E(c, e, g), h(e, i), r[n].m(i, null), l = !0;
    },
    p(c, [g]) {
      let f = n;
      n = u(c), n === f ? r[n].p(c, g) : (Fe(), z(r[f], 1, 1, () => {
        r[f] = null;
      }), Ue(), o = r[n], o ? o.p(c, g) : (o = r[n] = a[n](c), o.c()), V(o, 1), o.m(i, null)), (!l || g & /*playerStyle, positionClasses*/
      24 && s !== (s = "time-indicator " + /*playerStyle*/
      c[3] + " " + /*positionClasses*/
      c[4] + " svelte-pvh6ay")) && ao(e, "class", s), (!l || g & /*opacityCss*/
      4096) && ao(
        e,
        "style",
        /*opacityCss*/
        c[12]
      ), (!l || g & /*playerStyle, positionClasses, isMobile*/
      56) && ne(
        e,
        "mobile",
        /*isMobile*/
        c[5]
      ), (!l || g & /*playerStyle, positionClasses, isAdvert*/
      88) && ne(
        e,
        "advert_",
        /*isAdvert*/
        c[6]
      ), (!l || g & /*playerStyle, positionClasses, isStopped*/
      152) && ne(
        e,
        "stopped",
        /*isStopped*/
        c[7]
      ), (!l || g & /*playerStyle, positionClasses, largeImage*/
      280) && ne(e, "no-image", !/*largeImage*/
      c[8]), (!l || g & /*playerStyle, positionClasses, showBeyondWords*/
      536) && ne(e, "no-logo", !/*showBeyondWords*/
      c[9]), (!l || g & /*playerStyle, positionClasses, noTransition*/
      2072) && ne(
        e,
        "no-transition",
        /*noTransition*/
        c[11]
      );
    },
    i(c) {
      l || (V(o), l = !0);
    },
    o(c) {
      z(o), l = !1;
    },
    d(c) {
      c && M(e), r[n].d();
    }
  };
}
function G_(t, e, i) {
  let n, o, s, l, a, { duration: r = 0 } = e, { durationFormat: u = void 0 } = e, { currentTime: c = 0 } = e, { playerStyle: g } = e, { positionClasses: f } = e, { isMobile: A } = e, { isAdvert: _ } = e, { isStopped: k } = e, { collapsed: S } = e, { largeImage: T } = e, { showBeyondWords: v } = e, { color: P = "323232" } = e;
  return t.$$set = (O) => {
    "duration" in O && i(0, r = O.duration), "durationFormat" in O && i(1, u = O.durationFormat), "currentTime" in O && i(2, c = O.currentTime), "playerStyle" in O && i(3, g = O.playerStyle), "positionClasses" in O && i(4, f = O.positionClasses), "isMobile" in O && i(5, A = O.isMobile), "isAdvert" in O && i(6, _ = O.isAdvert), "isStopped" in O && i(7, k = O.isStopped), "collapsed" in O && i(15, S = O.collapsed), "largeImage" in O && i(8, T = O.largeImage), "showBeyondWords" in O && i(9, v = O.showBeyondWords), "color" in O && i(10, P = O.color);
  }, t.$$.update = () => {
    t.$$.dirty & /*duration, currentTime*/
    5 && i(14, n = Math.max(0, r - c)), t.$$.dirty & /*playerStyle*/
    8 && i(16, o = g === "screen"), t.$$.dirty & /*isScreen, isMobile*/
    65568 && i(13, s = o && !A ? 3 : o ? 2 : 1), t.$$.dirty & /*collapsed*/
    32768 && i(12, l = S ? "opacity: 0" : ""), t.$$.dirty & /*isAdvert, currentTime*/
    68 && i(11, a = !_ && c < 0.1);
  }, [
    r,
    u,
    c,
    g,
    f,
    A,
    _,
    k,
    T,
    v,
    P,
    a,
    l,
    s,
    n,
    S,
    o
  ];
}
class J_ extends we {
  constructor(e) {
    super(), Pe(this, e, G_, K_, pe, {
      duration: 0,
      durationFormat: 1,
      currentTime: 2,
      playerStyle: 3,
      positionClasses: 4,
      isMobile: 5,
      isAdvert: 6,
      isStopped: 7,
      collapsed: 15,
      largeImage: 8,
      showBeyondWords: 9,
      color: 10
    });
  }
  get duration() {
    return this.$$.ctx[0];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get durationFormat() {
    return this.$$.ctx[1];
  }
  set durationFormat(e) {
    this.$$set({ durationFormat: e }), d();
  }
  get currentTime() {
    return this.$$.ctx[2];
  }
  set currentTime(e) {
    this.$$set({ currentTime: e }), d();
  }
  get playerStyle() {
    return this.$$.ctx[3];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get positionClasses() {
    return this.$$.ctx[4];
  }
  set positionClasses(e) {
    this.$$set({ positionClasses: e }), d();
  }
  get isMobile() {
    return this.$$.ctx[5];
  }
  set isMobile(e) {
    this.$$set({ isMobile: e }), d();
  }
  get isAdvert() {
    return this.$$.ctx[6];
  }
  set isAdvert(e) {
    this.$$set({ isAdvert: e }), d();
  }
  get isStopped() {
    return this.$$.ctx[7];
  }
  set isStopped(e) {
    this.$$set({ isStopped: e }), d();
  }
  get collapsed() {
    return this.$$.ctx[15];
  }
  set collapsed(e) {
    this.$$set({ collapsed: e }), d();
  }
  get largeImage() {
    return this.$$.ctx[8];
  }
  set largeImage(e) {
    this.$$set({ largeImage: e }), d();
  }
  get showBeyondWords() {
    return this.$$.ctx[9];
  }
  set showBeyondWords(e) {
    this.$$set({ showBeyondWords: e }), d();
  }
  get color() {
    return this.$$.ctx[10];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
}
const $t = (t, e, i) => Ie(t, e, e === "style" ? Q_(i) : i), X_ = /;(?!([^()]*\([^()]*\))*[^()]*\))/, Q_ = (t) => t.split(X_).filter((e) => e).map((e) => e + " !important").join(";");
function $_(t) {
  let e, i, n, o, s, l;
  return {
    c() {
      e = Se("svg"), i = Se("rect"), n = Se("path"), $t(
        i,
        "fill",
        /*fill*/
        t[3]
      ), $t(i, "width", "100%"), $t(i, "height", "100%"), $t(
        n,
        "fill",
        /*color*/
        t[2]
      ), $t(n, "transform", o = "scale(" + /*zoom*/
      t[1] + ")"), $t(n, "transform-origin", "50% 50%"), $t(n, "d", "M0 6.99996V11C0 11.55 0.45 12 1 12H4L7.29 15.29C7.92 15.92 9 15.47 9 14.58V3.40996C9 2.51996 7.92 2.06996 7.29 2.69996L4 5.99996H1C0.45 5.99996 0 6.44996 0 6.99996ZM13.5 8.99996C13.5 7.22996 12.48 5.70996 11 4.96996V13.02C12.48 12.29 13.5 10.77 13.5 8.99996ZM11 1.44996V1.64996C11 2.02996 11.25 2.35996 11.6 2.49996C14.18 3.52996 16 6.05996 16 8.99996C16 11.94 14.18 14.47 11.6 15.5C11.24 15.64 11 15.97 11 16.35V16.55C11 17.18 11.63 17.62 12.21 17.4C15.6 16.11 18 12.84 18 8.99996C18 5.15996 15.6 1.88996 12.21 0.599963C11.63 0.369963 11 0.819963 11 1.44996V1.44996Z"), $t(e, "width", s = 18 * /*scale*/
      t[0]), $t(e, "height", l = 18 * /*scale*/
      t[0]), $t(e, "viewBox", "0 0 18 18"), $t(e, "fill", "none"), $t(e, "xmlns", "http://www.w3.org/2000/svg");
    },
    m(a, r) {
      E(a, e, r), h(e, i), h(e, n);
    },
    p(a, [r]) {
      r & /*fill*/
      8 && $t(
        i,
        "fill",
        /*fill*/
        a[3]
      ), r & /*color*/
      4 && $t(
        n,
        "fill",
        /*color*/
        a[2]
      ), r & /*zoom*/
      2 && o !== (o = "scale(" + /*zoom*/
      a[1] + ")") && $t(n, "transform", o), r & /*scale*/
      1 && s !== (s = 18 * /*scale*/
      a[0]) && $t(e, "width", s), r & /*scale*/
      1 && l !== (l = 18 * /*scale*/
      a[0]) && $t(e, "height", l);
    },
    i: Q,
    o: Q,
    d(a) {
      a && M(e);
    }
  };
}
function eA(t, e, i) {
  let { scale: n = 1 } = e, { zoom: o = 1 } = e, { color: s = "#323232" } = e, { fill: l = "transparent" } = e;
  return t.$$set = (a) => {
    "scale" in a && i(0, n = a.scale), "zoom" in a && i(1, o = a.zoom), "color" in a && i(2, s = a.color), "fill" in a && i(3, l = a.fill);
  }, [n, o, s, l];
}
class Ur extends we {
  constructor(e) {
    super(), Pe(this, e, eA, $_, pe, { scale: 0, zoom: 1, color: 2, fill: 3 });
  }
  get scale() {
    return this.$$.ctx[0];
  }
  set scale(e) {
    this.$$set({ scale: e }), d();
  }
  get zoom() {
    return this.$$.ctx[1];
  }
  set zoom(e) {
    this.$$set({ zoom: e }), d();
  }
  get color() {
    return this.$$.ctx[2];
  }
  set color(e) {
    this.$$set({ color: e }), d();
  }
  get fill() {
    return this.$$.ctx[3];
  }
  set fill(e) {
    this.$$set({ fill: e }), d();
  }
}
const pn = (t, e, i) => Zt(t, e, i, 1), vi = (t, e, i) => Ie(t, e, e === "style" ? iA(i) : i), tA = /;(?!([^()]*\([^()]*\))*[^()]*\))/, iA = (t) => t.split(tA).filter((e) => e).map((e) => e + " !important").join(";");
function _a(t, e, i) {
  const n = t.slice();
  return n[19] = e[i].title, n[20] = e[i].duration, n[21] = e[i].audio, n[22] = e[i].video, n[24] = i, n;
}
function nA(t) {
  let e, i = (
    /*i*/
    t[24] + 1 + ""
  ), n;
  return {
    c() {
      e = y("span"), n = ie(i), vi(e, "class", "number svelte-1hl1xir"), pn(
        e,
        "color",
        /*textColor*/
        t[2]
      ), vi(e, "aria-hidden", "true");
    },
    m(o, s) {
      E(o, e, s), h(e, n);
    },
    p(o, s) {
      s & /*textColor*/
      4 && pn(
        e,
        "color",
        /*textColor*/
        o[2]
      );
    },
    i: Q,
    o: Q,
    d(o) {
      o && M(e);
    }
  };
}
function oA(t) {
  let e, i, n;
  return i = new Ur({
    props: {
      color: (
        /*iconColor*/
        t[4]
      ),
      scale: (
        /*scale*/
        t[10]
      )
    }
  }), {
    c() {
      e = y("span"), me(i.$$.fragment), vi(e, "class", "speaker svelte-1hl1xir");
    },
    m(o, s) {
      E(o, e, s), de(i, e, null), n = !0;
    },
    p(o, s) {
      const l = {};
      s & /*iconColor*/
      16 && (l.color = /*iconColor*/
      o[4]), s & /*scale*/
      1024 && (l.scale = /*scale*/
      o[10]), i.$set(l);
    },
    i(o) {
      n || (V(i.$$.fragment, o), n = !0);
    },
    o(o) {
      z(i.$$.fragment, o), n = !1;
    },
    d(o) {
      o && M(e), ge(i);
    }
  };
}
function Aa(t) {
  let e, i, n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P;
  const O = [oA, nA], D = [];
  function p(q, x) {
    return (
      /*i*/
      q[24] === /*index*/
      q[6] ? 0 : 1
    );
  }
  n = p(t), o = D[n] = O[n](t), a = new Bl({
    props: {
      title: (
        /*title*/
        t[19]
      ),
      scale: (
        /*scale*/
        t[10]
      ),
      maxLines: (
        /*isMobile*/
        t[7] ? 3 : 2
      ),
      bold: (
        /*i*/
        t[24] === /*index*/
        t[6]
      ),
      color: (
        /*textColor*/
        t[2]
      )
    }
  }), c = new Fr({
    props: {
      duration: (
        /*duration*/
        t[20]
      ),
      scale: (
        /*scale*/
        t[10]
      ),
      bold: (
        /*i*/
        t[24] === /*index*/
        t[6]
      ),
      color: (
        /*textColor*/
        t[2]
      )
    }
  });
  function C(q) {
    t[18](q);
  }
  let Z = {
    onEvent: (
      /*onEvent*/
      t[8]
    ),
    color: (
      /*iconColor*/
      t[4]
    ),
    downloadFormats: (
      /*downloadFormats*/
      t[0]
    ),
    contentIndex: (
      /*i*/
      t[24]
    ),
    audio: (
      /*audio*/
      t[21]
    ),
    video: (
      /*video*/
      t[22]
    ),
    padding: (
      /*isMobile*/
      t[7] ? 8 : 0
    )
  };
  return (
    /*downloadIsVisible*/
    t[9] !== void 0 && (Z.isVisible = /*downloadIsVisible*/
    t[9]), _ = new jr({ props: Z }), se.push(() => be(_, "isVisible", C)), {
      c() {
        e = y("div"), i = y("button"), o.c(), s = J(), l = y("span"), me(a.$$.fragment), r = J(), u = y("span"), me(c.$$.fragment), f = J(), A = y("span"), me(_.$$.fragment), S = J(), vi(l, "class", "title svelte-1hl1xir"), ne(
          l,
          "download-is-visible",
          /*downloadIsVisible*/
          t[9]
        ), vi(u, "class", "duration svelte-1hl1xir"), vi(i, "type", "button"), vi(i, "class", "item svelte-1hl1xir"), vi(i, "aria-label", g = /*title*/
        t[19]), ne(
          i,
          "active",
          /*i*/
          t[24] === /*index*/
          t[6]
        ), vi(A, "class", "download svelte-1hl1xir"), vi(e, "class", "row svelte-1hl1xir");
      },
      m(q, x) {
        E(q, e, x), h(e, i), D[n].m(i, null), h(i, s), h(i, l), de(a, l, null), h(i, r), h(i, u), de(c, u, null), h(e, f), h(e, A), de(_, A, null), h(e, S), T = !0, v || (P = [
          Y(
            i,
            "click",
            /*handleClick*/
            t[13](
              /*i*/
              t[24]
            )
          ),
          Y(
            i,
            "keydown",
            /*handleKeydown*/
            t[14]
          ),
          Y(
            i,
            "focus",
            /*handleFocus*/
            t[15]
          ),
          Y(i, "mouseup", ai)
        ], v = !0);
      },
      p(q, x) {
        t = q;
        let X = n;
        n = p(t), n === X ? D[n].p(t, x) : (Fe(), z(D[X], 1, 1, () => {
          D[X] = null;
        }), Ue(), o = D[n], o ? o.p(t, x) : (o = D[n] = O[n](t), o.c()), V(o, 1), o.m(i, s));
        const oe = {};
        x & /*content*/
        32 && (oe.title = /*title*/
        t[19]), x & /*scale*/
        1024 && (oe.scale = /*scale*/
        t[10]), x & /*isMobile*/
        128 && (oe.maxLines = /*isMobile*/
        t[7] ? 3 : 2), x & /*index*/
        64 && (oe.bold = /*i*/
        t[24] === /*index*/
        t[6]), x & /*textColor*/
        4 && (oe.color = /*textColor*/
        t[2]), a.$set(oe), (!T || x & /*downloadIsVisible*/
        512) && ne(
          l,
          "download-is-visible",
          /*downloadIsVisible*/
          t[9]
        );
        const ae = {};
        x & /*content*/
        32 && (ae.duration = /*duration*/
        t[20]), x & /*scale*/
        1024 && (ae.scale = /*scale*/
        t[10]), x & /*index*/
        64 && (ae.bold = /*i*/
        t[24] === /*index*/
        t[6]), x & /*textColor*/
        4 && (ae.color = /*textColor*/
        t[2]), c.$set(ae), (!T || x & /*content*/
        32 && g !== (g = /*title*/
        t[19])) && vi(i, "aria-label", g), (!T || x & /*index*/
        64) && ne(
          i,
          "active",
          /*i*/
          t[24] === /*index*/
          t[6]
        );
        const $ = {};
        x & /*onEvent*/
        256 && ($.onEvent = /*onEvent*/
        t[8]), x & /*iconColor*/
        16 && ($.color = /*iconColor*/
        t[4]), x & /*downloadFormats*/
        1 && ($.downloadFormats = /*downloadFormats*/
        t[0]), x & /*content*/
        32 && ($.audio = /*audio*/
        t[21]), x & /*content*/
        32 && ($.video = /*video*/
        t[22]), x & /*isMobile*/
        128 && ($.padding = /*isMobile*/
        t[7] ? 8 : 0), !k && x & /*downloadIsVisible*/
        512 && (k = !0, $.isVisible = /*downloadIsVisible*/
        t[9], ve(() => k = !1)), _.$set($);
      },
      i(q) {
        T || (V(o), V(a.$$.fragment, q), V(c.$$.fragment, q), V(_.$$.fragment, q), T = !0);
      },
      o(q) {
        z(o), z(a.$$.fragment, q), z(c.$$.fragment, q), z(_.$$.fragment, q), T = !1;
      },
      d(q) {
        q && M(e), D[n].d(), ge(a), ge(c), ge(_), v = !1, _t(P);
      }
    }
  );
}
function sA(t) {
  let e, i, n, o = ti(
    /*content*/
    t[5]
  ), s = [];
  for (let a = 0; a < o.length; a += 1)
    s[a] = Aa(_a(t, o, a));
  const l = (a) => z(s[a], 1, 1, () => {
    s[a] = null;
  });
  return {
    c() {
      e = y("div"), i = y("div");
      for (let a = 0; a < s.length; a += 1)
        s[a].c();
      vi(i, "class", "scrollable svelte-1hl1xir"), vi(i, "tabindex", "-1"), vi(e, "class", "playlist svelte-1hl1xir"), pn(
        e,
        "--desktop-rows",
        /*desktopRows*/
        t[12]
      ), pn(
        e,
        "--mobile-rows",
        /*mobileRows*/
        t[11]
      ), pn(
        e,
        "background",
        /*backgroundColor*/
        t[3]
      ), ne(
        e,
        "mobile",
        /*isMobile*/
        t[7]
      ), ne(
        e,
        "larger",
        /*larger*/
        t[1]
      );
    },
    m(a, r) {
      E(a, e, r), h(e, i);
      for (let u = 0; u < s.length; u += 1)
        s[u] && s[u].m(i, null);
      n = !0;
    },
    p(a, [r]) {
      if (r & /*onEvent, iconColor, downloadFormats, content, isMobile, downloadIsVisible, index, handleClick, handleKeydown, handleFocus, scale, textColor*/
      59381) {
        o = ti(
          /*content*/
          a[5]
        );
        let u;
        for (u = 0; u < o.length; u += 1) {
          const c = _a(a, o, u);
          s[u] ? (s[u].p(c, r), V(s[u], 1)) : (s[u] = Aa(c), s[u].c(), V(s[u], 1), s[u].m(i, null));
        }
        for (Fe(), u = o.length; u < s.length; u += 1)
          l(u);
        Ue();
      }
      (!n || r & /*desktopRows*/
      4096) && pn(
        e,
        "--desktop-rows",
        /*desktopRows*/
        a[12]
      ), (!n || r & /*mobileRows*/
      2048) && pn(
        e,
        "--mobile-rows",
        /*mobileRows*/
        a[11]
      ), (!n || r & /*backgroundColor*/
      8) && pn(
        e,
        "background",
        /*backgroundColor*/
        a[3]
      ), (!n || r & /*isMobile*/
      128) && ne(
        e,
        "mobile",
        /*isMobile*/
        a[7]
      ), (!n || r & /*larger*/
      2) && ne(
        e,
        "larger",
        /*larger*/
        a[1]
      );
    },
    i(a) {
      if (!n) {
        for (let r = 0; r < o.length; r += 1)
          V(s[r]);
        n = !0;
      }
    },
    o(a) {
      s = s.filter(Boolean);
      for (let r = 0; r < s.length; r += 1)
        z(s[r]);
      n = !1;
    },
    d(a) {
      a && M(e), Cn(s, a);
    }
  };
}
function lA(t, e, i) {
  let n, o, s, l, { style: a = "auto" } = e, { downloadFormats: r = [] } = e, { larger: u = !1 } = e, { textColor: c = "#111" } = e, { backgroundColor: g = "#f5f5f5" } = e, { iconColor: f = "#000" } = e, { content: A = [] } = e, { index: _ = 0 } = e, { isMobile: k } = e, { onEvent: S } = e, T;
  const v = (p) => () => {
    S(ke({
      type: "PressedPlaylistItem",
      description: "A playlist item was pressed.",
      initiatedBy: "user",
      index: p
    }));
  }, P = (p) => {
    if (p.key === "ArrowUp") {
      p.preventDefault();
      const C = p.target.previousElementSibling;
      C && C.focus();
    }
    if (p.key === "ArrowDown") {
      p.preventDefault();
      const C = p.target.nextElementSibling;
      C && C.focus();
    }
  }, O = (p) => {
    const C = p.target.parentNode, Z = Math.round(C.scrollTop / 10) * 10;
    C.scrollTop = Z;
  };
  function D(p) {
    T = p, i(9, T);
  }
  return t.$$set = (p) => {
    "style" in p && i(16, a = p.style), "downloadFormats" in p && i(0, r = p.downloadFormats), "larger" in p && i(1, u = p.larger), "textColor" in p && i(2, c = p.textColor), "backgroundColor" in p && i(3, g = p.backgroundColor), "iconColor" in p && i(4, f = p.iconColor), "content" in p && i(5, A = p.content), "index" in p && i(6, _ = p.index), "isMobile" in p && i(7, k = p.isMobile), "onEvent" in p && i(8, S = p.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty & /*style*/
    65536 && i(17, n = a.split("-")), t.$$.dirty & /*parts*/
    131072 && i(12, o = n[1] || 5), t.$$.dirty & /*parts*/
    131072 && i(11, s = n[2] || n[1] || 4), t.$$.dirty & /*larger*/
    2 && i(10, l = u ? 1.25 : 1);
  }, [
    r,
    u,
    c,
    g,
    f,
    A,
    _,
    k,
    S,
    T,
    l,
    s,
    o,
    v,
    P,
    O,
    a,
    n,
    D
  ];
}
class aA extends we {
  constructor(e) {
    super(), Pe(this, e, lA, sA, pe, {
      style: 16,
      downloadFormats: 0,
      larger: 1,
      textColor: 2,
      backgroundColor: 3,
      iconColor: 4,
      content: 5,
      index: 6,
      isMobile: 7,
      onEvent: 8
    });
  }
  get style() {
    return this.$$.ctx[16];
  }
  set style(e) {
    this.$$set({ style: e }), d();
  }
  get downloadFormats() {
    return this.$$.ctx[0];
  }
  set downloadFormats(e) {
    this.$$set({ downloadFormats: e }), d();
  }
  get larger() {
    return this.$$.ctx[1];
  }
  set larger(e) {
    this.$$set({ larger: e }), d();
  }
  get textColor() {
    return this.$$.ctx[2];
  }
  set textColor(e) {
    this.$$set({ textColor: e }), d();
  }
  get backgroundColor() {
    return this.$$.ctx[3];
  }
  set backgroundColor(e) {
    this.$$set({ backgroundColor: e }), d();
  }
  get iconColor() {
    return this.$$.ctx[4];
  }
  set iconColor(e) {
    this.$$set({ iconColor: e }), d();
  }
  get content() {
    return this.$$.ctx[5];
  }
  set content(e) {
    this.$$set({ content: e }), d();
  }
  get index() {
    return this.$$.ctx[6];
  }
  set index(e) {
    this.$$set({ index: e }), d();
  }
  get isMobile() {
    return this.$$.ctx[7];
  }
  set isMobile(e) {
    this.$$set({ isMobile: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[8];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const ya = (t, e, i) => Ie(t, e, e === "style" ? uA(i) : i), rA = /;(?!([^()]*\([^()]*\))*[^()]*\))/, uA = (t) => t.split(rA).filter((e) => e).map((e) => e + " !important").join(";");
function cA(t) {
  let e, i, n, o;
  const s = (
    /*#slots*/
    t[9].default
  ), l = Qn(
    s,
    t,
    /*$$scope*/
    t[8],
    null
  );
  return {
    c() {
      e = y("div"), l && l.c(), ya(e, "class", "hoverable"), ya(e, "role", "none");
    },
    m(a, r) {
      E(a, e, r), l && l.m(e, null), i = !0, n || (o = [
        Y(
          e,
          "mouseenter",
          /*onEnter*/
          t[1]
        ),
        Y(
          e,
          "mouseleave",
          /*onLeave*/
          t[2]
        ),
        Y(e, "mousemove", function() {
          Xn(
            /*idleDelay*/
            t[0] !== 1 / 0 && /*onMove*/
            t[3]
          ) && /*idleDelay*/
          (t[0] !== 1 / 0 && /*onMove*/
          t[3]).apply(this, arguments);
        })
      ], n = !0);
    },
    p(a, [r]) {
      t = a, l && l.p && (!i || r & /*$$scope*/
      256) && eo(
        l,
        s,
        t,
        /*$$scope*/
        t[8],
        i ? $n(
          s,
          /*$$scope*/
          t[8],
          r,
          null
        ) : to(
          /*$$scope*/
          t[8]
        ),
        null
      );
    },
    i(a) {
      i || (V(l, a), i = !0);
    },
    o(a) {
      z(l, a), i = !1;
    },
    d(a) {
      a && M(e), l && l.d(a), n = !1, _t(o);
    }
  };
}
function dA(t, e, i) {
  let { $$slots: n = {}, $$scope: o } = e, { exitDelay: s = 0 } = e, { idleDelay: l = 1 / 0 } = e, { isHovering: a = !1 } = e, r = !0, u = !0, c, g;
  const f = () => {
    c && clearTimeout(c), g && clearTimeout(g), i(6, r = !1), i(7, u = !1);
  }, A = () => {
    c && clearTimeout(c), i(6, r = !1), c = setTimeout(() => i(6, r = !0), s);
  }, _ = () => {
    g && clearTimeout(g), i(7, u = !1), g = setTimeout(() => i(7, u = !0), l);
  };
  return uc(() => {
    c && clearTimeout(c), g && clearTimeout(g);
  }), t.$$set = (k) => {
    "exitDelay" in k && i(5, s = k.exitDelay), "idleDelay" in k && i(0, l = k.idleDelay), "isHovering" in k && i(4, a = k.isHovering), "$$scope" in k && i(8, o = k.$$scope);
  }, t.$$.update = () => {
    t.$$.dirty & /*isExit, isIdle*/
    192 && i(4, a = !r && !u);
  }, [
    l,
    f,
    A,
    _,
    a,
    s,
    r,
    u,
    o,
    n
  ];
}
class gA extends we {
  constructor(e) {
    super(), Pe(this, e, dA, cA, pe, {
      exitDelay: 5,
      idleDelay: 0,
      isHovering: 4
    });
  }
  get exitDelay() {
    return this.$$.ctx[5];
  }
  set exitDelay(e) {
    this.$$set({ exitDelay: e }), d();
  }
  get idleDelay() {
    return this.$$.ctx[0];
  }
  set idleDelay(e) {
    this.$$set({ idleDelay: e }), d();
  }
  get isHovering() {
    return this.$$.ctx[4];
  }
  set isHovering(e) {
    this.$$set({ isHovering: e }), d();
  }
}
const fA = (t, e, i) => Ie(t, e, e === "style" ? hA(i) : i), mA = /;(?!([^()]*\([^()]*\))*[^()]*\))/, hA = (t) => t.split(mA).filter((e) => e).map((e) => e + " !important").join(";");
function _A(t) {
  let e, i;
  const n = (
    /*#slots*/
    t[7].default
  ), o = Qn(
    n,
    t,
    /*$$scope*/
    t[6],
    null
  );
  return {
    c() {
      e = y("div"), o && o.c(), fA(e, "class", "visibility svelte-1exdg3");
    },
    m(s, l) {
      E(s, e, l), o && o.m(e, null), t[8](e), i = !0;
    },
    p(s, [l]) {
      o && o.p && (!i || l & /*$$scope*/
      64) && eo(
        o,
        n,
        s,
        /*$$scope*/
        s[6],
        i ? $n(
          n,
          /*$$scope*/
          s[6],
          l,
          null
        ) : to(
          /*$$scope*/
          s[6]
        ),
        null
      );
    },
    i(s) {
      i || (V(o, s), i = !0);
    },
    o(s) {
      z(o, s), i = !1;
    },
    d(s) {
      s && M(e), o && o.d(s), t[8](null);
    }
  };
}
function AA(t, e, i) {
  let { $$slots: n = {}, $$scope: o } = e, s, { enabled: l = !1 } = e, { relativeY: a = void 0 } = e, { absoluteY: r = void 0 } = e, { isVisible: u = void 0 } = e, { onEvent: c = () => {
  } } = e;
  const g = ([A]) => {
    i(1, a = A.boundingClientRect.y), i(2, r = a + window.scrollY), u !== A.isIntersecting && (i(3, u = A.isIntersecting), c(ke({
      type: "VisibilityChanged",
      description: "The player was scrolled into or out of view.",
      initiatedBy: "user",
      isVisible: u
    })));
  };
  Vo(() => {
    if (!l || typeof IntersectionObserver == "undefined")
      return;
    const A = new IntersectionObserver(g, { threshold: 0.5 });
    return A.observe(s), () => {
      A.unobserve(s), g([
        {
          isIntersecting: !0,
          boundingClientRect: { y: 1 / 0 }
        }
      ]);
    };
  });
  function f(A) {
    se[A ? "unshift" : "push"](() => {
      s = A, i(0, s);
    });
  }
  return t.$$set = (A) => {
    "enabled" in A && i(4, l = A.enabled), "relativeY" in A && i(1, a = A.relativeY), "absoluteY" in A && i(2, r = A.absoluteY), "isVisible" in A && i(3, u = A.isVisible), "onEvent" in A && i(5, c = A.onEvent), "$$scope" in A && i(6, o = A.$$scope);
  }, [
    s,
    a,
    r,
    u,
    l,
    c,
    o,
    n,
    f
  ];
}
class yA extends we {
  constructor(e) {
    super(), Pe(this, e, AA, _A, pe, {
      enabled: 4,
      relativeY: 1,
      absoluteY: 2,
      isVisible: 3,
      onEvent: 5
    });
  }
  get enabled() {
    return this.$$.ctx[4];
  }
  set enabled(e) {
    this.$$set({ enabled: e }), d();
  }
  get relativeY() {
    return this.$$.ctx[1];
  }
  set relativeY(e) {
    this.$$set({ relativeY: e }), d();
  }
  get absoluteY() {
    return this.$$.ctx[2];
  }
  set absoluteY(e) {
    this.$$set({ absoluteY: e }), d();
  }
  get isVisible() {
    return this.$$.ctx[3];
  }
  set isVisible(e) {
    this.$$set({ isVisible: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[5];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const vA = ({ playerStyle: t, width: e }) => t === "standard" && e < 380 || t === "large" && e < 380 || t === "video" && e < 480 || t === "screen" && e < 640, bA = ({ playerStyle: t, position: e, isMobile: i, isAdvert: n }) => t === "screen" || t === "large" && i ? "symmetrical" : t === "standard" && e === "left" || t === "standard" && i ? "left-to-right" : t === "standard" && e === "right" && n ? "right-to-left" : t === "standard" && e === "right" ? "left-to-right-but-swap-ends" : t === "small" && e === "left" ? "left-to-right" : t === "small" && e === "right" ? "right-to-left" : "left-to-right", va = () => document.fullscreenEnabled || document.webkitFullscreenEnabled, kA = (t) => {
  t.requestFullscreen ? t.requestFullscreen() : t.webkitRequestFullscreen && t.webkitRequestFullscreen();
}, pA = () => {
  document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
}, ba = () => document.fullscreenElement || document.webkitCurrentFullScreenElement, Sn = (t, e, i) => Zt(t, e, i, 1), Mi = (t, e, i) => Ie(t, e, e === "style" ? PA(i) : i), SA = /;(?!([^()]*\([^()]*\))*[^()]*\))/, PA = (t) => t.split(SA).filter((e) => e).map((e) => e + " !important").join(";");
function ka(t) {
  let e, i, n, o = !/*videoPosterImage*/
  t[19] && pa(t);
  return {
    c() {
      e = y("div"), o && o.c(), Mi(e, "class", "video-placeholder svelte-k6qh1c"), Mi(e, "style", i = /*videoPosterImage*/
      t[19] ? `background-image: url(${/*videoPosterImage*/
      t[19]})` : "");
    },
    m(s, l) {
      E(s, e, l), o && o.m(e, null), n = !0;
    },
    p(s, l) {
      /*videoPosterImage*/
      s[19] ? o && (Fe(), z(o, 1, 1, () => {
        o = null;
      }), Ue()) : o ? (o.p(s, l), l[0] & /*videoPosterImage*/
      524288 && V(o, 1)) : (o = pa(s), o.c(), V(o, 1), o.m(e, null)), (!n || l[0] & /*videoPosterImage*/
      524288 && i !== (i = /*videoPosterImage*/
      s[19] ? `background-image: url(${/*videoPosterImage*/
      s[19]})` : "")) && Mi(e, "style", i);
    },
    i(s) {
      n || (V(o), n = !0);
    },
    o(s) {
      z(o), n = !1;
    },
    d(s) {
      s && M(e), o && o.d();
    }
  };
}
function pa(t) {
  let e, i, n, o = gt("videoInWidget") + "", s, l;
  return e = new A2({
    props: { color: (
      /*activeIconColor*/
      t[60]
    ) }
  }), {
    c() {
      me(e.$$.fragment), i = J(), n = y("span"), s = ie(o), Sn(
        n,
        "color",
        /*activeTextColor*/
        t[62]
      );
    },
    m(a, r) {
      de(e, a, r), E(a, i, r), E(a, n, r), h(n, s), l = !0;
    },
    p(a, r) {
      const u = {};
      r[1] & /*activeIconColor*/
      536870912 && (u.color = /*activeIconColor*/
      a[60]), e.$set(u), (!l || r[2] & /*activeTextColor*/
      1) && Sn(
        n,
        "color",
        /*activeTextColor*/
        a[62]
      );
    },
    i(a) {
      l || (V(e.$$.fragment, a), l = !0);
    },
    o(a) {
      z(e.$$.fragment, a), l = !1;
    },
    d(a) {
      a && (M(i), M(n)), ge(e, a);
    }
  };
}
function Sa(t) {
  let e, i;
  return e = new i_({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      src: (
        /*largeImage*/
        t[50]
      ),
      href: (
        /*largeImageHref*/
        t[49]
      ),
      size: (
        /*imageSize*/
        t[48]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[1] & /*largeImage*/
      524288 && (s.src = /*largeImage*/
      n[50]), o[1] & /*largeImageHref*/
      262144 && (s.href = /*largeImageHref*/
      n[49]), o[1] & /*imageSize*/
      131072 && (s.size = /*imageSize*/
      n[48]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Pa(t) {
  let e, i, n, o, s;
  return i = new Rr({
    props: {
      title: (
        /*playerTitle*/
        t[8]
      ),
      visible: !/*isAdvert*/
      t[29],
      playerStyle: (
        /*playerStyle*/
        t[3]
      ),
      scale: (
        /*isScreen*/
        t[28] ? 2 : 1
      ),
      color: (
        /*activeTextColor*/
        t[62]
      )
    }
  }), o = new Bl({
    props: {
      title: (
        /*contentItem*/
        t[35].title
      ),
      maxLines: (
        /*isMobile*/
        t[33] || /*isScreen*/
        t[28] ? 3 : 1
      ),
      center: (
        /*isScreen*/
        t[28]
      ),
      scale: (
        /*isScreen*/
        t[28] ? 2 : 1
      ),
      maxWidth: (
        /*isScreen*/
        t[28] && !/*isMobile*/
        t[33] ? 640 : (
          /*isScreen*/
          t[28] ? 320 : null
        )
      ),
      color: (
        /*activeTextColor*/
        t[62]
      )
    }
  }), {
    c() {
      e = y("div"), me(i.$$.fragment), n = J(), me(o.$$.fragment), Mi(e, "class", "summary svelte-k6qh1c");
    },
    m(l, a) {
      E(l, e, a), de(i, e, null), h(e, n), de(o, e, null), s = !0;
    },
    p(l, a) {
      const r = {};
      a[0] & /*playerTitle*/
      256 && (r.title = /*playerTitle*/
      l[8]), a[0] & /*isAdvert*/
      536870912 && (r.visible = !/*isAdvert*/
      l[29]), a[0] & /*playerStyle*/
      8 && (r.playerStyle = /*playerStyle*/
      l[3]), a[0] & /*isScreen*/
      268435456 && (r.scale = /*isScreen*/
      l[28] ? 2 : 1), a[2] & /*activeTextColor*/
      1 && (r.color = /*activeTextColor*/
      l[62]), i.$set(r);
      const u = {};
      a[1] & /*contentItem*/
      16 && (u.title = /*contentItem*/
      l[35].title), a[0] & /*isScreen*/
      268435456 | a[1] & /*isMobile*/
      4 && (u.maxLines = /*isMobile*/
      l[33] || /*isScreen*/
      l[28] ? 3 : 1), a[0] & /*isScreen*/
      268435456 && (u.center = /*isScreen*/
      l[28]), a[0] & /*isScreen*/
      268435456 && (u.scale = /*isScreen*/
      l[28] ? 2 : 1), a[0] & /*isScreen*/
      268435456 | a[1] & /*isMobile*/
      4 && (u.maxWidth = /*isScreen*/
      l[28] && !/*isMobile*/
      l[33] ? 640 : (
        /*isScreen*/
        l[28] ? 320 : null
      )), a[2] & /*activeTextColor*/
      1 && (u.color = /*activeTextColor*/
      l[62]), o.$set(u);
    },
    i(l) {
      s || (V(i.$$.fragment, l), V(o.$$.fragment, l), s = !0);
    },
    o(l) {
      z(i.$$.fragment, l), z(o.$$.fragment, l), s = !1;
    },
    d(l) {
      l && M(e), ge(i), ge(o);
    }
  };
}
function wA(t) {
  let e, i;
  return e = new yh({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      isPlaying: (
        /*isPlaying*/
        t[64]
      ),
      scale: (
        /*playPauseScale*/
        t[58]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[2] & /*isPlaying*/
      4 && (s.isPlaying = /*isPlaying*/
      n[64]), o[1] & /*playPauseScale*/
      134217728 && (s.scale = /*playPauseScale*/
      n[58]), o[1] & /*activeIconColor*/
      536870912 && (s.color = /*activeIconColor*/
      n[60]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function TA(t) {
  let e, i;
  return e = new p_({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      progress: (
        /*progress*/
        t[63]
      ),
      enabled: (
        /*isScreen*/
        t[28] || /*isSmall*/
        t[26]
      ),
      bold: (
        /*isSmall*/
        t[26]
      ),
      scale: (
        /*playPauseScale*/
        t[58]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      ),
      $$slots: { default: [wA] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[2] & /*progress*/
      2 && (s.progress = /*progress*/
      n[63]), o[0] & /*isScreen, isSmall*/
      335544320 && (s.enabled = /*isScreen*/
      n[28] || /*isSmall*/
      n[26]), o[0] & /*isSmall*/
      67108864 && (s.bold = /*isSmall*/
      n[26]), o[1] & /*playPauseScale*/
      134217728 && (s.scale = /*playPauseScale*/
      n[58]), o[1] & /*activeIconColor*/
      536870912 && (s.color = /*activeIconColor*/
      n[60]), o[0] & /*onEvent*/
      262144 | o[1] & /*playPauseScale, activeIconColor*/
      671088640 | o[2] & /*isPlaying*/
      4 | o[3] & /*$$scope*/
      2 && (s.$$scope = { dirty: o, ctx: n }), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function wa(t) {
  let e, i;
  return e = new Rr({
    props: {
      title: (
        /*callToAction*/
        t[4] || gt("listenToThisArticle")
      ),
      visible: !/*isAdvert*/
      t[29],
      playerStyle: (
        /*playerStyle*/
        t[3]
      ),
      scale: (
        /*playerTitleScale*/
        t[57]
      ),
      collapsible: (
        /*collapsible*/
        t[32]
      ),
      collapsed: (
        /*collapsed*/
        t[47]
      ),
      color: (
        /*activeTextColor*/
        t[62]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*callToAction*/
      16 && (s.title = /*callToAction*/
      n[4] || gt("listenToThisArticle")), o[0] & /*isAdvert*/
      536870912 && (s.visible = !/*isAdvert*/
      n[29]), o[0] & /*playerStyle*/
      8 && (s.playerStyle = /*playerStyle*/
      n[3]), o[1] & /*playerTitleScale*/
      67108864 && (s.scale = /*playerTitleScale*/
      n[57]), o[1] & /*collapsible*/
      2 && (s.collapsible = /*collapsible*/
      n[32]), o[1] & /*collapsed*/
      65536 && (s.collapsed = /*collapsed*/
      n[47]), o[2] & /*activeTextColor*/
      1 && (s.color = /*activeTextColor*/
      n[62]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Ta(t) {
  let e, i, n, o, s, l;
  return e = new Sh({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      rates: (
        /*playbackRates*/
        t[16]
      ),
      rate: (
        /*playbackRate*/
        t[15]
      ),
      scale: (
        /*buttonScale*/
        t[36]
      ),
      color: (
        /*activeTextColor*/
        t[62]
      )
    }
  }), n = new Yh({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      style: (
        /*skipStyle*/
        t[59]
      ),
      scale: (
        /*buttonScale*/
        t[36]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), s = new h0({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      style: (
        /*skipStyle*/
        t[59]
      ),
      scale: (
        /*buttonScale*/
        t[36]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), {
    c() {
      me(e.$$.fragment), i = J(), me(n.$$.fragment), o = J(), me(s.$$.fragment);
    },
    m(a, r) {
      de(e, a, r), E(a, i, r), de(n, a, r), E(a, o, r), de(s, a, r), l = !0;
    },
    p(a, r) {
      const u = {};
      r[0] & /*onEvent*/
      262144 && (u.onEvent = /*onEvent*/
      a[18]), r[0] & /*playbackRates*/
      65536 && (u.rates = /*playbackRates*/
      a[16]), r[0] & /*playbackRate*/
      32768 && (u.rate = /*playbackRate*/
      a[15]), r[1] & /*buttonScale*/
      32 && (u.scale = /*buttonScale*/
      a[36]), r[2] & /*activeTextColor*/
      1 && (u.color = /*activeTextColor*/
      a[62]), e.$set(u);
      const c = {};
      r[0] & /*onEvent*/
      262144 && (c.onEvent = /*onEvent*/
      a[18]), r[1] & /*skipStyle*/
      268435456 && (c.style = /*skipStyle*/
      a[59]), r[1] & /*buttonScale*/
      32 && (c.scale = /*buttonScale*/
      a[36]), r[1] & /*activeIconColor*/
      536870912 && (c.color = /*activeIconColor*/
      a[60]), n.$set(c);
      const g = {};
      r[0] & /*onEvent*/
      262144 && (g.onEvent = /*onEvent*/
      a[18]), r[1] & /*skipStyle*/
      268435456 && (g.style = /*skipStyle*/
      a[59]), r[1] & /*buttonScale*/
      32 && (g.scale = /*buttonScale*/
      a[36]), r[1] & /*activeIconColor*/
      536870912 && (g.color = /*activeIconColor*/
      a[60]), s.$set(g);
    },
    i(a) {
      l || (V(e.$$.fragment, a), V(n.$$.fragment, a), V(s.$$.fragment, a), l = !0);
    },
    o(a) {
      z(e.$$.fragment, a), z(n.$$.fragment, a), z(s.$$.fragment, a), l = !1;
    },
    d(a) {
      a && (M(i), M(o)), ge(e, a), ge(n, a), ge(s, a);
    }
  };
}
function Ca(t) {
  let e, i;
  return e = new Bl({
    props: {
      title: (
        /*contentItem*/
        t[35].title
      ),
      maxLines: 1,
      bold: !0,
      scale: 1.2,
      flex: 0.52,
      color: (
        /*activeTextColor*/
        t[62]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[1] & /*contentItem*/
      16 && (s.title = /*contentItem*/
      n[35].title), o[2] & /*activeTextColor*/
      1 && (s.color = /*activeTextColor*/
      n[62]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Ia(t) {
  let e, i;
  return e = new h_({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      progress: (
        /*progress*/
        t[63]
      ),
      duration: (
        /*duration*/
        t[13]
      ),
      fullWidth: (
        /*isVideo*/
        t[23]
      ),
      readonly: (
        /*isAdvert*/
        t[29]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[2] & /*progress*/
      2 && (s.progress = /*progress*/
      n[63]), o[0] & /*duration*/
      8192 && (s.duration = /*duration*/
      n[13]), o[0] & /*isVideo*/
      8388608 && (s.fullWidth = /*isVideo*/
      n[23]), o[0] & /*isAdvert*/
      536870912 && (s.readonly = /*isAdvert*/
      n[29]), o[1] & /*activeIconColor*/
      536870912 && (s.color = /*activeIconColor*/
      n[60]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Oa(t) {
  let e, i, n, o;
  return e = new p2({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      href: (
        /*advertClickThroughUrl*/
        t[34]
      ),
      playerStyle: (
        /*playerStyle*/
        t[3]
      ),
      scale: (
        /*isScreen*/
        t[28] && !/*isMobile*/
        t[33] ? 2 : (
          /*isScreen*/
          t[28] ? 1.6 : 1
        )
      ),
      controlsOrder: (
        /*controlsOrder*/
        t[24]
      ),
      color: (
        /*activeTextColor*/
        t[62]
      ),
      largeImage: (
        /*largeImage*/
        t[50]
      ),
      isMobile: (
        /*isMobile*/
        t[33]
      ),
      endVisible: (
        /*showBeyondWords*/
        t[45] || /*showCloseWidget*/
        t[46]
      )
    }
  }), n = new z2({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      href: (
        /*advertClickThroughUrl*/
        t[34]
      ),
      playerStyle: (
        /*playerStyle*/
        t[3]
      ),
      scale: (
        /*buttonScale*/
        t[36]
      ),
      controlsOrder: (
        /*controlsOrder*/
        t[24]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), {
    c() {
      me(e.$$.fragment), i = J(), me(n.$$.fragment);
    },
    m(s, l) {
      de(e, s, l), E(s, i, l), de(n, s, l), o = !0;
    },
    p(s, l) {
      const a = {};
      l[0] & /*onEvent*/
      262144 && (a.onEvent = /*onEvent*/
      s[18]), l[1] & /*advertClickThroughUrl*/
      8 && (a.href = /*advertClickThroughUrl*/
      s[34]), l[0] & /*playerStyle*/
      8 && (a.playerStyle = /*playerStyle*/
      s[3]), l[0] & /*isScreen*/
      268435456 | l[1] & /*isMobile*/
      4 && (a.scale = /*isScreen*/
      s[28] && !/*isMobile*/
      s[33] ? 2 : (
        /*isScreen*/
        s[28] ? 1.6 : 1
      )), l[0] & /*controlsOrder*/
      16777216 && (a.controlsOrder = /*controlsOrder*/
      s[24]), l[2] & /*activeTextColor*/
      1 && (a.color = /*activeTextColor*/
      s[62]), l[1] & /*largeImage*/
      524288 && (a.largeImage = /*largeImage*/
      s[50]), l[1] & /*isMobile*/
      4 && (a.isMobile = /*isMobile*/
      s[33]), l[1] & /*showBeyondWords, showCloseWidget*/
      49152 && (a.endVisible = /*showBeyondWords*/
      s[45] || /*showCloseWidget*/
      s[46]), e.$set(a);
      const r = {};
      l[0] & /*onEvent*/
      262144 && (r.onEvent = /*onEvent*/
      s[18]), l[1] & /*advertClickThroughUrl*/
      8 && (r.href = /*advertClickThroughUrl*/
      s[34]), l[0] & /*playerStyle*/
      8 && (r.playerStyle = /*playerStyle*/
      s[3]), l[1] & /*buttonScale*/
      32 && (r.scale = /*buttonScale*/
      s[36]), l[0] & /*controlsOrder*/
      16777216 && (r.controlsOrder = /*controlsOrder*/
      s[24]), l[1] & /*activeIconColor*/
      536870912 && (r.color = /*activeIconColor*/
      s[60]), n.$set(r);
    },
    i(s) {
      o || (V(e.$$.fragment, s), V(n.$$.fragment, s), o = !0);
    },
    o(s) {
      z(e.$$.fragment, s), z(n.$$.fragment, s), o = !1;
    },
    d(s) {
      s && M(i), ge(e, s), ge(n, s);
    }
  };
}
function Va(t) {
  let e, i;
  return e = new j0({
    props: {
      playerStyle: (
        /*playerStyle*/
        t[3]
      ),
      isMobile: (
        /*isMobile*/
        t[33]
      ),
      isAdvert: (
        /*isAdvert*/
        t[29]
      ),
      scale: (
        /*buttonScale*/
        t[36]
      ),
      controlsOrder: (
        /*controlsOrder*/
        t[24]
      ),
      fixedPosition: (
        /*fixedPosition*/
        t[9]
      ),
      $$slots: { default: [VA] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*playerStyle*/
      8 && (s.playerStyle = /*playerStyle*/
      n[3]), o[1] & /*isMobile*/
      4 && (s.isMobile = /*isMobile*/
      n[33]), o[0] & /*isAdvert*/
      536870912 && (s.isAdvert = /*isAdvert*/
      n[29]), o[1] & /*buttonScale*/
      32 && (s.scale = /*buttonScale*/
      n[36]), o[0] & /*controlsOrder*/
      16777216 && (s.controlsOrder = /*controlsOrder*/
      n[24]), o[0] & /*fixedPosition*/
      512 && (s.fixedPosition = /*fixedPosition*/
      n[9]), o[0] & /*onEvent, isScreen, isHovering, isVideo, playerStyle, downloadFormats, contentIndex, isAdvert, width*/
      820252744 | o[1] & /*logoScale, showBeyondWords, buttonScale, activeIconColor, contentItem, showPlaylist, showPlaylistToggle*/
      570454064 | o[2] & /*isPlaying*/
      4 | o[3] & /*$$scope*/
      2 && (s.$$scope = { dirty: o, ctx: n }), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function CA(t) {
  var n, o;
  let e, i;
  return e = new jr({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      scale: (
        /*isScreen*/
        t[28] ? (
          /*buttonScale*/
          t[36]
        ) : (
          /*logoScale*/
          t[56]
        )
      ),
      color: (
        /*activeIconColor*/
        t[60]
      ),
      downloadFormats: (
        /*downloadFormats*/
        t[6]
      ),
      contentIndex: (
        /*contentIndex*/
        t[12]
      ),
      audio: (
        /*contentItem*/
        (n = t[35]) == null ? void 0 : n.audio
      ),
      video: (
        /*contentItem*/
        (o = t[35]) == null ? void 0 : o.video
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(s, l) {
      de(e, s, l), i = !0;
    },
    p(s, l) {
      var r, u;
      const a = {};
      l[0] & /*onEvent*/
      262144 && (a.onEvent = /*onEvent*/
      s[18]), l[0] & /*isScreen*/
      268435456 | l[1] & /*buttonScale, logoScale*/
      33554464 && (a.scale = /*isScreen*/
      s[28] ? (
        /*buttonScale*/
        s[36]
      ) : (
        /*logoScale*/
        s[56]
      )), l[1] & /*activeIconColor*/
      536870912 && (a.color = /*activeIconColor*/
      s[60]), l[0] & /*downloadFormats*/
      64 && (a.downloadFormats = /*downloadFormats*/
      s[6]), l[0] & /*contentIndex*/
      4096 && (a.contentIndex = /*contentIndex*/
      s[12]), l[1] & /*contentItem*/
      16 && (a.audio = /*contentItem*/
      (r = s[35]) == null ? void 0 : r.audio), l[1] & /*contentItem*/
      16 && (a.video = /*contentItem*/
      (u = s[35]) == null ? void 0 : u.video), e.$set(a);
    },
    i(s) {
      i || (V(e.$$.fragment, s), i = !0);
    },
    o(s) {
      z(e.$$.fragment, s), i = !1;
    },
    d(s) {
      ge(e, s);
    }
  };
}
function IA(t) {
  let e, i;
  return e = new W0({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      scale: (
        /*isVideo*/
        (t[23] ? 1.25 : 1) * /*buttonScale*/
        t[36]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      ),
      playlistShowing: (
        /*showPlaylist*/
        t[44]
      ),
      playerStyle: (
        /*playerStyle*/
        t[3]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[0] & /*isVideo*/
      8388608 | o[1] & /*buttonScale*/
      32 && (s.scale = /*isVideo*/
      (n[23] ? 1.25 : 1) * /*buttonScale*/
      n[36]), o[1] & /*activeIconColor*/
      536870912 && (s.color = /*activeIconColor*/
      n[60]), o[1] & /*showPlaylist*/
      8192 && (s.playlistShowing = /*showPlaylist*/
      n[44]), o[0] & /*playerStyle*/
      8 && (s.playerStyle = /*playerStyle*/
      n[3]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function OA(t) {
  let e, i;
  return e = new G2({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      scale: (
        /*buttonScale*/
        t[36]
      ),
      href: (
        /*contentItem*/
        t[35].sourceUrl
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[1] & /*buttonScale*/
      32 && (s.scale = /*buttonScale*/
      n[36]), o[1] & /*contentItem*/
      16 && (s.href = /*contentItem*/
      n[35].sourceUrl), o[1] & /*activeIconColor*/
      536870912 && (s.color = /*activeIconColor*/
      n[60]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Ba(t) {
  let e, i;
  return e = new i2({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      scale: (
        /*buttonScale*/
        t[36]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[1] & /*buttonScale*/
      32 && (s.scale = /*buttonScale*/
      n[36]), o[1] & /*activeIconColor*/
      536870912 && (s.color = /*activeIconColor*/
      n[60]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function Wa(t) {
  let e, i;
  return e = new Nr({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      scale: (
        /*logoScale*/
        t[56]
      ),
      visible: (
        /*isScreen*/
        t[28] || /*isHovering*/
        t[22] || /*isPlaying*/
        t[64]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[1] & /*logoScale*/
      33554432 && (s.scale = /*logoScale*/
      n[56]), o[0] & /*isScreen, isHovering*/
      272629760 | o[2] & /*isPlaying*/
      4 && (s.visible = /*isScreen*/
      n[28] || /*isHovering*/
      n[22] || /*isPlaying*/
      n[64]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function VA(t) {
  let e, i, n, o = (
    /*isVideo*/
    t[23] && va()
  ), s, l, a;
  const r = [OA, IA, CA], u = [];
  function c(A, _) {
    return (
      /*isScreen*/
      A[28] && /*contentItem*/
      A[35].sourceUrl ? 0 : (
        /*showPlaylistToggle*/
        A[43] ? 1 : !/*showPlaylist*/
        A[44] && !/*isAdvert*/
        A[29] && !/*isVideo*/
        (A[23] && /*width*/
        A[21] < 320) ? 2 : -1
      )
    );
  }
  ~(e = c(t)) && (i = u[e] = r[e](t));
  let g = o && Ba(t), f = (
    /*isVideo*/
    t[23] && /*showBeyondWords*/
    t[45] && Wa(t)
  );
  return {
    c() {
      i && i.c(), n = J(), g && g.c(), s = J(), f && f.c(), l = Ei();
    },
    m(A, _) {
      ~e && u[e].m(A, _), E(A, n, _), g && g.m(A, _), E(A, s, _), f && f.m(A, _), E(A, l, _), a = !0;
    },
    p(A, _) {
      let k = e;
      e = c(A), e === k ? ~e && u[e].p(A, _) : (i && (Fe(), z(u[k], 1, 1, () => {
        u[k] = null;
      }), Ue()), ~e ? (i = u[e], i ? i.p(A, _) : (i = u[e] = r[e](A), i.c()), V(i, 1), i.m(n.parentNode, n)) : i = null), _[0] & /*isVideo*/
      8388608 && (o = /*isVideo*/
      A[23] && va()), o ? g ? (g.p(A, _), _[0] & /*isVideo*/
      8388608 && V(g, 1)) : (g = Ba(A), g.c(), V(g, 1), g.m(s.parentNode, s)) : g && (Fe(), z(g, 1, 1, () => {
        g = null;
      }), Ue()), /*isVideo*/
      A[23] && /*showBeyondWords*/
      A[45] ? f ? (f.p(A, _), _[0] & /*isVideo*/
      8388608 | _[1] & /*showBeyondWords*/
      16384 && V(f, 1)) : (f = Wa(A), f.c(), V(f, 1), f.m(l.parentNode, l)) : f && (Fe(), z(f, 1, 1, () => {
        f = null;
      }), Ue());
    },
    i(A) {
      a || (V(i), V(g), V(f), a = !0);
    },
    o(A) {
      z(i), z(g), z(f), a = !1;
    },
    d(A) {
      A && (M(n), M(s), M(l)), ~e && u[e].d(A), g && g.d(A), f && f.d(A);
    }
  };
}
function Ma(t) {
  let e, i, n, o;
  const s = [WA, BA], l = [];
  function a(r, u) {
    return (
      /*showCloseWidget*/
      r[46] ? 0 : (
        /*showBeyondWords*/
        r[45] && !/*isVideo*/
        r[23] ? 1 : -1
      )
    );
  }
  return ~(i = a(t)) && (n = l[i] = s[i](t)), {
    c() {
      e = y("div"), n && n.c(), Mi(e, "class", "end svelte-k6qh1c"), ne(
        e,
        "logo-image-right",
        /*logoImagePosition*/
        t[17] !== "top-left"
      ), ne(
        e,
        "has-content",
        /*showCloseWidget*/
        t[46] || /*showBeyondWords*/
        t[45] && !/*isVideo*/
        t[23]
      );
    },
    m(r, u) {
      E(r, e, u), ~i && l[i].m(e, null), o = !0;
    },
    p(r, u) {
      let c = i;
      i = a(r), i === c ? ~i && l[i].p(r, u) : (n && (Fe(), z(l[c], 1, 1, () => {
        l[c] = null;
      }), Ue()), ~i ? (n = l[i], n ? n.p(r, u) : (n = l[i] = s[i](r), n.c()), V(n, 1), n.m(e, null)) : n = null), (!o || u[0] & /*logoImagePosition*/
      131072) && ne(
        e,
        "logo-image-right",
        /*logoImagePosition*/
        r[17] !== "top-left"
      ), (!o || u[0] & /*isVideo*/
      8388608 | u[1] & /*showCloseWidget, showBeyondWords*/
      49152) && ne(
        e,
        "has-content",
        /*showCloseWidget*/
        r[46] || /*showBeyondWords*/
        r[45] && !/*isVideo*/
        r[23]
      );
    },
    i(r) {
      o || (V(n), o = !0);
    },
    o(r) {
      z(n), o = !1;
    },
    d(r) {
      r && M(e), ~i && l[i].d();
    }
  };
}
function BA(t) {
  let e, i;
  return e = new Nr({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      scale: (
        /*logoScale*/
        t[56]
      ),
      visible: (
        /*isScreen*/
        t[28] || /*isHovering*/
        t[22] || /*isPlaying*/
        t[64]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[1] & /*logoScale*/
      33554432 && (s.scale = /*logoScale*/
      n[56]), o[0] & /*isScreen, isHovering*/
      272629760 | o[2] & /*isPlaying*/
      4 && (s.visible = /*isScreen*/
      n[28] || /*isHovering*/
      n[22] || /*isPlaying*/
      n[64]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function WA(t) {
  let e, i;
  return e = new g2({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      scale: (
        /*closeScale*/
        t[55]
      ),
      margin: (
        /*closeMargin*/
        t[54]
      ),
      color: (
        /*activeIconColor*/
        t[60]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[1] & /*closeScale*/
      16777216 && (s.scale = /*closeScale*/
      n[55]), o[1] & /*closeMargin*/
      8388608 && (s.margin = /*closeMargin*/
      n[54]), o[1] & /*activeIconColor*/
      536870912 && (s.color = /*activeIconColor*/
      n[60]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function MA(t) {
  let e, i, n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, C = (
    /*isVideo*/
    t[23] && /*videoPosterImage*/
    (t[19] || !/*videoIsBehind*/
    t[20]) && ka(t)
  ), Z = (
    /*largeImage*/
    t[50] && /*isLarge*/
    (t[65] || /*isScreen*/
    t[28]) && Sa(t)
  ), q = (
    /*isLarge*/
    (t[65] || /*isScreen*/
    t[28]) && Pa(t)
  );
  function x(b) {
    t[89](b);
  }
  function X(b) {
    t[90](b);
  }
  function oe(b) {
    t[91](b);
  }
  let ae = {
    onEvent: (
      /*onEvent*/
      t[18]
    ),
    enabled: !/*fixedPosition*/
    t[9],
    $$slots: { default: [TA] },
    $$scope: { ctx: t }
  };
  /*isVisible*/
  t[0] !== void 0 && (ae.isVisible = /*isVisible*/
  t[0]), /*relativeY*/
  t[1] !== void 0 && (ae.relativeY = /*relativeY*/
  t[1]), /*absoluteY*/
  t[2] !== void 0 && (ae.absoluteY = /*absoluteY*/
  t[2]), l = new yA({ props: ae }), se.push(() => be(l, "isVisible", x)), se.push(() => be(l, "relativeY", X)), se.push(() => be(l, "absoluteY", oe));
  let $ = (
    /*isStandard*/
    ((t[30] || /*isVideo*/
    t[23]) && /*isStopped*/
    t[31] || /*isSmall*/
    t[26]) && wa(t)
  ), ee = (!/*isSmall*/
  t[26] && !/*isStopped*/
  t[31] && !/*isAdvert*/
  t[29] || /*isScreen*/
  t[28] && /*isAdvert*/
  t[29]) && Ta(t), ue = (
    /*isStandard*/
    t[30] && /*fixedPosition*/
    t[9] && !/*isStopped*/
    t[31] && !/*isAdvert*/
    t[29] && /*width*/
    t[21] > 720 && /*controlsOrder*/
    t[24] !== "left-to-right-but-swap-ends" && Ca(t)
  );
  _ = new J_({
    props: {
      currentTime: (
        /*currentTime*/
        t[14]
      ),
      duration: (
        /*duration*/
        t[13]
      ),
      durationFormat: (
        /*durationFormat*/
        t[7]
      ),
      playerStyle: (
        /*playerStyle*/
        t[3]
      ),
      isAdvert: (
        /*isAdvert*/
        t[29]
      ),
      isMobile: (
        /*isMobile*/
        t[33]
      ),
      isStopped: (
        /*isStopped*/
        t[31]
      ),
      positionClasses: (
        /*positionClasses*/
        t[25]
      ),
      collapsed: (
        /*collapsed*/
        t[47]
      ),
      largeImage: (
        /*largeImage*/
        t[50]
      ),
      showBeyondWords: (
        /*showBeyondWords*/
        t[45]
      ),
      color: (
        /*activeTextColor*/
        t[62]
      )
    }
  });
  let Ae = (
    /*isStandard*/
    (t[30] && !/*isMobile*/
    t[33] && !/*isStopped*/
    t[31] || /*isLarge*/
    t[65] && !/*isMobile*/
    t[33] || /*isVideo*/
    t[23] && !/*isStopped*/
    t[31]) && Ia(t)
  ), ce = (
    /*isAdvert*/
    t[29] && !/*forcedCollapsed*/
    t[27] && Oa(t)
  ), ye = !/*isStopped*/
  t[31] && Va(t), re = (
    /*showCloseWidget*/
    (t[46] || /*showBeyondWords*/
    t[45] && !/*isVideo*/
    t[23] || !/*isAdvert*/
    t[29] && !/*isSmall*/
    t[26]) && Ma(t)
  );
  return {
    c() {
      C && C.c(), e = J(), i = y("div"), Z && Z.c(), n = J(), q && q.c(), o = J(), s = y("div"), me(l.$$.fragment), c = J(), $ && $.c(), g = J(), ee && ee.c(), f = J(), ue && ue.c(), A = J(), me(_.$$.fragment), k = J(), Ae && Ae.c(), S = J(), ce && ce.c(), T = J(), ye && ye.c(), v = J(), re && re.c(), Mi(s, "class", "controls svelte-k6qh1c"), Mi(i, "class", "main svelte-k6qh1c"), Mi(i, "role", "none"), Mi(i, "style", P = /*isVideo*/
      t[23] ? "" : `background: ${/*activeBgColor*/
      t[61]}`), ne(i, "no-image", !/*largeImage*/
      t[50]);
    },
    m(b, w) {
      C && C.m(b, w), E(b, e, w), E(b, i, w), Z && Z.m(i, null), h(i, n), q && q.m(i, null), h(i, o), h(i, s), de(l, s, null), h(s, c), $ && $.m(s, null), h(s, g), ee && ee.m(s, null), h(s, f), ue && ue.m(s, null), h(s, A), de(_, s, null), h(s, k), Ae && Ae.m(s, null), h(s, S), ce && ce.m(s, null), h(s, T), ye && ye.m(s, null), h(i, v), re && re.m(i, null), O = !0, D || (p = [
        Y(
          i,
          "mousedown",
          /*handleMouseDown*/
          t[67]
        ),
        Y(i, "keyup", null)
      ], D = !0);
    },
    p(b, w) {
      /*isVideo*/
      b[23] && /*videoPosterImage*/
      (b[19] || !/*videoIsBehind*/
      b[20]) ? C ? (C.p(b, w), w[0] & /*isVideo, videoPosterImage, videoIsBehind*/
      9961472 && V(C, 1)) : (C = ka(b), C.c(), V(C, 1), C.m(e.parentNode, e)) : C && (Fe(), z(C, 1, 1, () => {
        C = null;
      }), Ue()), /*largeImage*/
      b[50] && /*isLarge*/
      (b[65] || /*isScreen*/
      b[28]) ? Z ? (Z.p(b, w), w[0] & /*isScreen*/
      268435456 | w[1] & /*largeImage*/
      524288 | w[2] & /*isLarge*/
      8 && V(Z, 1)) : (Z = Sa(b), Z.c(), V(Z, 1), Z.m(i, n)) : Z && (Fe(), z(Z, 1, 1, () => {
        Z = null;
      }), Ue()), /*isLarge*/
      b[65] || /*isScreen*/
      b[28] ? q ? (q.p(b, w), w[0] & /*isScreen*/
      268435456 | w[2] & /*isLarge*/
      8 && V(q, 1)) : (q = Pa(b), q.c(), V(q, 1), q.m(i, o)) : q && (Fe(), z(q, 1, 1, () => {
        q = null;
      }), Ue());
      const R = {};
      w[0] & /*onEvent*/
      262144 && (R.onEvent = /*onEvent*/
      b[18]), w[0] & /*fixedPosition*/
      512 && (R.enabled = !/*fixedPosition*/
      b[9]), w[0] & /*onEvent, isScreen, isSmall*/
      335806464 | w[1] & /*playPauseScale, activeIconColor*/
      671088640 | w[2] & /*progress, isPlaying*/
      6 | w[3] & /*$$scope*/
      2 && (R.$$scope = { dirty: w, ctx: b }), !a && w[0] & /*isVisible*/
      1 && (a = !0, R.isVisible = /*isVisible*/
      b[0], ve(() => a = !1)), !r && w[0] & /*relativeY*/
      2 && (r = !0, R.relativeY = /*relativeY*/
      b[1], ve(() => r = !1)), !u && w[0] & /*absoluteY*/
      4 && (u = !0, R.absoluteY = /*absoluteY*/
      b[2], ve(() => u = !1)), l.$set(R), /*isStandard*/
      (b[30] || /*isVideo*/
      b[23]) && /*isStopped*/
      b[31] || /*isSmall*/
      b[26] ? $ ? ($.p(b, w), w[0] & /*isStandard, isVideo, isSmall*/
      1149239296 | w[1] & /*isStopped*/
      1 && V($, 1)) : ($ = wa(b), $.c(), V($, 1), $.m(s, g)) : $ && (Fe(), z($, 1, 1, () => {
        $ = null;
      }), Ue()), !/*isSmall*/
      b[26] && !/*isStopped*/
      b[31] && !/*isAdvert*/
      b[29] || /*isScreen*/
      b[28] && /*isAdvert*/
      b[29] ? ee ? (ee.p(b, w), w[0] & /*isSmall, isAdvert, isScreen*/
      872415232 | w[1] & /*isStopped*/
      1 && V(ee, 1)) : (ee = Ta(b), ee.c(), V(ee, 1), ee.m(s, f)) : ee && (Fe(), z(ee, 1, 1, () => {
        ee = null;
      }), Ue()), /*isStandard*/
      b[30] && /*fixedPosition*/
      b[9] && !/*isStopped*/
      b[31] && !/*isAdvert*/
      b[29] && /*width*/
      b[21] > 720 && /*controlsOrder*/
      b[24] !== "left-to-right-but-swap-ends" ? ue ? (ue.p(b, w), w[0] & /*isStandard, fixedPosition, isAdvert, width, controlsOrder*/
      1629487616 | w[1] & /*isStopped*/
      1 && V(ue, 1)) : (ue = Ca(b), ue.c(), V(ue, 1), ue.m(s, A)) : ue && (Fe(), z(ue, 1, 1, () => {
        ue = null;
      }), Ue());
      const L = {};
      w[0] & /*currentTime*/
      16384 && (L.currentTime = /*currentTime*/
      b[14]), w[0] & /*duration*/
      8192 && (L.duration = /*duration*/
      b[13]), w[0] & /*durationFormat*/
      128 && (L.durationFormat = /*durationFormat*/
      b[7]), w[0] & /*playerStyle*/
      8 && (L.playerStyle = /*playerStyle*/
      b[3]), w[0] & /*isAdvert*/
      536870912 && (L.isAdvert = /*isAdvert*/
      b[29]), w[1] & /*isMobile*/
      4 && (L.isMobile = /*isMobile*/
      b[33]), w[1] & /*isStopped*/
      1 && (L.isStopped = /*isStopped*/
      b[31]), w[0] & /*positionClasses*/
      33554432 && (L.positionClasses = /*positionClasses*/
      b[25]), w[1] & /*collapsed*/
      65536 && (L.collapsed = /*collapsed*/
      b[47]), w[1] & /*largeImage*/
      524288 && (L.largeImage = /*largeImage*/
      b[50]), w[1] & /*showBeyondWords*/
      16384 && (L.showBeyondWords = /*showBeyondWords*/
      b[45]), w[2] & /*activeTextColor*/
      1 && (L.color = /*activeTextColor*/
      b[62]), _.$set(L), /*isStandard*/
      b[30] && !/*isMobile*/
      b[33] && !/*isStopped*/
      b[31] || /*isLarge*/
      b[65] && !/*isMobile*/
      b[33] || /*isVideo*/
      b[23] && !/*isStopped*/
      b[31] ? Ae ? (Ae.p(b, w), w[0] & /*isStandard, isVideo*/
      1082130432 | w[1] & /*isMobile, isStopped*/
      5 | w[2] & /*isLarge*/
      8 && V(Ae, 1)) : (Ae = Ia(b), Ae.c(), V(Ae, 1), Ae.m(s, S)) : Ae && (Fe(), z(Ae, 1, 1, () => {
        Ae = null;
      }), Ue()), /*isAdvert*/
      b[29] && !/*forcedCollapsed*/
      b[27] ? ce ? (ce.p(b, w), w[0] & /*isAdvert, forcedCollapsed*/
      671088640 && V(ce, 1)) : (ce = Oa(b), ce.c(), V(ce, 1), ce.m(s, T)) : ce && (Fe(), z(ce, 1, 1, () => {
        ce = null;
      }), Ue()), /*isStopped*/
      b[31] ? ye && (Fe(), z(ye, 1, 1, () => {
        ye = null;
      }), Ue()) : ye ? (ye.p(b, w), w[1] & /*isStopped*/
      1 && V(ye, 1)) : (ye = Va(b), ye.c(), V(ye, 1), ye.m(s, null)), /*showCloseWidget*/
      b[46] || /*showBeyondWords*/
      b[45] && !/*isVideo*/
      b[23] || !/*isAdvert*/
      b[29] && !/*isSmall*/
      b[26] ? re ? (re.p(b, w), w[0] & /*isVideo, isAdvert, isSmall*/
      612368384 | w[1] & /*showCloseWidget, showBeyondWords*/
      49152 && V(re, 1)) : (re = Ma(b), re.c(), V(re, 1), re.m(i, null)) : re && (Fe(), z(re, 1, 1, () => {
        re = null;
      }), Ue()), (!O || w[0] & /*isVideo*/
      8388608 | w[1] & /*activeBgColor*/
      1073741824 && P !== (P = /*isVideo*/
      b[23] ? "" : `background: ${/*activeBgColor*/
      b[61]}`)) && Mi(i, "style", P), (!O || w[1] & /*largeImage*/
      524288) && ne(i, "no-image", !/*largeImage*/
      b[50]);
    },
    i(b) {
      O || (V(C), V(Z), V(q), V(l.$$.fragment, b), V($), V(ee), V(ue), V(_.$$.fragment, b), V(Ae), V(ce), V(ye), V(re), O = !0);
    },
    o(b) {
      z(C), z(Z), z(q), z(l.$$.fragment, b), z($), z(ee), z(ue), z(_.$$.fragment, b), z(Ae), z(ce), z(ye), z(re), O = !1;
    },
    d(b) {
      b && (M(e), M(i)), C && C.d(b), Z && Z.d(), q && q.d(), ge(l), $ && $.d(), ee && ee.d(), ue && ue.d(), ge(_), Ae && Ae.d(), ce && ce.d(), ye && ye.d(), re && re.d(), D = !1, _t(p);
    }
  };
}
function Ea(t) {
  let e, i;
  return e = new aA({
    props: {
      onEvent: (
        /*onEvent*/
        t[18]
      ),
      style: (
        /*playlistStyle*/
        t[5]
      ),
      downloadFormats: (
        /*downloadFormats*/
        t[6]
      ),
      larger: (
        /*isScreen*/
        t[28] && !/*isMobile*/
        t[33]
      ),
      content: (
        /*content*/
        t[11]
      ),
      index: (
        /*contentIndex*/
        t[12]
      ),
      isMobile: (
        /*isMobile*/
        t[33]
      ),
      textColor: (
        /*nonVideoTextColor*/
        t[39]
      ),
      backgroundColor: (
        /*nonVideoBgColor*/
        t[38]
      ),
      iconColor: (
        /*nonVideoIconColor*/
        t[37]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*onEvent*/
      262144 && (s.onEvent = /*onEvent*/
      n[18]), o[0] & /*playlistStyle*/
      32 && (s.style = /*playlistStyle*/
      n[5]), o[0] & /*downloadFormats*/
      64 && (s.downloadFormats = /*downloadFormats*/
      n[6]), o[0] & /*isScreen*/
      268435456 | o[1] & /*isMobile*/
      4 && (s.larger = /*isScreen*/
      n[28] && !/*isMobile*/
      n[33]), o[0] & /*content*/
      2048 && (s.content = /*content*/
      n[11]), o[0] & /*contentIndex*/
      4096 && (s.index = /*contentIndex*/
      n[12]), o[1] & /*isMobile*/
      4 && (s.isMobile = /*isMobile*/
      n[33]), o[1] & /*nonVideoTextColor*/
      256 && (s.textColor = /*nonVideoTextColor*/
      n[39]), o[1] & /*nonVideoBgColor*/
      128 && (s.backgroundColor = /*nonVideoBgColor*/
      n[38]), o[1] & /*nonVideoIconColor*/
      64 && (s.iconColor = /*nonVideoIconColor*/
      n[37]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function EA(t) {
  let e, i, n, o, s, l, a, r, u;
  function c(A) {
    t[92](A);
  }
  let g = {
    exitDelay: (
      /*collapsible*/
      t[32] ? 500 : 0
    ),
    idleDelay: (
      /*isVideo*/
      t[23] ? 1500 : 1 / 0
    ),
    $$slots: { default: [MA] },
    $$scope: { ctx: t }
  };
  /*isHovering*/
  t[22] !== void 0 && (g.isHovering = /*isHovering*/
  t[22]), i = new gA({ props: g }), se.push(() => be(i, "isHovering", c));
  let f = (
    /*showPlaylist*/
    t[44] && Ea(t)
  );
  return {
    c() {
      e = y("div"), me(i.$$.fragment), o = J(), f && f.c(), Mi(e, "class", s = xl(
        /*classes*/
        t[42]
      ) + " svelte-k6qh1c"), Sn(
        e,
        "width",
        /*widthStyle*/
        t[53]
      ), Sn(
        e,
        "--margin",
        /*fixedMargin*/
        t[10]
      ), Sn(
        e,
        "--margin-width",
        /*marginWidth*/
        t[51]
      ), ne(
        e,
        "mobile",
        /*isMobile*/
        t[33]
      ), ne(
        e,
        "advert_",
        /*isAdvert*/
        t[29]
      ), ne(
        e,
        "hovering",
        /*isHovering*/
        t[22]
      ), ne(
        e,
        "collapsed",
        /*collapsed*/
        t[47]
      ), ne(
        e,
        "animating",
        /*timeout*/
        t[41]
      );
    },
    m(A, _) {
      E(A, e, _), de(i, e, null), h(e, o), f && f.m(e, null), t[93](e), a = !0, r || (u = Y(
        e,
        "outrostart",
        /*animate*/
        t[66]
      ), r = !0);
    },
    p(A, _) {
      const k = {};
      _[1] & /*collapsible*/
      2 && (k.exitDelay = /*collapsible*/
      A[32] ? 500 : 0), _[0] & /*isVideo*/
      8388608 && (k.idleDelay = /*isVideo*/
      A[23] ? 1500 : 1 / 0), _[0] & /*isVideo, logoImagePosition, onEvent, isScreen, isHovering, isAdvert, isSmall, playerStyle, controlsOrder, fixedPosition, downloadFormats, contentIndex, width, forcedCollapsed, duration, isStandard, currentTime, durationFormat, positionClasses, playbackRates, playbackRate, callToAction, isVisible, relativeY, absoluteY, playerTitle, videoPosterImage, videoIsBehind*/
      2147480543 | _[1] & /*activeBgColor, largeImage, showCloseWidget, showBeyondWords, closeScale, closeMargin, activeIconColor, logoScale, isMobile, buttonScale, contentItem, showPlaylist, showPlaylistToggle, isStopped, advertClickThroughUrl, collapsed, skipStyle, playerTitleScale, collapsible, playPauseScale, largeImageHref, imageSize*/
      2140139583 | _[2] & /*isPlaying, activeTextColor, progress, isLarge*/
      15 | _[3] & /*$$scope*/
      2 && (k.$$scope = { dirty: _, ctx: A }), !n && _[0] & /*isHovering*/
      4194304 && (n = !0, k.isHovering = /*isHovering*/
      A[22], ve(() => n = !1)), i.$set(k), /*showPlaylist*/
      A[44] ? f ? (f.p(A, _), _[1] & /*showPlaylist*/
      8192 && V(f, 1)) : (f = Ea(A), f.c(), V(f, 1), f.m(e, null)) : f && (Fe(), z(f, 1, 1, () => {
        f = null;
      }), Ue()), (!a || _[1] & /*classes*/
      2048 && s !== (s = xl(
        /*classes*/
        A[42]
      ) + " svelte-k6qh1c")) && Mi(e, "class", s), (!a || _[1] & /*widthStyle*/
      4194304) && Sn(
        e,
        "width",
        /*widthStyle*/
        A[53]
      ), (!a || _[0] & /*fixedMargin*/
      1024) && Sn(
        e,
        "--margin",
        /*fixedMargin*/
        A[10]
      ), (!a || _[1] & /*marginWidth*/
      1048576) && Sn(
        e,
        "--margin-width",
        /*marginWidth*/
        A[51]
      ), (!a || _[1] & /*classes, isMobile*/
      2052) && ne(
        e,
        "mobile",
        /*isMobile*/
        A[33]
      ), (!a || _[0] & /*isAdvert*/
      536870912 | _[1] & /*classes*/
      2048) && ne(
        e,
        "advert_",
        /*isAdvert*/
        A[29]
      ), (!a || _[0] & /*isHovering*/
      4194304 | _[1] & /*classes*/
      2048) && ne(
        e,
        "hovering",
        /*isHovering*/
        A[22]
      ), (!a || _[1] & /*classes, collapsed*/
      67584) && ne(
        e,
        "collapsed",
        /*collapsed*/
        A[47]
      ), (!a || _[1] & /*classes, timeout*/
      3072) && ne(
        e,
        "animating",
        /*timeout*/
        A[41]
      );
    },
    i(A) {
      a || (V(i.$$.fragment, A), V(f), dt(() => {
        a && (l || (l = Fl(
          e,
          /*flyWidget*/
          t[52],
          {},
          !0
        )), l.run(1));
      }), a = !0);
    },
    o(A) {
      z(i.$$.fragment, A), z(f), l || (l = Fl(
        e,
        /*flyWidget*/
        t[52],
        {},
        !1
      )), l.run(0), a = !1;
    },
    d(A) {
      A && M(e), ge(i), f && f.d(), t[93](null), A && l && l.end(), r = !1, u();
    }
  };
}
function zA(t, e, i) {
  let n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, C, Z, q, x, X, oe, ae, $, ee, ue, Ae, ce, ye, re, b, w, R, L, Ve, Le, Qe, j, he, ze, Re, Ge;
  import("./././././././././style.js");
  let { playerStyle: Me = "standard" } = e, { callToAction: nt = void 0 } = e, { skipButtonStyle: Te = "auto" } = e, { playlistStyle: Je = "auto-5-4" } = e, { playlistToggle: Ce = "auto" } = e, { downloadFormats: Lt = [] } = e, { durationFormat: Ee = void 0 } = e, { playerTitle: ft = void 0 } = e, { fixedPosition: Oe = void 0 } = e, { fixedWidth: qe = "auto" } = e, { fixedMargin: Nt = "0" } = e, { content: De = [] } = e, { contentIndex: St = 0 } = e, { duration: Ye = 0 } = e, { currentTime: At = 0 } = e, { playbackState: $e = "stopped" } = e, { playbackRate: mt = 1 } = e, { playbackRates: Ze = [] } = e, { activeAdvert: xe = void 0 } = e, { persistentAdvert: yt = void 0 } = e, { companionAdvert: et = void 0 } = e, { textColor: lt = "#111" } = e, { backgroundColor: ot = "#f5f5f5" } = e, { iconColor: Pt = "black" } = e, { videoTextColor: Xe = "white" } = e, { videoBackgroundColor: Ot = "black" } = e, { videoIconColor: vt = "white" } = e, { logoIconEnabled: Vt = !0 } = e, { logoImagePosition: wt = void 0 } = e, { maxImageSize: tt = 0 } = e, { onEvent: at = () => {
  } } = e, { videoPosterImage: Bt = "" } = e, { videoIsBehind: bt = !1 } = e, { isFullScreen: kt = !1 } = e, { isVisible: Ke = void 0 } = e, { relativeY: rt = void 0 } = e, { absoluteY: pt = void 0 } = e, st, it, He, ht;
  const Tt = () => {
    ht && clearTimeout(ht), i(41, ht = setTimeout(() => i(41, ht = null), 500));
  }, U = (K) => {
    !a || !(K.button === 0) || !K.target.classList.contains("main") || at(ke({
      type: "PressedVideoBackground",
      description: "The video background was pressed.",
      initiatedBy: "user"
    }));
  };
  Vo(() => {
    const K = new th(([jt]) => {
      i(21, it = jt.contentRect.width);
    });
    return K.observe(st), () => K.unobserve(st);
  });
  function ut(K) {
    Ke = K, i(0, Ke);
  }
  function te(K) {
    rt = K, i(1, rt);
  }
  function I(K) {
    pt = K, i(2, pt);
  }
  function B(K) {
    He = K, i(22, He);
  }
  function le(K) {
    se[K ? "unshift" : "push"](() => {
      st = K, i(40, st);
    });
  }
  return t.$$set = (K) => {
    "playerStyle" in K && i(3, Me = K.playerStyle), "callToAction" in K && i(4, nt = K.callToAction), "skipButtonStyle" in K && i(68, Te = K.skipButtonStyle), "playlistStyle" in K && i(5, Je = K.playlistStyle), "playlistToggle" in K && i(69, Ce = K.playlistToggle), "downloadFormats" in K && i(6, Lt = K.downloadFormats), "durationFormat" in K && i(7, Ee = K.durationFormat), "playerTitle" in K && i(8, ft = K.playerTitle), "fixedPosition" in K && i(9, Oe = K.fixedPosition), "fixedWidth" in K && i(70, qe = K.fixedWidth), "fixedMargin" in K && i(10, Nt = K.fixedMargin), "content" in K && i(11, De = K.content), "contentIndex" in K && i(12, St = K.contentIndex), "duration" in K && i(13, Ye = K.duration), "currentTime" in K && i(14, At = K.currentTime), "playbackState" in K && i(71, $e = K.playbackState), "playbackRate" in K && i(15, mt = K.playbackRate), "playbackRates" in K && i(16, Ze = K.playbackRates), "activeAdvert" in K && i(72, xe = K.activeAdvert), "persistentAdvert" in K && i(73, yt = K.persistentAdvert), "companionAdvert" in K && i(74, et = K.companionAdvert), "textColor" in K && i(75, lt = K.textColor), "backgroundColor" in K && i(76, ot = K.backgroundColor), "iconColor" in K && i(77, Pt = K.iconColor), "videoTextColor" in K && i(78, Xe = K.videoTextColor), "videoBackgroundColor" in K && i(79, Ot = K.videoBackgroundColor), "videoIconColor" in K && i(80, vt = K.videoIconColor), "logoIconEnabled" in K && i(81, Vt = K.logoIconEnabled), "logoImagePosition" in K && i(17, wt = K.logoImagePosition), "maxImageSize" in K && i(82, tt = K.maxImageSize), "onEvent" in K && i(18, at = K.onEvent), "videoPosterImage" in K && i(19, Bt = K.videoPosterImage), "videoIsBehind" in K && i(20, bt = K.videoIsBehind), "isFullScreen" in K && i(83, kt = K.isFullScreen), "isVisible" in K && i(0, Ke = K.isVisible), "relativeY" in K && i(1, rt = K.relativeY), "absoluteY" in K && i(2, pt = K.absoluteY);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*playerStyle*/
    8 && i(26, n = Me === "small"), t.$$.dirty[0] & /*playerStyle*/
    8 && i(30, o = Me === "standard"), t.$$.dirty[0] & /*playerStyle*/
    8 && i(65, s = Me === "large"), t.$$.dirty[0] & /*playerStyle*/
    8 && i(28, l = Me === "screen"), t.$$.dirty[0] & /*playerStyle*/
    8 && i(23, a = Me === "video"), t.$$.dirty[2] & /*playbackState*/
    512 && i(64, r = $e === "playing"), t.$$.dirty[2] & /*playbackState*/
    512 && i(31, u = $e === "stopped"), t.$$.dirty[1] & /*isStopped*/
    1 | t.$$.dirty[2] & /*activeAdvert*/
    1024 && i(29, c = xe && !u), t.$$.dirty[0] & /*content*/
    2048 && i(84, g = De.length > 1), t.$$.dirty[0] & /*playerStyle, width*/
    2097160 && i(33, f = vA({ playerStyle: Me, width: it })), t.$$.dirty[0] & /*content, contentIndex*/
    6144 && i(35, A = De[St] || {}), t.$$.dirty[0] & /*currentTime, duration*/
    24576 && i(63, _ = At / Ye), t.$$.dirty[0] & /*isAdvert*/
    536870912 | t.$$.dirty[2] & /*activeAdvert, textColor*/
    9216 && i(39, k = c && xe.textColor || lt), t.$$.dirty[0] & /*isAdvert*/
    536870912 | t.$$.dirty[2] & /*activeAdvert, backgroundColor*/
    17408 && i(38, S = c && xe.backgroundColor || ot), t.$$.dirty[0] & /*isAdvert*/
    536870912 | t.$$.dirty[2] & /*activeAdvert, iconColor*/
    33792 && i(37, T = c && xe.iconColor || Pt), t.$$.dirty[0] & /*isVideo, isAdvert*/
    545259520 | t.$$.dirty[1] & /*nonVideoTextColor*/
    256 | t.$$.dirty[2] & /*activeAdvert, videoTextColor*/
    66560 && i(62, v = a ? c && xe.videoTextColor || Xe : k), t.$$.dirty[0] & /*isVideo, isAdvert*/
    545259520 | t.$$.dirty[1] & /*nonVideoBgColor*/
    128 | t.$$.dirty[2] & /*activeAdvert, videoBackgroundColor*/
    132096 && i(61, P = a ? c && xe.videoBackgroundColor || Ot : S), t.$$.dirty[0] & /*isVideo, isAdvert*/
    545259520 | t.$$.dirty[1] & /*nonVideoIconColor*/
    64 | t.$$.dirty[2] & /*activeAdvert, videoIconColor*/
    263168 && i(60, O = a ? c && xe.videoIconColor || vt : T), t.$$.dirty[2] & /*skipButtonStyle, isPlaylist*/
    4194368 && i(59, D = Te === "auto" ? g ? "tracks" : "segments" : Te), t.$$.dirty[0] & /*isSmall, isVideo, fixedPosition, isScreen*/
    343933440 | t.$$.dirty[1] & /*isMobile*/
    4 && i(36, p = n || a && Oe ? 0.8 : l && !f ? 2 : 1), t.$$.dirty[0] & /*isScreen, isVideo*/
    276824064 | t.$$.dirty[1] & /*buttonScale, isStopped*/
    33 && i(58, C = p * (l ? 1.5 : a && u ? 1.6 : 1)), t.$$.dirty[0] & /*isVideo, fixedPosition*/
    8389120 && i(57, Z = a && !Oe ? 1.2 : 1), t.$$.dirty[0] & /*isScreen, isVideo*/
    276824064 | t.$$.dirty[1] & /*isMobile*/
    4 && i(56, q = l && !f ? 3 : l ? 2 : a && !f ? 1.5 : 1), t.$$.dirty[0] & /*isScreen, isVideo*/
    276824064 | t.$$.dirty[1] & /*isMobile*/
    4 && i(55, x = l && !f ? 2.5 : l ? 1.75 : a && !f ? 2 : a ? 1.5 : 1), t.$$.dirty[0] & /*isScreen*/
    268435456 | t.$$.dirty[1] & /*isMobile*/
    4 && i(54, X = l && !f ? "12px 0" : l ? "4px 0" : "auto"), t.$$.dirty[0] & /*isSmall*/
    67108864 | t.$$.dirty[2] & /*fixedWidth*/
    256 && i(53, oe = qe === "auto" ? n ? "fit-content" : "" : qe), t.$$.dirty[0] & /*fixedPosition, isStandard*/
    1073742336 && i(87, ae = Oe === "auto" ? o ? "center" : "right" : Oe), t.$$.dirty[0] & /*fixedPosition*/
    512 | t.$$.dirty[2] & /*position*/
    33554432 && i(25, $ = Oe ? `fixed fixed-${ae}` : ""), t.$$.dirty[0] & /*fixedPosition, isSmall, isStandard*/
    1140851200 && i(52, ee = (K) => Oe && !window.disableAnimation && jm(K, { y: n || o ? 40 : 100 })), t.$$.dirty[0] & /*fixedMargin*/
    1024 && i(88, ue = Cr(Nt)), t.$$.dirty[2] & /*margin*/
    67108864 && i(51, Ae = `calc(${ue.left} + ${ue.right})`), t.$$.dirty[0] & /*playerStyle, isAdvert*/
    536870920 | t.$$.dirty[1] & /*isMobile*/
    4 | t.$$.dirty[2] & /*position*/
    33554432 && i(24, ce = bA({
      playerStyle: Me,
      position: ae,
      isMobile: f,
      isAdvert: c
    })), t.$$.dirty[2] & /*companionAdvert, activeAdvert*/
    5120 && i(86, ye = (et == null ? void 0 : et.imageUrl) || (xe == null ? void 0 : xe.imageUrl)), t.$$.dirty[2] & /*companionAdvert, activeAdvert*/
    5120 && i(34, re = (et == null ? void 0 : et.clickThroughUrl) || (xe == null ? void 0 : xe.clickThroughUrl)), t.$$.dirty[0] & /*isAdvert*/
    536870912 | t.$$.dirty[1] & /*isStopped, contentItem*/
    17 | t.$$.dirty[2] & /*advertImageUrl, persistentAdvert*/
    16779264 && i(50, b = c && ye || !u && (yt == null ? void 0 : yt.imageUrl) || A.imageUrl), t.$$.dirty[0] & /*isAdvert*/
    536870912 | t.$$.dirty[1] & /*advertClickThroughUrl, isStopped*/
    9 | t.$$.dirty[2] & /*persistentAdvert*/
    2048 && i(49, w = c && re || !u && (yt == null ? void 0 : yt.clickThroughUrl)), t.$$.dirty[1] & /*isMobile*/
    4 | t.$$.dirty[2] & /*maxImageSize*/
    1048576 && i(48, R = f ? 80 : tt), t.$$.dirty[0] & /*isSmall, fixedPosition*/
    67109376 | t.$$.dirty[2] & /*fixedWidth*/
    256 && i(32, L = n && Oe && qe === "auto"), t.$$.dirty[0] & /*isSmall*/
    67108864 | t.$$.dirty[2] & /*fixedWidth*/
    256 && i(27, Ve = n && (qe === 0 || qe === "0")), t.$$.dirty[0] & /*forcedCollapsed, isAdvert, isHovering*/
    675282944 | t.$$.dirty[1] & /*collapsible, isStopped*/
    3 && i(47, Le = Ve || L && !c && !u && !He), t.$$.dirty[0] & /*fixedPosition, isSmall, isStandard, isAdvert*/
    1677722112 && i(46, Qe = Oe && !n && !(o && c)), t.$$.dirty[0] & /*isAdvert, isScreen, fixedPosition, isSmall, forcedCollapsed*/
    1006633472 | t.$$.dirty[2] & /*logoIconEnabled*/
    524288 && i(45, j = Vt && (!c || l) && !(Oe && n) && !Ve), t.$$.dirty[0] & /*playlistStyle*/
    32 && i(85, he = Je.split("-")), t.$$.dirty[0] & /*isSmall*/
    67108864 | t.$$.dirty[2] & /*playlistParts, isPlaylist*/
    12582912 && i(44, ze = (he[0] === "show" || he[0] === "auto" && g) && !n), t.$$.dirty[0] & /*isSmall*/
    67108864 | t.$$.dirty[2] & /*playlistToggle, isPlaylist, isFullScreen*/
    6291584 && i(43, Re = (Ce === "show" || Ce === "auto" && g) && !n && !kt), t.$$.dirty[0] & /*playerStyle, positionClasses, controlsOrder*/
    50331656 | t.$$.dirty[2] & /*playbackState*/
    512 && i(42, Ge = `user-interface ${Me} ${$e} ${$} ${ce}`), t.$$.dirty[0] & /*fixedPosition*/
    512 && Oe && Tt();
  }, [
    Ke,
    rt,
    pt,
    Me,
    nt,
    Je,
    Lt,
    Ee,
    ft,
    Oe,
    Nt,
    De,
    St,
    Ye,
    At,
    mt,
    Ze,
    wt,
    at,
    Bt,
    bt,
    it,
    He,
    a,
    ce,
    $,
    n,
    Ve,
    l,
    c,
    o,
    u,
    L,
    f,
    re,
    A,
    p,
    T,
    S,
    k,
    st,
    ht,
    Ge,
    Re,
    ze,
    j,
    Qe,
    Le,
    R,
    w,
    b,
    Ae,
    ee,
    oe,
    X,
    x,
    q,
    Z,
    C,
    D,
    O,
    P,
    v,
    _,
    r,
    s,
    Tt,
    U,
    Te,
    Ce,
    qe,
    $e,
    xe,
    yt,
    et,
    lt,
    ot,
    Pt,
    Xe,
    Ot,
    vt,
    Vt,
    tt,
    kt,
    g,
    he,
    ye,
    ae,
    ue,
    ut,
    te,
    I,
    B,
    le
  ];
}
class Wl extends we {
  constructor(e) {
    super(), Pe(
      this,
      e,
      zA,
      EA,
      pe,
      {
        playerStyle: 3,
        callToAction: 4,
        skipButtonStyle: 68,
        playlistStyle: 5,
        playlistToggle: 69,
        downloadFormats: 6,
        durationFormat: 7,
        playerTitle: 8,
        fixedPosition: 9,
        fixedWidth: 70,
        fixedMargin: 10,
        content: 11,
        contentIndex: 12,
        duration: 13,
        currentTime: 14,
        playbackState: 71,
        playbackRate: 15,
        playbackRates: 16,
        activeAdvert: 72,
        persistentAdvert: 73,
        companionAdvert: 74,
        textColor: 75,
        backgroundColor: 76,
        iconColor: 77,
        videoTextColor: 78,
        videoBackgroundColor: 79,
        videoIconColor: 80,
        logoIconEnabled: 81,
        logoImagePosition: 17,
        maxImageSize: 82,
        onEvent: 18,
        videoPosterImage: 19,
        videoIsBehind: 20,
        isFullScreen: 83,
        isVisible: 0,
        relativeY: 1,
        absoluteY: 2
      },
      null,
      [-1, -1, -1, -1]
    );
  }
  get playerStyle() {
    return this.$$.ctx[3];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get callToAction() {
    return this.$$.ctx[4];
  }
  set callToAction(e) {
    this.$$set({ callToAction: e }), d();
  }
  get skipButtonStyle() {
    return this.$$.ctx[68];
  }
  set skipButtonStyle(e) {
    this.$$set({ skipButtonStyle: e }), d();
  }
  get playlistStyle() {
    return this.$$.ctx[5];
  }
  set playlistStyle(e) {
    this.$$set({ playlistStyle: e }), d();
  }
  get playlistToggle() {
    return this.$$.ctx[69];
  }
  set playlistToggle(e) {
    this.$$set({ playlistToggle: e }), d();
  }
  get downloadFormats() {
    return this.$$.ctx[6];
  }
  set downloadFormats(e) {
    this.$$set({ downloadFormats: e }), d();
  }
  get durationFormat() {
    return this.$$.ctx[7];
  }
  set durationFormat(e) {
    this.$$set({ durationFormat: e }), d();
  }
  get playerTitle() {
    return this.$$.ctx[8];
  }
  set playerTitle(e) {
    this.$$set({ playerTitle: e }), d();
  }
  get fixedPosition() {
    return this.$$.ctx[9];
  }
  set fixedPosition(e) {
    this.$$set({ fixedPosition: e }), d();
  }
  get fixedWidth() {
    return this.$$.ctx[70];
  }
  set fixedWidth(e) {
    this.$$set({ fixedWidth: e }), d();
  }
  get fixedMargin() {
    return this.$$.ctx[10];
  }
  set fixedMargin(e) {
    this.$$set({ fixedMargin: e }), d();
  }
  get content() {
    return this.$$.ctx[11];
  }
  set content(e) {
    this.$$set({ content: e }), d();
  }
  get contentIndex() {
    return this.$$.ctx[12];
  }
  set contentIndex(e) {
    this.$$set({ contentIndex: e }), d();
  }
  get duration() {
    return this.$$.ctx[13];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get currentTime() {
    return this.$$.ctx[14];
  }
  set currentTime(e) {
    this.$$set({ currentTime: e }), d();
  }
  get playbackState() {
    return this.$$.ctx[71];
  }
  set playbackState(e) {
    this.$$set({ playbackState: e }), d();
  }
  get playbackRate() {
    return this.$$.ctx[15];
  }
  set playbackRate(e) {
    this.$$set({ playbackRate: e }), d();
  }
  get playbackRates() {
    return this.$$.ctx[16];
  }
  set playbackRates(e) {
    this.$$set({ playbackRates: e }), d();
  }
  get activeAdvert() {
    return this.$$.ctx[72];
  }
  set activeAdvert(e) {
    this.$$set({ activeAdvert: e }), d();
  }
  get persistentAdvert() {
    return this.$$.ctx[73];
  }
  set persistentAdvert(e) {
    this.$$set({ persistentAdvert: e }), d();
  }
  get companionAdvert() {
    return this.$$.ctx[74];
  }
  set companionAdvert(e) {
    this.$$set({ companionAdvert: e }), d();
  }
  get textColor() {
    return this.$$.ctx[75];
  }
  set textColor(e) {
    this.$$set({ textColor: e }), d();
  }
  get backgroundColor() {
    return this.$$.ctx[76];
  }
  set backgroundColor(e) {
    this.$$set({ backgroundColor: e }), d();
  }
  get iconColor() {
    return this.$$.ctx[77];
  }
  set iconColor(e) {
    this.$$set({ iconColor: e }), d();
  }
  get videoTextColor() {
    return this.$$.ctx[78];
  }
  set videoTextColor(e) {
    this.$$set({ videoTextColor: e }), d();
  }
  get videoBackgroundColor() {
    return this.$$.ctx[79];
  }
  set videoBackgroundColor(e) {
    this.$$set({ videoBackgroundColor: e }), d();
  }
  get videoIconColor() {
    return this.$$.ctx[80];
  }
  set videoIconColor(e) {
    this.$$set({ videoIconColor: e }), d();
  }
  get logoIconEnabled() {
    return this.$$.ctx[81];
  }
  set logoIconEnabled(e) {
    this.$$set({ logoIconEnabled: e }), d();
  }
  get logoImagePosition() {
    return this.$$.ctx[17];
  }
  set logoImagePosition(e) {
    this.$$set({ logoImagePosition: e }), d();
  }
  get maxImageSize() {
    return this.$$.ctx[82];
  }
  set maxImageSize(e) {
    this.$$set({ maxImageSize: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[18];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
  get videoPosterImage() {
    return this.$$.ctx[19];
  }
  set videoPosterImage(e) {
    this.$$set({ videoPosterImage: e }), d();
  }
  get videoIsBehind() {
    return this.$$.ctx[20];
  }
  set videoIsBehind(e) {
    this.$$set({ videoIsBehind: e }), d();
  }
  get isFullScreen() {
    return this.$$.ctx[83];
  }
  set isFullScreen(e) {
    this.$$set({ isFullScreen: e }), d();
  }
  get isVisible() {
    return this.$$.ctx[0];
  }
  set isVisible(e) {
    this.$$set({ isVisible: e }), d();
  }
  get relativeY() {
    return this.$$.ctx[1];
  }
  set relativeY(e) {
    this.$$set({ relativeY: e }), d();
  }
  get absoluteY() {
    return this.$$.ctx[2];
  }
  set absoluteY(e) {
    this.$$set({ absoluteY: e }), d();
  }
}
const $s = (t, e, i) => Ie(t, e, e === "style" ? jA(i) : i), LA = /;(?!([^()]*\([^()]*\))*[^()]*\))/, jA = (t) => t.split(LA).filter((e) => e).map((e) => e + " !important").join(";");
function DA(t) {
  let e, i, n;
  const o = (
    /*#slots*/
    t[6].default
  ), s = Qn(
    o,
    t,
    /*$$scope*/
    t[5],
    null
  );
  return {
    c() {
      e = y("div"), s && s.c(), $s(e, "class", "external-widget"), $s(e, "style", i = /*root*/
      t[0] ? "position: relative" : "");
    },
    m(l, a) {
      E(l, e, a), s && s.m(e, null), t[7](e), n = !0;
    },
    p(l, [a]) {
      s && s.p && (!n || a & /*$$scope*/
      32) && eo(
        s,
        o,
        l,
        /*$$scope*/
        l[5],
        n ? $n(
          o,
          /*$$scope*/
          l[5],
          a,
          null
        ) : to(
          /*$$scope*/
          l[5]
        ),
        null
      ), (!n || a & /*root*/
      1 && i !== (i = /*root*/
      l[0] ? "position: relative" : "")) && $s(e, "style", i);
    },
    i(l) {
      n || (V(s, l), n = !0);
    },
    o(l) {
      z(s, l), n = !1;
    },
    d(l) {
      l && M(e), s && s.d(l), t[7](null);
    }
  };
}
function xA(t, e, i) {
  let n, { $$slots: o = {}, $$scope: s } = e, { root: l = void 0 } = e, { prepend: a = !1 } = e, r, u;
  Vo(() => i(3, u = r.parentNode));
  const c = (A, _) => A.insertBefore(_, A.firstChild), g = (A, _) => A.appendChild(_);
  function f(A) {
    se[A ? "unshift" : "push"](() => {
      r = A, i(1, r);
    });
  }
  return t.$$set = (A) => {
    "root" in A && i(0, l = A.root), "prepend" in A && i(2, a = A.prepend), "$$scope" in A && i(5, s = A.$$scope);
  }, t.$$.update = () => {
    var A;
    t.$$.dirty & /*root, originalParent*/
    9 && i(4, n = typeof l != "string" && l || u), t.$$.dirty & /*newRoot, element, prepend*/
    22 && n && r && (a ? c : g)(n, r), t.$$.dirty & /*root*/
    1 && ((A = l == null ? void 0 : l.classList) == null || A.add("beyondwords-widget", "bwp"));
  }, [l, r, a, u, n, s, o, f];
}
class xs extends we {
  constructor(e) {
    super(), Pe(this, e, xA, DA, pe, { root: 0, prepend: 2 });
  }
  get root() {
    return this.$$.ctx[0];
  }
  set root(e) {
    this.$$set({ root: e }), d();
  }
  get prepend() {
    return this.$$.ctx[2];
  }
  set prepend(e) {
    this.$$set({ prepend: e }), d();
  }
}
const W = (t, e, i) => Ie(t, e, e === "style" ? RA(i) : i), NA = /;(?!([^()]*\([^()]*\))*[^()]*\))/, RA = (t) => t.split(NA).filter((e) => e).map((e) => e + " !important").join(";");
function za(t, e, i) {
  const n = t.slice();
  return n[92] = e[i], n[94] = i, n;
}
function La(t, e, i) {
  const n = t.slice();
  return n[92] = e[i], n[94] = i, n;
}
function ja(t, e, i) {
  const n = t.slice();
  return n[92] = e[i], n[94] = i, n;
}
function FA(t, e, i) {
  const n = t.slice();
  return n[97] = e[i], n;
}
function Da(t, e, i) {
  const n = t.slice();
  return n[92] = e[i], n[94] = i, n;
}
function xa(t) {
  let e, i, n, o = (
    /*item*/
    t[92].placement + ""
  ), s, l;
  return {
    c() {
      e = y("option"), i = ie(
        /*i*/
        t[94]
      ), n = ie(" ("), s = ie(o), l = ie(")"), e.__value = /*i*/
      t[94], H(e, e.__value);
    },
    m(a, r) {
      E(a, e, r), h(e, i), h(e, n), h(e, s), h(e, l);
    },
    p(a, r) {
      r[1] & /*adverts*/
      16384 && o !== (o = /*item*/
      a[92].placement + "") && bi(s, o);
    },
    d(a) {
      a && M(e);
    }
  };
}
function UA(t) {
  let e;
  return {
    c() {
      e = y("option"), e.textContent = `${/*hour*/
      t[97]}-oclock`, e.__value = /*hour*/
      t[97] + "-oclock", H(e, e.__value);
    },
    m(i, n) {
      E(i, e, n);
    },
    p: Q,
    d(i) {
      i && M(e);
    }
  };
}
function Na(t) {
  let e, i, n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, C, Z, q, x, X, oe, ae, $, ee, ue, Ae, ce, ye, re, b, w, R, L, Ve, Le, Qe, j, he, ze, Re, Ge, Me, nt, Te, Je, Ce, Lt, Ee, ft, Oe, qe, Nt, De, St, Ye, At, $e, mt, Ze, xe, yt, et, lt, ot, Pt, Xe, Ot, vt, Vt, wt, tt, at, Bt, bt, kt, Ke, rt, pt, st, it, He, ht, Tt, U, ut, te, I, B, le, K, jt, dn, Et, Ti, ri, ui, qt, fi, ki, Kt, Rt, Ci, zi, ci, Ft, Ii, ni = ti(
    /*content*/
    t[43]
  ), Ct = [];
  for (let N = 0; N < ni.length; N += 1)
    Ct[N] = Ra(ja(t, ni, N));
  let oi = ti(
    /*introsOutros*/
    t[44]
  ), It = [];
  for (let N = 0; N < oi.length; N += 1)
    It[N] = Fa(La(t, oi, N));
  let Oi = ti(
    /*adverts*/
    t[45]
  ), Wt = [];
  for (let N = 0; N < Oi.length; N += 1)
    Wt[N] = Ua(za(t, Oi, N));
  return {
    c() {
      e = y("br"), i = J(), n = y("strong"), n.textContent = "Advanced settings:", o = J(), s = y("br"), l = y("br"), a = J(), r = y("div"), u = ie(`projectId:
      `), c = y("input"), g = J(), f = y("div"), A = ie(`contentId:
      `), _ = y("input"), k = J(), S = y("div"), T = ie(`playlistId:
      `), v = y("input"), P = J(), O = y("div"), D = ie(`sourceId:
      `), p = y("input"), C = J(), Z = y("div"), q = ie(`sourceUrl:
      `), x = y("input"), X = J(), oe = y("div"), ae = ie(`showUserInterface:
      `), $ = y("select"), ee = y("option"), ee.textContent = `${!1}`, ue = y("option"), ue.textContent = `${!0}`, Ae = J(), ce = y("div"), ye = ie(`videoTextColor:
      `), re = y("input"), b = J(), w = y("div"), R = ie(`videoIconColor:
      `), L = y("input"), Ve = J(), Le = y("div"), Qe = ie(`mediaSession:
      `), j = y("select"), he = y("option"), he.textContent = "auto", ze = y("option"), ze.textContent = "override", Re = y("option"), Re.textContent = "none", Ge = J(), Me = y("div"), nt = ie(`contentIndex:
      `), Te = y("select");
      for (let N = 0; N < Ct.length; N += 1)
        Ct[N].c();
      Je = J(), Ce = y("div"), Lt = ie(`introsOutrosIndex:
      `), Ee = y("select"), ft = y("option"), ft.textContent = "-1 (none)";
      for (let N = 0; N < It.length; N += 1)
        It[N].c();
      Oe = J(), qe = y("div"), Nt = ie(`persistentAdImage:
      `), De = y("select"), St = y("option"), St.textContent = `${!1}`, Ye = y("option"), Ye.textContent = `${!0}`, At = J(), $e = y("div"), mt = ie(`persistentIndex:
      `), Ze = y("select"), xe = y("option"), xe.textContent = "-1 (none)";
      for (let N = 0; N < Wt.length; N += 1)
        Wt[N].c();
      yt = J(), et = y("div"), lt = ie(`duration:
      `), ot = y("input"), Pt = J(), Xe = y("div"), Ot = ie(`currentTime:
      `), vt = y("input"), Vt = J(), wt = y("div"), tt = ie(`playbackRate:
      `), at = y("input"), Bt = J(), bt = y("div"), kt = ie(`widgetTarget:
      `), Ke = y("input"), rt = J(), pt = y("div"), st = ie(`logoIconEnabled:
      `), it = y("select"), He = y("option"), He.textContent = `${!1}`, ht = y("option"), ht.textContent = `${!0}`, Tt = J(), U = y("div"), ut = ie(`advertConsent:
      `), te = y("select"), I = y("option"), I.textContent = "personalized", B = y("option"), B.textContent = "non-personalized", le = y("option"), le.textContent = "under-the-age-of-consent", K = J(), jt = y("div"), dn = ie(`analyticsConsent:
      `), Et = y("select"), Ti = y("option"), Ti.textContent = "allowed", ri = y("option"), ri.textContent = "without-local-storage", ui = y("option"), ui.textContent = "none", qt = J(), fi = y("div"), ki = ie(`analyticsCustomUrl:
      `), Kt = y("input"), Rt = J(), Ci = y("div"), zi = ie(`analyticsTag:
      `), ci = y("input"), W(n, "class", "svelte-1a8td5m"), W(c, "tabindex", -1), W(c, "type", "text"), W(c, "class", "svelte-1a8td5m"), W(r, "class", "control svelte-1a8td5m"), W(_, "tabindex", -1), W(_, "type", "text"), W(_, "class", "svelte-1a8td5m"), W(f, "class", "control svelte-1a8td5m"), W(v, "tabindex", -1), W(v, "type", "text"), W(v, "class", "svelte-1a8td5m"), W(S, "class", "control svelte-1a8td5m"), W(p, "tabindex", -1), W(p, "type", "text"), W(p, "class", "svelte-1a8td5m"), W(O, "class", "control svelte-1a8td5m"), W(x, "tabindex", -1), W(x, "type", "text"), W(x, "class", "svelte-1a8td5m"), W(Z, "class", "control svelte-1a8td5m"), ee.__value = !1, H(ee, ee.__value), ue.__value = !0, H(ue, ue.__value), W($, "tabindex", -1), W($, "class", "svelte-1a8td5m"), /*showUserInterface*/
      t[5] === void 0 && dt(() => (
        /*select0_change_handler_1*/
        t[72].call($)
      )), W(oe, "class", "control svelte-1a8td5m"), W(re, "tabindex", -1), W(re, "type", "text"), W(re, "class", "svelte-1a8td5m"), W(ce, "class", "control svelte-1a8td5m"), W(L, "tabindex", -1), W(L, "type", "text"), W(L, "class", "svelte-1a8td5m"), W(w, "class", "control svelte-1a8td5m"), he.__value = "auto", H(he, he.__value), ze.__value = "override", H(ze, ze.__value), Re.__value = "none", H(Re, Re.__value), W(j, "tabindex", -1), W(j, "class", "svelte-1a8td5m"), /*mediaSession*/
      t[12] === void 0 && dt(() => (
        /*select1_change_handler_1*/
        t[75].call(j)
      )), W(Le, "class", "control svelte-1a8td5m"), W(Te, "tabindex", -1), W(Te, "class", "svelte-1a8td5m"), /*contentIndex*/
      t[13] === void 0 && dt(() => (
        /*select2_change_handler_1*/
        t[76].call(Te)
      )), W(Me, "class", "control svelte-1a8td5m"), ft.__value = -1, H(ft, ft.__value), W(Ee, "tabindex", -1), W(Ee, "class", "svelte-1a8td5m"), /*introsOutrosIndex*/
      t[14] === void 0 && dt(() => (
        /*select3_change_handler_1*/
        t[77].call(Ee)
      )), W(Ce, "class", "control svelte-1a8td5m"), St.__value = !1, H(St, St.__value), Ye.__value = !0, H(Ye, Ye.__value), W(De, "tabindex", -1), W(De, "class", "svelte-1a8td5m"), /*persistentAdImage*/
      t[16] === void 0 && dt(() => (
        /*select4_change_handler_1*/
        t[78].call(De)
      )), W(qe, "class", "control svelte-1a8td5m"), xe.__value = -1, H(xe, xe.__value), W(Ze, "tabindex", -1), W(Ze, "class", "svelte-1a8td5m"), /*persistentIndex*/
      t[17] === void 0 && dt(() => (
        /*select5_change_handler_1*/
        t[79].call(Ze)
      )), W($e, "class", "control svelte-1a8td5m"), W(ot, "tabindex", -1), W(ot, "type", "text"), W(ot, "class", "svelte-1a8td5m"), W(et, "class", "control svelte-1a8td5m"), W(vt, "tabindex", -1), W(vt, "type", "text"), W(vt, "class", "svelte-1a8td5m"), W(Xe, "class", "control svelte-1a8td5m"), W(at, "tabindex", -1), W(at, "type", "text"), W(at, "class", "svelte-1a8td5m"), W(wt, "class", "control svelte-1a8td5m"), W(Ke, "tabindex", -1), W(Ke, "type", "text"), W(Ke, "class", "svelte-1a8td5m"), W(bt, "class", "control svelte-1a8td5m"), He.__value = !1, H(He, He.__value), ht.__value = !0, H(ht, ht.__value), W(it, "tabindex", -1), W(it, "class", "svelte-1a8td5m"), /*logoIconEnabled*/
      t[33] === void 0 && dt(() => (
        /*select6_change_handler_1*/
        t[84].call(it)
      )), W(pt, "class", "control svelte-1a8td5m"), I.__value = "personalized", H(I, I.__value), B.__value = "non-personalized", H(B, B.__value), le.__value = "under-the-age-of-consent", H(le, le.__value), W(te, "tabindex", -1), W(te, "class", "svelte-1a8td5m"), /*advertConsent*/
      t[38] === void 0 && dt(() => (
        /*select7_change_handler_1*/
        t[85].call(te)
      )), W(U, "class", "control svelte-1a8td5m"), Ti.__value = "allowed", H(Ti, Ti.__value), ri.__value = "without-local-storage", H(ri, ri.__value), ui.__value = "none", H(ui, ui.__value), W(Et, "tabindex", -1), W(Et, "class", "svelte-1a8td5m"), /*analyticsConsent*/
      t[39] === void 0 && dt(() => (
        /*select8_change_handler_1*/
        t[86].call(Et)
      )), W(jt, "class", "control svelte-1a8td5m"), W(Kt, "tabindex", -1), W(Kt, "type", "text"), W(Kt, "class", "svelte-1a8td5m"), W(fi, "class", "control svelte-1a8td5m"), W(ci, "tabindex", -1), W(ci, "type", "text"), W(ci, "class", "svelte-1a8td5m"), W(Ci, "class", "control svelte-1a8td5m");
    },
    m(N, G) {
      E(N, e, G), E(N, i, G), E(N, n, G), E(N, o, G), E(N, s, G), E(N, l, G), E(N, a, G), E(N, r, G), h(r, u), h(r, c), H(
        c,
        /*projectId*/
        t[0]
      ), E(N, g, G), E(N, f, G), h(f, A), h(f, _), H(
        _,
        /*contentId*/
        t[1]
      ), E(N, k, G), E(N, S, G), h(S, T), h(S, v), H(
        v,
        /*playlistId*/
        t[2]
      ), E(N, P, G), E(N, O, G), h(O, D), h(O, p), H(
        p,
        /*sourceId*/
        t[3]
      ), E(N, C, G), E(N, Z, G), h(Z, q), h(Z, x), H(
        x,
        /*sourceUrl*/
        t[4]
      ), E(N, X, G), E(N, oe, G), h(oe, ae), h(oe, $), h($, ee), h($, ue), We(
        $,
        /*showUserInterface*/
        t[5],
        !0
      ), E(N, Ae, G), E(N, ce, G), h(ce, ye), h(ce, re), H(
        re,
        /*videoTextColor*/
        t[31]
      ), E(N, b, G), E(N, w, G), h(w, R), h(w, L), H(
        L,
        /*videoIconColor*/
        t[32]
      ), E(N, Ve, G), E(N, Le, G), h(Le, Qe), h(Le, j), h(j, he), h(j, ze), h(j, Re), We(
        j,
        /*mediaSession*/
        t[12],
        !0
      ), E(N, Ge, G), E(N, Me, G), h(Me, nt), h(Me, Te);
      for (let fe = 0; fe < Ct.length; fe += 1)
        Ct[fe] && Ct[fe].m(Te, null);
      We(
        Te,
        /*contentIndex*/
        t[13],
        !0
      ), E(N, Je, G), E(N, Ce, G), h(Ce, Lt), h(Ce, Ee), h(Ee, ft);
      for (let fe = 0; fe < It.length; fe += 1)
        It[fe] && It[fe].m(Ee, null);
      We(
        Ee,
        /*introsOutrosIndex*/
        t[14],
        !0
      ), E(N, Oe, G), E(N, qe, G), h(qe, Nt), h(qe, De), h(De, St), h(De, Ye), We(
        De,
        /*persistentAdImage*/
        t[16],
        !0
      ), E(N, At, G), E(N, $e, G), h($e, mt), h($e, Ze), h(Ze, xe);
      for (let fe = 0; fe < Wt.length; fe += 1)
        Wt[fe] && Wt[fe].m(Ze, null);
      We(
        Ze,
        /*persistentIndex*/
        t[17],
        !0
      ), E(N, yt, G), E(N, et, G), h(et, lt), h(et, ot), H(
        ot,
        /*duration*/
        t[18]
      ), E(N, Pt, G), E(N, Xe, G), h(Xe, Ot), h(Xe, vt), H(
        vt,
        /*currentTime*/
        t[19]
      ), E(N, Vt, G), E(N, wt, G), h(wt, tt), h(wt, at), H(
        at,
        /*playbackRate*/
        t[21]
      ), E(N, Bt, G), E(N, bt, G), h(bt, kt), h(bt, Ke), H(
        Ke,
        /*widgetTarget*/
        t[26]
      ), E(N, rt, G), E(N, pt, G), h(pt, st), h(pt, it), h(it, He), h(it, ht), We(
        it,
        /*logoIconEnabled*/
        t[33],
        !0
      ), E(N, Tt, G), E(N, U, G), h(U, ut), h(U, te), h(te, I), h(te, B), h(te, le), We(
        te,
        /*advertConsent*/
        t[38],
        !0
      ), E(N, K, G), E(N, jt, G), h(jt, dn), h(jt, Et), h(Et, Ti), h(Et, ri), h(Et, ui), We(
        Et,
        /*analyticsConsent*/
        t[39],
        !0
      ), E(N, qt, G), E(N, fi, G), h(fi, ki), h(fi, Kt), H(
        Kt,
        /*analyticsCustomUrl*/
        t[40]
      ), E(N, Rt, G), E(N, Ci, G), h(Ci, zi), h(Ci, ci), H(
        ci,
        /*analyticsTag*/
        t[41]
      ), Ft || (Ii = [
        Y(
          c,
          "input",
          /*input0_input_handler_1*/
          t[67]
        ),
        Y(
          _,
          "input",
          /*input1_input_handler_1*/
          t[68]
        ),
        Y(
          v,
          "input",
          /*input2_input_handler_1*/
          t[69]
        ),
        Y(
          p,
          "input",
          /*input3_input_handler_1*/
          t[70]
        ),
        Y(
          x,
          "input",
          /*input4_input_handler_1*/
          t[71]
        ),
        Y(
          $,
          "change",
          /*select0_change_handler_1*/
          t[72]
        ),
        Y(
          re,
          "input",
          /*input5_input_handler_1*/
          t[73]
        ),
        Y(
          L,
          "input",
          /*input6_input_handler*/
          t[74]
        ),
        Y(
          j,
          "change",
          /*select1_change_handler_1*/
          t[75]
        ),
        Y(
          Te,
          "change",
          /*select2_change_handler_1*/
          t[76]
        ),
        Y(
          Ee,
          "change",
          /*select3_change_handler_1*/
          t[77]
        ),
        Y(
          De,
          "change",
          /*select4_change_handler_1*/
          t[78]
        ),
        Y(
          Ze,
          "change",
          /*select5_change_handler_1*/
          t[79]
        ),
        Y(
          ot,
          "input",
          /*input7_input_handler*/
          t[80]
        ),
        Y(
          vt,
          "input",
          /*input8_input_handler*/
          t[81]
        ),
        Y(
          at,
          "input",
          /*input9_input_handler*/
          t[82]
        ),
        Y(
          Ke,
          "input",
          /*input10_input_handler*/
          t[83]
        ),
        Y(
          it,
          "change",
          /*select6_change_handler_1*/
          t[84]
        ),
        Y(
          te,
          "change",
          /*select7_change_handler_1*/
          t[85]
        ),
        Y(
          Et,
          "change",
          /*select8_change_handler_1*/
          t[86]
        ),
        Y(
          Kt,
          "input",
          /*input11_input_handler*/
          t[87]
        ),
        Y(
          ci,
          "input",
          /*input12_input_handler*/
          t[88]
        )
      ], Ft = !0);
    },
    p(N, G) {
      if (G[0] & /*projectId*/
      1 && c.value !== /*projectId*/
      N[0] && H(
        c,
        /*projectId*/
        N[0]
      ), G[0] & /*contentId*/
      2 && _.value !== /*contentId*/
      N[1] && H(
        _,
        /*contentId*/
        N[1]
      ), G[0] & /*playlistId*/
      4 && v.value !== /*playlistId*/
      N[2] && H(
        v,
        /*playlistId*/
        N[2]
      ), G[0] & /*sourceId*/
      8 && p.value !== /*sourceId*/
      N[3] && H(
        p,
        /*sourceId*/
        N[3]
      ), G[0] & /*sourceUrl*/
      16 && x.value !== /*sourceUrl*/
      N[4] && H(
        x,
        /*sourceUrl*/
        N[4]
      ), G[0] & /*showUserInterface*/
      32 && We(
        $,
        /*showUserInterface*/
        N[5]
      ), G[1] & /*videoTextColor*/
      1 && re.value !== /*videoTextColor*/
      N[31] && H(
        re,
        /*videoTextColor*/
        N[31]
      ), G[1] & /*videoIconColor*/
      2 && L.value !== /*videoIconColor*/
      N[32] && H(
        L,
        /*videoIconColor*/
        N[32]
      ), G[0] & /*mediaSession*/
      4096 && We(
        j,
        /*mediaSession*/
        N[12]
      ), G[1] & /*content*/
      4096) {
        ni = ti(
          /*content*/
          N[43]
        );
        let fe;
        for (fe = 0; fe < ni.length; fe += 1) {
          const Ht = ja(N, ni, fe);
          Ct[fe] ? Ct[fe].p(Ht, G) : (Ct[fe] = Ra(Ht), Ct[fe].c(), Ct[fe].m(Te, null));
        }
        for (; fe < Ct.length; fe += 1)
          Ct[fe].d(1);
        Ct.length = ni.length;
      }
      if (G[0] & /*contentIndex*/
      8192 && We(
        Te,
        /*contentIndex*/
        N[13]
      ), G[1] & /*introsOutros*/
      8192) {
        oi = ti(
          /*introsOutros*/
          N[44]
        );
        let fe;
        for (fe = 0; fe < oi.length; fe += 1) {
          const Ht = La(N, oi, fe);
          It[fe] ? It[fe].p(Ht, G) : (It[fe] = Fa(Ht), It[fe].c(), It[fe].m(Ee, null));
        }
        for (; fe < It.length; fe += 1)
          It[fe].d(1);
        It.length = oi.length;
      }
      if (G[0] & /*introsOutrosIndex*/
      16384 && We(
        Ee,
        /*introsOutrosIndex*/
        N[14]
      ), G[0] & /*persistentAdImage*/
      65536 && We(
        De,
        /*persistentAdImage*/
        N[16]
      ), G[1] & /*adverts*/
      16384) {
        Oi = ti(
          /*adverts*/
          N[45]
        );
        let fe;
        for (fe = 0; fe < Oi.length; fe += 1) {
          const Ht = za(N, Oi, fe);
          Wt[fe] ? Wt[fe].p(Ht, G) : (Wt[fe] = Ua(Ht), Wt[fe].c(), Wt[fe].m(Ze, null));
        }
        for (; fe < Wt.length; fe += 1)
          Wt[fe].d(1);
        Wt.length = Oi.length;
      }
      G[0] & /*persistentIndex*/
      131072 && We(
        Ze,
        /*persistentIndex*/
        N[17]
      ), G[0] & /*duration*/
      262144 && ot.value !== /*duration*/
      N[18] && H(
        ot,
        /*duration*/
        N[18]
      ), G[0] & /*currentTime*/
      524288 && vt.value !== /*currentTime*/
      N[19] && H(
        vt,
        /*currentTime*/
        N[19]
      ), G[0] & /*playbackRate*/
      2097152 && at.value !== /*playbackRate*/
      N[21] && H(
        at,
        /*playbackRate*/
        N[21]
      ), G[0] & /*widgetTarget*/
      67108864 && Ke.value !== /*widgetTarget*/
      N[26] && H(
        Ke,
        /*widgetTarget*/
        N[26]
      ), G[1] & /*logoIconEnabled*/
      4 && We(
        it,
        /*logoIconEnabled*/
        N[33]
      ), G[1] & /*advertConsent*/
      128 && We(
        te,
        /*advertConsent*/
        N[38]
      ), G[1] & /*analyticsConsent*/
      256 && We(
        Et,
        /*analyticsConsent*/
        N[39]
      ), G[1] & /*analyticsCustomUrl*/
      512 && Kt.value !== /*analyticsCustomUrl*/
      N[40] && H(
        Kt,
        /*analyticsCustomUrl*/
        N[40]
      ), G[1] & /*analyticsTag*/
      1024 && ci.value !== /*analyticsTag*/
      N[41] && H(
        ci,
        /*analyticsTag*/
        N[41]
      );
    },
    d(N) {
      N && (M(e), M(i), M(n), M(o), M(s), M(l), M(a), M(r), M(g), M(f), M(k), M(S), M(P), M(O), M(C), M(Z), M(X), M(oe), M(Ae), M(ce), M(b), M(w), M(Ve), M(Le), M(Ge), M(Me), M(Je), M(Ce), M(Oe), M(qe), M(At), M($e), M(yt), M(et), M(Pt), M(Xe), M(Vt), M(wt), M(Bt), M(bt), M(rt), M(pt), M(Tt), M(U), M(K), M(jt), M(qt), M(fi), M(Rt), M(Ci)), Cn(Ct, N), Cn(It, N), Cn(Wt, N), Ft = !1, _t(Ii);
    }
  };
}
function Ra(t) {
  let e, i, n, o = (
    /*item*/
    t[92].title + ""
  ), s, l;
  return {
    c() {
      e = y("option"), i = ie(
        /*i*/
        t[94]
      ), n = ie(" ("), s = ie(o), l = ie(")"), e.__value = /*i*/
      t[94], H(e, e.__value);
    },
    m(a, r) {
      E(a, e, r), h(e, i), h(e, n), h(e, s), h(e, l);
    },
    p(a, r) {
      r[1] & /*content*/
      4096 && o !== (o = /*item*/
      a[92].title + "") && bi(s, o);
    },
    d(a) {
      a && M(e);
    }
  };
}
function Fa(t) {
  let e, i, n, o = (
    /*item*/
    t[92].placement + ""
  ), s;
  return {
    c() {
      e = y("option"), i = ie(
        /*i*/
        t[94]
      ), n = ie(": "), s = ie(o), e.__value = /*i*/
      t[94], H(e, e.__value);
    },
    m(l, a) {
      E(l, e, a), h(e, i), h(e, n), h(e, s);
    },
    p(l, a) {
      a[1] & /*introsOutros*/
      8192 && o !== (o = /*item*/
      l[92].placement + "") && bi(s, o);
    },
    d(l) {
      l && M(e);
    }
  };
}
function Ua(t) {
  let e, i, n, o = (
    /*item*/
    t[92].placement + ""
  ), s;
  return {
    c() {
      e = y("option"), i = ie(
        /*i*/
        t[94]
      ), n = ie(": "), s = ie(o), e.__value = /*i*/
      t[94], H(e, e.__value);
    },
    m(l, a) {
      E(l, e, a), h(e, i), h(e, n), h(e, s);
    },
    p(l, a) {
      a[1] & /*adverts*/
      16384 && o !== (o = /*item*/
      l[92].placement + "") && bi(s, o);
    },
    d(l) {
      l && M(e);
    }
  };
}
function HA(t) {
  let e, i, n;
  return {
    c() {
      e = y("a"), e.textContent = "show advanced settings", W(e, "tabindex", -1), W(e, "href", "#_"), W(e, "class", "svelte-1a8td5m");
    },
    m(o, s) {
      E(o, e, s), i || (n = Y(
        e,
        "click",
        /*click_handler_1*/
        t[90]
      ), i = !0);
    },
    p: Q,
    d(o) {
      o && M(e), i = !1, n();
    }
  };
}
function qA(t) {
  let e, i, n;
  return {
    c() {
      e = y("a"), e.textContent = "hide advanced settings", W(e, "tabindex", -1), W(e, "href", "#_"), W(e, "class", "svelte-1a8td5m");
    },
    m(o, s) {
      E(o, e, s), i || (n = Y(
        e,
        "click",
        /*click_handler*/
        t[89]
      ), i = !0);
    },
    p: Q,
    d(o) {
      o && M(e), i = !1, n();
    }
  };
}
function YA(t) {
  let e, i, n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, C, Z, q, x, X, oe, ae, $, ee, ue, Ae, ce, ye, re, b, w, R, L, Ve, Le, Qe, j, he, ze, Re, Ge, Me, nt, Te, Je, Ce, Lt, Ee, ft, Oe, qe, Nt, De, St, Ye, At, $e, mt, Ze, xe, yt, et, lt, ot, Pt, Xe, Ot, vt, Vt, wt, tt, at, Bt, bt, kt, Ke, rt, pt, st, it, He, ht, Tt, U, ut, te, I, B, le, K, jt, dn, Et, Ti, ri, ui, qt, fi, ki, Kt, Rt, Ci, zi, ci, Ft, Ii, ni, Ct, oi, It, Oi, Wt, N, G, fe, Ht, Li, Ri, gn, Wo, In, Mo, di, fn, mn, hn, _n, An, Eo, On, zo, ji, Lo, io, jo, Do, Qi, no, $i, oo, xo, yn = ti(
    /*adverts*/
    t[45]
  ), Gt = [];
  for (let _e = 0; _e < yn.length; _e += 1)
    Gt[_e] = xa(Da(t, yn, _e));
  let Ns = ti([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]), Vn = [];
  for (let _e = 0; _e < 12; _e += 1)
    Vn[_e] = UA(FA(t, Ns, _e));
  let si = (
    /*showAdvancedSettings*/
    t[46] && Na(t)
  );
  function No(_e, ct) {
    return (
      /*showAdvancedSettings*/
      _e[46] ? qA : HA
    );
  }
  let jn = No(t), Vi = jn(t);
  return {
    c() {
      e = y("div"), i = y("div"), i.innerHTML = '<strong class="svelte-1a8td5m">Player settings:</strong> <a tabindex="-1" target="_blank" class="docs svelte-1a8td5m" href="https://github.com/beyondwords-io/player/blob/main/doc/player-settings.md">view docs</a>', n = J(), o = y("br"), s = J(), l = y("div"), a = ie(`playerStyle:
    `), r = y("select"), u = y("option"), u.textContent = "small", c = y("option"), c.textContent = "standard", g = y("option"), g.textContent = "large", f = y("option"), f.textContent = "video", A = J(), _ = y("div"), k = ie(`playbackState:
    `), S = y("select"), T = y("option"), T.textContent = "stopped", v = y("option"), v.textContent = "playing", P = y("option"), P.textContent = "paused", O = J(), D = y("div"), p = ie(`playerTitle:
    `), C = y("input"), Z = J(), q = y("div"), x = ie(`callToAction:
    `), X = y("input"), oe = J(), ae = y("div"), $ = ie(`skipButtonStyle:
    `), ee = y("select"), ue = y("option"), ue.textContent = "auto", Ae = y("option"), Ae.textContent = "segments", ce = y("option"), ce.textContent = "seconds", ye = y("option"), ye.textContent = "seconds-15", re = y("option"), re.textContent = "seconds-15-30", b = y("option"), b.textContent = "tracks", w = J(), R = y("div"), L = ie(`playlistStyle:
    `), Ve = y("select"), Le = y("option"), Le.textContent = "auto", Qe = y("option"), Qe.textContent = "show", j = y("option"), j.textContent = "show-3", he = y("option"), he.textContent = "show-999", ze = y("option"), ze.textContent = "hide", Re = J(), Ge = y("div"), Me = ie(`playlistToggle:
    `), nt = y("select"), Te = y("option"), Te.textContent = "auto", Je = y("option"), Je.textContent = "show", Ce = y("option"), Ce.textContent = "hide", Lt = J(), Ee = y("div"), ft = ie(`advertIndex:
    `), Oe = y("select"), qe = y("option"), qe.textContent = "-1 (none)";
      for (let _e = 0; _e < Gt.length; _e += 1)
        Gt[_e].c();
      Nt = J(), De = y("div"), St = ie(`widgetStyle:
    `), Ye = y("select"), At = y("option"), At.textContent = "small", $e = y("option"), $e.textContent = "standard", mt = y("option"), mt.textContent = "large", Ze = y("option"), Ze.textContent = "video", xe = J(), yt = y("div"), et = ie(`widgetPosition:
    `), lt = y("select"), ot = y("option"), ot.textContent = "auto", Pt = y("option"), Pt.textContent = "left", Xe = y("option"), Xe.textContent = "center", Ot = y("option"), Ot.textContent = "right", vt = J(), Vt = y("div"), wt = ie(`widgetWidth:
    `), tt = y("select"), at = y("option"), at.textContent = "auto", Bt = y("option"), Bt.textContent = "400px", bt = y("option"), bt.textContent = "30rem", kt = y("option"), kt.textContent = "fit-content", Ke = y("option"), Ke.textContent = "initial", rt = y("option"), rt.textContent = "0", pt = J(), st = y("div"), it = ie(`widgetMargin:
    `), He = y("select"), ht = y("option"), ht.textContent = "16px", Tt = y("option"), Tt.textContent = "32px", U = y("option"), U.textContent = "32px 16px", ut = y("option"), ut.textContent = "10px 20px 30px 40px", te = J(), I = y("div"), B = ie(`textColor:
    `), le = y("input"), K = J(), jt = y("div"), dn = ie(`backgroundColor:
    `), Et = y("input"), Ti = J(), ri = y("div"), ui = ie(`iconColor:
    `), qt = y("input"), fi = J(), ki = y("div"), Kt = ie(`highlightColor:
    `), Rt = y("input"), Ci = J(), zi = y("div"), ci = ie(`highlightSections:
    `), Ft = y("select"), Ii = y("option"), Ii.textContent = "all", ni = y("option"), ni.textContent = "body", Ct = y("option"), Ct.textContent = "none", oi = y("option"), oi.textContent = "all-none", It = y("option"), It.textContent = "none-all", Oi = J(), Wt = y("div"), N = ie(`clickableSections:
    `), G = y("select"), fe = y("option"), fe.textContent = "all", Ht = y("option"), Ht.textContent = "body", Li = y("option"), Li.textContent = "none", Ri = y("option"), Ri.textContent = "all-none", gn = y("option"), gn.textContent = "none-all", Wo = J(), In = y("div"), Mo = ie(`segmentWidgetSections:
    `), di = y("select"), fn = y("option"), fn.textContent = "all", mn = y("option"), mn.textContent = "body", hn = y("option"), hn.textContent = "none", _n = y("option"), _n.textContent = "all-none", An = y("option"), An.textContent = "none-all", Eo = J(), On = y("div"), zo = ie(`segmentWidgetPosition:
    `), ji = y("select");
      for (let _e = 0; _e < 12; _e += 1)
        Vn[_e].c();
      Lo = J(), si && si.c(), io = J(), jo = y("br"), Do = J(), Qi = y("div"), Vi.c(), no = J(), $i = y("a"), $i.textContent = "close", W(i, "class", "heading svelte-1a8td5m"), u.__value = "small", H(u, u.__value), c.__value = "standard", H(c, c.__value), g.__value = "large", H(g, g.__value), f.__value = "video", H(f, f.__value), W(r, "tabindex", -1), W(r, "class", "svelte-1a8td5m"), /*playerStyle*/
      t[6] === void 0 && dt(() => (
        /*select0_change_handler*/
        t[47].call(r)
      )), W(l, "class", "control svelte-1a8td5m"), T.__value = "stopped", H(T, T.__value), v.__value = "playing", H(v, v.__value), P.__value = "paused", H(P, P.__value), W(S, "tabindex", -1), W(S, "class", "svelte-1a8td5m"), /*playbackState*/
      t[20] === void 0 && dt(() => (
        /*select1_change_handler*/
        t[48].call(S)
      )), W(_, "class", "control svelte-1a8td5m"), W(C, "tabindex", -1), W(C, "type", "text"), W(C, "class", "svelte-1a8td5m"), W(D, "class", "control svelte-1a8td5m"), W(X, "tabindex", -1), W(X, "type", "text"), W(X, "class", "svelte-1a8td5m"), W(q, "class", "control svelte-1a8td5m"), ue.__value = "auto", H(ue, ue.__value), Ae.__value = "segments", H(Ae, Ae.__value), ce.__value = "seconds", H(ce, ce.__value), ye.__value = "seconds-15", H(ye, ye.__value), re.__value = "seconds-15-30", H(re, re.__value), b.__value = "tracks", H(b, b.__value), W(ee, "tabindex", -1), W(ee, "class", "svelte-1a8td5m"), /*skipButtonStyle*/
      t[9] === void 0 && dt(() => (
        /*select2_change_handler*/
        t[51].call(ee)
      )), W(ae, "class", "control svelte-1a8td5m"), Le.__value = "auto", H(Le, Le.__value), Qe.__value = "show", H(Qe, Qe.__value), j.__value = "show-3", H(j, j.__value), he.__value = "show-999", H(he, he.__value), ze.__value = "hide", H(ze, ze.__value), W(Ve, "tabindex", -1), W(Ve, "class", "svelte-1a8td5m"), /*playlistStyle*/
      t[10] === void 0 && dt(() => (
        /*select3_change_handler*/
        t[52].call(Ve)
      )), W(R, "class", "control svelte-1a8td5m"), Te.__value = "auto", H(Te, Te.__value), Je.__value = "show", H(Je, Je.__value), Ce.__value = "hide", H(Ce, Ce.__value), W(nt, "tabindex", -1), W(nt, "class", "svelte-1a8td5m"), /*playlistToggle*/
      t[11] === void 0 && dt(() => (
        /*select4_change_handler*/
        t[53].call(nt)
      )), W(Ge, "class", "control svelte-1a8td5m"), qe.__value = -1, H(qe, qe.__value), W(Oe, "tabindex", -1), W(Oe, "class", "svelte-1a8td5m"), /*advertIndex*/
      t[15] === void 0 && dt(() => (
        /*select5_change_handler*/
        t[54].call(Oe)
      )), W(Ee, "class", "control svelte-1a8td5m"), At.__value = "small", H(At, At.__value), $e.__value = "standard", H($e, $e.__value), mt.__value = "large", H(mt, mt.__value), Ze.__value = "video", H(Ze, Ze.__value), W(Ye, "tabindex", -1), W(Ye, "class", "svelte-1a8td5m"), /*widgetStyle*/
      t[22] === void 0 && dt(() => (
        /*select6_change_handler*/
        t[55].call(Ye)
      )), W(De, "class", "control svelte-1a8td5m"), ot.__value = "auto", H(ot, ot.__value), Pt.__value = "left", H(Pt, Pt.__value), Xe.__value = "center", H(Xe, Xe.__value), Ot.__value = "right", H(Ot, Ot.__value), W(lt, "tabindex", -1), W(lt, "class", "svelte-1a8td5m"), /*widgetPosition*/
      t[23] === void 0 && dt(() => (
        /*select7_change_handler*/
        t[56].call(lt)
      )), W(yt, "class", "control svelte-1a8td5m"), at.__value = "auto", H(at, at.__value), Bt.__value = "400px", H(Bt, Bt.__value), bt.__value = "30rem", H(bt, bt.__value), kt.__value = "fit-content", H(kt, kt.__value), Ke.__value = "initial", H(Ke, Ke.__value), rt.__value = "0", H(rt, rt.__value), W(tt, "tabindex", -1), W(tt, "class", "svelte-1a8td5m"), /*widgetWidth*/
      t[24] === void 0 && dt(() => (
        /*select8_change_handler*/
        t[57].call(tt)
      )), W(Vt, "class", "control svelte-1a8td5m"), ht.__value = "16px", H(ht, ht.__value), Tt.__value = "32px", H(Tt, Tt.__value), U.__value = "32px 16px", H(U, U.__value), ut.__value = "10px 20px 30px 40px", H(ut, ut.__value), W(He, "tabindex", -1), W(He, "class", "svelte-1a8td5m"), /*widgetMargin*/
      t[25] === void 0 && dt(() => (
        /*select9_change_handler*/
        t[58].call(He)
      )), W(st, "class", "control svelte-1a8td5m"), W(le, "tabindex", -1), W(le, "type", "text"), W(le, "class", "svelte-1a8td5m"), W(I, "class", "control svelte-1a8td5m"), W(Et, "tabindex", -1), W(Et, "type", "text"), W(Et, "class", "svelte-1a8td5m"), W(jt, "class", "control svelte-1a8td5m"), W(qt, "tabindex", -1), W(qt, "type", "text"), W(qt, "class", "svelte-1a8td5m"), W(ri, "class", "control svelte-1a8td5m"), W(Rt, "tabindex", -1), W(Rt, "type", "text"), W(Rt, "class", "svelte-1a8td5m"), W(ki, "class", "control svelte-1a8td5m"), Ii.__value = "all", H(Ii, Ii.__value), ni.__value = "body", H(ni, ni.__value), Ct.__value = "none", H(Ct, Ct.__value), oi.__value = "all-none", H(oi, oi.__value), It.__value = "none-all", H(It, It.__value), W(Ft, "tabindex", -1), W(Ft, "class", "svelte-1a8td5m"), /*highlightSections*/
      t[34] === void 0 && dt(() => (
        /*select10_change_handler*/
        t[63].call(Ft)
      )), W(zi, "class", "control svelte-1a8td5m"), fe.__value = "all", H(fe, fe.__value), Ht.__value = "body", H(Ht, Ht.__value), Li.__value = "none", H(Li, Li.__value), Ri.__value = "all-none", H(Ri, Ri.__value), gn.__value = "none-all", H(gn, gn.__value), W(G, "tabindex", -1), W(G, "class", "svelte-1a8td5m"), /*clickableSections*/
      t[35] === void 0 && dt(() => (
        /*select11_change_handler*/
        t[64].call(G)
      )), W(Wt, "class", "control svelte-1a8td5m"), fn.__value = "all", H(fn, fn.__value), mn.__value = "body", H(mn, mn.__value), hn.__value = "none", H(hn, hn.__value), _n.__value = "all-none", H(_n, _n.__value), An.__value = "none-all", H(An, An.__value), W(di, "tabindex", -1), W(di, "class", "svelte-1a8td5m"), /*segmentWidgetSections*/
      t[36] === void 0 && dt(() => (
        /*select12_change_handler*/
        t[65].call(di)
      )), W(In, "class", "control svelte-1a8td5m"), W(ji, "tabindex", -1), W(ji, "class", "svelte-1a8td5m"), /*segmentWidgetPosition*/
      t[37] === void 0 && dt(() => (
        /*select13_change_handler*/
        t[66].call(ji)
      )), W(On, "class", "control svelte-1a8td5m"), W($i, "class", "close svelte-1a8td5m"), W($i, "tabindex", -1), W($i, "href", "#_"), W(Qi, "class", "settings-toggle svelte-1a8td5m"), W(e, "class", "control-panel");
    },
    m(_e, ct) {
      E(_e, e, ct), h(e, i), h(e, n), h(e, o), h(e, s), h(e, l), h(l, a), h(l, r), h(r, u), h(r, c), h(r, g), h(r, f), We(
        r,
        /*playerStyle*/
        t[6],
        !0
      ), h(e, A), h(e, _), h(_, k), h(_, S), h(S, T), h(S, v), h(S, P), We(
        S,
        /*playbackState*/
        t[20],
        !0
      ), h(e, O), h(e, D), h(D, p), h(D, C), H(
        C,
        /*playerTitle*/
        t[7]
      ), h(e, Z), h(e, q), h(q, x), h(q, X), H(
        X,
        /*callToAction*/
        t[8]
      ), h(e, oe), h(e, ae), h(ae, $), h(ae, ee), h(ee, ue), h(ee, Ae), h(ee, ce), h(ee, ye), h(ee, re), h(ee, b), We(
        ee,
        /*skipButtonStyle*/
        t[9],
        !0
      ), h(e, w), h(e, R), h(R, L), h(R, Ve), h(Ve, Le), h(Ve, Qe), h(Ve, j), h(Ve, he), h(Ve, ze), We(
        Ve,
        /*playlistStyle*/
        t[10],
        !0
      ), h(e, Re), h(e, Ge), h(Ge, Me), h(Ge, nt), h(nt, Te), h(nt, Je), h(nt, Ce), We(
        nt,
        /*playlistToggle*/
        t[11],
        !0
      ), h(e, Lt), h(e, Ee), h(Ee, ft), h(Ee, Oe), h(Oe, qe);
      for (let Mt = 0; Mt < Gt.length; Mt += 1)
        Gt[Mt] && Gt[Mt].m(Oe, null);
      We(
        Oe,
        /*advertIndex*/
        t[15],
        !0
      ), h(e, Nt), h(e, De), h(De, St), h(De, Ye), h(Ye, At), h(Ye, $e), h(Ye, mt), h(Ye, Ze), We(
        Ye,
        /*widgetStyle*/
        t[22],
        !0
      ), h(e, xe), h(e, yt), h(yt, et), h(yt, lt), h(lt, ot), h(lt, Pt), h(lt, Xe), h(lt, Ot), We(
        lt,
        /*widgetPosition*/
        t[23],
        !0
      ), h(e, vt), h(e, Vt), h(Vt, wt), h(Vt, tt), h(tt, at), h(tt, Bt), h(tt, bt), h(tt, kt), h(tt, Ke), h(tt, rt), We(
        tt,
        /*widgetWidth*/
        t[24],
        !0
      ), h(e, pt), h(e, st), h(st, it), h(st, He), h(He, ht), h(He, Tt), h(He, U), h(He, ut), We(
        He,
        /*widgetMargin*/
        t[25],
        !0
      ), h(e, te), h(e, I), h(I, B), h(I, le), H(
        le,
        /*textColor*/
        t[27]
      ), h(e, K), h(e, jt), h(jt, dn), h(jt, Et), H(
        Et,
        /*backgroundColor*/
        t[28]
      ), h(e, Ti), h(e, ri), h(ri, ui), h(ri, qt), H(
        qt,
        /*iconColor*/
        t[29]
      ), h(e, fi), h(e, ki), h(ki, Kt), h(ki, Rt), H(
        Rt,
        /*highlightColor*/
        t[30]
      ), h(e, Ci), h(e, zi), h(zi, ci), h(zi, Ft), h(Ft, Ii), h(Ft, ni), h(Ft, Ct), h(Ft, oi), h(Ft, It), We(
        Ft,
        /*highlightSections*/
        t[34],
        !0
      ), h(e, Oi), h(e, Wt), h(Wt, N), h(Wt, G), h(G, fe), h(G, Ht), h(G, Li), h(G, Ri), h(G, gn), We(
        G,
        /*clickableSections*/
        t[35],
        !0
      ), h(e, Wo), h(e, In), h(In, Mo), h(In, di), h(di, fn), h(di, mn), h(di, hn), h(di, _n), h(di, An), We(
        di,
        /*segmentWidgetSections*/
        t[36],
        !0
      ), h(e, Eo), h(e, On), h(On, zo), h(On, ji);
      for (let Mt = 0; Mt < 12; Mt += 1)
        Vn[Mt] && Vn[Mt].m(ji, null);
      We(
        ji,
        /*segmentWidgetPosition*/
        t[37],
        !0
      ), h(e, Lo), si && si.m(e, null), h(e, io), h(e, jo), h(e, Do), h(e, Qi), Vi.m(Qi, null), h(Qi, no), h(Qi, $i), oo || (xo = [
        Y(
          r,
          "change",
          /*select0_change_handler*/
          t[47]
        ),
        Y(
          S,
          "change",
          /*select1_change_handler*/
          t[48]
        ),
        Y(
          C,
          "input",
          /*input0_input_handler*/
          t[49]
        ),
        Y(
          X,
          "input",
          /*input1_input_handler*/
          t[50]
        ),
        Y(
          ee,
          "change",
          /*select2_change_handler*/
          t[51]
        ),
        Y(
          Ve,
          "change",
          /*select3_change_handler*/
          t[52]
        ),
        Y(
          nt,
          "change",
          /*select4_change_handler*/
          t[53]
        ),
        Y(
          Oe,
          "change",
          /*select5_change_handler*/
          t[54]
        ),
        Y(
          Ye,
          "change",
          /*select6_change_handler*/
          t[55]
        ),
        Y(
          lt,
          "change",
          /*select7_change_handler*/
          t[56]
        ),
        Y(
          tt,
          "change",
          /*select8_change_handler*/
          t[57]
        ),
        Y(
          He,
          "change",
          /*select9_change_handler*/
          t[58]
        ),
        Y(
          le,
          "input",
          /*input2_input_handler*/
          t[59]
        ),
        Y(
          Et,
          "input",
          /*input3_input_handler*/
          t[60]
        ),
        Y(
          qt,
          "input",
          /*input4_input_handler*/
          t[61]
        ),
        Y(
          Rt,
          "input",
          /*input5_input_handler*/
          t[62]
        ),
        Y(
          Ft,
          "change",
          /*select10_change_handler*/
          t[63]
        ),
        Y(
          G,
          "change",
          /*select11_change_handler*/
          t[64]
        ),
        Y(
          di,
          "change",
          /*select12_change_handler*/
          t[65]
        ),
        Y(
          ji,
          "change",
          /*select13_change_handler*/
          t[66]
        ),
        Y(
          $i,
          "click",
          /*click_handler_2*/
          t[91]
        )
      ], oo = !0);
    },
    p(_e, ct) {
      if (ct[0] & /*playerStyle*/
      64 && We(
        r,
        /*playerStyle*/
        _e[6]
      ), ct[0] & /*playbackState*/
      1048576 && We(
        S,
        /*playbackState*/
        _e[20]
      ), ct[0] & /*playerTitle*/
      128 && C.value !== /*playerTitle*/
      _e[7] && H(
        C,
        /*playerTitle*/
        _e[7]
      ), ct[0] & /*callToAction*/
      256 && X.value !== /*callToAction*/
      _e[8] && H(
        X,
        /*callToAction*/
        _e[8]
      ), ct[0] & /*skipButtonStyle*/
      512 && We(
        ee,
        /*skipButtonStyle*/
        _e[9]
      ), ct[0] & /*playlistStyle*/
      1024 && We(
        Ve,
        /*playlistStyle*/
        _e[10]
      ), ct[0] & /*playlistToggle*/
      2048 && We(
        nt,
        /*playlistToggle*/
        _e[11]
      ), ct[1] & /*adverts*/
      16384) {
        yn = ti(
          /*adverts*/
          _e[45]
        );
        let Mt;
        for (Mt = 0; Mt < yn.length; Mt += 1) {
          const Ro = Da(_e, yn, Mt);
          Gt[Mt] ? Gt[Mt].p(Ro, ct) : (Gt[Mt] = xa(Ro), Gt[Mt].c(), Gt[Mt].m(Oe, null));
        }
        for (; Mt < Gt.length; Mt += 1)
          Gt[Mt].d(1);
        Gt.length = yn.length;
      }
      ct[0] & /*advertIndex*/
      32768 && We(
        Oe,
        /*advertIndex*/
        _e[15]
      ), ct[0] & /*widgetStyle*/
      4194304 && We(
        Ye,
        /*widgetStyle*/
        _e[22]
      ), ct[0] & /*widgetPosition*/
      8388608 && We(
        lt,
        /*widgetPosition*/
        _e[23]
      ), ct[0] & /*widgetWidth*/
      16777216 && We(
        tt,
        /*widgetWidth*/
        _e[24]
      ), ct[0] & /*widgetMargin*/
      33554432 && We(
        He,
        /*widgetMargin*/
        _e[25]
      ), ct[0] & /*textColor*/
      134217728 && le.value !== /*textColor*/
      _e[27] && H(
        le,
        /*textColor*/
        _e[27]
      ), ct[0] & /*backgroundColor*/
      268435456 && Et.value !== /*backgroundColor*/
      _e[28] && H(
        Et,
        /*backgroundColor*/
        _e[28]
      ), ct[0] & /*iconColor*/
      536870912 && qt.value !== /*iconColor*/
      _e[29] && H(
        qt,
        /*iconColor*/
        _e[29]
      ), ct[0] & /*highlightColor*/
      1073741824 && Rt.value !== /*highlightColor*/
      _e[30] && H(
        Rt,
        /*highlightColor*/
        _e[30]
      ), ct[1] & /*highlightSections*/
      8 && We(
        Ft,
        /*highlightSections*/
        _e[34]
      ), ct[1] & /*clickableSections*/
      16 && We(
        G,
        /*clickableSections*/
        _e[35]
      ), ct[1] & /*segmentWidgetSections*/
      32 && We(
        di,
        /*segmentWidgetSections*/
        _e[36]
      ), ct[1] & /*segmentWidgetPosition*/
      64 && We(
        ji,
        /*segmentWidgetPosition*/
        _e[37]
      ), /*showAdvancedSettings*/
      _e[46] ? si ? si.p(_e, ct) : (si = Na(_e), si.c(), si.m(e, io)) : si && (si.d(1), si = null), jn === (jn = No(_e)) && Vi ? Vi.p(_e, ct) : (Vi.d(1), Vi = jn(_e), Vi && (Vi.c(), Vi.m(Qi, no)));
    },
    i: Q,
    o: Q,
    d(_e) {
      _e && M(e), Cn(Gt, _e), Cn(Vn, _e), si && si.d(), Vi.d(), oo = !1, _t(xo);
    }
  };
}
function ZA(t, e, i) {
  import("./././././././././style.js");
  let { controlPanel: n } = e, { projectId: o } = e, { contentId: s } = e, { playlistId: l } = e, { sourceId: a } = e, { sourceUrl: r } = e, { showUserInterface: u } = e, { playerStyle: c } = e, { playerTitle: g } = e, { callToAction: f } = e, { skipButtonStyle: A } = e, { playlistStyle: _ } = e, { playlistToggle: k } = e, { mediaSession: S } = e, { content: T } = e, { contentIndex: v } = e, { introsOutros: P } = e, { introsOutrosIndex: O } = e, { adverts: D } = e, { advertIndex: p } = e, { persistentAdImage: C } = e, { persistentIndex: Z } = e, { duration: q } = e, { currentTime: x } = e, { playbackState: X } = e, { playbackRate: oe } = e, { widgetStyle: ae } = e, { widgetPosition: $ } = e, { widgetWidth: ee } = e, { widgetMargin: ue } = e, { widgetTarget: Ae } = e, { textColor: ce } = e, { backgroundColor: ye } = e, { iconColor: re } = e, { highlightColor: b } = e, { videoTextColor: w } = e, { videoIconColor: R } = e, { logoIconEnabled: L } = e, { highlightSections: Ve } = e, { clickableSections: Le } = e, { segmentWidgetSections: Qe } = e, { segmentWidgetPosition: j } = e, { advertConsent: he } = e, { analyticsConsent: ze } = e, { analyticsCustomUrl: Re } = e, { analyticsTag: Ge } = e, Me = !1;
  function nt() {
    c = zt(this), i(6, c);
  }
  function Te() {
    X = zt(this), i(20, X);
  }
  function Je() {
    g = this.value, i(7, g);
  }
  function Ce() {
    f = this.value, i(8, f);
  }
  function Lt() {
    A = zt(this), i(9, A);
  }
  function Ee() {
    _ = zt(this), i(10, _);
  }
  function ft() {
    k = zt(this), i(11, k);
  }
  function Oe() {
    p = zt(this), i(15, p);
  }
  function qe() {
    ae = zt(this), i(22, ae);
  }
  function Nt() {
    $ = zt(this), i(23, $);
  }
  function De() {
    ee = zt(this), i(24, ee);
  }
  function St() {
    ue = zt(this), i(25, ue);
  }
  function Ye() {
    ce = this.value, i(27, ce);
  }
  function At() {
    ye = this.value, i(28, ye);
  }
  function $e() {
    re = this.value, i(29, re);
  }
  function mt() {
    b = this.value, i(30, b);
  }
  function Ze() {
    Ve = zt(this), i(34, Ve);
  }
  function xe() {
    Le = zt(this), i(35, Le);
  }
  function yt() {
    Qe = zt(this), i(36, Qe);
  }
  function et() {
    j = zt(this), i(37, j);
  }
  function lt() {
    o = this.value, i(0, o);
  }
  function ot() {
    s = this.value, i(1, s);
  }
  function Pt() {
    l = this.value, i(2, l);
  }
  function Xe() {
    a = this.value, i(3, a);
  }
  function Ot() {
    r = this.value, i(4, r);
  }
  function vt() {
    u = zt(this), i(5, u);
  }
  function Vt() {
    w = this.value, i(31, w);
  }
  function wt() {
    R = this.value, i(32, R);
  }
  function tt() {
    S = zt(this), i(12, S);
  }
  function at() {
    v = zt(this), i(13, v);
  }
  function Bt() {
    O = zt(this), i(14, O);
  }
  function bt() {
    C = zt(this), i(16, C);
  }
  function kt() {
    Z = zt(this), i(17, Z);
  }
  function Ke() {
    q = this.value, i(18, q);
  }
  function rt() {
    x = this.value, i(19, x);
  }
  function pt() {
    oe = this.value, i(21, oe);
  }
  function st() {
    Ae = this.value, i(26, Ae);
  }
  function it() {
    L = zt(this), i(33, L);
  }
  function He() {
    he = zt(this), i(38, he);
  }
  function ht() {
    ze = zt(this), i(39, ze);
  }
  function Tt() {
    Re = this.value, i(40, Re);
  }
  function U() {
    Ge = this.value, i(41, Ge);
  }
  const ut = () => i(46, Me = !1), te = () => i(46, Me = !0), I = () => n.remove();
  return t.$$set = (B) => {
    "controlPanel" in B && i(42, n = B.controlPanel), "projectId" in B && i(0, o = B.projectId), "contentId" in B && i(1, s = B.contentId), "playlistId" in B && i(2, l = B.playlistId), "sourceId" in B && i(3, a = B.sourceId), "sourceUrl" in B && i(4, r = B.sourceUrl), "showUserInterface" in B && i(5, u = B.showUserInterface), "playerStyle" in B && i(6, c = B.playerStyle), "playerTitle" in B && i(7, g = B.playerTitle), "callToAction" in B && i(8, f = B.callToAction), "skipButtonStyle" in B && i(9, A = B.skipButtonStyle), "playlistStyle" in B && i(10, _ = B.playlistStyle), "playlistToggle" in B && i(11, k = B.playlistToggle), "mediaSession" in B && i(12, S = B.mediaSession), "content" in B && i(43, T = B.content), "contentIndex" in B && i(13, v = B.contentIndex), "introsOutros" in B && i(44, P = B.introsOutros), "introsOutrosIndex" in B && i(14, O = B.introsOutrosIndex), "adverts" in B && i(45, D = B.adverts), "advertIndex" in B && i(15, p = B.advertIndex), "persistentAdImage" in B && i(16, C = B.persistentAdImage), "persistentIndex" in B && i(17, Z = B.persistentIndex), "duration" in B && i(18, q = B.duration), "currentTime" in B && i(19, x = B.currentTime), "playbackState" in B && i(20, X = B.playbackState), "playbackRate" in B && i(21, oe = B.playbackRate), "widgetStyle" in B && i(22, ae = B.widgetStyle), "widgetPosition" in B && i(23, $ = B.widgetPosition), "widgetWidth" in B && i(24, ee = B.widgetWidth), "widgetMargin" in B && i(25, ue = B.widgetMargin), "widgetTarget" in B && i(26, Ae = B.widgetTarget), "textColor" in B && i(27, ce = B.textColor), "backgroundColor" in B && i(28, ye = B.backgroundColor), "iconColor" in B && i(29, re = B.iconColor), "highlightColor" in B && i(30, b = B.highlightColor), "videoTextColor" in B && i(31, w = B.videoTextColor), "videoIconColor" in B && i(32, R = B.videoIconColor), "logoIconEnabled" in B && i(33, L = B.logoIconEnabled), "highlightSections" in B && i(34, Ve = B.highlightSections), "clickableSections" in B && i(35, Le = B.clickableSections), "segmentWidgetSections" in B && i(36, Qe = B.segmentWidgetSections), "segmentWidgetPosition" in B && i(37, j = B.segmentWidgetPosition), "advertConsent" in B && i(38, he = B.advertConsent), "analyticsConsent" in B && i(39, ze = B.analyticsConsent), "analyticsCustomUrl" in B && i(40, Re = B.analyticsCustomUrl), "analyticsTag" in B && i(41, Ge = B.analyticsTag);
  }, [
    o,
    s,
    l,
    a,
    r,
    u,
    c,
    g,
    f,
    A,
    _,
    k,
    S,
    v,
    O,
    p,
    C,
    Z,
    q,
    x,
    X,
    oe,
    ae,
    $,
    ee,
    ue,
    Ae,
    ce,
    ye,
    re,
    b,
    w,
    R,
    L,
    Ve,
    Le,
    Qe,
    j,
    he,
    ze,
    Re,
    Ge,
    n,
    T,
    P,
    D,
    Me,
    nt,
    Te,
    Je,
    Ce,
    Lt,
    Ee,
    ft,
    Oe,
    qe,
    Nt,
    De,
    St,
    Ye,
    At,
    $e,
    mt,
    Ze,
    xe,
    yt,
    et,
    lt,
    ot,
    Pt,
    Xe,
    Ot,
    vt,
    Vt,
    wt,
    tt,
    at,
    Bt,
    bt,
    kt,
    Ke,
    rt,
    pt,
    st,
    it,
    He,
    ht,
    Tt,
    U,
    ut,
    te,
    I
  ];
}
class KA extends we {
  constructor(e) {
    super(), Pe(
      this,
      e,
      ZA,
      YA,
      pe,
      {
        controlPanel: 42,
        projectId: 0,
        contentId: 1,
        playlistId: 2,
        sourceId: 3,
        sourceUrl: 4,
        showUserInterface: 5,
        playerStyle: 6,
        playerTitle: 7,
        callToAction: 8,
        skipButtonStyle: 9,
        playlistStyle: 10,
        playlistToggle: 11,
        mediaSession: 12,
        content: 43,
        contentIndex: 13,
        introsOutros: 44,
        introsOutrosIndex: 14,
        adverts: 45,
        advertIndex: 15,
        persistentAdImage: 16,
        persistentIndex: 17,
        duration: 18,
        currentTime: 19,
        playbackState: 20,
        playbackRate: 21,
        widgetStyle: 22,
        widgetPosition: 23,
        widgetWidth: 24,
        widgetMargin: 25,
        widgetTarget: 26,
        textColor: 27,
        backgroundColor: 28,
        iconColor: 29,
        highlightColor: 30,
        videoTextColor: 31,
        videoIconColor: 32,
        logoIconEnabled: 33,
        highlightSections: 34,
        clickableSections: 35,
        segmentWidgetSections: 36,
        segmentWidgetPosition: 37,
        advertConsent: 38,
        analyticsConsent: 39,
        analyticsCustomUrl: 40,
        analyticsTag: 41
      },
      null,
      [-1, -1, -1, -1]
    );
  }
  get controlPanel() {
    return this.$$.ctx[42];
  }
  set controlPanel(e) {
    this.$$set({ controlPanel: e }), d();
  }
  get projectId() {
    return this.$$.ctx[0];
  }
  set projectId(e) {
    this.$$set({ projectId: e }), d();
  }
  get contentId() {
    return this.$$.ctx[1];
  }
  set contentId(e) {
    this.$$set({ contentId: e }), d();
  }
  get playlistId() {
    return this.$$.ctx[2];
  }
  set playlistId(e) {
    this.$$set({ playlistId: e }), d();
  }
  get sourceId() {
    return this.$$.ctx[3];
  }
  set sourceId(e) {
    this.$$set({ sourceId: e }), d();
  }
  get sourceUrl() {
    return this.$$.ctx[4];
  }
  set sourceUrl(e) {
    this.$$set({ sourceUrl: e }), d();
  }
  get showUserInterface() {
    return this.$$.ctx[5];
  }
  set showUserInterface(e) {
    this.$$set({ showUserInterface: e }), d();
  }
  get playerStyle() {
    return this.$$.ctx[6];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get playerTitle() {
    return this.$$.ctx[7];
  }
  set playerTitle(e) {
    this.$$set({ playerTitle: e }), d();
  }
  get callToAction() {
    return this.$$.ctx[8];
  }
  set callToAction(e) {
    this.$$set({ callToAction: e }), d();
  }
  get skipButtonStyle() {
    return this.$$.ctx[9];
  }
  set skipButtonStyle(e) {
    this.$$set({ skipButtonStyle: e }), d();
  }
  get playlistStyle() {
    return this.$$.ctx[10];
  }
  set playlistStyle(e) {
    this.$$set({ playlistStyle: e }), d();
  }
  get playlistToggle() {
    return this.$$.ctx[11];
  }
  set playlistToggle(e) {
    this.$$set({ playlistToggle: e }), d();
  }
  get mediaSession() {
    return this.$$.ctx[12];
  }
  set mediaSession(e) {
    this.$$set({ mediaSession: e }), d();
  }
  get content() {
    return this.$$.ctx[43];
  }
  set content(e) {
    this.$$set({ content: e }), d();
  }
  get contentIndex() {
    return this.$$.ctx[13];
  }
  set contentIndex(e) {
    this.$$set({ contentIndex: e }), d();
  }
  get introsOutros() {
    return this.$$.ctx[44];
  }
  set introsOutros(e) {
    this.$$set({ introsOutros: e }), d();
  }
  get introsOutrosIndex() {
    return this.$$.ctx[14];
  }
  set introsOutrosIndex(e) {
    this.$$set({ introsOutrosIndex: e }), d();
  }
  get adverts() {
    return this.$$.ctx[45];
  }
  set adverts(e) {
    this.$$set({ adverts: e }), d();
  }
  get advertIndex() {
    return this.$$.ctx[15];
  }
  set advertIndex(e) {
    this.$$set({ advertIndex: e }), d();
  }
  get persistentAdImage() {
    return this.$$.ctx[16];
  }
  set persistentAdImage(e) {
    this.$$set({ persistentAdImage: e }), d();
  }
  get persistentIndex() {
    return this.$$.ctx[17];
  }
  set persistentIndex(e) {
    this.$$set({ persistentIndex: e }), d();
  }
  get duration() {
    return this.$$.ctx[18];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get currentTime() {
    return this.$$.ctx[19];
  }
  set currentTime(e) {
    this.$$set({ currentTime: e }), d();
  }
  get playbackState() {
    return this.$$.ctx[20];
  }
  set playbackState(e) {
    this.$$set({ playbackState: e }), d();
  }
  get playbackRate() {
    return this.$$.ctx[21];
  }
  set playbackRate(e) {
    this.$$set({ playbackRate: e }), d();
  }
  get widgetStyle() {
    return this.$$.ctx[22];
  }
  set widgetStyle(e) {
    this.$$set({ widgetStyle: e }), d();
  }
  get widgetPosition() {
    return this.$$.ctx[23];
  }
  set widgetPosition(e) {
    this.$$set({ widgetPosition: e }), d();
  }
  get widgetWidth() {
    return this.$$.ctx[24];
  }
  set widgetWidth(e) {
    this.$$set({ widgetWidth: e }), d();
  }
  get widgetMargin() {
    return this.$$.ctx[25];
  }
  set widgetMargin(e) {
    this.$$set({ widgetMargin: e }), d();
  }
  get widgetTarget() {
    return this.$$.ctx[26];
  }
  set widgetTarget(e) {
    this.$$set({ widgetTarget: e }), d();
  }
  get textColor() {
    return this.$$.ctx[27];
  }
  set textColor(e) {
    this.$$set({ textColor: e }), d();
  }
  get backgroundColor() {
    return this.$$.ctx[28];
  }
  set backgroundColor(e) {
    this.$$set({ backgroundColor: e }), d();
  }
  get iconColor() {
    return this.$$.ctx[29];
  }
  set iconColor(e) {
    this.$$set({ iconColor: e }), d();
  }
  get highlightColor() {
    return this.$$.ctx[30];
  }
  set highlightColor(e) {
    this.$$set({ highlightColor: e }), d();
  }
  get videoTextColor() {
    return this.$$.ctx[31];
  }
  set videoTextColor(e) {
    this.$$set({ videoTextColor: e }), d();
  }
  get videoIconColor() {
    return this.$$.ctx[32];
  }
  set videoIconColor(e) {
    this.$$set({ videoIconColor: e }), d();
  }
  get logoIconEnabled() {
    return this.$$.ctx[33];
  }
  set logoIconEnabled(e) {
    this.$$set({ logoIconEnabled: e }), d();
  }
  get highlightSections() {
    return this.$$.ctx[34];
  }
  set highlightSections(e) {
    this.$$set({ highlightSections: e }), d();
  }
  get clickableSections() {
    return this.$$.ctx[35];
  }
  set clickableSections(e) {
    this.$$set({ clickableSections: e }), d();
  }
  get segmentWidgetSections() {
    return this.$$.ctx[36];
  }
  set segmentWidgetSections(e) {
    this.$$set({ segmentWidgetSections: e }), d();
  }
  get segmentWidgetPosition() {
    return this.$$.ctx[37];
  }
  set segmentWidgetPosition(e) {
    this.$$set({ segmentWidgetPosition: e }), d();
  }
  get advertConsent() {
    return this.$$.ctx[38];
  }
  set advertConsent(e) {
    this.$$set({ advertConsent: e }), d();
  }
  get analyticsConsent() {
    return this.$$.ctx[39];
  }
  set analyticsConsent(e) {
    this.$$set({ analyticsConsent: e }), d();
  }
  get analyticsCustomUrl() {
    return this.$$.ctx[40];
  }
  set analyticsCustomUrl(e) {
    this.$$set({ analyticsCustomUrl: e }), d();
  }
  get analyticsTag() {
    return this.$$.ctx[41];
  }
  set analyticsTag(e) {
    this.$$set({ analyticsTag: e }), d();
  }
}
const GA = (t, e, i) => {
  QA(t);
  const n = new Image();
  return n.setAttribute("crossorigin", "anonymous"), new Promise((o, s) => {
    n.addEventListener("load", JA(n, e, i, o, s)), n.addEventListener("error", s), n.src = t;
  });
}, JA = (t, e, i, n, o) => () => {
  const s = document.createElement("canvas"), l = s.getContext("2d");
  s.width = e, s.height = i, l.drawImage(t, 0, 0, e, i), s.toBlob(XA(t, e, i, n, o));
}, Yn = {}, XA = (t, e, i, n, o) => (s) => {
  var a;
  s || o();
  const l = URL.createObjectURL(s);
  Yn[a = t.src] || (Yn[a] = []), Yn[t.src].push(l), n({ src: l, sizes: `${e}x${i}`, type: "image/png" });
}, QA = (t) => {
  Object.keys(Yn).filter((n) => n !== t).map((n) => Yn[n]).flat().forEach((n) => URL.revokeObjectURL(n));
}, $A = (t, e, i) => Fi(void 0, null, function* () {
  t = yield t;
  const n = t.innerHTML;
  return { src: `data:image/svg+xml,${encodeURIComponent(n)}`, sizes: `${e}x${i}`, type: "image/svg+xml" };
}), e3 = (t, e, i) => Zt(t, e, i, 1), t3 = (t, e, i) => Ie(t, e, e === "style" ? n3(i) : i), i3 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, n3 = (t) => t.split(i3).filter((e) => e).map((e) => e + " !important").join(";");
function Ha(t, e, i) {
  const n = t.slice();
  return n[41] = e[i], n[42] = e, n[43] = i, n;
}
function qa(t) {
  let e, i, n, o = (
    /*i*/
    t[43]
  ), s;
  i = new Ur({
    props: {
      fill: (
        /*background*/
        t[2]
      ),
      color: (
        /*foreground*/
        t[1]
      ),
      scale: (
        /*size*/
        t[41] / 18
      ),
      zoom: 0.65
    }
  });
  const l = () => (
    /*div_binding*/
    t[38](e, o)
  ), a = () => (
    /*div_binding*/
    t[38](null, o)
  );
  return {
    c() {
      e = y("div"), me(i.$$.fragment), n = J(), e3(e, "display", "none");
    },
    m(r, u) {
      E(r, e, u), de(i, e, null), h(e, n), l(), s = !0;
    },
    p(r, u) {
      t = r;
      const c = {};
      u[0] & /*background*/
      4 && (c.fill = /*background*/
      t[2]), u[0] & /*foreground*/
      2 && (c.color = /*foreground*/
      t[1]), i.$set(c), o !== /*i*/
      t[43] && (a(), o = /*i*/
      t[43], l());
    },
    i(r) {
      s || (V(i.$$.fragment, r), s = !0);
    },
    o(r) {
      z(i.$$.fragment, r), s = !1;
    },
    d(r) {
      r && M(e), ge(i), a();
    }
  };
}
function o3(t) {
  let e, i, n = ti(
    /*imageSizes*/
    t[3]
  ), o = [];
  for (let l = 0; l < n.length; l += 1)
    o[l] = qa(Ha(t, n, l));
  const s = (l) => z(o[l], 1, 1, () => {
    o[l] = null;
  });
  return {
    c() {
      e = y("div");
      for (let l = 0; l < o.length; l += 1)
        o[l].c();
      t3(e, "class", "media-session");
    },
    m(l, a) {
      E(l, e, a);
      for (let r = 0; r < o.length; r += 1)
        o[r] && o[r].m(e, null);
      i = !0;
    },
    p(l, a) {
      if (a[0] & /*fallbackSvgs, background, foreground, imageSizes*/
      15) {
        n = ti(
          /*imageSizes*/
          l[3]
        );
        let r;
        for (r = 0; r < n.length; r += 1) {
          const u = Ha(l, n, r);
          o[r] ? (o[r].p(u, a), V(o[r], 1)) : (o[r] = qa(u), o[r].c(), V(o[r], 1), o[r].m(e, null));
        }
        for (Fe(), r = n.length; r < o.length; r += 1)
          s(r);
        Ue();
      }
    },
    i(l) {
      if (!i) {
        for (let a = 0; a < n.length; a += 1)
          V(o[a]);
        i = !0;
      }
    },
    o(l) {
      o = o.filter(Boolean);
      for (let a = 0; a < o.length; a += 1)
        z(o[a]);
      i = !1;
    },
    d(l) {
      l && M(e), Cn(o, l);
    }
  };
}
function s3(t, e, i) {
  let n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, C, Z;
  const q = [96, 128, 192, 256, 384, 512], x = [
    "hangup",
    "nextslide",
    "nexttrack",
    "pause",
    "play",
    "previousslide",
    "previoustrack",
    "seekbackward",
    "seekforward",
    "seekto",
    "skipad",
    "stop",
    "togglecamera",
    "togglemicrophone"
  ];
  let { content: X = [] } = e, { contentIndex: oe = 0 } = e, { activeAdvert: ae = void 0 } = e, { persistentAdvert: $ = void 0 } = e, { companionAdvert: ee = void 0 } = e, { duration: ue = 0 } = e, { playbackState: Ae = "stopped" } = e, { skipButtonStyle: ce = "auto" } = e, { backgroundColor: ye = "#f5f5f5" } = e, { iconColor: re = "black" } = e, { onEvent: b = () => {
  } } = e, w = [], R = /* @__PURE__ */ new Set(), L = q.map(() => {
  }), Ve = q.map(() => {
  });
  const Le = () => i(16, R = R.add(T));
  function Qe(j, he) {
    se[j ? "unshift" : "push"](() => {
      L[he] = j, i(0, L);
    });
  }
  return t.$$set = (j) => {
    "content" in j && i(4, X = j.content), "contentIndex" in j && i(5, oe = j.contentIndex), "activeAdvert" in j && i(6, ae = j.activeAdvert), "persistentAdvert" in j && i(7, $ = j.persistentAdvert), "companionAdvert" in j && i(8, ee = j.companionAdvert), "duration" in j && i(9, ue = j.duration), "playbackState" in j && i(10, Ae = j.playbackState), "skipButtonStyle" in j && i(11, ce = j.skipButtonStyle), "backgroundColor" in j && i(12, ye = j.backgroundColor), "iconColor" in j && i(13, re = j.iconColor), "onEvent" in j && i(14, b = j.onEvent);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*playbackState*/
    1024 && i(34, n = Ae === "stopped"), t.$$.dirty[0] & /*activeAdvert*/
    64 | t.$$.dirty[1] & /*isStopped*/
    8 && i(36, o = ae && !n), t.$$.dirty[0] & /*content*/
    16 && i(37, s = X.length > 1), t.$$.dirty[0] & /*content, contentIndex*/
    48 && i(28, l = X[oe]), t.$$.dirty[0] & /*skipButtonStyle*/
    2048 | t.$$.dirty[1] & /*isPlaylist*/
    64 && i(20, a = ce === "auto" ? s ? "tracks" : "segments" : ce), t.$$.dirty[0] & /*skipStyle*/
    1048576 && i(22, r = parseFloat(a.split("-")[1] || 10)), t.$$.dirty[0] & /*skipStyle, backwardsSeconds*/
    5242880 && i(19, u = parseFloat(a.split("-")[2] || r)), t.$$.dirty[0] & /*skipStyle*/
    1048576 | t.$$.dirty[1] & /*isAdvert*/
    32 && i(21, c = !o && a !== "tracks"), t.$$.dirty[0] & /*skipStyle*/
    1048576 | t.$$.dirty[1] & /*isAdvert*/
    32 && i(18, g = !o && a === "tracks"), t.$$.dirty[1] & /*isAdvert*/
    32 && i(23, f = !o), t.$$.dirty[0] & /*activeAdvert, backgroundColor*/
    4160 | t.$$.dirty[1] & /*isAdvert*/
    32 && i(2, A = o && (ae == null ? void 0 : ae.backgroundColor) || ye), t.$$.dirty[0] & /*activeAdvert, iconColor*/
    8256 | t.$$.dirty[1] & /*isAdvert*/
    32 && i(1, _ = o && (ae == null ? void 0 : ae.iconColor) || re), t.$$.dirty[0] & /*background, foreground, fallbackSvgs*/
    7 && i(17, Ve = q.map((j, he) => kr().then(() => L[he]))), t.$$.dirty[0] & /*companionAdvert, activeAdvert*/
    320 && i(35, k = (ee == null ? void 0 : ee.imageUrl) || (ae == null ? void 0 : ae.imageUrl)), t.$$.dirty[0] & /*persistentAdvert, contentItem*/
    268435584 | t.$$.dirty[1] & /*isAdvert, advertImageUrl, isStopped*/
    56 && i(33, S = o && k || !n && ($ == null ? void 0 : $.imageUrl) || (l == null ? void 0 : l.imageUrl)), t.$$.dirty[0] & /*failedUrls*/
    65536 | t.$$.dirty[1] & /*imageUrl_*/
    4 && i(29, T = R.has(S) ? null : S), t.$$.dirty[0] & /*imageUrl*/
    536870912 && i(32, v = T ? q.map((j) => GA(T, j, j)) : []), t.$$.dirty[0] & /*imageUrl*/
    536870912 && i(31, P = T ? [{ src: T, sizes: "any" }] : []), t.$$.dirty[0] & /*imageUrl, renderedSvgs*/
    537001984 && i(30, O = T ? [] : q.map((j, he) => $A(Ve[he], j, j))), t.$$.dirty[0] & /*svgArtworks*/
    1073741824 | t.$$.dirty[1] & /*pngArtworks, urlArtworks*/
    3 && i(27, D = Promise.all([...v, ...P, ...O])), t.$$.dirty[0] & /*contentItem*/
    268435456 && i(26, p = (l == null ? void 0 : l.title) || ""), t.$$.dirty[0] & /*artworks*/
    134217728 && D.then((j) => i(15, w = j)).catch(Le), t.$$.dirty[0] & /*title, artist, album, artwork*/
    117473280 && (navigator.mediaSession.metadata = new MediaMetadata({ title: p, artist: C, album: Z, artwork: w })), t.$$.dirty[0] & /*onEvent*/
    16384 && navigator.mediaSession.setActionHandler("play", () => {
      b(ke({
        type: "PressedPlay",
        description: "The play button was pressed.",
        initiatedBy: "media-session-api"
      }));
    }), t.$$.dirty[0] & /*onEvent*/
    16384 && navigator.mediaSession.setActionHandler("pause", () => {
      b(ke({
        type: "PressedPause",
        description: "The pause button was pressed.",
        initiatedBy: "media-session-api"
      }));
    }), t.$$.dirty[0] & /*allowScrubbing, onEvent, duration*/
    8405504 && navigator.mediaSession.setActionHandler("seekto", f ? ({ seekTime: j }) => {
      b(ke({
        type: "ScrubbedProgressBar",
        description: "The user pressed on the progress bar then dragged.",
        initiatedBy: "media-session-api",
        ratio: Math.max(0, Math.min(1, j / ue))
      }));
    } : null), t.$$.dirty[0] & /*showSeekButtons, skipStyle, onEvent, backwardsSeconds*/
    7356416 && navigator.mediaSession.setActionHandler("seekbackward", c ? ({ seekOffset: j }) => {
      b(ke(a === "seconds" || j ? {
        type: "PressedSeekBack",
        description: "The seek backward button was pressed.",
        initiatedBy: "media-session-api",
        seconds: j || r
      } : {
        type: "PressedPrevSegment",
        description: "The previous segment button was pressed.",
        initiatedBy: "media-session-api"
      }));
    } : null), t.$$.dirty[0] & /*showSeekButtons, skipStyle, onEvent, forwardsSeconds*/
    3686400 && navigator.mediaSession.setActionHandler("seekforward", c ? ({ seekOffset: j }) => {
      b(ke(a === "seconds" || j ? {
        type: "PressedSeekAhead",
        description: "The seek ahead button was pressed.",
        initiatedBy: "media-session-api",
        seconds: j || u
      } : {
        type: "PressedNextSegment",
        description: "The next segment button was pressed.",
        initiatedBy: "media-session-api"
      }));
    } : null), t.$$.dirty[0] & /*showTrackButtons, onEvent*/
    278528 && navigator.mediaSession.setActionHandler("previoustrack", g ? () => {
      b(ke({
        type: "PressedPrevTrack",
        description: "The previous track button was pressed.",
        initiatedBy: "media-session-api"
      }));
    } : null), t.$$.dirty[0] & /*showTrackButtons, onEvent*/
    278528 && navigator.mediaSession.setActionHandler("nexttrack", g ? () => {
      b(ke({
        type: "PressedNextTrack",
        description: "The next track button was pressed.",
        initiatedBy: "media-session-api"
      }));
    } : null);
  }, i(25, C = ""), i(24, Z = ""), navigator.mediaSession.setByPlayer = !0, x.forEach((j) => {
    try {
      navigator.mediaSession.setActionHandler(j, null);
    } catch (he) {
    }
  }), [
    L,
    _,
    A,
    q,
    X,
    oe,
    ae,
    $,
    ee,
    ue,
    Ae,
    ce,
    ye,
    re,
    b,
    w,
    R,
    Ve,
    g,
    u,
    a,
    c,
    r,
    f,
    Z,
    C,
    p,
    D,
    l,
    T,
    O,
    P,
    v,
    S,
    n,
    k,
    o,
    s,
    Qe
  ];
}
class l3 extends we {
  constructor(e) {
    super(), Pe(
      this,
      e,
      s3,
      o3,
      pe,
      {
        content: 4,
        contentIndex: 5,
        activeAdvert: 6,
        persistentAdvert: 7,
        companionAdvert: 8,
        duration: 9,
        playbackState: 10,
        skipButtonStyle: 11,
        backgroundColor: 12,
        iconColor: 13,
        onEvent: 14
      },
      null,
      [-1, -1]
    );
  }
  get content() {
    return this.$$.ctx[4];
  }
  set content(e) {
    this.$$set({ content: e }), d();
  }
  get contentIndex() {
    return this.$$.ctx[5];
  }
  set contentIndex(e) {
    this.$$set({ contentIndex: e }), d();
  }
  get activeAdvert() {
    return this.$$.ctx[6];
  }
  set activeAdvert(e) {
    this.$$set({ activeAdvert: e }), d();
  }
  get persistentAdvert() {
    return this.$$.ctx[7];
  }
  set persistentAdvert(e) {
    this.$$set({ persistentAdvert: e }), d();
  }
  get companionAdvert() {
    return this.$$.ctx[8];
  }
  set companionAdvert(e) {
    this.$$set({ companionAdvert: e }), d();
  }
  get duration() {
    return this.$$.ctx[9];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get playbackState() {
    return this.$$.ctx[10];
  }
  set playbackState(e) {
    this.$$set({ playbackState: e }), d();
  }
  get skipButtonStyle() {
    return this.$$.ctx[11];
  }
  set skipButtonStyle(e) {
    this.$$set({ skipButtonStyle: e }), d();
  }
  get backgroundColor() {
    return this.$$.ctx[12];
  }
  set backgroundColor(e) {
    this.$$set({ backgroundColor: e }), d();
  }
  get iconColor() {
    return this.$$.ctx[13];
  }
  set iconColor(e) {
    this.$$set({ iconColor: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[14];
  }
  set onEvent(e) {
    this.$$set({ onEvent: e }), d();
  }
}
const Ya = (t, e, i) => Ie(t, e, e === "style" ? r3(i) : i), a3 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, r3 = (t) => t.split(a3).filter((e) => e).map((e) => e + " !important").join(";");
function Za(t) {
  let e, i, n, o;
  return {
    c() {
      e = y("script"), n = J(), o = y("script"), o.textContent = `window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag("js", new Date());`, e.async = !0, Ni(e.src, i = "https://www.googletagmanager.com/gtag/js?id=" + /*analyticsTag*/
      t[0]) || Ya(e, "src", i);
    },
    m(s, l) {
      E(s, e, l), E(s, n, l), E(s, o, l);
    },
    p(s, l) {
      l & /*analyticsTag*/
      1 && !Ni(e.src, i = "https://www.googletagmanager.com/gtag/js?id=" + /*analyticsTag*/
      s[0]) && Ya(e, "src", i);
    },
    d(s) {
      s && (M(e), M(n), M(o));
    }
  };
}
function u3(t) {
  let e, i = !/*alreadyLoaded*/
  t[1] && Za(t);
  return {
    c() {
      i && i.c(), e = Ei();
    },
    m(n, o) {
      i && i.m(document.head, null), h(document.head, e);
    },
    p(n, [o]) {
      /*alreadyLoaded*/
      n[1] ? i && (i.d(1), i = null) : i ? i.p(n, o) : (i = Za(n), i.c(), i.m(e.parentNode, e));
    },
    i: Q,
    o: Q,
    d(n) {
      i && i.d(n), M(e);
    }
  };
}
function c3(t, e, i) {
  let n, { analyticsTag: o } = e;
  return t.$$set = (s) => {
    "analyticsTag" in s && i(0, o = s.analyticsTag);
  }, i(1, n = window.gtag), [o, n];
}
class d3 extends we {
  constructor(e) {
    super(), Pe(this, e, c3, u3, pe, { analyticsTag: 0 });
  }
  get analyticsTag() {
    return this.$$.ctx[0];
  }
  set analyticsTag(e) {
    this.$$set({ analyticsTag: e }), d();
  }
}
const Ka = (t, e, i) => Ie(t, e, e === "style" ? f3(i) : i), g3 = /;(?!([^()]*\([^()]*\))*[^()]*\))/, f3 = (t) => t.split(g3).filter((e) => e).map((e) => e + " !important").join(";");
function Ga(t) {
  let e, i;
  return {
    c() {
      e = y("script"), e.async = !0, Ni(e.src, i = "https://geo.ads.audio.thisisdax.com/bulk_sync.js?cb=" + /*cacheBuster*/
      t[0]) || Ka(e, "src", i);
    },
    m(n, o) {
      E(n, e, o);
    },
    p(n, o) {
      o & /*cacheBuster*/
      1 && !Ni(e.src, i = "https://geo.ads.audio.thisisdax.com/bulk_sync.js?cb=" + /*cacheBuster*/
      n[0]) && Ka(e, "src", i);
    },
    d(n) {
      n && M(e);
    }
  };
}
function m3(t) {
  let e, i = !/*alreadyLoaded*/
  t[1] && Ga(t);
  return {
    c() {
      i && i.c(), e = Ei();
    },
    m(n, o) {
      i && i.m(document.head, null), h(document.head, e);
    },
    p(n, [o]) {
      /*alreadyLoaded*/
      n[1] ? i && (i.d(1), i = null) : i ? i.p(n, o) : (i = Ga(n), i.c(), i.m(e.parentNode, e));
    },
    i: Q,
    o: Q,
    d(n) {
      i && i.d(n), M(e);
    }
  };
}
function h3(t, e, i) {
  let n, o;
  return i(1, n = window.daxListenerId), i(0, o = Math.floor(Math.random() * 1e10)), [o, n];
}
class _3 extends we {
  constructor(e) {
    super(), Pe(this, e, h3, m3, pe, {});
  }
}
class A3 extends we {
  constructor(e) {
    super(), Pe(this, e, null, null, pe, {});
  }
}
var vo, fl, hs, Hr;
class Ml {
  constructor(e, i) {
    // private
    Be(this, vo);
    Be(this, hs);
    this.onSelected = e, this.onDeselected = i, this.consumers = {};
  }
  addInterest(e, i, ...n) {
    var s;
    (s = this.consumers)[e] || (s[e] = []);
    const o = this.consumers[e].slice(-1)[0];
    this.consumers[e].push({ consumerId: i, args: n }), !(o && F(this, vo, fl).call(this, n, o.args)) && (o && this.onDeselected(e, ...o.args), this.onSelected(e, ...n));
  }
  removeInterest(e, i) {
    var l;
    (l = this.consumers)[e] || (l[e] = []);
    const n = this.consumers[e].slice(-1)[0];
    if (F(this, hs, Hr).call(this, this.consumers[e], (a) => a.consumerId === i), !(n && i === n.consumerId))
      return;
    const s = this.consumers[e].slice(-1)[0];
    s && F(this, vo, fl).call(this, n.args, s.args) || (this.onDeselected(e, ...n.args), s && this.onSelected(e, ...s.args));
  }
}
vo = new WeakSet(), fl = function(e, i) {
  return e.length === i.length && e.every((n, o) => n === i[o]);
}, hs = new WeakSet(), Hr = function(e, i) {
  for (let n = e.length - 1; n >= 0; n -= 1)
    if (i(e[n])) {
      e.splice(n, 1);
      return;
    }
};
var _s, qr;
class El {
  constructor() {
    Be(this, _s);
    this.randomIds = /* @__PURE__ */ new WeakMap();
  }
  fetchOrAdd(e) {
    return e != null && e.segmentElement ? e.marker ? e.marker : (this.uniqueIds.has(e.segmentElement) || this.uniqueIds.set(e.segmentElement, F(this, _s, qr).call(this)), this.randomIds.get(e.segmentElement)) : null;
  }
}
_s = new WeakSet(), qr = function() {
  return Math.random().toString(36).substring(2);
};
const yo = (t, e, i) => {
  let [n, o] = i.split("-");
  n || (n = "none"), o || (o = n);
  const s = t === "current" ? n : o;
  return s === "all" || s === "body" && (e == null ? void 0 : e.section) === "body" || s === "summary" && (e == null ? void 0 : e.section) === "summary";
}, ns = ["beyondwords-clickable", "bwp"];
var bo, As, Yr, ys, Zr;
const on = class on {
  constructor() {
    this.ids = new El();
  }
  update(e, i) {
    const n = yo("hovered", e, i), o = this.previous, s = n ? this.ids.fetchOrAdd(e) : null;
    s && Di(on, bo).addInterest(s, this, e), o && Di(on, bo).removeInterest(o, this), this.previous = s;
  }
};
bo = new WeakMap(), As = new WeakSet(), Yr = function(e, i) {
  if (i.segmentElement.classList.add(...ns), !i.marker)
    return;
  const n = document.querySelectorAll(`[data-beyondwords-marker="${i.marker}"]`);
  for (const o of n)
    o.classList.add(...ns);
}, ys = new WeakSet(), Zr = function(e, i) {
  if (hl(i.segmentElement, ns), !i.marker)
    return;
  const n = document.querySelectorAll(`[data-beyondwords-marker="${i.marker}"]`);
  for (const o of n)
    hl(o, ns);
}, Be(on, As), Be(on, ys), Be(on, bo, new Ml(F(on, As, Yr), F(on, ys, Zr)));
let ml = on;
const hl = (t, e) => {
  if (!t)
    return;
  const o = [...t.classList].filter((s) => !e.includes(s)).some((s) => s.startsWith("beyondwords-")) ? e.filter((s) => s !== "bwp") : e;
  t.classList.remove(...o);
}, Ja = (t, e, i) => ["beyondwords-widget", "bwp", `id-${t}`, `position-${e}`, `for-${i}-player`], Xa = ["beyondwords-relative", "bwp"];
var ko, vs, Kr, bs, Gr, ks, Jr;
const sn = class sn {
  constructor(e) {
    // Add the container next to the first DOM node that matches the segment's
    // marker. There might be an edge case where the segment was matched using
    // (xpath, md5) and the marker set on the DOM node does not match the one from
    // the API. In this case, pool all of the elements together and add the
    // container next to the first one on the page. If there are no markers on the
    // page for the segment then add the container next to the segmentElement.
    Be(this, ks);
    this.onUpdate = e, this.containers = [], this.ids = new El();
  }
  update(e, i, n, o) {
    const s = i.includes("all") || i.includes("body"), l = e || s && this.previous, a = this.previous, r = this.ids.fetchOrAdd(l);
    r && Di(sn, ko).addInterest(r, this, this, l, n, o), a && Di(sn, ko).removeInterest(a, this), this.previous = r;
  }
  reset() {
    this.update(null, "none");
  }
};
ko = new WeakMap(), vs = new WeakSet(), Kr = function(e, i, n, o, s) {
  var c;
  const l = F(c = i, ks, Jr).call(c, n);
  ["2-oclock", "3-oclock", "4-oclock", "8-oclock", "9-oclock", "10-oclock"].includes(o) && l.classList.add(...Xa);
  const r = document.createElement("div");
  r.classList.add(...Ja(e, o, s)), ["11-oclock", "12-oclock", "1-oclock"].includes(o) ? l.insertBefore(r, l.firstChild) : l.appendChild(r), i.containers.push(r), i.onUpdate(i.containers);
}, bs = new WeakSet(), Gr = function(e, i, n, o, s) {
  const l = Ja(e, o, s);
  for (let a = 0; a < i.containers.length; a += 1) {
    if (!l.every((c) => i.containers[a].classList.contains(c)))
      continue;
    const u = i.containers[a].parentNode;
    hl(u, Xa), i.containers[a].remove(), i.containers.splice(a, 1), a -= 1;
  }
  i.onUpdate(i.containers);
}, ks = new WeakSet(), Jr = function(e) {
  var s;
  const i = e.marker, n = (s = e.segmentElement) == null ? void 0 : s.getAttribute("data-beyondwords-marker");
  let o;
  if (i || n) {
    const l = i && `[data-beyondwords-marker="${i}"]`, a = n && `[data-beyondwords-marker="${n}"]`, r = [l, a].filter((u) => u).join(", ");
    o = document.querySelectorAll(r);
  }
  return o.length > 0 ? o[0] : e.segmentElement;
}, Be(sn, vs), Be(sn, bs), Be(sn, ko, new Ml(F(sn, vs, Kr), F(sn, bs, Gr)));
let _l = sn;
const Qa = (t) => ["beyondwords-highlight", "bwp", `id-${t}`];
var po, ps, Xr, Ss, Qr, So, yl;
const ln = class ln {
  constructor() {
    // Highlight the segmentElement and all DOM nodes with the same marker. There
    // might be an edge case where the segment was matched using (xpath, md5) and
    // the marker set on the DOM node does not match the one from the API. In this
    // case, pool all elements together anyway and highlight all of them.
    Be(this, So);
    this.ids = new El();
  }
  update(e, i, n, o) {
    const s = yo(e, i, n), l = this[`prev${e}`], a = s ? this.ids.fetchOrAdd(i) : null;
    a && Di(ln, po).addInterest(a, this, this, i, o), l && Di(ln, po).removeInterest(l, this), this[`prev${e}`] = a;
  }
};
po = new WeakMap(), ps = new WeakSet(), Xr = function(e, i, n, o) {
  var s;
  for (const l of F(s = i, So, yl).call(s, n)) {
    const a = document.createTreeWalker(l, NodeFilter.SHOW_TEXT, null, !1);
    let r;
    for (; r = a.nextNode(); ) {
      if (/^\s*$/.test(r.nodeValue))
        continue;
      r.parentNode.nodeName.toLowerCase() === "a" && (r = r.parentNode);
      const g = document.createElement("mark");
      g.classList.add(...Qa(e)), g.style.background = o, r.parentNode.insertBefore(g, r), g.appendChild(r);
    }
  }
}, Ss = new WeakSet(), Qr = function(e, i, n) {
  var o;
  for (const s of F(o = i, So, yl).call(o, n)) {
    const l = s.querySelectorAll(`mark.${Qa(e)}`);
    for (const a of l)
      for (const r of a.childNodes)
        a.parentNode.insertBefore(r, a), a.remove();
  }
}, So = new WeakSet(), yl = function(e) {
  var s;
  const i = /* @__PURE__ */ new Set([e.segmentElement]), n = e.marker, o = (s = e.segmentElement) == null ? void 0 : s.getAttribute("data-beyondwords-marker");
  for (const l of [n, o].filter((a) => a)) {
    const a = document.querySelectorAll(`[data-beyondwords-marker="${l}"]`);
    for (const r of a)
      i.add(r);
  }
  return i;
}, Be(ln, ps), Be(ln, Ss), Be(ln, po, new Ml(F(ln, ps, Xr), F(ln, Ss, Qr)));
let Al = ln;
const y3 = () => ke({
  type: "IdentifiersChanged",
  description: "The Player's content identifiers changed.",
  initiatedBy: "browser"
}), $r = (t) => {
  if (!t())
    return new Promise((e) => {
      setInterval(() => t() && e(), 10);
    });
}, eu = (t, e) => {
  const i = /* @__PURE__ */ new Set([...Object.keys(t), ...Object.keys(e)]), n = {};
  for (const o of i) {
    const s = t[o], l = e[o];
    s !== l && (n[o] = { previousValue: s, currentValue: l });
  }
  return n;
};
let ro = -1;
const tu = [], v3 = (t, e, i) => Fi(void 0, null, function* () {
  yield $r(() => e.player);
  const n = e.player, o = b3(n.contentIndex, i, t);
  o > ro && k3(n, ro, o, t), o < ro && p3(n, ro, o), ro = o;
}), b3 = (t, e, i) => {
  const n = i.findIndex((s) => s[0] === t && s[1] > e || s[0] > t);
  return n === -1 ? i.length - 1 : n - 1;
}, k3 = (t, e, i, n) => {
  for (let o = e + 1; o <= i; o += 1) {
    const s = t.properties();
    n[o][2](t);
    const l = t.properties(), a = eu(s, l);
    tu.push(a);
  }
}, p3 = (t, e, i) => {
  for (let n = e; n > i; n -= 1) {
    const o = tu.pop();
    for (const [s, l] of Object.entries(o))
      t[s] = l.previousValue;
  }
}, S3 = (t) => t ? P3(t) ? { newTarget: T3(t), showUserInterface: !0 } : typeof t == "string" ? { newTarget: vl(t), showUserInterface: !0 } : { newTarget: t, showUserInterface: !0 } : { newTarget: w3(), showUserInterface: !1 }, P3 = (t) => typeof t == "object" && t.nodeName.toLowerCase() === "script", w3 = () => {
  const t = document.createElement("div");
  return document.body.appendChild(t), t;
}, T3 = (t) => {
  const e = document.createElement("div");
  return t.parentNode.insertBefore(e, t.nextSibling), e;
}, vl = (t, e = "player") => {
  if (typeof t != "string")
    return t;
  const i = document.querySelectorAll(t);
  return i.length === 0 && wi(`Failed to initialize ${e} because the target could not be found.`, { target: t, elements: i }), i.length > 1 && wi(`Failed to initialize ${e} because the target is ambiguous. (${i.length} elements match)`, { target: t, elements: i }), i[0];
}, C3 = ["small", "standard", "large", "screen", "video"], bl = (t) => C3.indexOf(t) !== -1;
function $a(t, e, i) {
  const n = t.slice();
  return n[179] = e[i], n;
}
function I3(t) {
  var S;
  let e, i, n, o, s, l, a, r;
  function u(T) {
    t[123](T);
  }
  function c(T) {
    t[124](T);
  }
  function g(T) {
    t[125](T);
  }
  function f(T) {
    t[126](T);
  }
  function A(T) {
    t[127](T);
  }
  function _(T) {
    t[128](T);
  }
  let k = {
    onEvent: (
      /*onEvent*/
      t[67]
    ),
    content: (
      /*content*/
      t[54]
    ),
    contentIndex: (
      /*contentIndex*/
      t[7]
    ),
    contentVariant: (
      /*contentVariant*/
      t[25]
    ),
    introOrOutro: (
      /*introOrOutro*/
      t[69]
    ),
    preloadAdvert: (
      /*preloadAdvert*/
      t[85]
    ),
    activeAdvert: (
      /*activeAdvert*/
      t[70]
    ),
    advertConsent: (
      /*advertConsent*/
      t[22]
    ),
    maxImageSize: (
      /*maxImageSize*/
      t[82]
    ),
    projectId: (
      /*projectId*/
      t[0]
    ),
    playlistId: (
      /*playlistId*/
      t[2]
    ),
    contentId: (
      /*contentItem*/
      (S = t[72]) == null ? void 0 : S.id
    ),
    contentLanguage: (
      /*contentLanguage*/
      t[65]
    ),
    platform: (
      /*platform*/
      t[62]
    ),
    vendorIdentifier: (
      /*vendorIdentifier*/
      t[63]
    ),
    bundleIdentifier: (
      /*bundleIdentifier*/
      t[64]
    ),
    showUserInterface: (
      /*showUserInterface*/
      t[5]
    ),
    videoBehindWidget: (
      /*videoBehindWidget*/
      t[74]
    ),
    videoBehindStatic: (
      /*videoBehindStatic*/
      t[79]
    ),
    videoMightBeShown: (
      /*videoMightBeShown*/
      t[73]
    ),
    widgetPosition: (
      /*widgetPosition*/
      t[35]
    ),
    widgetWidth: (
      /*widgetWidth*/
      t[36]
    ),
    widgetMargin: (
      /*widgetMargin*/
      t[37]
    ),
    widgetTarget: (
      /*widgetTarget*/
      t[14]
    )
  };
  return (
    /*playbackState*/
    t[12] !== void 0 && (k.playbackState = /*playbackState*/
    t[12]), /*duration*/
    t[33] !== void 0 && (k.duration = /*duration*/
    t[33]), /*currentTime*/
    t[11] !== void 0 && (k.currentTime = /*currentTime*/
    t[11]), /*playbackRate*/
    t[34] !== void 0 && (k.playbackRate = /*playbackRate*/
    t[34]), /*prevPercentage*/
    t[50] !== void 0 && (k.prevPercentage = /*prevPercentage*/
    t[50]), /*metadataLoaded*/
    t[24] !== void 0 && (k.metadataLoaded = /*metadataLoaded*/
    t[24]), e = new zm({ props: k }), t[122](e), se.push(() => be(e, "playbackState", u)), se.push(() => be(e, "duration", c)), se.push(() => be(e, "currentTime", g)), se.push(() => be(e, "playbackRate", f)), se.push(() => be(e, "prevPercentage", A)), se.push(() => be(e, "metadataLoaded", _)), {
      c() {
        me(e.$$.fragment);
      },
      m(T, v) {
        de(e, T, v), r = !0;
      },
      p(T, v) {
        var O;
        const P = {};
        v[1] & /*content*/
        8388608 && (P.content = /*content*/
        T[54]), v[0] & /*contentIndex*/
        128 && (P.contentIndex = /*contentIndex*/
        T[7]), v[0] & /*contentVariant*/
        33554432 && (P.contentVariant = /*contentVariant*/
        T[25]), v[2] & /*introOrOutro*/
        128 && (P.introOrOutro = /*introOrOutro*/
        T[69]), v[2] & /*preloadAdvert*/
        8388608 && (P.preloadAdvert = /*preloadAdvert*/
        T[85]), v[2] & /*activeAdvert*/
        256 && (P.activeAdvert = /*activeAdvert*/
        T[70]), v[0] & /*advertConsent*/
        4194304 && (P.advertConsent = /*advertConsent*/
        T[22]), v[2] & /*maxImageSize*/
        1048576 && (P.maxImageSize = /*maxImageSize*/
        T[82]), v[0] & /*projectId*/
        1 && (P.projectId = /*projectId*/
        T[0]), v[0] & /*playlistId*/
        4 && (P.playlistId = /*playlistId*/
        T[2]), v[2] & /*contentItem*/
        1024 && (P.contentId = /*contentItem*/
        (O = T[72]) == null ? void 0 : O.id), v[2] & /*contentLanguage*/
        8 && (P.contentLanguage = /*contentLanguage*/
        T[65]), v[2] & /*platform*/
        1 && (P.platform = /*platform*/
        T[62]), v[2] & /*vendorIdentifier*/
        2 && (P.vendorIdentifier = /*vendorIdentifier*/
        T[63]), v[2] & /*bundleIdentifier*/
        4 && (P.bundleIdentifier = /*bundleIdentifier*/
        T[64]), v[0] & /*showUserInterface*/
        32 && (P.showUserInterface = /*showUserInterface*/
        T[5]), v[2] & /*videoBehindWidget*/
        4096 && (P.videoBehindWidget = /*videoBehindWidget*/
        T[74]), v[2] & /*videoBehindStatic*/
        131072 && (P.videoBehindStatic = /*videoBehindStatic*/
        T[79]), v[2] & /*videoMightBeShown*/
        2048 && (P.videoMightBeShown = /*videoMightBeShown*/
        T[73]), v[1] & /*widgetPosition*/
        16 && (P.widgetPosition = /*widgetPosition*/
        T[35]), v[1] & /*widgetWidth*/
        32 && (P.widgetWidth = /*widgetWidth*/
        T[36]), v[1] & /*widgetMargin*/
        64 && (P.widgetMargin = /*widgetMargin*/
        T[37]), v[0] & /*widgetTarget*/
        16384 && (P.widgetTarget = /*widgetTarget*/
        T[14]), !i && v[0] & /*playbackState*/
        4096 && (i = !0, P.playbackState = /*playbackState*/
        T[12], ve(() => i = !1)), !n && v[1] & /*duration*/
        4 && (n = !0, P.duration = /*duration*/
        T[33], ve(() => n = !1)), !o && v[0] & /*currentTime*/
        2048 && (o = !0, P.currentTime = /*currentTime*/
        T[11], ve(() => o = !1)), !s && v[1] & /*playbackRate*/
        8 && (s = !0, P.playbackRate = /*playbackRate*/
        T[34], ve(() => s = !1)), !l && v[1] & /*prevPercentage*/
        524288 && (l = !0, P.prevPercentage = /*prevPercentage*/
        T[50], ve(() => l = !1)), !a && v[0] & /*metadataLoaded*/
        16777216 && (a = !0, P.metadataLoaded = /*metadataLoaded*/
        T[24], ve(() => a = !1)), e.$set(P);
      },
      i(T) {
        r || (V(e.$$.fragment, T), r = !0);
      },
      o(T) {
        z(e.$$.fragment, T), r = !1;
      },
      d(T) {
        t[122](null), ge(e, T);
      }
    }
  );
}
function er(t) {
  let e, i, n = {
    onEvent: (
      /*onEvent*/
      t[67]
    ),
    playerStyle: (
      /*interfaceStyle*/
      t[75]
    ),
    callToAction: (
      /*callToAction*/
      t[27]
    ),
    skipButtonStyle: (
      /*skipButtonStyle*/
      t[28]
    ),
    playlistStyle: (
      /*playlistStyle*/
      t[29]
    ),
    playlistToggle: (
      /*playlistToggle*/
      t[30]
    ),
    downloadFormats: (
      /*downloadFormats*/
      t[52]
    ),
    durationFormat: (
      /*durationFormat*/
      t[53]
    ),
    playerTitle: (
      /*playerTitle*/
      t[26]
    ),
    content: (
      /*content*/
      t[54]
    ),
    contentIndex: (
      /*contentIndex*/
      t[7]
    ),
    duration: (
      /*duration*/
      t[33]
    ),
    currentTime: (
      /*currentTime*/
      t[11]
    ),
    playbackState: (
      /*playbackState*/
      t[12]
    ),
    playbackRate: (
      /*playbackRate*/
      t[34]
    ),
    playbackRates: (
      /*playbackRates*/
      t[57]
    ),
    activeAdvert: (
      /*activeAdvert*/
      t[70]
    ),
    persistentAdvert: (
      /*persistentAdvert*/
      t[84]
    ),
    companionAdvert: (
      /*companionAdvert*/
      t[66]
    ),
    textColor: (
      /*textColor*/
      t[38]
    ),
    backgroundColor: (
      /*backgroundColor*/
      t[39]
    ),
    iconColor: (
      /*iconColor*/
      t[40]
    ),
    videoTextColor: (
      /*videoTextColor*/
      t[41]
    ),
    videoBackgroundColor: (
      /*videoBackgroundColor*/
      t[58]
    ),
    videoIconColor: (
      /*videoIconColor*/
      t[42]
    ),
    logoIconEnabled: (
      /*logoIconEnabled*/
      t[43]
    ),
    logoImagePosition: (
      /*logoImagePosition*/
      t[61]
    ),
    maxImageSize: (
      /*maxImageSize*/
      t[82]
    ),
    isFullScreen: (
      /*isFullScreen*/
      t[60]
    ),
    videoPosterImage: (
      /*videoPosterImage*/
      t[77]
    ),
    videoIsBehind: (
      /*videoBehindStatic*/
      t[79]
    )
  };
  return e = new Wl({ props: n }), t[129](e), {
    c() {
      me(e.$$.fragment);
    },
    m(o, s) {
      de(e, o, s), i = !0;
    },
    p(o, s) {
      const l = {};
      s[2] & /*interfaceStyle*/
      8192 && (l.playerStyle = /*interfaceStyle*/
      o[75]), s[0] & /*callToAction*/
      134217728 && (l.callToAction = /*callToAction*/
      o[27]), s[0] & /*skipButtonStyle*/
      268435456 && (l.skipButtonStyle = /*skipButtonStyle*/
      o[28]), s[0] & /*playlistStyle*/
      536870912 && (l.playlistStyle = /*playlistStyle*/
      o[29]), s[0] & /*playlistToggle*/
      1073741824 && (l.playlistToggle = /*playlistToggle*/
      o[30]), s[1] & /*downloadFormats*/
      2097152 && (l.downloadFormats = /*downloadFormats*/
      o[52]), s[1] & /*durationFormat*/
      4194304 && (l.durationFormat = /*durationFormat*/
      o[53]), s[0] & /*playerTitle*/
      67108864 && (l.playerTitle = /*playerTitle*/
      o[26]), s[1] & /*content*/
      8388608 && (l.content = /*content*/
      o[54]), s[0] & /*contentIndex*/
      128 && (l.contentIndex = /*contentIndex*/
      o[7]), s[1] & /*duration*/
      4 && (l.duration = /*duration*/
      o[33]), s[0] & /*currentTime*/
      2048 && (l.currentTime = /*currentTime*/
      o[11]), s[0] & /*playbackState*/
      4096 && (l.playbackState = /*playbackState*/
      o[12]), s[1] & /*playbackRate*/
      8 && (l.playbackRate = /*playbackRate*/
      o[34]), s[1] & /*playbackRates*/
      67108864 && (l.playbackRates = /*playbackRates*/
      o[57]), s[2] & /*activeAdvert*/
      256 && (l.activeAdvert = /*activeAdvert*/
      o[70]), s[2] & /*persistentAdvert*/
      4194304 && (l.persistentAdvert = /*persistentAdvert*/
      o[84]), s[2] & /*companionAdvert*/
      16 && (l.companionAdvert = /*companionAdvert*/
      o[66]), s[1] & /*textColor*/
      128 && (l.textColor = /*textColor*/
      o[38]), s[1] & /*backgroundColor*/
      256 && (l.backgroundColor = /*backgroundColor*/
      o[39]), s[1] & /*iconColor*/
      512 && (l.iconColor = /*iconColor*/
      o[40]), s[1] & /*videoTextColor*/
      1024 && (l.videoTextColor = /*videoTextColor*/
      o[41]), s[1] & /*videoBackgroundColor*/
      134217728 && (l.videoBackgroundColor = /*videoBackgroundColor*/
      o[58]), s[1] & /*videoIconColor*/
      2048 && (l.videoIconColor = /*videoIconColor*/
      o[42]), s[1] & /*logoIconEnabled*/
      4096 && (l.logoIconEnabled = /*logoIconEnabled*/
      o[43]), s[1] & /*logoImagePosition*/
      1073741824 && (l.logoImagePosition = /*logoImagePosition*/
      o[61]), s[2] & /*maxImageSize*/
      1048576 && (l.maxImageSize = /*maxImageSize*/
      o[82]), s[1] & /*isFullScreen*/
      536870912 && (l.isFullScreen = /*isFullScreen*/
      o[60]), s[2] & /*videoPosterImage*/
      32768 && (l.videoPosterImage = /*videoPosterImage*/
      o[77]), s[2] & /*videoBehindStatic*/
      131072 && (l.videoIsBehind = /*videoBehindStatic*/
      o[79]), e.$set(l);
    },
    i(o) {
      i || (V(e.$$.fragment, o), i = !0);
    },
    o(o) {
      z(e.$$.fragment, o), i = !1;
    },
    d(o) {
      t[129](null), ge(e, o);
    }
  };
}
function tr(t) {
  let e, i;
  return e = new xs({
    props: {
      root: (
        /*widgetTarget*/
        t[14]
      ),
      $$slots: { default: [O3] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*widgetTarget*/
      16384 && (s.root = /*widgetTarget*/
      n[14]), o[0] & /*widgetStyle, callToAction, skipButtonStyle, playerTitle, widgetTarget, contentIndex, currentTime, playbackState*/
      469792896 | o[1] & /*downloadFormats, durationFormat, widgetPosition, widgetWidth, widgetMargin, content, duration, playbackRate, playbackRates, textColor, backgroundColor, iconColor, videoTextColor, videoBackgroundColor, videoIconColor, logoIconEnabled, logoImagePosition, widgetInterface*/
      1290018812 | o[2] & /*activeAdvert, persistentAdvert, companionAdvert, maxImageSize, videoPosterImage, videoBehindWidget*/
      5280016 | o[5] & /*$$scope*/
      134217728 && (s.$$scope = { dirty: o, ctx: n }), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function O3(t) {
  let e, i, n = {
    onEvent: (
      /*onEvent*/
      t[67]
    ),
    playerStyle: (
      /*widgetStyle*/
      t[13]
    ),
    callToAction: (
      /*callToAction*/
      t[27]
    ),
    skipButtonStyle: (
      /*skipButtonStyle*/
      t[28]
    ),
    playlistStyle: "hide",
    playlistToggle: "hide",
    downloadFormats: (
      /*downloadFormats*/
      t[52]
    ),
    durationFormat: (
      /*durationFormat*/
      t[53]
    ),
    playerTitle: (
      /*playerTitle*/
      t[26]
    ),
    fixedPosition: !/*widgetTarget*/
    t[14] && /*widgetPosition*/
    t[35],
    fixedWidth: (
      /*widgetWidth*/
      t[36]
    ),
    fixedMargin: (
      /*widgetMargin*/
      t[37]
    ),
    content: (
      /*content*/
      t[54]
    ),
    contentIndex: (
      /*contentIndex*/
      t[7]
    ),
    duration: (
      /*duration*/
      t[33]
    ),
    currentTime: (
      /*currentTime*/
      t[11]
    ),
    playbackState: (
      /*playbackState*/
      t[12]
    ),
    playbackRate: (
      /*playbackRate*/
      t[34]
    ),
    playbackRates: (
      /*playbackRates*/
      t[57]
    ),
    activeAdvert: (
      /*activeAdvert*/
      t[70]
    ),
    persistentAdvert: (
      /*persistentAdvert*/
      t[84]
    ),
    companionAdvert: (
      /*companionAdvert*/
      t[66]
    ),
    textColor: (
      /*textColor*/
      t[38]
    ),
    backgroundColor: (
      /*backgroundColor*/
      t[39]
    ),
    iconColor: (
      /*iconColor*/
      t[40]
    ),
    videoTextColor: (
      /*videoTextColor*/
      t[41]
    ),
    videoBackgroundColor: (
      /*videoBackgroundColor*/
      t[58]
    ),
    videoIconColor: (
      /*videoIconColor*/
      t[42]
    ),
    logoIconEnabled: (
      /*logoIconEnabled*/
      t[43]
    ),
    logoImagePosition: (
      /*logoImagePosition*/
      t[61]
    ),
    maxImageSize: (
      /*maxImageSize*/
      t[82]
    ),
    videoPosterImage: (
      /*videoPosterImage*/
      t[77]
    ),
    videoIsBehind: (
      /*videoBehindWidget*/
      t[74]
    )
  };
  return e = new Wl({ props: n }), t[130](e), {
    c() {
      me(e.$$.fragment);
    },
    m(o, s) {
      de(e, o, s), i = !0;
    },
    p(o, s) {
      const l = {};
      s[0] & /*widgetStyle*/
      8192 && (l.playerStyle = /*widgetStyle*/
      o[13]), s[0] & /*callToAction*/
      134217728 && (l.callToAction = /*callToAction*/
      o[27]), s[0] & /*skipButtonStyle*/
      268435456 && (l.skipButtonStyle = /*skipButtonStyle*/
      o[28]), s[1] & /*downloadFormats*/
      2097152 && (l.downloadFormats = /*downloadFormats*/
      o[52]), s[1] & /*durationFormat*/
      4194304 && (l.durationFormat = /*durationFormat*/
      o[53]), s[0] & /*playerTitle*/
      67108864 && (l.playerTitle = /*playerTitle*/
      o[26]), s[0] & /*widgetTarget*/
      16384 | s[1] & /*widgetPosition*/
      16 && (l.fixedPosition = !/*widgetTarget*/
      o[14] && /*widgetPosition*/
      o[35]), s[1] & /*widgetWidth*/
      32 && (l.fixedWidth = /*widgetWidth*/
      o[36]), s[1] & /*widgetMargin*/
      64 && (l.fixedMargin = /*widgetMargin*/
      o[37]), s[1] & /*content*/
      8388608 && (l.content = /*content*/
      o[54]), s[0] & /*contentIndex*/
      128 && (l.contentIndex = /*contentIndex*/
      o[7]), s[1] & /*duration*/
      4 && (l.duration = /*duration*/
      o[33]), s[0] & /*currentTime*/
      2048 && (l.currentTime = /*currentTime*/
      o[11]), s[0] & /*playbackState*/
      4096 && (l.playbackState = /*playbackState*/
      o[12]), s[1] & /*playbackRate*/
      8 && (l.playbackRate = /*playbackRate*/
      o[34]), s[1] & /*playbackRates*/
      67108864 && (l.playbackRates = /*playbackRates*/
      o[57]), s[2] & /*activeAdvert*/
      256 && (l.activeAdvert = /*activeAdvert*/
      o[70]), s[2] & /*persistentAdvert*/
      4194304 && (l.persistentAdvert = /*persistentAdvert*/
      o[84]), s[2] & /*companionAdvert*/
      16 && (l.companionAdvert = /*companionAdvert*/
      o[66]), s[1] & /*textColor*/
      128 && (l.textColor = /*textColor*/
      o[38]), s[1] & /*backgroundColor*/
      256 && (l.backgroundColor = /*backgroundColor*/
      o[39]), s[1] & /*iconColor*/
      512 && (l.iconColor = /*iconColor*/
      o[40]), s[1] & /*videoTextColor*/
      1024 && (l.videoTextColor = /*videoTextColor*/
      o[41]), s[1] & /*videoBackgroundColor*/
      134217728 && (l.videoBackgroundColor = /*videoBackgroundColor*/
      o[58]), s[1] & /*videoIconColor*/
      2048 && (l.videoIconColor = /*videoIconColor*/
      o[42]), s[1] & /*logoIconEnabled*/
      4096 && (l.logoIconEnabled = /*logoIconEnabled*/
      o[43]), s[1] & /*logoImagePosition*/
      1073741824 && (l.logoImagePosition = /*logoImagePosition*/
      o[61]), s[2] & /*maxImageSize*/
      1048576 && (l.maxImageSize = /*maxImageSize*/
      o[82]), s[2] & /*videoPosterImage*/
      32768 && (l.videoPosterImage = /*videoPosterImage*/
      o[77]), s[2] & /*videoBehindWidget*/
      4096 && (l.videoIsBehind = /*videoBehindWidget*/
      o[74]), e.$set(l);
    },
    i(o) {
      i || (V(e.$$.fragment, o), i = !0);
    },
    o(o) {
      z(e.$$.fragment, o), i = !1;
    },
    d(o) {
      t[130](null), ge(e, o);
    }
  };
}
function V3(t) {
  let e, i;
  return e = new Wl({
    props: {
      onEvent: (
        /*func*/
        t[131]
      ),
      playerStyle: "small",
      fixedWidth: 0,
      logoIconEnabled: !1,
      content: (
        /*content*/
        t[54]
      ),
      contentIndex: (
        /*contentIndex*/
        t[7]
      ),
      duration: (
        /*duration*/
        t[33]
      ),
      currentTime: (
        /*showRealTimeInWidget*/
        t[76] ? (
          /*currentTime*/
          t[11]
        ) : (
          /*widgetSegment*/
          t[68].startTime
        )
      ),
      playbackState: (
        /*showRealTimeInWidget*/
        t[76] ? (
          /*playbackState*/
          t[12]
        ) : "paused"
      ),
      activeAdvert: (
        /*activeAdvert*/
        t[70]
      ),
      persistentAdvert: (
        /*persistentAdvert*/
        t[84]
      ),
      companionAdvert: (
        /*companionAdvert*/
        t[66]
      ),
      textColor: (
        /*textColor*/
        t[38]
      ),
      backgroundColor: (
        /*backgroundColor*/
        t[39]
      ),
      iconColor: (
        /*iconColor*/
        t[40]
      ),
      videoTextColor: (
        /*videoTextColor*/
        t[41]
      ),
      videoBackgroundColor: (
        /*videoBackgroundColor*/
        t[58]
      ),
      videoIconColor: (
        /*videoIconColor*/
        t[42]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[2] & /*widgetSegment, widgetIsCurrent*/
      576 && (s.onEvent = /*func*/
      n[131]), o[1] & /*content*/
      8388608 && (s.content = /*content*/
      n[54]), o[0] & /*contentIndex*/
      128 && (s.contentIndex = /*contentIndex*/
      n[7]), o[1] & /*duration*/
      4 && (s.duration = /*duration*/
      n[33]), o[0] & /*currentTime*/
      2048 | o[2] & /*showRealTimeInWidget, widgetSegment*/
      16448 && (s.currentTime = /*showRealTimeInWidget*/
      n[76] ? (
        /*currentTime*/
        n[11]
      ) : (
        /*widgetSegment*/
        n[68].startTime
      )), o[0] & /*playbackState*/
      4096 | o[2] & /*showRealTimeInWidget*/
      16384 && (s.playbackState = /*showRealTimeInWidget*/
      n[76] ? (
        /*playbackState*/
        n[12]
      ) : "paused"), o[2] & /*activeAdvert*/
      256 && (s.activeAdvert = /*activeAdvert*/
      n[70]), o[2] & /*persistentAdvert*/
      4194304 && (s.persistentAdvert = /*persistentAdvert*/
      n[84]), o[2] & /*companionAdvert*/
      16 && (s.companionAdvert = /*companionAdvert*/
      n[66]), o[1] & /*textColor*/
      128 && (s.textColor = /*textColor*/
      n[38]), o[1] & /*backgroundColor*/
      256 && (s.backgroundColor = /*backgroundColor*/
      n[39]), o[1] & /*iconColor*/
      512 && (s.iconColor = /*iconColor*/
      n[40]), o[1] & /*videoTextColor*/
      1024 && (s.videoTextColor = /*videoTextColor*/
      n[41]), o[1] & /*videoBackgroundColor*/
      134217728 && (s.videoBackgroundColor = /*videoBackgroundColor*/
      n[58]), o[1] & /*videoIconColor*/
      2048 && (s.videoIconColor = /*videoIconColor*/
      n[42]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function ir(t, e) {
  let i, n, o;
  return n = new xs({
    props: {
      root: (
        /*root*/
        e[179]
      ),
      $$slots: { default: [V3] },
      $$scope: { ctx: e }
    }
  }), {
    key: t,
    first: null,
    c() {
      i = Ei(), me(n.$$.fragment), this.first = i;
    },
    m(s, l) {
      E(s, i, l), de(n, s, l), o = !0;
    },
    p(s, l) {
      e = s;
      const a = {};
      l[1] & /*segmentWidgets*/
      1048576 && (a.root = /*root*/
      e[179]), l[0] & /*contentIndex, currentTime, playbackState*/
      6272 | l[1] & /*content, duration, textColor, backgroundColor, iconColor, videoTextColor, videoBackgroundColor, videoIconColor*/
      142610308 | l[2] & /*widgetSegment, widgetIsCurrent, showRealTimeInWidget, activeAdvert, persistentAdvert, companionAdvert*/
      4211536 | l[5] & /*$$scope*/
      134217728 && (a.$$scope = { dirty: l, ctx: e }), n.$set(a);
    },
    i(s) {
      o || (V(n.$$.fragment, s), o = !0);
    },
    o(s) {
      z(n.$$.fragment, s), o = !1;
    },
    d(s) {
      s && M(i), ge(n, s);
    }
  };
}
function nr(t) {
  let e, i;
  return e = new xs({
    props: {
      root: (
        /*controlPanel*/
        t[23]
      ),
      $$slots: { default: [B3] },
      $$scope: { ctx: t }
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[0] & /*controlPanel*/
      8388608 && (s.root = /*controlPanel*/
      n[23]), o[0] & /*controlPanel, projectId, contentId, playlistId, sourceId, sourceUrl, showUserInterface, playerStyle, playerTitle, callToAction, skipButtonStyle, playlistStyle, playlistToggle, contentIndex, introsOutrosIndex, advertIndex, persistentIndex, currentTime, playbackState, widgetStyle, widgetTarget, highlightColor, highlightSections, clickableSections, segmentWidgetSections, segmentWidgetPosition, currentSegment, hoveredSegment, advertConsent*/
      2097151999 | o[1] & /*content, introsOutros, adverts, mediaSession, persistentAdImage, duration, playbackRate, widgetPosition, widgetWidth, widgetMargin, textColor, backgroundColor, iconColor, videoTextColor, videoIconColor, logoIconEnabled, analyticsConsent, analyticsCustomUrl, analyticsTag*/
      58785791 | o[5] & /*$$scope*/
      134217728 && (s.$$scope = { dirty: o, ctx: n }), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function B3(t) {
  let e, i, n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, C, Z, q, x, X, oe, ae, $, ee, ue, Ae, ce, ye, re, b, w, R, L, Ve, Le, Qe, j, he, ze, Re;
  function Ge(I) {
    t[132](I);
  }
  function Me(I) {
    t[133](I);
  }
  function nt(I) {
    t[134](I);
  }
  function Te(I) {
    t[135](I);
  }
  function Je(I) {
    t[136](I);
  }
  function Ce(I) {
    t[137](I);
  }
  function Lt(I) {
    t[138](I);
  }
  function Ee(I) {
    t[139](I);
  }
  function ft(I) {
    t[140](I);
  }
  function Oe(I) {
    t[141](I);
  }
  function qe(I) {
    t[142](I);
  }
  function Nt(I) {
    t[143](I);
  }
  function De(I) {
    t[144](I);
  }
  function St(I) {
    t[145](I);
  }
  function Ye(I) {
    t[146](I);
  }
  function At(I) {
    t[147](I);
  }
  function $e(I) {
    t[148](I);
  }
  function mt(I) {
    t[149](I);
  }
  function Ze(I) {
    t[150](I);
  }
  function xe(I) {
    t[151](I);
  }
  function yt(I) {
    t[152](I);
  }
  function et(I) {
    t[153](I);
  }
  function lt(I) {
    t[154](I);
  }
  function ot(I) {
    t[155](I);
  }
  function Pt(I) {
    t[156](I);
  }
  function Xe(I) {
    t[157](I);
  }
  function Ot(I) {
    t[158](I);
  }
  function vt(I) {
    t[159](I);
  }
  function Vt(I) {
    t[160](I);
  }
  function wt(I) {
    t[161](I);
  }
  function tt(I) {
    t[162](I);
  }
  function at(I) {
    t[163](I);
  }
  function Bt(I) {
    t[164](I);
  }
  function bt(I) {
    t[165](I);
  }
  function kt(I) {
    t[166](I);
  }
  function Ke(I) {
    t[167](I);
  }
  function rt(I) {
    t[168](I);
  }
  function pt(I) {
    t[169](I);
  }
  function st(I) {
    t[170](I);
  }
  function it(I) {
    t[171](I);
  }
  function He(I) {
    t[172](I);
  }
  function ht(I) {
    t[173](I);
  }
  function Tt(I) {
    t[174](I);
  }
  function U(I) {
    t[175](I);
  }
  function ut(I) {
    t[176](I);
  }
  let te = {
    content: (
      /*content*/
      t[54]
    ),
    introsOutros: (
      /*introsOutros*/
      t[55]
    ),
    adverts: (
      /*adverts*/
      t[56]
    )
  };
  return (
    /*controlPanel*/
    t[23] !== void 0 && (te.controlPanel = /*controlPanel*/
    t[23]), /*projectId*/
    t[0] !== void 0 && (te.projectId = /*projectId*/
    t[0]), /*contentId*/
    t[1] !== void 0 && (te.contentId = /*contentId*/
    t[1]), /*playlistId*/
    t[2] !== void 0 && (te.playlistId = /*playlistId*/
    t[2]), /*sourceId*/
    t[3] !== void 0 && (te.sourceId = /*sourceId*/
    t[3]), /*sourceUrl*/
    t[4] !== void 0 && (te.sourceUrl = /*sourceUrl*/
    t[4]), /*showUserInterface*/
    t[5] !== void 0 && (te.showUserInterface = /*showUserInterface*/
    t[5]), /*playerStyle*/
    t[6] !== void 0 && (te.playerStyle = /*playerStyle*/
    t[6]), /*playerTitle*/
    t[26] !== void 0 && (te.playerTitle = /*playerTitle*/
    t[26]), /*callToAction*/
    t[27] !== void 0 && (te.callToAction = /*callToAction*/
    t[27]), /*skipButtonStyle*/
    t[28] !== void 0 && (te.skipButtonStyle = /*skipButtonStyle*/
    t[28]), /*playlistStyle*/
    t[29] !== void 0 && (te.playlistStyle = /*playlistStyle*/
    t[29]), /*playlistToggle*/
    t[30] !== void 0 && (te.playlistToggle = /*playlistToggle*/
    t[30]), /*mediaSession*/
    t[31] !== void 0 && (te.mediaSession = /*mediaSession*/
    t[31]), /*contentIndex*/
    t[7] !== void 0 && (te.contentIndex = /*contentIndex*/
    t[7]), /*introsOutrosIndex*/
    t[8] !== void 0 && (te.introsOutrosIndex = /*introsOutrosIndex*/
    t[8]), /*advertIndex*/
    t[9] !== void 0 && (te.advertIndex = /*advertIndex*/
    t[9]), /*persistentAdImage*/
    t[32] !== void 0 && (te.persistentAdImage = /*persistentAdImage*/
    t[32]), /*persistentIndex*/
    t[10] !== void 0 && (te.persistentIndex = /*persistentIndex*/
    t[10]), /*duration*/
    t[33] !== void 0 && (te.duration = /*duration*/
    t[33]), /*currentTime*/
    t[11] !== void 0 && (te.currentTime = /*currentTime*/
    t[11]), /*playbackState*/
    t[12] !== void 0 && (te.playbackState = /*playbackState*/
    t[12]), /*playbackRate*/
    t[34] !== void 0 && (te.playbackRate = /*playbackRate*/
    t[34]), /*widgetStyle*/
    t[13] !== void 0 && (te.widgetStyle = /*widgetStyle*/
    t[13]), /*widgetPosition*/
    t[35] !== void 0 && (te.widgetPosition = /*widgetPosition*/
    t[35]), /*widgetWidth*/
    t[36] !== void 0 && (te.widgetWidth = /*widgetWidth*/
    t[36]), /*widgetMargin*/
    t[37] !== void 0 && (te.widgetMargin = /*widgetMargin*/
    t[37]), /*widgetTarget*/
    t[14] !== void 0 && (te.widgetTarget = /*widgetTarget*/
    t[14]), /*textColor*/
    t[38] !== void 0 && (te.textColor = /*textColor*/
    t[38]), /*backgroundColor*/
    t[39] !== void 0 && (te.backgroundColor = /*backgroundColor*/
    t[39]), /*iconColor*/
    t[40] !== void 0 && (te.iconColor = /*iconColor*/
    t[40]), /*highlightColor*/
    t[15] !== void 0 && (te.highlightColor = /*highlightColor*/
    t[15]), /*videoTextColor*/
    t[41] !== void 0 && (te.videoTextColor = /*videoTextColor*/
    t[41]), /*videoIconColor*/
    t[42] !== void 0 && (te.videoIconColor = /*videoIconColor*/
    t[42]), /*logoIconEnabled*/
    t[43] !== void 0 && (te.logoIconEnabled = /*logoIconEnabled*/
    t[43]), /*highlightSections*/
    t[16] !== void 0 && (te.highlightSections = /*highlightSections*/
    t[16]), /*clickableSections*/
    t[17] !== void 0 && (te.clickableSections = /*clickableSections*/
    t[17]), /*segmentWidgetSections*/
    t[18] !== void 0 && (te.segmentWidgetSections = /*segmentWidgetSections*/
    t[18]), /*segmentWidgetPosition*/
    t[19] !== void 0 && (te.segmentWidgetPosition = /*segmentWidgetPosition*/
    t[19]), /*currentSegment*/
    t[20] !== void 0 && (te.currentSegment = /*currentSegment*/
    t[20]), /*hoveredSegment*/
    t[21] !== void 0 && (te.hoveredSegment = /*hoveredSegment*/
    t[21]), /*advertConsent*/
    t[22] !== void 0 && (te.advertConsent = /*advertConsent*/
    t[22]), /*analyticsConsent*/
    t[44] !== void 0 && (te.analyticsConsent = /*analyticsConsent*/
    t[44]), /*analyticsCustomUrl*/
    t[45] !== void 0 && (te.analyticsCustomUrl = /*analyticsCustomUrl*/
    t[45]), /*analyticsTag*/
    t[46] !== void 0 && (te.analyticsTag = /*analyticsTag*/
    t[46]), e = new KA({ props: te }), se.push(() => be(e, "controlPanel", Ge)), se.push(() => be(e, "projectId", Me)), se.push(() => be(e, "contentId", nt)), se.push(() => be(e, "playlistId", Te)), se.push(() => be(e, "sourceId", Je)), se.push(() => be(e, "sourceUrl", Ce)), se.push(() => be(e, "showUserInterface", Lt)), se.push(() => be(e, "playerStyle", Ee)), se.push(() => be(e, "playerTitle", ft)), se.push(() => be(e, "callToAction", Oe)), se.push(() => be(e, "skipButtonStyle", qe)), se.push(() => be(e, "playlistStyle", Nt)), se.push(() => be(e, "playlistToggle", De)), se.push(() => be(e, "mediaSession", St)), se.push(() => be(e, "contentIndex", Ye)), se.push(() => be(e, "introsOutrosIndex", At)), se.push(() => be(e, "advertIndex", $e)), se.push(() => be(e, "persistentAdImage", mt)), se.push(() => be(e, "persistentIndex", Ze)), se.push(() => be(e, "duration", xe)), se.push(() => be(e, "currentTime", yt)), se.push(() => be(e, "playbackState", et)), se.push(() => be(e, "playbackRate", lt)), se.push(() => be(e, "widgetStyle", ot)), se.push(() => be(e, "widgetPosition", Pt)), se.push(() => be(e, "widgetWidth", Xe)), se.push(() => be(e, "widgetMargin", Ot)), se.push(() => be(e, "widgetTarget", vt)), se.push(() => be(e, "textColor", Vt)), se.push(() => be(e, "backgroundColor", wt)), se.push(() => be(e, "iconColor", tt)), se.push(() => be(e, "highlightColor", at)), se.push(() => be(e, "videoTextColor", Bt)), se.push(() => be(e, "videoIconColor", bt)), se.push(() => be(e, "logoIconEnabled", kt)), se.push(() => be(e, "highlightSections", Ke)), se.push(() => be(e, "clickableSections", rt)), se.push(() => be(e, "segmentWidgetSections", pt)), se.push(() => be(e, "segmentWidgetPosition", st)), se.push(() => be(e, "currentSegment", it)), se.push(() => be(e, "hoveredSegment", He)), se.push(() => be(e, "advertConsent", ht)), se.push(() => be(e, "analyticsConsent", Tt)), se.push(() => be(e, "analyticsCustomUrl", U)), se.push(() => be(e, "analyticsTag", ut)), {
      c() {
        me(e.$$.fragment);
      },
      m(I, B) {
        de(e, I, B), Re = !0;
      },
      p(I, B) {
        const le = {};
        B[1] & /*content*/
        8388608 && (le.content = /*content*/
        I[54]), B[1] & /*introsOutros*/
        16777216 && (le.introsOutros = /*introsOutros*/
        I[55]), B[1] & /*adverts*/
        33554432 && (le.adverts = /*adverts*/
        I[56]), !i && B[0] & /*controlPanel*/
        8388608 && (i = !0, le.controlPanel = /*controlPanel*/
        I[23], ve(() => i = !1)), !n && B[0] & /*projectId*/
        1 && (n = !0, le.projectId = /*projectId*/
        I[0], ve(() => n = !1)), !o && B[0] & /*contentId*/
        2 && (o = !0, le.contentId = /*contentId*/
        I[1], ve(() => o = !1)), !s && B[0] & /*playlistId*/
        4 && (s = !0, le.playlistId = /*playlistId*/
        I[2], ve(() => s = !1)), !l && B[0] & /*sourceId*/
        8 && (l = !0, le.sourceId = /*sourceId*/
        I[3], ve(() => l = !1)), !a && B[0] & /*sourceUrl*/
        16 && (a = !0, le.sourceUrl = /*sourceUrl*/
        I[4], ve(() => a = !1)), !r && B[0] & /*showUserInterface*/
        32 && (r = !0, le.showUserInterface = /*showUserInterface*/
        I[5], ve(() => r = !1)), !u && B[0] & /*playerStyle*/
        64 && (u = !0, le.playerStyle = /*playerStyle*/
        I[6], ve(() => u = !1)), !c && B[0] & /*playerTitle*/
        67108864 && (c = !0, le.playerTitle = /*playerTitle*/
        I[26], ve(() => c = !1)), !g && B[0] & /*callToAction*/
        134217728 && (g = !0, le.callToAction = /*callToAction*/
        I[27], ve(() => g = !1)), !f && B[0] & /*skipButtonStyle*/
        268435456 && (f = !0, le.skipButtonStyle = /*skipButtonStyle*/
        I[28], ve(() => f = !1)), !A && B[0] & /*playlistStyle*/
        536870912 && (A = !0, le.playlistStyle = /*playlistStyle*/
        I[29], ve(() => A = !1)), !_ && B[0] & /*playlistToggle*/
        1073741824 && (_ = !0, le.playlistToggle = /*playlistToggle*/
        I[30], ve(() => _ = !1)), !k && B[1] & /*mediaSession*/
        1 && (k = !0, le.mediaSession = /*mediaSession*/
        I[31], ve(() => k = !1)), !S && B[0] & /*contentIndex*/
        128 && (S = !0, le.contentIndex = /*contentIndex*/
        I[7], ve(() => S = !1)), !T && B[0] & /*introsOutrosIndex*/
        256 && (T = !0, le.introsOutrosIndex = /*introsOutrosIndex*/
        I[8], ve(() => T = !1)), !v && B[0] & /*advertIndex*/
        512 && (v = !0, le.advertIndex = /*advertIndex*/
        I[9], ve(() => v = !1)), !P && B[1] & /*persistentAdImage*/
        2 && (P = !0, le.persistentAdImage = /*persistentAdImage*/
        I[32], ve(() => P = !1)), !O && B[0] & /*persistentIndex*/
        1024 && (O = !0, le.persistentIndex = /*persistentIndex*/
        I[10], ve(() => O = !1)), !D && B[1] & /*duration*/
        4 && (D = !0, le.duration = /*duration*/
        I[33], ve(() => D = !1)), !p && B[0] & /*currentTime*/
        2048 && (p = !0, le.currentTime = /*currentTime*/
        I[11], ve(() => p = !1)), !C && B[0] & /*playbackState*/
        4096 && (C = !0, le.playbackState = /*playbackState*/
        I[12], ve(() => C = !1)), !Z && B[1] & /*playbackRate*/
        8 && (Z = !0, le.playbackRate = /*playbackRate*/
        I[34], ve(() => Z = !1)), !q && B[0] & /*widgetStyle*/
        8192 && (q = !0, le.widgetStyle = /*widgetStyle*/
        I[13], ve(() => q = !1)), !x && B[1] & /*widgetPosition*/
        16 && (x = !0, le.widgetPosition = /*widgetPosition*/
        I[35], ve(() => x = !1)), !X && B[1] & /*widgetWidth*/
        32 && (X = !0, le.widgetWidth = /*widgetWidth*/
        I[36], ve(() => X = !1)), !oe && B[1] & /*widgetMargin*/
        64 && (oe = !0, le.widgetMargin = /*widgetMargin*/
        I[37], ve(() => oe = !1)), !ae && B[0] & /*widgetTarget*/
        16384 && (ae = !0, le.widgetTarget = /*widgetTarget*/
        I[14], ve(() => ae = !1)), !$ && B[1] & /*textColor*/
        128 && ($ = !0, le.textColor = /*textColor*/
        I[38], ve(() => $ = !1)), !ee && B[1] & /*backgroundColor*/
        256 && (ee = !0, le.backgroundColor = /*backgroundColor*/
        I[39], ve(() => ee = !1)), !ue && B[1] & /*iconColor*/
        512 && (ue = !0, le.iconColor = /*iconColor*/
        I[40], ve(() => ue = !1)), !Ae && B[0] & /*highlightColor*/
        32768 && (Ae = !0, le.highlightColor = /*highlightColor*/
        I[15], ve(() => Ae = !1)), !ce && B[1] & /*videoTextColor*/
        1024 && (ce = !0, le.videoTextColor = /*videoTextColor*/
        I[41], ve(() => ce = !1)), !ye && B[1] & /*videoIconColor*/
        2048 && (ye = !0, le.videoIconColor = /*videoIconColor*/
        I[42], ve(() => ye = !1)), !re && B[1] & /*logoIconEnabled*/
        4096 && (re = !0, le.logoIconEnabled = /*logoIconEnabled*/
        I[43], ve(() => re = !1)), !b && B[0] & /*highlightSections*/
        65536 && (b = !0, le.highlightSections = /*highlightSections*/
        I[16], ve(() => b = !1)), !w && B[0] & /*clickableSections*/
        131072 && (w = !0, le.clickableSections = /*clickableSections*/
        I[17], ve(() => w = !1)), !R && B[0] & /*segmentWidgetSections*/
        262144 && (R = !0, le.segmentWidgetSections = /*segmentWidgetSections*/
        I[18], ve(() => R = !1)), !L && B[0] & /*segmentWidgetPosition*/
        524288 && (L = !0, le.segmentWidgetPosition = /*segmentWidgetPosition*/
        I[19], ve(() => L = !1)), !Ve && B[0] & /*currentSegment*/
        1048576 && (Ve = !0, le.currentSegment = /*currentSegment*/
        I[20], ve(() => Ve = !1)), !Le && B[0] & /*hoveredSegment*/
        2097152 && (Le = !0, le.hoveredSegment = /*hoveredSegment*/
        I[21], ve(() => Le = !1)), !Qe && B[0] & /*advertConsent*/
        4194304 && (Qe = !0, le.advertConsent = /*advertConsent*/
        I[22], ve(() => Qe = !1)), !j && B[1] & /*analyticsConsent*/
        8192 && (j = !0, le.analyticsConsent = /*analyticsConsent*/
        I[44], ve(() => j = !1)), !he && B[1] & /*analyticsCustomUrl*/
        16384 && (he = !0, le.analyticsCustomUrl = /*analyticsCustomUrl*/
        I[45], ve(() => he = !1)), !ze && B[1] & /*analyticsTag*/
        32768 && (ze = !0, le.analyticsTag = /*analyticsTag*/
        I[46], ve(() => ze = !1)), e.$set(le);
      },
      i(I) {
        Re || (V(e.$$.fragment, I), Re = !0);
      },
      o(I) {
        z(e.$$.fragment, I), Re = !1;
      },
      d(I) {
        ge(e, I);
      }
    }
  );
}
function or(t) {
  let e, i;
  return e = new l3({
    props: {
      onEvent: (
        /*onEvent*/
        t[67]
      ),
      content: (
        /*content*/
        t[54]
      ),
      contentIndex: (
        /*contentIndex*/
        t[7]
      ),
      activeAdvert: (
        /*activeAdvert*/
        t[70]
      ),
      persistentAdvert: (
        /*persistentAdvert*/
        t[84]
      ),
      companionAdvert: (
        /*companionAdvert*/
        t[66]
      ),
      duration: (
        /*duration*/
        t[33]
      ),
      playbackState: (
        /*playbackState*/
        t[12]
      ),
      skipButtonStyle: (
        /*skipButtonStyle*/
        t[28]
      ),
      backgroundColor: (
        /*backgroundColor*/
        t[39]
      ),
      iconColor: (
        /*iconColor*/
        t[40]
      )
    }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[1] & /*content*/
      8388608 && (s.content = /*content*/
      n[54]), o[0] & /*contentIndex*/
      128 && (s.contentIndex = /*contentIndex*/
      n[7]), o[2] & /*activeAdvert*/
      256 && (s.activeAdvert = /*activeAdvert*/
      n[70]), o[2] & /*persistentAdvert*/
      4194304 && (s.persistentAdvert = /*persistentAdvert*/
      n[84]), o[2] & /*companionAdvert*/
      16 && (s.companionAdvert = /*companionAdvert*/
      n[66]), o[1] & /*duration*/
      4 && (s.duration = /*duration*/
      n[33]), o[0] & /*playbackState*/
      4096 && (s.playbackState = /*playbackState*/
      n[12]), o[0] & /*skipButtonStyle*/
      268435456 && (s.skipButtonStyle = /*skipButtonStyle*/
      n[28]), o[1] & /*backgroundColor*/
      256 && (s.backgroundColor = /*backgroundColor*/
      n[39]), o[1] & /*iconColor*/
      512 && (s.iconColor = /*iconColor*/
      n[40]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function sr(t) {
  let e, i;
  return e = new d3({
    props: { analyticsTag: (
      /*analyticsTag*/
      t[46]
    ) }
  }), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    p(n, o) {
      const s = {};
      o[1] & /*analyticsTag*/
      32768 && (s.analyticsTag = /*analyticsTag*/
      n[46]), e.$set(s);
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function lr(t) {
  let e, i;
  return e = new _3({}), {
    c() {
      me(e.$$.fragment);
    },
    m(n, o) {
      de(e, n, o), i = !0;
    },
    i(n) {
      i || (V(e.$$.fragment, n), i = !0);
    },
    o(n) {
      z(e.$$.fragment, n), i = !1;
    },
    d(n) {
      ge(e, n);
    }
  };
}
function W3(t) {
  let e, i, n, o, s = [], l = /* @__PURE__ */ new Map(), a, r, u, c, g, f, A;
  e = new xs({
    props: {
      prepend: !0,
      root: (
        /*videoRoot*/
        t[78]
      ),
      $$slots: { default: [I3] },
      $$scope: { ctx: t }
    }
  });
  let _ = (
    /*showStaticInterface*/
    t[81] && er(t)
  ), k = (
    /*showWidgetInterface*/
    t[80] && tr(t)
  ), S = ti(
    /*segmentWidgets*/
    t[51]
  );
  const T = (p) => (
    /*root*/
    p[179]
  );
  for (let p = 0; p < S.length; p += 1) {
    let C = $a(t, S, p), Z = T(C);
    l.set(Z, s[p] = ir(Z, C));
  }
  let v = (
    /*controlPanel*/
    t[23] && nr(t)
  ), P = (
    /*showMediaSession*/
    t[59] && or(t)
  ), O = (
    /*analyticsTag*/
    t[46] && sr(t)
  ), D = (
    /*setDaxListenerId*/
    t[83] && lr()
  );
  return f = new A3({}), {
    c() {
      me(e.$$.fragment), i = J(), _ && _.c(), n = J(), k && k.c(), o = J();
      for (let p = 0; p < s.length; p += 1)
        s[p].c();
      a = J(), v && v.c(), r = J(), P && P.c(), u = J(), O && O.c(), c = J(), D && D.c(), g = J(), me(f.$$.fragment);
    },
    m(p, C) {
      de(e, p, C), E(p, i, C), _ && _.m(p, C), E(p, n, C), k && k.m(p, C), E(p, o, C);
      for (let Z = 0; Z < s.length; Z += 1)
        s[Z] && s[Z].m(p, C);
      E(p, a, C), v && v.m(p, C), E(p, r, C), P && P.m(p, C), E(p, u, C), O && O.m(p, C), E(p, c, C), D && D.m(p, C), E(p, g, C), de(f, p, C), A = !0;
    },
    p(p, C) {
      const Z = {};
      C[2] & /*videoRoot*/
      65536 && (Z.root = /*videoRoot*/
      p[78]), C[0] & /*contentIndex, contentVariant, advertConsent, projectId, playlistId, showUserInterface, widgetTarget, playbackState, currentTime, metadataLoaded*/
      54548645 | C[1] & /*content, widgetPosition, widgetWidth, widgetMargin, mediaElement, duration, playbackRate, prevPercentage*/
      8978556 | C[2] & /*introOrOutro, preloadAdvert, activeAdvert, maxImageSize, contentItem, contentLanguage, platform, vendorIdentifier, bundleIdentifier, videoBehindWidget, videoBehindStatic, videoMightBeShown*/
      9575823 | C[5] & /*$$scope*/
      134217728 && (Z.$$scope = { dirty: C, ctx: p }), e.$set(Z), /*showStaticInterface*/
      p[81] ? _ ? (_.p(p, C), C[2] & /*showStaticInterface*/
      524288 && V(_, 1)) : (_ = er(p), _.c(), V(_, 1), _.m(n.parentNode, n)) : _ && (Fe(), z(_, 1, 1, () => {
        _ = null;
      }), Ue()), /*showWidgetInterface*/
      p[80] ? k ? (k.p(p, C), C[2] & /*showWidgetInterface*/
      262144 && V(k, 1)) : (k = tr(p), k.c(), V(k, 1), k.m(o.parentNode, o)) : k && (Fe(), z(k, 1, 1, () => {
        k = null;
      }), Ue()), C[0] & /*contentIndex, currentTime, playbackState*/
      6272 | C[1] & /*segmentWidgets, content, duration, textColor, backgroundColor, iconColor, videoTextColor, videoBackgroundColor, videoIconColor*/
      143658884 | C[2] & /*onEvent, widgetSegment, widgetIsCurrent, showRealTimeInWidget, activeAdvert, persistentAdvert, companionAdvert*/
      4211568 && (S = ti(
        /*segmentWidgets*/
        p[51]
      ), Fe(), s = hc(s, C, T, 1, p, S, l, a.parentNode, mc, ir, a, $a), Ue()), /*controlPanel*/
      p[23] ? v ? (v.p(p, C), C[0] & /*controlPanel*/
      8388608 && V(v, 1)) : (v = nr(p), v.c(), V(v, 1), v.m(r.parentNode, r)) : v && (Fe(), z(v, 1, 1, () => {
        v = null;
      }), Ue()), /*showMediaSession*/
      p[59] ? P ? (P.p(p, C), C[1] & /*showMediaSession*/
      268435456 && V(P, 1)) : (P = or(p), P.c(), V(P, 1), P.m(u.parentNode, u)) : P && (Fe(), z(P, 1, 1, () => {
        P = null;
      }), Ue()), /*analyticsTag*/
      p[46] ? O ? (O.p(p, C), C[1] & /*analyticsTag*/
      32768 && V(O, 1)) : (O = sr(p), O.c(), V(O, 1), O.m(c.parentNode, c)) : O && (Fe(), z(O, 1, 1, () => {
        O = null;
      }), Ue()), /*setDaxListenerId*/
      p[83] ? D ? C[2] & /*setDaxListenerId*/
      2097152 && V(D, 1) : (D = lr(), D.c(), V(D, 1), D.m(g.parentNode, g)) : D && (Fe(), z(D, 1, 1, () => {
        D = null;
      }), Ue());
    },
    i(p) {
      if (!A) {
        V(e.$$.fragment, p), V(_), V(k);
        for (let C = 0; C < S.length; C += 1)
          V(s[C]);
        V(v), V(P), V(O), V(D), V(f.$$.fragment, p), A = !0;
      }
    },
    o(p) {
      z(e.$$.fragment, p), z(_), z(k);
      for (let C = 0; C < s.length; C += 1)
        z(s[C]);
      z(v), z(P), z(O), z(D), z(f.$$.fragment, p), A = !1;
    },
    d(p) {
      p && (M(i), M(n), M(o), M(a), M(r), M(u), M(c), M(g)), ge(e, p), _ && _.d(p), k && k.d(p);
      for (let C = 0; C < s.length; C += 1)
        s[C].d(p);
      v && v.d(p), P && P.d(p), O && O.d(p), D && D.d(p), ge(f, p);
    }
  };
}
function M3(t, e, i) {
  let n, o, s, l, a, r, u, c, g, f, A, _, k, S, T, v, P, O, D, p, C, Z, q, x, X, oe, ae, $, ee, { playerApiUrl: ue = "https://api.beyondwords.io/v1/projects/{id}/player" } = e, { projectId: Ae = void 0 } = e, { contentId: ce = void 0 } = e, { playlistId: ye = void 0 } = e, { sourceId: re = void 0 } = e, { sourceUrl: b = void 0 } = e, { playlist: w = [] } = e, { loadContentAs: R = ["article"] } = e, { contentVariant: L = R[0] } = e, { clientSideEnabled: Ve = !1 } = e, { showUserInterface: Le = !0 } = e, { showBottomWidget: Qe = !1 } = e, { playerStyle: j = "standard" } = e, { playerTitle: he = void 0 } = e, { callToAction: ze = void 0 } = e, { skipButtonStyle: Re = "auto" } = e, { playlistStyle: Ge = "auto-5-4" } = e, { playlistToggle: Me = "auto" } = e, { downloadFormats: nt = [] } = e, { durationFormat: Te = void 0 } = e, { mediaSession: Je = "auto" } = e, { content: Ce = [] } = e, { contentIndex: Lt = 0 } = e, { introsOutros: Ee = [] } = e, { introsOutrosIndex: ft = -1 } = e, { adverts: Oe = [] } = e, { advertIndex: qe = -1 } = e, { preloadAdvertIndex: Nt = -1 } = e, { minDurationForMidroll: De = 2 * 60 } = e, { minTimeUntilEndForMidroll: St = 10 } = e, { persistentAdImage: Ye = !1 } = e, { persistentIndex: At = -1 } = e, { duration: $e = 0 } = e, { currentTime: mt = 0 } = e, { playbackState: Ze = "stopped" } = e, { playbackRate: xe = 1 } = e, { playbackRates: yt = [0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 2, 2.5, 3] } = e, { widgetStyle: et = "standard" } = e, { widgetPosition: lt = "auto" } = e, { widgetWidth: ot = "auto" } = e, { widgetMargin: Pt = "16px" } = e, { widgetTarget: Xe = void 0 } = e, { textColor: Ot = "#111" } = e, { backgroundColor: vt = "#f5f5f5" } = e, { iconColor: Vt = "rgba(0, 0, 0, 0.8)" } = e, { highlightColor: wt = "#eee" } = e, { videoTextColor: tt = "white" } = e, { videoBackgroundColor: at = "black" } = e, { videoIconColor: Bt = "white" } = e, { logoIconEnabled: bt = !0 } = e, { highlightSections: kt = "all" } = e, { clickableSections: Ke = "all" } = e, { segmentWidgetSections: rt = "body" } = e, { segmentWidgetPosition: pt = "7-oclock" } = e, { currentSegment: st = void 0 } = e, { hoveredSegment: it = void 0 } = e, { loadedMedia: He = void 0 } = e, { previewToken: ht = void 0 } = e, { advertConsent: Tt = "personalized" } = e, { analyticsConsent: U = "allowed" } = e, { analyticsCustomUrl: ut = void 0 } = e, { analyticsDeviceType: te = "auto" } = e, { analyticsTag: I = void 0 } = e, { captureErrors: B = !0 } = e, { onError: le = () => {
  } } = e, { transitions: K = [] } = e, { controlPanel: jt = void 0 } = e;
  const dn = (...m) => Rt.addEventListener(...m), Et = (...m) => Rt.removeEventListener(...m);
  let { initialProps: Ti = {} } = e, { showMediaSession: ri = !1 } = e, { metadataLoaded: ui = !1 } = e, { isFullScreen: qt = !1 } = e, { mediaElement: fi = void 0 } = e, { userInterface: ki = void 0 } = e, { widgetInterface: Kt = void 0 } = e, { controller: Rt = void 0 } = e, { logoImagePosition: Ci = void 0 } = e, { analyticsUrl: zi = void 0 } = e, { analyticsId: ci = void 0 } = e, { platform: Ft = "web" } = e, { vendorIdentifier: Ii = void 0 } = e, { bundleIdentifier: ni = void 0 } = e, { contentLanguage: Ct = "en" } = e, { listenSessionId: oi = void 0 } = e, { sessionCreatedAt: It = void 0 } = e, { companionAdvert: Oi = void 0 } = e, { isNewListen: Wt = !1 } = e, { prevPercentage: N = 0 } = e, { segmentWidgets: G = [] } = e, { segmentContainers: fe = new _l((m) => i(51, G = m)) } = e, { segmentClickables: Ht = new ml() } = e, { segmentHighlights: Li = new Al() } = e;
  const Ri = (m) => Rt.processEvent(Jt({ emittedFrom: D }, m)), gn = () => i(113, x = it);
  function Wo(m) {
    se[m ? "unshift" : "push"](() => {
      fi = m, i(47, fi);
    });
  }
  function In(m) {
    Ze = m, i(12, Ze);
  }
  function Mo(m) {
    $e = m, i(33, $e);
  }
  function di(m) {
    mt = m, i(11, mt);
  }
  function fn(m) {
    xe = m, i(34, xe);
  }
  function mn(m) {
    N = m, i(50, N);
  }
  function hn(m) {
    ui = m, i(24, ui);
  }
  function _n(m) {
    se[m ? "unshift" : "push"](() => {
      ki = m, i(48, ki);
    });
  }
  function An(m) {
    se[m ? "unshift" : "push"](() => {
      Kt = m, i(49, Kt);
    });
  }
  const Eo = (m) => Ri(en(Jt({}, m), {
    emittedFrom: "segment-widget",
    widgetSegment: ae,
    widgetIsCurrent: $
  }));
  function On(m) {
    jt = m, i(23, jt);
  }
  function zo(m) {
    Ae = m, i(0, Ae);
  }
  function ji(m) {
    ce = m, i(1, ce);
  }
  function Lo(m) {
    ye = m, i(2, ye);
  }
  function io(m) {
    re = m, i(3, re);
  }
  function jo(m) {
    b = m, i(4, b);
  }
  function Do(m) {
    Le = m, i(5, Le);
  }
  function Qi(m) {
    j = m, i(6, j);
  }
  function no(m) {
    he = m, i(26, he);
  }
  function $i(m) {
    ze = m, i(27, ze);
  }
  function oo(m) {
    Re = m, i(28, Re);
  }
  function xo(m) {
    Ge = m, i(29, Ge);
  }
  function yn(m) {
    Me = m, i(30, Me);
  }
  function Gt(m) {
    Je = m, i(31, Je);
  }
  function Ns(m) {
    Lt = m, i(7, Lt);
  }
  function Vn(m) {
    ft = m, i(8, ft);
  }
  function si(m) {
    qe = m, i(9, qe);
  }
  function No(m) {
    Ye = m, i(32, Ye);
  }
  function jn(m) {
    At = m, i(10, At);
  }
  function Vi(m) {
    $e = m, i(33, $e);
  }
  function _e(m) {
    mt = m, i(11, mt);
  }
  function ct(m) {
    Ze = m, i(12, Ze);
  }
  function Mt(m) {
    xe = m, i(34, xe);
  }
  function Ro(m) {
    et = m, i(13, et);
  }
  function wu(m) {
    lt = m, i(35, lt);
  }
  function Tu(m) {
    ot = m, i(36, ot);
  }
  function Cu(m) {
    Pt = m, i(37, Pt);
  }
  function Iu(m) {
    Xe = m, i(14, Xe);
  }
  function Ou(m) {
    Ot = m, i(38, Ot);
  }
  function Vu(m) {
    vt = m, i(39, vt);
  }
  function Bu(m) {
    Vt = m, i(40, Vt);
  }
  function Wu(m) {
    wt = m, i(15, wt);
  }
  function Mu(m) {
    tt = m, i(41, tt);
  }
  function Eu(m) {
    Bt = m, i(42, Bt);
  }
  function zu(m) {
    bt = m, i(43, bt);
  }
  function Lu(m) {
    kt = m, i(16, kt);
  }
  function ju(m) {
    Ke = m, i(17, Ke);
  }
  function Du(m) {
    rt = m, i(18, rt);
  }
  function xu(m) {
    pt = m, i(19, pt);
  }
  function Nu(m) {
    st = m, i(20, st);
  }
  function Ru(m) {
    it = m, i(21, it);
  }
  function Fu(m) {
    Tt = m, i(22, Tt);
  }
  function Uu(m) {
    U = m, i(44, U);
  }
  function Hu(m) {
    ut = m, i(45, ut);
  }
  function qu(m) {
    I = m, i(46, I);
  }
  return t.$$set = (m) => {
    "playerApiUrl" in m && i(86, ue = m.playerApiUrl), "projectId" in m && i(0, Ae = m.projectId), "contentId" in m && i(1, ce = m.contentId), "playlistId" in m && i(2, ye = m.playlistId), "sourceId" in m && i(3, re = m.sourceId), "sourceUrl" in m && i(4, b = m.sourceUrl), "playlist" in m && i(87, w = m.playlist), "loadContentAs" in m && i(88, R = m.loadContentAs), "contentVariant" in m && i(25, L = m.contentVariant), "clientSideEnabled" in m && i(89, Ve = m.clientSideEnabled), "showUserInterface" in m && i(5, Le = m.showUserInterface), "showBottomWidget" in m && i(90, Qe = m.showBottomWidget), "playerStyle" in m && i(6, j = m.playerStyle), "playerTitle" in m && i(26, he = m.playerTitle), "callToAction" in m && i(27, ze = m.callToAction), "skipButtonStyle" in m && i(28, Re = m.skipButtonStyle), "playlistStyle" in m && i(29, Ge = m.playlistStyle), "playlistToggle" in m && i(30, Me = m.playlistToggle), "downloadFormats" in m && i(52, nt = m.downloadFormats), "durationFormat" in m && i(53, Te = m.durationFormat), "mediaSession" in m && i(31, Je = m.mediaSession), "content" in m && i(54, Ce = m.content), "contentIndex" in m && i(7, Lt = m.contentIndex), "introsOutros" in m && i(55, Ee = m.introsOutros), "introsOutrosIndex" in m && i(8, ft = m.introsOutrosIndex), "adverts" in m && i(56, Oe = m.adverts), "advertIndex" in m && i(9, qe = m.advertIndex), "preloadAdvertIndex" in m && i(91, Nt = m.preloadAdvertIndex), "minDurationForMidroll" in m && i(92, De = m.minDurationForMidroll), "minTimeUntilEndForMidroll" in m && i(93, St = m.minTimeUntilEndForMidroll), "persistentAdImage" in m && i(32, Ye = m.persistentAdImage), "persistentIndex" in m && i(10, At = m.persistentIndex), "duration" in m && i(33, $e = m.duration), "currentTime" in m && i(11, mt = m.currentTime), "playbackState" in m && i(12, Ze = m.playbackState), "playbackRate" in m && i(34, xe = m.playbackRate), "playbackRates" in m && i(57, yt = m.playbackRates), "widgetStyle" in m && i(13, et = m.widgetStyle), "widgetPosition" in m && i(35, lt = m.widgetPosition), "widgetWidth" in m && i(36, ot = m.widgetWidth), "widgetMargin" in m && i(37, Pt = m.widgetMargin), "widgetTarget" in m && i(14, Xe = m.widgetTarget), "textColor" in m && i(38, Ot = m.textColor), "backgroundColor" in m && i(39, vt = m.backgroundColor), "iconColor" in m && i(40, Vt = m.iconColor), "highlightColor" in m && i(15, wt = m.highlightColor), "videoTextColor" in m && i(41, tt = m.videoTextColor), "videoBackgroundColor" in m && i(58, at = m.videoBackgroundColor), "videoIconColor" in m && i(42, Bt = m.videoIconColor), "logoIconEnabled" in m && i(43, bt = m.logoIconEnabled), "highlightSections" in m && i(16, kt = m.highlightSections), "clickableSections" in m && i(17, Ke = m.clickableSections), "segmentWidgetSections" in m && i(18, rt = m.segmentWidgetSections), "segmentWidgetPosition" in m && i(19, pt = m.segmentWidgetPosition), "currentSegment" in m && i(20, st = m.currentSegment), "hoveredSegment" in m && i(21, it = m.hoveredSegment), "loadedMedia" in m && i(94, He = m.loadedMedia), "previewToken" in m && i(95, ht = m.previewToken), "advertConsent" in m && i(22, Tt = m.advertConsent), "analyticsConsent" in m && i(44, U = m.analyticsConsent), "analyticsCustomUrl" in m && i(45, ut = m.analyticsCustomUrl), "analyticsDeviceType" in m && i(96, te = m.analyticsDeviceType), "analyticsTag" in m && i(46, I = m.analyticsTag), "captureErrors" in m && i(97, B = m.captureErrors), "onError" in m && i(98, le = m.onError), "transitions" in m && i(99, K = m.transitions), "controlPanel" in m && i(23, jt = m.controlPanel), "initialProps" in m && i(102, Ti = m.initialProps), "showMediaSession" in m && i(59, ri = m.showMediaSession), "metadataLoaded" in m && i(24, ui = m.metadataLoaded), "isFullScreen" in m && i(60, qt = m.isFullScreen), "mediaElement" in m && i(47, fi = m.mediaElement), "userInterface" in m && i(48, ki = m.userInterface), "widgetInterface" in m && i(49, Kt = m.widgetInterface), "controller" in m && i(103, Rt = m.controller), "logoImagePosition" in m && i(61, Ci = m.logoImagePosition), "analyticsUrl" in m && i(104, zi = m.analyticsUrl), "analyticsId" in m && i(105, ci = m.analyticsId), "platform" in m && i(62, Ft = m.platform), "vendorIdentifier" in m && i(63, Ii = m.vendorIdentifier), "bundleIdentifier" in m && i(64, ni = m.bundleIdentifier), "contentLanguage" in m && i(65, Ct = m.contentLanguage), "listenSessionId" in m && i(106, oi = m.listenSessionId), "sessionCreatedAt" in m && i(107, It = m.sessionCreatedAt), "companionAdvert" in m && i(66, Oi = m.companionAdvert), "isNewListen" in m && i(108, Wt = m.isNewListen), "prevPercentage" in m && i(50, N = m.prevPercentage), "segmentWidgets" in m && i(51, G = m.segmentWidgets), "segmentContainers" in m && i(109, fe = m.segmentContainers), "segmentClickables" in m && i(110, Ht = m.segmentClickables), "segmentHighlights" in m && i(111, Li = m.segmentHighlights);
  }, t.$$.update = () => {
    t.$$.dirty[0] & /*contentIndex*/
    128 | t.$$.dirty[1] & /*content*/
    8388608 && i(72, n = Ce[Lt]), t.$$.dirty[0] & /*introsOutrosIndex*/
    256 | t.$$.dirty[1] & /*introsOutros*/
    16777216 && i(69, o = Ee[ft]), t.$$.dirty[0] & /*advertIndex*/
    512 | t.$$.dirty[1] & /*adverts*/
    33554432 && i(70, s = Oe[qe]), t.$$.dirty[1] & /*adverts*/
    33554432 | t.$$.dirty[2] & /*preloadAdvertIndex*/
    536870912 && i(85, l = Oe[Nt]), t.$$.dirty[0] & /*persistentIndex*/
    1024 | t.$$.dirty[1] & /*adverts*/
    33554432 && i(84, a = Oe[At]), t.$$.dirty[0] & /*playbackState*/
    4096 | t.$$.dirty[2] & /*activeAdvert*/
    256 && i(115, r = s && Ze !== "stopped"), t.$$.dirty[3] & /*loadedMedia*/
    2 && i(117, u = (He == null ? void 0 : He.format) === "audio"), t.$$.dirty[1] & /*adverts*/
    33554432 && i(121, c = Oe.some((m) => Sr(m.vastUrl))), t.$$.dirty[0] & /*advertConsent*/
    4194304 | t.$$.dirty[3] & /*hasDaxAdverts*/
    268435456 && i(83, g = c && Tt === "personalized"), t.$$.dirty[0] & /*playerStyle*/
    64 | t.$$.dirty[1] & /*isFullScreen*/
    536870912 && i(75, f = qt ? "video" : j), t.$$.dirty[0] & /*widgetTarget*/
    16384 && i(14, Xe = vl(Xe, "widget")), t.$$.dirty[0] & /*widgetTarget*/
    16384 | t.$$.dirty[2] & /*showBottomWidget*/
    268435456 && i(118, A = Qe || Xe), t.$$.dirty[2] & /*interfaceStyle*/
    8192 && i(120, _ = f === "screen"), t.$$.dirty[2] & /*interfaceStyle*/
    8192 && i(119, k = f === "large"), t.$$.dirty[3] & /*isScreen, isLarge*/
    201326592 && i(82, S = _ ? 120 : k ? 80 : 0), t.$$.dirty[0] & /*showUserInterface*/
    32 | t.$$.dirty[1] & /*content*/
    8388608 | t.$$.dirty[2] & /*interfaceStyle*/
    8192 && i(81, T = Le && bl(f) && Ce.length > 0), t.$$.dirty[0] & /*showUserInterface, widgetStyle*/
    8224 | t.$$.dirty[1] & /*content*/
    8388608 | t.$$.dirty[3] & /*showWidget*/
    33554432 && i(80, v = Le && A && bl(et) && Ce.length > 0), t.$$.dirty[0] & /*controlPanel*/
    8388608 && i(23, jt = vl(jt, "control panel")), t.$$.dirty[0] & /*widgetStyle*/
    8192 | t.$$.dirty[1] & /*isFullScreen*/
    536870912 | t.$$.dirty[3] & /*showWidget*/
    33554432 && i(74, P = A && et === "video" && !qt), t.$$.dirty[2] & /*interfaceStyle, videoBehindWidget*/
    12288 && i(79, O = f === "video" && !P), t.$$.dirty[2] & /*videoBehindWidget*/
    4096 && (D = P ? "bottom-widget" : "inline-player"), t.$$.dirty[0] & /*playerStyle, widgetStyle*/
    8256 && i(73, p = j === "video" || et === "video"), t.$$.dirty[0] & /*widgetTarget*/
    16384 | t.$$.dirty[2] & /*videoBehindWidget*/
    4096 && i(78, C = P ? Xe : null), t.$$.dirty[0] & /*metadataLoaded*/
    16777216 | t.$$.dirty[2] & /*videoMightBeShown*/
    2048 | t.$$.dirty[3] & /*isAudio*/
    16777216 && i(116, Z = u && p && ui), t.$$.dirty[2] & /*activeAdvert, contentItem*/
    1280 | t.$$.dirty[3] & /*showVideoPoster, isAdvert*/
    12582912 && i(77, q = Z ? r && (s == null ? void 0 : s.imageUrl) || (n == null ? void 0 : n.imageUrl) : ""), t.$$.dirty[0] & /*projectId, contentId, playlistId, sourceId, sourceUrl*/
    31 | t.$$.dirty[2] & /*playlist*/
    33554432 | t.$$.dirty[3] & /*previewToken*/
    4 && Ri(y3()), t.$$.dirty[2] & /*loadContentAs*/
    67108864 && i(25, L = R[0]), t.$$.dirty[0] & /*hoveredSegment*/
    2097152 | t.$$.dirty[3] & /*lastHovered*/
    1048576 && i(113, x = it || x), t.$$.dirty[0] & /*currentSegment, segmentWidgetSections*/
    1310720 && i(112, X = yo("current", st, rt)), t.$$.dirty[0] & /*currentSegment*/
    1048576 | t.$$.dirty[3] & /*currentAllowedInWidget*/
    524288 && X && gn(), t.$$.dirty[0] & /*segmentWidgetSections*/
    262144 | t.$$.dirty[3] & /*lastHovered*/
    1048576 && i(114, oe = yo("hovered", x, rt)), t.$$.dirty[0] & /*currentSegment*/
    1048576 | t.$$.dirty[3] & /*hoveredAllowedInWidget, lastHovered, currentAllowedInWidget*/
    3670016 && i(68, ae = oe && x || X && st), t.$$.dirty[0] & /*currentSegment*/
    1048576 | t.$$.dirty[2] & /*widgetSegment*/
    64 && i(71, $ = (ae == null ? void 0 : ae.marker) === (st == null ? void 0 : st.marker)), t.$$.dirty[2] & /*widgetIsCurrent, activeAdvert, introOrOutro*/
    896 && i(76, ee = $ || s || o), t.$$.dirty[0] & /*segmentWidgetSections, segmentWidgetPosition, playerStyle*/
    786496 | t.$$.dirty[2] & /*widgetSegment*/
    64 | t.$$.dirty[3] & /*segmentContainers*/
    65536 && fe.update(ae, rt, pt, j), t.$$.dirty[0] & /*hoveredSegment, clickableSections*/
    2228224 | t.$$.dirty[3] & /*segmentClickables*/
    131072 && Ht.update(it, Ke), t.$$.dirty[0] & /*currentSegment, highlightSections, highlightColor*/
    1146880 | t.$$.dirty[3] & /*segmentHighlights*/
    262144 && Li.update("current", st, kt, wt), t.$$.dirty[0] & /*hoveredSegment, highlightSections, highlightColor*/
    2195456 | t.$$.dirty[3] & /*segmentHighlights*/
    262144 && Li.update("hovered", it, kt, wt), t.$$.dirty[0] & /*currentTime*/
    2048 | t.$$.dirty[3] & /*transitions, controller*/
    1088 && v3(K, Rt, mt);
  }, [
    Ae,
    ce,
    ye,
    re,
    b,
    Le,
    j,
    Lt,
    ft,
    qe,
    At,
    mt,
    Ze,
    et,
    Xe,
    wt,
    kt,
    Ke,
    rt,
    pt,
    st,
    it,
    Tt,
    jt,
    ui,
    L,
    he,
    ze,
    Re,
    Ge,
    Me,
    Je,
    Ye,
    $e,
    xe,
    lt,
    ot,
    Pt,
    Ot,
    vt,
    Vt,
    tt,
    Bt,
    bt,
    U,
    ut,
    I,
    fi,
    ki,
    Kt,
    N,
    G,
    nt,
    Te,
    Ce,
    Ee,
    Oe,
    yt,
    at,
    ri,
    qt,
    Ci,
    Ft,
    Ii,
    ni,
    Ct,
    Oi,
    Ri,
    ae,
    o,
    s,
    $,
    n,
    p,
    P,
    f,
    ee,
    q,
    C,
    O,
    v,
    T,
    S,
    g,
    a,
    l,
    ue,
    w,
    R,
    Ve,
    Qe,
    Nt,
    De,
    St,
    He,
    ht,
    te,
    B,
    le,
    K,
    dn,
    Et,
    Ti,
    Rt,
    zi,
    ci,
    oi,
    It,
    Wt,
    fe,
    Ht,
    Li,
    X,
    x,
    oe,
    r,
    Z,
    u,
    A,
    k,
    _,
    c,
    Wo,
    In,
    Mo,
    di,
    fn,
    mn,
    hn,
    _n,
    An,
    Eo,
    On,
    zo,
    ji,
    Lo,
    io,
    jo,
    Do,
    Qi,
    no,
    $i,
    oo,
    xo,
    yn,
    Gt,
    Ns,
    Vn,
    si,
    No,
    jn,
    Vi,
    _e,
    ct,
    Mt,
    Ro,
    wu,
    Tu,
    Cu,
    Iu,
    Ou,
    Vu,
    Bu,
    Wu,
    Mu,
    Eu,
    zu,
    Lu,
    ju,
    Du,
    xu,
    Nu,
    Ru,
    Fu,
    Uu,
    Hu,
    qu
  ];
}
let E3 = class extends we {
  constructor(e) {
    super(), Pe(
      this,
      e,
      M3,
      W3,
      pe,
      {
        playerApiUrl: 86,
        projectId: 0,
        contentId: 1,
        playlistId: 2,
        sourceId: 3,
        sourceUrl: 4,
        playlist: 87,
        loadContentAs: 88,
        contentVariant: 25,
        clientSideEnabled: 89,
        showUserInterface: 5,
        showBottomWidget: 90,
        playerStyle: 6,
        playerTitle: 26,
        callToAction: 27,
        skipButtonStyle: 28,
        playlistStyle: 29,
        playlistToggle: 30,
        downloadFormats: 52,
        durationFormat: 53,
        mediaSession: 31,
        content: 54,
        contentIndex: 7,
        introsOutros: 55,
        introsOutrosIndex: 8,
        adverts: 56,
        advertIndex: 9,
        preloadAdvertIndex: 91,
        minDurationForMidroll: 92,
        minTimeUntilEndForMidroll: 93,
        persistentAdImage: 32,
        persistentIndex: 10,
        duration: 33,
        currentTime: 11,
        playbackState: 12,
        playbackRate: 34,
        playbackRates: 57,
        widgetStyle: 13,
        widgetPosition: 35,
        widgetWidth: 36,
        widgetMargin: 37,
        widgetTarget: 14,
        textColor: 38,
        backgroundColor: 39,
        iconColor: 40,
        highlightColor: 15,
        videoTextColor: 41,
        videoBackgroundColor: 58,
        videoIconColor: 42,
        logoIconEnabled: 43,
        highlightSections: 16,
        clickableSections: 17,
        segmentWidgetSections: 18,
        segmentWidgetPosition: 19,
        currentSegment: 20,
        hoveredSegment: 21,
        loadedMedia: 94,
        previewToken: 95,
        advertConsent: 22,
        analyticsConsent: 44,
        analyticsCustomUrl: 45,
        analyticsDeviceType: 96,
        analyticsTag: 46,
        captureErrors: 97,
        onError: 98,
        transitions: 99,
        controlPanel: 23,
        addEventListener: 100,
        removeEventListener: 101,
        initialProps: 102,
        showMediaSession: 59,
        metadataLoaded: 24,
        isFullScreen: 60,
        mediaElement: 47,
        userInterface: 48,
        widgetInterface: 49,
        controller: 103,
        logoImagePosition: 61,
        analyticsUrl: 104,
        analyticsId: 105,
        platform: 62,
        vendorIdentifier: 63,
        bundleIdentifier: 64,
        contentLanguage: 65,
        listenSessionId: 106,
        sessionCreatedAt: 107,
        companionAdvert: 66,
        isNewListen: 108,
        prevPercentage: 50,
        segmentWidgets: 51,
        segmentContainers: 109,
        segmentClickables: 110,
        segmentHighlights: 111,
        onEvent: 67
      },
      null,
      [-1, -1, -1, -1, -1, -1]
    );
  }
  get playerApiUrl() {
    return this.$$.ctx[86];
  }
  set playerApiUrl(e) {
    this.$$set({ playerApiUrl: e }), d();
  }
  get projectId() {
    return this.$$.ctx[0];
  }
  set projectId(e) {
    this.$$set({ projectId: e }), d();
  }
  get contentId() {
    return this.$$.ctx[1];
  }
  set contentId(e) {
    this.$$set({ contentId: e }), d();
  }
  get playlistId() {
    return this.$$.ctx[2];
  }
  set playlistId(e) {
    this.$$set({ playlistId: e }), d();
  }
  get sourceId() {
    return this.$$.ctx[3];
  }
  set sourceId(e) {
    this.$$set({ sourceId: e }), d();
  }
  get sourceUrl() {
    return this.$$.ctx[4];
  }
  set sourceUrl(e) {
    this.$$set({ sourceUrl: e }), d();
  }
  get playlist() {
    return this.$$.ctx[87];
  }
  set playlist(e) {
    this.$$set({ playlist: e }), d();
  }
  get loadContentAs() {
    return this.$$.ctx[88];
  }
  set loadContentAs(e) {
    this.$$set({ loadContentAs: e }), d();
  }
  get contentVariant() {
    return this.$$.ctx[25];
  }
  set contentVariant(e) {
    this.$$set({ contentVariant: e }), d();
  }
  get clientSideEnabled() {
    return this.$$.ctx[89];
  }
  set clientSideEnabled(e) {
    this.$$set({ clientSideEnabled: e }), d();
  }
  get showUserInterface() {
    return this.$$.ctx[5];
  }
  set showUserInterface(e) {
    this.$$set({ showUserInterface: e }), d();
  }
  get showBottomWidget() {
    return this.$$.ctx[90];
  }
  set showBottomWidget(e) {
    this.$$set({ showBottomWidget: e }), d();
  }
  get playerStyle() {
    return this.$$.ctx[6];
  }
  set playerStyle(e) {
    this.$$set({ playerStyle: e }), d();
  }
  get playerTitle() {
    return this.$$.ctx[26];
  }
  set playerTitle(e) {
    this.$$set({ playerTitle: e }), d();
  }
  get callToAction() {
    return this.$$.ctx[27];
  }
  set callToAction(e) {
    this.$$set({ callToAction: e }), d();
  }
  get skipButtonStyle() {
    return this.$$.ctx[28];
  }
  set skipButtonStyle(e) {
    this.$$set({ skipButtonStyle: e }), d();
  }
  get playlistStyle() {
    return this.$$.ctx[29];
  }
  set playlistStyle(e) {
    this.$$set({ playlistStyle: e }), d();
  }
  get playlistToggle() {
    return this.$$.ctx[30];
  }
  set playlistToggle(e) {
    this.$$set({ playlistToggle: e }), d();
  }
  get downloadFormats() {
    return this.$$.ctx[52];
  }
  set downloadFormats(e) {
    this.$$set({ downloadFormats: e }), d();
  }
  get durationFormat() {
    return this.$$.ctx[53];
  }
  set durationFormat(e) {
    this.$$set({ durationFormat: e }), d();
  }
  get mediaSession() {
    return this.$$.ctx[31];
  }
  set mediaSession(e) {
    this.$$set({ mediaSession: e }), d();
  }
  get content() {
    return this.$$.ctx[54];
  }
  set content(e) {
    this.$$set({ content: e }), d();
  }
  get contentIndex() {
    return this.$$.ctx[7];
  }
  set contentIndex(e) {
    this.$$set({ contentIndex: e }), d();
  }
  get introsOutros() {
    return this.$$.ctx[55];
  }
  set introsOutros(e) {
    this.$$set({ introsOutros: e }), d();
  }
  get introsOutrosIndex() {
    return this.$$.ctx[8];
  }
  set introsOutrosIndex(e) {
    this.$$set({ introsOutrosIndex: e }), d();
  }
  get adverts() {
    return this.$$.ctx[56];
  }
  set adverts(e) {
    this.$$set({ adverts: e }), d();
  }
  get advertIndex() {
    return this.$$.ctx[9];
  }
  set advertIndex(e) {
    this.$$set({ advertIndex: e }), d();
  }
  get preloadAdvertIndex() {
    return this.$$.ctx[91];
  }
  set preloadAdvertIndex(e) {
    this.$$set({ preloadAdvertIndex: e }), d();
  }
  get minDurationForMidroll() {
    return this.$$.ctx[92];
  }
  set minDurationForMidroll(e) {
    this.$$set({ minDurationForMidroll: e }), d();
  }
  get minTimeUntilEndForMidroll() {
    return this.$$.ctx[93];
  }
  set minTimeUntilEndForMidroll(e) {
    this.$$set({ minTimeUntilEndForMidroll: e }), d();
  }
  get persistentAdImage() {
    return this.$$.ctx[32];
  }
  set persistentAdImage(e) {
    this.$$set({ persistentAdImage: e }), d();
  }
  get persistentIndex() {
    return this.$$.ctx[10];
  }
  set persistentIndex(e) {
    this.$$set({ persistentIndex: e }), d();
  }
  get duration() {
    return this.$$.ctx[33];
  }
  set duration(e) {
    this.$$set({ duration: e }), d();
  }
  get currentTime() {
    return this.$$.ctx[11];
  }
  set currentTime(e) {
    this.$$set({ currentTime: e }), d();
  }
  get playbackState() {
    return this.$$.ctx[12];
  }
  set playbackState(e) {
    this.$$set({ playbackState: e }), d();
  }
  get playbackRate() {
    return this.$$.ctx[34];
  }
  set playbackRate(e) {
    this.$$set({ playbackRate: e }), d();
  }
  get playbackRates() {
    return this.$$.ctx[57];
  }
  set playbackRates(e) {
    this.$$set({ playbackRates: e }), d();
  }
  get widgetStyle() {
    return this.$$.ctx[13];
  }
  set widgetStyle(e) {
    this.$$set({ widgetStyle: e }), d();
  }
  get widgetPosition() {
    return this.$$.ctx[35];
  }
  set widgetPosition(e) {
    this.$$set({ widgetPosition: e }), d();
  }
  get widgetWidth() {
    return this.$$.ctx[36];
  }
  set widgetWidth(e) {
    this.$$set({ widgetWidth: e }), d();
  }
  get widgetMargin() {
    return this.$$.ctx[37];
  }
  set widgetMargin(e) {
    this.$$set({ widgetMargin: e }), d();
  }
  get widgetTarget() {
    return this.$$.ctx[14];
  }
  set widgetTarget(e) {
    this.$$set({ widgetTarget: e }), d();
  }
  get textColor() {
    return this.$$.ctx[38];
  }
  set textColor(e) {
    this.$$set({ textColor: e }), d();
  }
  get backgroundColor() {
    return this.$$.ctx[39];
  }
  set backgroundColor(e) {
    this.$$set({ backgroundColor: e }), d();
  }
  get iconColor() {
    return this.$$.ctx[40];
  }
  set iconColor(e) {
    this.$$set({ iconColor: e }), d();
  }
  get highlightColor() {
    return this.$$.ctx[15];
  }
  set highlightColor(e) {
    this.$$set({ highlightColor: e }), d();
  }
  get videoTextColor() {
    return this.$$.ctx[41];
  }
  set videoTextColor(e) {
    this.$$set({ videoTextColor: e }), d();
  }
  get videoBackgroundColor() {
    return this.$$.ctx[58];
  }
  set videoBackgroundColor(e) {
    this.$$set({ videoBackgroundColor: e }), d();
  }
  get videoIconColor() {
    return this.$$.ctx[42];
  }
  set videoIconColor(e) {
    this.$$set({ videoIconColor: e }), d();
  }
  get logoIconEnabled() {
    return this.$$.ctx[43];
  }
  set logoIconEnabled(e) {
    this.$$set({ logoIconEnabled: e }), d();
  }
  get highlightSections() {
    return this.$$.ctx[16];
  }
  set highlightSections(e) {
    this.$$set({ highlightSections: e }), d();
  }
  get clickableSections() {
    return this.$$.ctx[17];
  }
  set clickableSections(e) {
    this.$$set({ clickableSections: e }), d();
  }
  get segmentWidgetSections() {
    return this.$$.ctx[18];
  }
  set segmentWidgetSections(e) {
    this.$$set({ segmentWidgetSections: e }), d();
  }
  get segmentWidgetPosition() {
    return this.$$.ctx[19];
  }
  set segmentWidgetPosition(e) {
    this.$$set({ segmentWidgetPosition: e }), d();
  }
  get currentSegment() {
    return this.$$.ctx[20];
  }
  set currentSegment(e) {
    this.$$set({ currentSegment: e }), d();
  }
  get hoveredSegment() {
    return this.$$.ctx[21];
  }
  set hoveredSegment(e) {
    this.$$set({ hoveredSegment: e }), d();
  }
  get loadedMedia() {
    return this.$$.ctx[94];
  }
  set loadedMedia(e) {
    this.$$set({ loadedMedia: e }), d();
  }
  get previewToken() {
    return this.$$.ctx[95];
  }
  set previewToken(e) {
    this.$$set({ previewToken: e }), d();
  }
  get advertConsent() {
    return this.$$.ctx[22];
  }
  set advertConsent(e) {
    this.$$set({ advertConsent: e }), d();
  }
  get analyticsConsent() {
    return this.$$.ctx[44];
  }
  set analyticsConsent(e) {
    this.$$set({ analyticsConsent: e }), d();
  }
  get analyticsCustomUrl() {
    return this.$$.ctx[45];
  }
  set analyticsCustomUrl(e) {
    this.$$set({ analyticsCustomUrl: e }), d();
  }
  get analyticsDeviceType() {
    return this.$$.ctx[96];
  }
  set analyticsDeviceType(e) {
    this.$$set({ analyticsDeviceType: e }), d();
  }
  get analyticsTag() {
    return this.$$.ctx[46];
  }
  set analyticsTag(e) {
    this.$$set({ analyticsTag: e }), d();
  }
  get captureErrors() {
    return this.$$.ctx[97];
  }
  set captureErrors(e) {
    this.$$set({ captureErrors: e }), d();
  }
  get onError() {
    return this.$$.ctx[98];
  }
  set onError(e) {
    this.$$set({ onError: e }), d();
  }
  get transitions() {
    return this.$$.ctx[99];
  }
  set transitions(e) {
    this.$$set({ transitions: e }), d();
  }
  get controlPanel() {
    return this.$$.ctx[23];
  }
  set controlPanel(e) {
    this.$$set({ controlPanel: e }), d();
  }
  get addEventListener() {
    return this.$$.ctx[100];
  }
  get removeEventListener() {
    return this.$$.ctx[101];
  }
  get initialProps() {
    return this.$$.ctx[102];
  }
  set initialProps(e) {
    this.$$set({ initialProps: e }), d();
  }
  get showMediaSession() {
    return this.$$.ctx[59];
  }
  set showMediaSession(e) {
    this.$$set({ showMediaSession: e }), d();
  }
  get metadataLoaded() {
    return this.$$.ctx[24];
  }
  set metadataLoaded(e) {
    this.$$set({ metadataLoaded: e }), d();
  }
  get isFullScreen() {
    return this.$$.ctx[60];
  }
  set isFullScreen(e) {
    this.$$set({ isFullScreen: e }), d();
  }
  get mediaElement() {
    return this.$$.ctx[47];
  }
  set mediaElement(e) {
    this.$$set({ mediaElement: e }), d();
  }
  get userInterface() {
    return this.$$.ctx[48];
  }
  set userInterface(e) {
    this.$$set({ userInterface: e }), d();
  }
  get widgetInterface() {
    return this.$$.ctx[49];
  }
  set widgetInterface(e) {
    this.$$set({ widgetInterface: e }), d();
  }
  get controller() {
    return this.$$.ctx[103];
  }
  set controller(e) {
    this.$$set({ controller: e }), d();
  }
  get logoImagePosition() {
    return this.$$.ctx[61];
  }
  set logoImagePosition(e) {
    this.$$set({ logoImagePosition: e }), d();
  }
  get analyticsUrl() {
    return this.$$.ctx[104];
  }
  set analyticsUrl(e) {
    this.$$set({ analyticsUrl: e }), d();
  }
  get analyticsId() {
    return this.$$.ctx[105];
  }
  set analyticsId(e) {
    this.$$set({ analyticsId: e }), d();
  }
  get platform() {
    return this.$$.ctx[62];
  }
  set platform(e) {
    this.$$set({ platform: e }), d();
  }
  get vendorIdentifier() {
    return this.$$.ctx[63];
  }
  set vendorIdentifier(e) {
    this.$$set({ vendorIdentifier: e }), d();
  }
  get bundleIdentifier() {
    return this.$$.ctx[64];
  }
  set bundleIdentifier(e) {
    this.$$set({ bundleIdentifier: e }), d();
  }
  get contentLanguage() {
    return this.$$.ctx[65];
  }
  set contentLanguage(e) {
    this.$$set({ contentLanguage: e }), d();
  }
  get listenSessionId() {
    return this.$$.ctx[106];
  }
  set listenSessionId(e) {
    this.$$set({ listenSessionId: e }), d();
  }
  get sessionCreatedAt() {
    return this.$$.ctx[107];
  }
  set sessionCreatedAt(e) {
    this.$$set({ sessionCreatedAt: e }), d();
  }
  get companionAdvert() {
    return this.$$.ctx[66];
  }
  set companionAdvert(e) {
    this.$$set({ companionAdvert: e }), d();
  }
  get isNewListen() {
    return this.$$.ctx[108];
  }
  set isNewListen(e) {
    this.$$set({ isNewListen: e }), d();
  }
  get prevPercentage() {
    return this.$$.ctx[50];
  }
  set prevPercentage(e) {
    this.$$set({ prevPercentage: e }), d();
  }
  get segmentWidgets() {
    return this.$$.ctx[51];
  }
  set segmentWidgets(e) {
    this.$$set({ segmentWidgets: e }), d();
  }
  get segmentContainers() {
    return this.$$.ctx[109];
  }
  set segmentContainers(e) {
    this.$$set({ segmentContainers: e }), d();
  }
  get segmentClickables() {
    return this.$$.ctx[110];
  }
  set segmentClickables(e) {
    this.$$set({ segmentClickables: e }), d();
  }
  get segmentHighlights() {
    return this.$$.ctx[111];
  }
  set segmentHighlights(e) {
    this.$$set({ segmentHighlights: e }), d();
  }
  get onEvent() {
    return this.$$.ctx[67];
  }
};
const iu = (i, ...n) => Fi(void 0, [i, ...n], function* (t, e = {}) {
  const o = yield fetch(t, e).catch(() => {
  }), s = yield o == null ? void 0 : o.json().catch(() => {
  });
  return (o == null ? void 0 : o.status) !== 200 && wi(`Failed to fetch ${t}`, en(Jt({}, e), {
    responseStatus: o == null ? void 0 : o.status,
    responseJson: s
  })), s;
}), z3 = (t, e) => iu(t, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(e, (i, n) => n === void 0 ? null : n)
});
var Pn, Un, Ps, nu;
class L3 {
  constructor(e, i, n, o) {
    Be(this, Pn);
    Be(this, Ps);
    this.baseUrl = e == null ? void 0 : e.replace("{id}", i), this.search = new URLSearchParams(), n && (this.headers = {
      "X-Referer": window.location.href,
      "X-Import": !!n
    }), o && this.search.set("preview_token", o);
  }
  byContentId(e) {
    return F(this, Pn, Un).call(this, `by_content_id/${e}`);
  }
  byPlaylistId(e) {
    return F(this, Pn, Un).call(this, `by_playlist_id/${e}`);
  }
  bySourceId(e) {
    return F(this, Pn, Un).call(this, `by_source_id/${e}`);
  }
  bySourceUrl(e) {
    return F(this, Pn, Un).call(this, `by_source_url/${encodeURIComponent(e)}`);
  }
  byIdentifiers(e) {
    return F(this, Pn, Un).call(this, `by_identifiers/${encodeURIComponent(JSON.stringify(e))}`);
  }
}
Pn = new WeakSet(), Un = function(e) {
  return iu(`${this.baseUrl}/${e}${F(this, Ps, nu).call(this)}`, { headers: this.headers });
}, Ps = new WeakSet(), nu = function() {
  return this.search.size ? `?${this.search}` : "";
};
const kl = (t) => typeof t != "object" || t === null ? t : Array.isArray(t) ? t.map(kl) : Object.fromEntries(Object.entries(t).map(([e, i]) => [e.replace(/([A-Z])/g, (n) => `_${n.toLowerCase()}`), kl(i)])), ou = (t) => t === "dark" || t === "auto" && j3() ? "dark" : "light", j3 = () => window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches, D3 = (t) => Fi(void 0, null, function* () {
  const e = new L3(t.playerApiUrl, t.projectId, t.clientSideEnabled, t.previewToken);
  if (!t.playerApiUrl || !t.projectId)
    return;
  const i = x3(t);
  if (i.length === 0) {
    t.sourceUrl = window.location.href;
    return;
  }
  const n = yield N3(e, i).catch(() => {
  });
  if (!(n != null && n.content)) {
    R3(t);
    return;
  }
  U3(t, n), F3(t);
}), x3 = (t) => {
  const e = [];
  return t.contentId && e.push({ content_id: t.contentId }), t.playlistId && e.push({ playlist_id: t.playlistId }), t.sourceId && e.push({ source_id: t.sourceId }), t.sourceUrl && e.push({ source_url: t.sourceUrl }), t.playlist && e.push(...kl(t.playlist)), [...new Set(e.map(JSON.stringify))].map(JSON.parse);
}, N3 = (t, e) => {
  const i = e[0];
  if (e.length > 1)
    return t.byIdentifiers(e);
  if (i.content_id)
    return t.byContentId(i.content_id);
  if (i.playlist_id)
    return t.byPlaylistId(i.playlist_id);
  if (i.source_id)
    return t.bySourceId(i.source_id);
  if (i.source_url)
    return t.bySourceUrl(i.source_url);
}, R3 = (t) => {
  su(t), lu(t), au(t), t.onEvent(ke({
    type: "NoContentAvailable",
    description: "No published and processed content is available for the identifiers.",
    initiatedBy: "browser"
  }));
}, F3 = (t) => {
  t.onEvent(ke({
    type: "ContentAvailable",
    description: "Content was loaded into the player and is ready to be played.",
    initiatedBy: "browser"
  }));
}, U3 = (t, e) => {
  var s, l, a, r, u, c, g, f;
  const i = ou(e.settings.theme), n = e.settings[`${i}_theme`], o = e.settings.video_theme;
  su(t), lu(t, e), au(t, e), je(t, "playerStyle", e.settings.player_style), je(t, "playerTitle", ((s = e.playlist) == null ? void 0 : s.title) || e.settings.player_title), je(t, "callToAction", e.settings.call_to_action === "Listen to this article" ? null : e.settings.call_to_action), je(t, "skipButtonStyle", e.settings.skip_button_style), je(t, "downloadFormats", e.settings.download_button_enabled ? ["mp3"] : []), je(t, "introsOutros", H3(e.settings)), je(t, "persistentAdImage", e.settings.persistent_ad_image), je(
    t,
    "duration",
    t.contentVariant === "summary" ? (u = (r = (a = (l = t.content[t.contentIndex]) == null ? void 0 : l.summarization) == null ? void 0 : a.audio) == null ? void 0 : r[0]) == null ? void 0 : u.duration : (f = (g = (c = t.content[t.contentIndex]) == null ? void 0 : c.audio) == null ? void 0 : g[0]) == null ? void 0 : f.duration
  ), je(t, "widgetStyle", e.settings.widget_style), je(t, "widgetPosition", e.settings.widget_position), je(t, "textColor", n.text_color), je(t, "backgroundColor", n.background_color), je(t, "iconColor", n.icon_color), je(t, "highlightColor", n.highlight_color), je(t, "videoTextColor", o.text_color), je(t, "videoBackgroundColor", o.background_color), je(t, "videoIconColor", o.icon_color), je(t, "logoIconEnabled", e.settings.logo_icon_enabled), je(t, "logoImagePosition", e.video_settings.logo_image_position), je(t, "highlightSections", e.settings.segment_playback_enabled ? "all" : "none"), je(t, "clickableSections", e.settings.segment_playback_enabled ? "all" : "none"), je(t, "segmentWidgetSections", (e.settings.segment_playback_enabled, "none")), je(t, "analyticsConsent", q3(e.settings)), je(t, "analyticsCustomUrl", e.settings.analytics_custom_url), je(t, "analyticsTag", e.settings.analytics_tag), je(t, "analyticsUrl", e.settings.analytics_url), je(t, "analyticsId", e.settings.analytics_id), je(t, "contentLanguage", e.language);
}, su = (t) => {
  je(t, "contentIndex", 0), je(t, "introsOutrosIndex", -1), je(t, "advertIndex", -1), je(t, "persistentIndex", -1), je(t, "duration", 0), je(t, "currentTime", 0), je(t, "playbackState", "stopped"), je(t, "currentSegment", void 0), je(t, "hoveredSegment", void 0);
}, lu = (t, e) => {
  var o;
  const i = (o = e == null ? void 0 : e.settings) == null ? void 0 : o.image_enabled, n = (e == null ? void 0 : e.content) || [];
  je(t, "content", n.map((s) => {
    var l, a, r, u;
    return {
      id: s.id,
      title: s.title,
      imageUrl: i ? ((l = e.playlist) == null ? void 0 : l.image_url) || e.settings.image_url || s.image_url : null,
      sourceId: s.source_id,
      sourceUrl: s.source_url,
      adsEnabled: s.ads_enabled,
      duration: s.audio[0] ? s.audio[0].duration / 1e3 : 0,
      audio: s.audio.map((c) => ({
        id: c.id,
        url: c.url,
        contentType: c.content_type,
        duration: c.duration ? c.duration / 1e3 : 0
      })),
      video: s.video.map((c) => ({
        id: c.id,
        url: c.url,
        contentType: c.content_type,
        duration: c.duration ? c.duration / 1e3 : 0
      })),
      summarization: {
        audio: (r = (((a = s.summarization) == null ? void 0 : a.audio) || []).map((c) => ({
          id: c.id,
          url: c.url,
          contentType: c.content_type,
          duration: c.duration ? c.duration / 1e3 : 0
        }))) != null ? r : [],
        video: (((u = s.summarization) == null ? void 0 : u.video) || []).map((c) => ({
          id: c.id,
          url: c.url,
          contentType: c.content_type,
          duration: c.duration ? c.duration / 1e3 : 0
        }))
      },
      segments: s.segments.map((c) => ({
        text: c.text,
        marker: c.marker,
        xpath: c.xpath,
        md5: c.md5,
        section: c.section,
        startTime: c.start_time ? c.start_time / 1e3 : 0,
        duration: c.duration ? c.duration / 1e3 : 0
      }))
    };
  }));
}, au = (t, e) => {
  var o;
  const i = (o = e == null ? void 0 : e.settings) == null ? void 0 : o.image_enabled, n = (e == null ? void 0 : e.ads) || [];
  je(t, "adverts", n.map((s) => {
    const l = s.type === "vast", a = ou(s.theme), r = s[`${a}_theme`], u = s.video_theme;
    return {
      id: s.id,
      type: s.type,
      placement: s.placement,
      vastUrl: l ? s.vast_url : null,
      clickThroughUrl: l ? null : s.click_through_url,
      imageUrl: i ? s.image_url : null,
      textColor: r == null ? void 0 : r.text_color,
      backgroundColor: r == null ? void 0 : r.background_color,
      iconColor: r == null ? void 0 : r.icon_color,
      videoTextColor: u == null ? void 0 : u.text_color,
      videoBackgroundColor: u == null ? void 0 : u.background_color,
      videoIconColor: u == null ? void 0 : u.icon_color,
      audio: l ? [] : (s.audio || s.media).map((c) => ({
        id: c.id,
        url: c.url,
        contentType: c.content_type,
        duration: c.duration ? c.duration / 1e3 : 0
      })),
      video: l ? [] : (s.video || []).map((c) => ({
        id: c.id,
        url: c.url,
        contentType: c.content_type,
        duration: c.duration ? c.duration / 1e3 : 0
      }))
    };
  }));
}, je = (t, e, i) => {
  var o;
  typeof ((o = t.initialProps) == null ? void 0 : o[e]) != "undefined" || (t[e] = i);
}, H3 = ({ intro_outro_enabled: t, intro_url: e, outro_url: i }) => {
  if (!t)
    return [];
  const n = [];
  return e && n.push({ placement: "pre-roll", audio: [{ url: e }], video: [] }), i && n.push({ placement: "post-roll", audio: [{ url: i }], video: [] }), n;
}, q3 = ({ analytics_enabled: t, analytics_uuid_enabled: e }) => t ? e ? "allowed" : "without-local-storage" : "none", Y3 = (t, e) => Fi(void 0, null, function* () {
  const n = yield (yield fetch(t)).blob(), o = URL.createObjectURL(n), s = document.createElement("a");
  document.body.append(s), s.href = o, s.setAttribute("download", e), s.setAttribute("target", "_blank"), s.click(), s.remove();
}), fs = { vastUrls: /* @__PURE__ */ new Map(), mediaSources: /* @__PURE__ */ new Set() }, Z3 = 6e4, K3 = (t) => {
  t.vastUrl && fs.vastUrls.set(t.vastUrl, Date.now());
  for (const e of [...t.audio || [], ...t.video || []])
    fs.mediaSources.add(e.url);
}, ru = (t) => {
  if (t.vastUrl) {
    const e = fs.vastUrls.get(t.vastUrl) || -1 / 0;
    if (Date.now() - e < Z3)
      return !0;
  }
  for (const e of [...t.audio || [], ...t.video || []])
    if (fs.mediaSources.has(e.url))
      return !0;
  return !1;
}, uu = /* @__PURE__ */ new Set(), G3 = (t) => {
  [...t.audio || [], ...t.video || []].forEach((i) => uu.add(i.url));
}, J3 = (t) => [...t.audio || [], ...t.video || []].some((i) => uu.has(i.url)), ar = ({ introsOutrosIndex: t, adverts: e, advertIndex: i, preloadAdvertIndex: n, content: o = [], contentIndex: s, currentTime: l, atTheStart: a, atTheEnd: r, errored: u, minTimeUntilEndForMidroll: c, minDurationForMidroll: g, contentVariant: f } = {}) => {
  var v;
  const A = e && e[i];
  e:
    if (A) {
      if (u) {
        K3(A);
        break e;
      }
      if (r)
        return G3(A), -1;
      if (!r)
        return i;
    }
  if (!((v = o[s]) != null && v.adsEnabled) || t !== -1)
    return -1;
  const _ = Q3({ content: o, contentIndex: s, currentTime: l, atTheStart: a, atTheEnd: r, minTimeUntilEndForMidroll: c, minDurationForMidroll: g, contentVariant: f });
  let k = -1, S = -1 / 0, T = -1 / 0;
  for (const [P, O] of e.entries()) {
    if (J3(O) || ru(O) || !_.has(O.placement))
      continue;
    const D = X3[O.type] || 0;
    if (D < S)
      continue;
    const p = n === P ? 1 / 0 : Math.random();
    D === S && p < T || (k = P, S = D, T = p);
  }
  return k;
}, X3 = { vast: 1, custom: 0 }, Q3 = ({ content: t, contentIndex: e, currentTime: i, atTheStart: n, atTheEnd: o, minTimeUntilEndForMidroll: s, minDurationForMidroll: l, contentVariant: a }) => {
  const r = e === 0, u = e === t.length - 1, c = t.length > 1, g = c && n && !r, f = t[e].segments, A = f[f.length - 1], _ = c ? null : ey(f, l, a), k = f[_], S = k && i > k.startTime, T = A ? A.startTime + A.duration : 0, v = i > T - s, P = /* @__PURE__ */ new Set();
  return n && P.add("pre-roll"), S && !v && P.add("mid-roll"), g && P.add("mid-roll"), o && u && P.add("post-roll"), g && P.add("post-roll"), P;
}, $3 = 0.5, ey = (t, e, i) => {
  const n = t[t.length - 1];
  if (!n)
    return;
  const o = n.startTime + n.duration;
  if (o < e)
    return;
  const s = o / 2, l = Vl(t, o / 2, i), u = t[l].startTime >= s - $3 ? l : l + 1;
  if (u !== t.length)
    return u;
}, ty = (t, e, i, n) => {
  let o = -1, s = -1 / 0, l = -1 / 0;
  for (const [a, r] of (n || []).entries()) {
    if (!t || ru(r) || r.type === "vast")
      continue;
    const u = ny(a, e, i);
    if (u < s)
      continue;
    const c = iy[r.placement] || 0;
    u === s && c < l || (o = a, s = u, l = c);
  }
  return o;
}, iy = { "pre-roll": 2, "mid-roll": 1 }, ny = (t, e, i) => t === i ? 2 : t === e ? 1 : 0, cu = { mediaSources: /* @__PURE__ */ new Set() }, oy = (t) => {
  for (const e of [...t.audio || [], t.video || []])
    cu.mediaSources.add(e.url);
}, sy = (t) => {
  for (const e of [...t.audio || [], t.video || []])
    if (cu.mediaSources.has(e.url))
      return !0;
  return !1;
}, du = /* @__PURE__ */ new Set(), ly = (t) => {
  [...t.audio || [], ...t.video || []].forEach((i) => du.add(i.url));
}, ay = (t) => [...t.audio || [], ...t.video || []].some((i) => du.has(i.url)), ry = ({ introsOutros: t = [], introsOutrosIndex: e, advertIndex: i, content: n, contentIndex: o, currentTime: s, atTheStart: l, atTheEnd: a, errored: r }) => {
  const u = t[e];
  e:
    if (u) {
      if (r) {
        oy(u);
        break e;
      }
      if (a)
        return ly(u), -1;
      if (!a)
        return e;
    }
  if (i !== -1)
    return -1;
  const c = uy({ content: n, contentIndex: o, currentTime: s, atTheStart: l, atTheEnd: a });
  let g = -1, f = -1 / 0, A = -1 / 0;
  for (const [_, k] of t.entries()) {
    if (sy(k) || !c.has(k.placement))
      continue;
    const S = ay(k) ? 1 : 0;
    if (S < f)
      continue;
    const T = Math.random();
    S === f && T < A || (g = _, f = S, A = T);
  }
  return g;
}, uy = ({ content: t, contentIndex: e, currentTime: i, atTheStart: n, atTheEnd: o }) => {
  const s = /* @__PURE__ */ new Set(), l = n && e === 0 && i === 0, a = o && e === t.length - 1;
  return l && s.add("pre-roll"), a && s.add("post-roll"), s;
}, cy = (t) => {
  if (!navigator.mediaSession)
    return;
  const e = t.instances().some((s) => s.mediaSession === "override");
  if (fy() && !e)
    return;
  let i, n = -1 / 0, o = -1 / 0;
  for (const s of t.instances()) {
    if (s.mediaSession === "none")
      continue;
    const l = dy[s.playbackState] || 0;
    if (l < n)
      continue;
    const a = gy[s.showMediaSession] || 0;
    l === n && a < o || (i = s, n = l, o = a);
  }
  for (const s of t.instances())
    s.showMediaSession = s === i;
  return i;
}, dy = { playing: 1, paused: 0, stopped: 0 }, gy = { true: 1, false: 0 }, fy = () => {
  const t = navigator.mediaSession.metadata;
  if (!t || navigator.mediaSession.setByPlayer)
    return !1;
  const { title: e, artist: i, album: n, artwork: o } = t;
  return e || i || n || (o == null ? void 0 : o.length);
}, my = (t) => {
  let e = !1, i, n = -1 / 0, o = -1 / 0;
  for (const s of t.instances()) {
    if (!s.userInterface || !bl(s.widgetStyle))
      continue;
    if (s.userInterface.isVisible) {
      e = !0;
      continue;
    }
    if (!(s.userInterface.relativeY < 0))
      continue;
    const u = hy[s.playbackState] || 0;
    if (u < n)
      continue;
    const c = s.userInterface.absoluteY;
    u === n && c < o || (i = s, n = u, o = c);
  }
  e && n === 0 && (i = null);
  for (const s of t.instances())
    s.showBottomWidget = s === i;
}, hy = { playing: 2, paused: 1, stopped: 0 };
var ws, gu, Ts, fu, Cs, mu, Po, pl, Is, hu, Os, _u, xi, nn, an, Wn, gi, Pi, wo, Sl, Vs, Au, zn, co, rn, Mn, Bs, yu, To, Pl, Ji, bn, Co, wl, un, En, Yt, li, wn, Hn, Xi, kn, Ws, vu, Ms, bu, Ln, go, Io, Tl, Es, ku, Oo, Cl, zs, pu;
class _y {
  constructor(e, i) {
    // private
    Be(this, ws);
    Be(this, Ts);
    Be(this, Cs);
    Be(this, Po);
    Be(this, Is);
    Be(this, Os);
    Be(this, xi);
    Be(this, an);
    Be(this, gi);
    Be(this, wo);
    Be(this, Vs);
    Be(this, zn);
    Be(this, rn);
    Be(this, Bs);
    Be(this, To);
    Be(this, Ji);
    Be(this, Co);
    Be(this, un);
    Be(this, Yt);
    Be(this, wn);
    Be(this, Xi);
    Be(this, Ws);
    Be(this, Ms);
    Be(this, Ln);
    Be(this, Io);
    Be(this, Es);
    Be(this, Oo);
    Be(this, zs);
    this.player = e, this.PlayerClass = i, this.eventListeners = { "<any>": {} };
  }
  addEventListener(e, i) {
    e === "<any>" || this[`handle${e}`] || wi(`Cannot add listener for unknown event type '${e}'.`);
    const o = `listener-handle-${rs()}`;
    return this.eventListeners[e] = this.eventListeners[e] || {}, this.eventListeners[e][o] = i, o;
  }
  removeEventListener(e, i) {
    this.eventListeners[e] = this.eventListeners[e] || {}, delete this.eventListeners[e][i];
  }
  processEvent(e) {
    return Fi(this, null, function* () {
      yield $r(() => this.player), Oc(e);
      const i = this[`handle${e.type}`], n = this.player.properties();
      F(this, ws, gu).call(this, e) ? e.status = "ignored-due-to-advert" : F(this, Ts, fu).call(this, e) ? e.status = "ignored-due-to-scrubbing" : F(this, Cs, mu).call(this, e) ? e.status = "ignored-due-to-precedence" : i ? (yield i.call(this, e), F(this, Ws, vu).call(this), F(this, Ms, bu).call(this), e.status = "handled") : wi("No handler function for event.", e);
      const o = this.player.properties();
      e.changedProps = eu(n, o), e.processedAt = (/* @__PURE__ */ new Date()).toISOString(), Vc(e), F(this, Po, pl).call(this, e.type, e), F(this, Po, pl).call(this, "<any>", e);
    });
  }
  // Please document all events and keep in-sync with /doc/player-events.md
  handlePressedChangeRate() {
    F(this, Ji, bn).call(this, (e) => e + 1, { cycle: !0 });
  }
  handlePressedEnterOnChangeRate() {
    F(this, Ji, bn).call(this, (e) => e + 1, { cycle: !0 });
  }
  handlePressedSpaceOnChangeRate() {
    F(this, Ji, bn).call(this, (e) => e + 1, { cycle: !0 });
  }
  handlePressedUpOnChangeRate() {
    F(this, Ji, bn).call(this, (e) => e + 1);
  }
  handlePressedRightOnChangeRate() {
    F(this, Ji, bn).call(this, (e) => e + 1);
  }
  handlePressedDownOnChangeRate() {
    F(this, Ji, bn).call(this, (e) => e - 1);
  }
  handlePressedLeftOnChangeRate() {
    F(this, Ji, bn).call(this, (e) => e - 1);
  }
  handlePressedPrevSegment() {
    F(this, Co, wl).call(this, (e) => e - 1);
  }
  handlePressedNextSegment() {
    F(this, Co, wl).call(this, (e) => e + 1);
  }
  handlePressedSeekBack({ seconds: e }) {
    F(this, Yt, li).call(this, (i) => i - e);
  }
  handlePressedSeekAhead({ seconds: e }) {
    F(this, Yt, li).call(this, (i) => i + e);
  }
  handlePressedPrevTrack() {
    F(this, un, En).call(this, (e) => e - 1);
  }
  handlePressedNextTrack() {
    F(this, un, En).call(this, (e) => e + 1);
  }
  handlePressedAdvertLink() {
  }
  handlePressedAdvertButton() {
  }
  handlePressedAdvertImage() {
  }
  handlePressedAdvertVideo() {
  }
  handlePressedBeyondWords() {
  }
  handlePressedSourceUrl() {
  }
  handleContentAvailable() {
  }
  handleDurationUpdated() {
  }
  handleMetadataLoaded({ loadedMedia: e }) {
    this.player.loadedMedia = e;
  }
  handleMediaLoaded({ loadedMedia: e }) {
    this.player.loadedMedia = e;
  }
  handleMediaSeeked() {
  }
  handlePlaybackRateUpdated() {
  }
  handleVisibilityChanged() {
    my(this.PlayerClass);
  }
  handlePressedVideoBackground() {
    F(this, rn, Mn).call(this);
  }
  handlePressedEnterOnProgressBar() {
    F(this, rn, Mn).call(this);
  }
  handlePressedSpaceOnProgressBar() {
    F(this, rn, Mn).call(this);
  }
  handlePressedEnterOnProgressCircle() {
    F(this, rn, Mn).call(this);
  }
  handlePressedSpaceOnProgressCircle() {
    F(this, rn, Mn).call(this);
  }
  handlePressedLeftOnProgressBar() {
    F(this, Yt, li).call(this, (e) => e - 5);
  }
  handlePressedRightOnProgressBar() {
    F(this, Yt, li).call(this, (e) => e + 5);
  }
  handlePressedLeftOnProgressCircle() {
    F(this, Yt, li).call(this, (e) => e - 5);
  }
  handlePressedRightOnProgressCircle() {
    F(this, Yt, li).call(this, (e) => e + 5);
  }
  handlePressedProgressBar({ ratio: e }) {
    this.preScrubState = this.player.playbackState, this.pauseTimeout = setTimeout(() => F(this, Bs, yu).call(this), 100), F(this, Yt, li).call(this, (i, n) => e * n), e !== 0 && (this.segmentPlayed = !0);
  }
  handleScrubbedProgressBar({ ratio: e }) {
    F(this, Yt, li).call(this, (i, n) => e * n - 0.01), e !== 0 && (this.segmentPlayed = !0);
  }
  handleFinishedScrubbingProgressBar() {
    clearTimeout(this.pauseTimeout), this.player.playbackState = this.preScrubState, delete this.preScrubState;
  }
  handleIdentifiersChanged() {
    D3(this.player).then(() => {
      F(this, wn, Hn).call(this, { atTheStart: !0 }), F(this, Xi, kn).call(this, { atTheStart: !0 });
    });
  }
  handleNoContentAvailable({ description: e }) {
    console.warn(`BeyondWords.Player: ${e}`);
  }
  handlePressedPlay({ emittedFrom: e, widgetSegment: i, widgetIsCurrent: n }) {
    e === "segment-widget" && !n ? F(this, To, Pl).call(this, i) : this.player.playbackState = "playing";
  }
  handlePressedPause() {
    this.player.playbackState = "paused";
  }
  handlePlaybackPlaying() {
    this.PlayerClass.instances().filter((n) => n !== this.player).filter((n) => n.playbackState === "playing").forEach((n) => n.playbackState = "paused"), cy(this.PlayerClass);
  }
  handlePlaybackPaused() {
    const e = this.player.playbackState === "playing", i = this.player.currentTime >= this.player.duration - 0.5;
    e && !i && !this.preScrubState && (this.player.playbackState = "paused");
  }
  handleCurrentTimeUpdated() {
    this.midrollPlayed || F(this, Xi, kn).call(this);
    const e = this.player.currentTime <= _o, i = this.player.currentTime >= this.player.duration, n = this.player.mediaElement.video.paused || F(this, Vs, Au).call(this);
    !e && !i && !n && (this.player.playbackState = "playing");
    const o = this.player.currentTime <= 0.5;
    !F(this, gi, Pi).call(this) && this.midrollPlayed && o && this.prevTime && F(this, Oo, Cl).call(this, !0);
  }
  handlePlaybackEnded() {
    F(this, wo, Sl).call(this) && (this.midrollPlayed = !0), this.segmentPlayed = !1;
    const e = F(this, xi, nn).call(this), i = F(this, gi, Pi).call(this);
    F(this, Xi, kn).call(this, { atTheEnd: !0, wasIntro: e }), !i && (F(this, wn, Hn).call(this, { atTheEnd: !0 }), !e && (F(this, an, Wn).call(this) || F(this, gi, Pi).call(this) || F(this, un, En).call(this, (n) => n + 1)));
  }
  handlePlaybackNotAllowed({ description: e }) {
    console.warn(`BeyondWords.Player: ${e}`);
    const i = this.player.contentIndex <= 0 && this.player.currentTime <= _o;
    this.player.playbackState = i ? "stopped" : "paused";
  }
  handlePlaybackErrored({ mediaType: e, preloading: i, errorMessage: n }) {
    console.warn(`BeyondWords.Player: ${e} playback error: ${n}`);
    const o = F(this, wo, Sl).call(this);
    F(this, xi, nn).call(this) || F(this, an, Wn).call(this) ? F(this, wn, Hn).call(this, { errored: !0 }) : F(this, gi, Pi).call(this) ? F(this, Xi, kn).call(this, { errored: !0 }) : i && e === "VAST" ? F(this, Xi, kn).call(this, { preloadingErrored: !0 }) : this.handlePlaybackEnded(), o && !F(this, gi, Pi).call(this) && (this.midrollPlayed = !0);
  }
  handleCompanionAdvertChanged({ clickThroughUrl: e, imageUrl: i }) {
    this.player.companionAdvert = { clickThroughUrl: e, imageUrl: i };
  }
  handlePressedMaximize() {
    ba() ? pA() : kA(this.player.target);
  }
  handleFullScreenModeUpdated() {
    const e = ba() === this.player.target, i = e ? "add" : "remove";
    this.player.isFullScreen = e, this.player.target.classList[i]("maximized");
  }
  handlePressedPlaylistItem({ index: e }) {
    F(this, un, En).call(this, () => e), this.player.playbackState = "playing";
  }
  handlePressedTogglePlaylist() {
    const e = this.player.playlistStyle.split("-"), i = this.player.content.length > 1, n = e[0] === "show" || e[0] === "auto" && i;
    e[0] = n ? "hide" : "show", this.player.playlistStyle = e.join("-");
  }
  handlePressedDownload({ contentIndex: e, audioIndex: i, videoIndex: n }) {
    var c, g;
    const o = this.player.content[e], s = (c = o.audio) == null ? void 0 : c[i], l = (g = o.video) == null ? void 0 : g[n], a = (s || l).url, r = a.split(".").pop(), u = `${o.title}.${r}`;
    return Y3(a, u);
  }
  handlePressedCloseWidget() {
    for (const e of this.PlayerClass.instances())
      e.playbackState = "paused", e.widgetStyle = "closed-by-user";
  }
  handleCurrentSegmentUpdated({ segment: e, contentIndex: i, segmentIndex: n, segmentElement: o }) {
    var s;
    F(this, zn, co).call(this) ? this.player.currentSegment = en(Jt({}, e), { contentIndex: i, segmentIndex: n, segmentElement: o }) : this.segmentPlayed || ((s = this.player.segmentContainers) == null || s.reset(), this.player.currentSegment = null);
  }
  handleHoveredSegmentUpdated({ segment: e, contentIndex: i, segmentIndex: n, segmentElement: o }) {
    e ? this.player.hoveredSegment = en(Jt({}, e), { contentIndex: i, segmentIndex: n, segmentElement: o }) : this.player.hoveredSegment = null;
  }
  handlePressedSegment({ segment: e, contentIndex: i, segmentIndex: n, segmentElement: o }) {
    if (!yo("hovered", e, this.player.clickableSections))
      return;
    if (!F(this, zs, pu).call(this, { contentIndex: i, segmentIndex: n }) && !F(this, gi, Pi).call(this)) {
      F(this, rn, Mn).call(this);
      return;
    }
    i !== this.player.contentIndex && F(this, un, En).call(this, () => i), F(this, To, Pl).call(this, Jt({ contentIndex: i, segmentIndex: n, segmentElement: o }, e));
  }
}
ws = new WeakSet(), gu = function({ type: e }) {
  return F(this, gi, Pi).call(this) && (e.includes("ChangeRate") || e.includes("PrevSegment") || e.includes("NextSegment") || e.includes("SeekBack") || e.includes("SeekAhead") || e.includes("Progress") && !e.includes("Space") && !e.includes("Enter"));
}, Ts = new WeakSet(), fu = function({ type: e }) {
  return this.preScrubState && (e.includes("CurrentTimeUpdated") || e.includes("PlaybackEnded"));
}, Cs = new WeakSet(), mu = function({ type: e, precedence: i }) {
  return e.includes("PressedSegment") && i > 0;
}, Po = new WeakSet(), pl = function(e, i) {
  const n = this.eventListeners[e] || {};
  Object.values(n).forEach((o) => o(i));
}, Is = new WeakSet(), hu = function() {
  return this.player.introsOutros.some((e) => e.placement === "pre-roll");
}, Os = new WeakSet(), _u = function() {
  return this.player.introsOutros.some((e) => e.placement === "post-roll");
}, xi = new WeakSet(), nn = function(e = this.player.introsOutrosIndex) {
  var i, n, o;
  return ((o = (n = (i = this.player) == null ? void 0 : i.introsOutros) == null ? void 0 : n[e]) == null ? void 0 : o.placement) === "pre-roll";
}, an = new WeakSet(), Wn = function(e = this.player.introsOutrosIndex) {
  var i, n, o;
  return ((o = (n = (i = this.player) == null ? void 0 : i.introsOutros) == null ? void 0 : n[e]) == null ? void 0 : o.placement) === "post-roll";
}, gi = new WeakSet(), Pi = function() {
  return this.player.advertIndex !== -1;
}, wo = new WeakSet(), Sl = function() {
  var e;
  return ((e = this.player.adverts[this.player.advertIndex]) == null ? void 0 : e.placement) === "mid-roll";
}, Vs = new WeakSet(), Au = function() {
  var e;
  return !!((e = this.player.adverts[this.player.advertIndex]) != null && e.vastUrl);
}, zn = new WeakSet(), co = function() {
  return !F(this, xi, nn).call(this) && !F(this, an, Wn).call(this) && !F(this, gi, Pi).call(this);
}, rn = new WeakSet(), Mn = function() {
  this.player.playbackState === "playing" ? this.player.playbackState = "paused" : this.player.playbackState = "playing";
}, Bs = new WeakSet(), yu = function() {
  this.player.playbackState === "playing" && (this.player.playbackState = "paused");
}, To = new WeakSet(), Pl = function(s) {
  var l = s, { contentIndex: e, segmentIndex: i, segmentElement: n } = l, o = Fs(l, ["contentIndex", "segmentIndex", "segmentElement"]);
  F(this, Yt, li).call(this, () => o.startTime, e), this.player.currentSegment = Jt({ contentIndex: e, segmentIndex: i, segmentElement: n }, o), this.player.playbackState = "playing", this.segmentPlayed = !0;
}, Ji = new WeakSet(), bn = function(e, { cycle: i } = {}) {
  const n = this.player.playbackRates, o = n.length - 1, s = n.indexOf(this.player.playbackRate), l = e(s);
  let a;
  i ? a = l % n.length : a = Math.max(0, Math.min(o, l)), this.player.playbackRate = n[a] || 1;
}, Co = new WeakSet(), wl = function(e) {
  const i = this.player.content[this.player.contentIndex].segments, n = Vl(i, this.player.currentTime, this.player.contentVariant), o = e(n);
  F(this, xi, nn).call(this) && o >= 0 ? this.handlePlaybackEnded() : F(this, an, Wn).call(this) && o < 0 ? (F(this, Ln, go).call(this, -1), F(this, Yt, li).call(this, () => {
    var s;
    return ((s = i[i.length - 1]) == null ? void 0 : s.startTime) || 0.01;
  }), this.player.playbackState = "playing") : F(this, zn, co).call(this) && o < 0 && F(this, Is, hu).call(this) ? (F(this, Yt, li).call(this, () => 0), F(this, wn, Hn).call(this, { atTheStart: !0 })) : F(this, zn, co).call(this) && o === i.length && F(this, Os, _u).call(this) ? F(this, Yt, li).call(this, () => this.player.duration - 0.01) : F(this, zn, co).call(this) && o >= 0 && o < i.length && F(this, Yt, li).call(this, () => i[o].startTime);
}, un = new WeakSet(), En = function(e) {
  const i = e(this.player.contentIndex), n = i < 0 || i >= this.player.content.length;
  n ? (this.player.playbackState = "stopped", F(this, Yt, li).call(this, () => 0)) : (this.player.contentIndex = i, F(this, gi, Pi).call(this) || (F(this, Yt, li).call(this, () => 0), this.midrollPlayed = !1)), F(this, Ln, go).call(this, -1), F(this, wn, Hn).call(this, { atTheStart: !0 }), n || F(this, Xi, kn).call(this, { atTheStart: !0 });
}, Yt = new WeakSet(), li = function(e, i) {
  if (F(this, gi, Pi).call(this))
    this.prevTime = e(), this.prevContent = i;
  else {
    const n = this.player.duration || 0;
    this.player.currentTime = e(this.player.currentTime, n);
  }
}, wn = new WeakSet(), Hn = function({ atTheStart: e, atTheEnd: i, errored: n } = {}) {
  const { content: o, introsOutros: s, currentTime: l } = this.player, a = typeof this.nextIntroOutro != "undefined" ? this.nextIntroOutro : this.player.introsOutrosIndex, r = typeof this.nextAdvert != "undefined" ? this.nextAdvert : this.player.advertIndex, u = typeof this.prevContent != "undefined" ? this.prevContent : this.player.contentIndex;
  F(this, Ln, go).call(this, ry({ introsOutros: s, introsOutrosIndex: a, advertIndex: r, content: o, contentIndex: u, currentTime: l, atTheStart: e, atTheEnd: i, errored: n }));
}, Xi = new WeakSet(), kn = function({ atTheStart: e, atTheEnd: i, wasIntro: n, errored: o, preloadingErrored: s } = {}) {
  var S;
  const { adverts: l, content: a, currentTime: r, minDurationForMidroll: u, minTimeUntilEndForMidroll: c } = this.player;
  let g = typeof this.nextIntroOutro != "undefined" ? this.nextIntroOutro : this.player.introsOutrosIndex;
  const f = typeof this.nextAdvert != "undefined" ? this.nextAdvert : this.player.advertIndex, A = typeof this.prevContent != "undefined" ? this.prevContent : this.player.contentIndex;
  if (n && (e = !0, i = !1, g = -1), F(this, Io, Tl).call(this, ar({ introsOutrosIndex: g, adverts: l, advertIndex: f, preloadAdvertIndex: this.player.preloadAdvertIndex, content: a, contentIndex: A, currentTime: r, atTheStart: e, atTheEnd: i, errored: o, minDurationForMidroll: u, minTimeUntilEndForMidroll: c, contentVariant: this.player.contentVariant })), F(this, gi, Pi).call(this))
    this.player.preloadAdvertIndex = -1;
  else {
    const T = ar({ introsOutrosIndex: g, adverts: l, advertIndex: this.player.preloadAdvertIndex, content: a, contentIndex: A, currentTime: r + 5, atTheStart: e, atTheEnd: i, errored: s, minDurationForMidroll: u, minTimeUntilEndForMidroll: c, contentVariant: this.player.contentVariant }), v = (S = this.player.adverts) == null ? void 0 : S[T];
    v != null && v.vastUrl && ["mid-roll", "post-roll"].includes(v == null ? void 0 : v.placement) ? this.player.preloadAdvertIndex = T : this.player.preloadAdvertIndex = -1;
  }
  const _ = this.player.persistentAdImage, k = this.player.persistentIndex;
  this.player.persistentIndex = ty(_, k, f, l);
}, Ws = new WeakSet(), vu = function() {
  this.player.playbackState === "playing" && typeof this.nextIntroOutro != "undefined" && (F(this, Ln, go).call(this, this.nextIntroOutro), delete this.nextIntroOutro);
}, Ms = new WeakSet(), bu = function() {
  this.player.playbackState === "playing" && typeof this.nextAdvert != "undefined" && (F(this, Io, Tl).call(this, this.nextAdvert), delete this.nextAdvert);
}, Ln = new WeakSet(), go = function(e) {
  if (this.player.playbackState !== "playing" && e !== -1) {
    this.nextIntroOutro = e;
    return;
  } else
    delete this.nextIntroOutro;
  if (!(this.player.contentIndex <= 0 && this.player.currentTime <= _o) && F(this, xi, nn).call(this, e)) {
    this.player.introsOutrosIndex = -1, F(this, Xi, kn).call(this, { atTheStart: !0 });
    return;
  }
  const s = F(this, xi, nn).call(this), l = F(this, an, Wn).call(this);
  this.player.introsOutrosIndex = e;
  const a = s && !F(this, xi, nn).call(this), r = l && !F(this, an, Wn).call(this);
  a && (this.player.currentTime = 0), r && F(this, un, En).call(this, () => 1 / 0);
}, Io = new WeakSet(), Tl = function(e) {
  if (this.player.playbackState !== "playing" && e !== -1) {
    this.nextAdvert = e;
    return;
  } else
    delete this.nextAdvert;
  const n = F(this, gi, Pi).call(this), o = e !== -1, s = !n && o, l = n && !o;
  s && F(this, Es, ku).call(this), this.player.advertIndex = e, l && F(this, Oo, Cl).call(this);
}, Es = new WeakSet(), ku = function() {
  F(this, xi, nn).call(this) || (this.prevTime = this.player.currentTime), this.prevRate = this.player.playbackRate, this.prevContent = this.player.contentIndex, this.player.playbackRate = 1;
}, Oo = new WeakSet(), Cl = function(e = !1) {
  this.player.playbackRate = this.prevRate || 1, this.player.contentIndex !== this.prevContent || (this.player.currentTime = this.prevTime), e && (delete this.prevTime, delete this.prevRate, delete this.prevContent);
}, zs = new WeakSet(), pu = function({ contentIndex: e, segmentIndex: i }) {
  var n, o;
  return ((n = this.player.currentSegment) == null ? void 0 : n.contentIndex) !== e || ((o = this.player.currentSegment) == null ? void 0 : o.segmentIndex) !== i;
};
var Bo = "<unknown>";
function Ay(t) {
  var e = t.split(`
`);
  return e.reduce(function(i, n) {
    var o = by(n) || py(n) || wy(n) || Oy(n) || Cy(n);
    return o && i.push(o), i;
  }, []);
}
var yy = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, vy = /\((\S*)(?::(\d+))(?::(\d+))\)/;
function by(t) {
  var e = yy.exec(t);
  if (!e)
    return null;
  var i = e[2] && e[2].indexOf("native") === 0, n = e[2] && e[2].indexOf("eval") === 0, o = vy.exec(e[2]);
  return n && o != null && (e[2] = o[1], e[3] = o[2], e[4] = o[3]), {
    file: i ? null : e[2],
    methodName: e[1] || Bo,
    arguments: i ? [e[2]] : [],
    lineNumber: e[3] ? +e[3] : null,
    column: e[4] ? +e[4] : null
  };
}
var ky = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function py(t) {
  var e = ky.exec(t);
  return e ? {
    file: e[2],
    methodName: e[1] || Bo,
    arguments: [],
    lineNumber: +e[3],
    column: e[4] ? +e[4] : null
  } : null;
}
var Sy = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, Py = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function wy(t) {
  var e = Sy.exec(t);
  if (!e)
    return null;
  var i = e[3] && e[3].indexOf(" > eval") > -1, n = Py.exec(e[3]);
  return i && n != null && (e[3] = n[1], e[4] = n[2], e[5] = null), {
    file: e[3],
    methodName: e[1] || Bo,
    arguments: e[2] ? e[2].split(",") : [],
    lineNumber: e[4] ? +e[4] : null,
    column: e[5] ? +e[5] : null
  };
}
var Ty = /^\s*(?:([^@]*)(?:\((.*?)\))?@)?(\S.*?):(\d+)(?::(\d+))?\s*$/i;
function Cy(t) {
  var e = Ty.exec(t);
  return e ? {
    file: e[3],
    methodName: e[1] || Bo,
    arguments: [],
    lineNumber: +e[4],
    column: e[5] ? +e[5] : null
  } : null;
}
var Iy = /^\s*at (?:((?:\[object object\])?[^\\/]+(?: \[as \S+\])?) )?\(?(.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function Oy(t) {
  var e = Iy.exec(t);
  return e ? {
    file: e[2],
    methodName: e[1] || Bo,
    arguments: [],
    lineNumber: +e[3],
    column: e[4] ? +e[4] : null
  } : null;
}
let rr = !1, el, tl;
const Vy = ({ onError: t }) => {
  if (!t || rr)
    return;
  rr = !0;
  const e = ur(new Error()), i = e == null ? void 0 : e.match(/setErrorHandler/);
  el = window.onerror, tl = window.onunhandledrejection, window.onerror = (n, o, s, l, a) => {
    var g;
    const r = o === e, u = (g = a == null ? void 0 : a.message) == null ? void 0 : g.match(/request was interrupted/);
    if ((i || r || u) && t(a))
      return !0;
    el && el(n, o, s, l, a);
  }, window.onunhandledrejection = (n) => {
    var r;
    const o = n.reason, s = ur(o) === e, l = (r = o == null ? void 0 : o.message) == null ? void 0 : r.match(/request was interrupted/);
    if ((i || s || l) && t(o)) {
      n.preventDefault();
      return;
    }
    tl && tl(n);
  };
}, ur = (t) => {
  var e;
  return (e = Ay((t == null ? void 0 : t.stack) || "")[0]) == null ? void 0 : e.file;
}, By = ({ windowObject: t } = { windowObject: window }) => {
  typeof t == "undefined" && wi([
    "Trying to initialize BeyondWords.Player in a server context but this is unsupported.",
    "Please only initialize the player in a context where the global window object is available.",
    "For example, by initializing the player inside a useEffect hook in a React application."
  ]);
};
let cr = !1;
const Wy = () => {
  cr || (addEventListener("mousedown", My), addEventListener("click", zy), addEventListener("mousemove", Ly), cr = !0);
};
let Su, Pu;
const My = (t) => {
  Su = t.pageX, Pu = t.pageY;
}, Ey = (t) => {
  const e = t.pageX - Su, i = t.pageY - Pu;
  return Math.sqrt(e * e + i * i) > 5;
}, zy = (t) => {
  if (!t.defaultPrevented && !Ey(t) && t.button === 0)
    for (const { player: e, segment: i, contentIndex: n, segmentIndex: o, segmentElement: s, precedence: l } of Br(t.target))
      i && e.onEvent(ke({
        type: "PressedSegment",
        description: "The user pressed on a segment in the article.",
        initiatedBy: "user",
        emittedFrom: "segment",
        segment: i,
        contentIndex: n,
        segmentIndex: o,
        segmentElement: s,
        precedence: l
      }));
}, Ly = (t) => {
  for (const { p: e, player: i, segment: n, contentIndex: o, segmentIndex: s, segmentElement: l, precedence: a } of Br(t.target))
    jy(e, o, s) && i.onEvent(ke({
      type: "HoveredSegmentUpdated",
      description: "The user hovered over a different segment in the article.",
      initiatedBy: "user",
      emittedFrom: "segment",
      segment: n,
      contentIndex: o,
      segmentIndex: s,
      segmentElement: l,
      precedence: a
    }));
}, os = {}, jy = (t, e, i) => {
  os[t] || (os[t] = {});
  const n = os[t];
  return n.contentIndex === e && n.segmentIndex === i ? !1 : (n.contentIndex = e, n.segmentIndex = i, !0);
};
class il {
  constructor(e) {
    this.analyticsSink = e;
  }
  sendToCustomAnalytics(e) {
    return z3(this.analyticsSink, e);
  }
  sendToGoogleAnalytics(e, i) {
    window.gtag("event", e, en(Jt({}, i), { send_to: this.analyticsSink }));
  }
}
const Dy = (t, e) => {
  const i = xy(t, e.type);
  if (!i)
    return;
  const n = Ny(t, i);
  Bc(n), t.analyticsUrl && t.analyticsConsent !== "none" && new il(t.analyticsUrl).sendToCustomAnalytics(n), t.analyticsCustomUrl && t.analyticsConsent !== "none" && new il(t.analyticsCustomUrl).sendToCustomAnalytics(n), t.analyticsTag && new il(t.analyticsTag).sendToGoogleAnalytics(Ry(n), n);
}, xy = (t, e) => {
  if (e === "ContentAvailable" && !t.listenSessionId)
    return "load";
  if (e === "PlaybackPlaying" && Fy(t) && (t.isNewListen = !0), e === "CurrentTimeUpdated" && t.isNewListen)
    return t.isNewListen = !1, "play";
  if (e === "CurrentTimeUpdated" && Uy(t))
    return "play_progress";
  if (e.startsWith("PressedAdvert"))
    return "ad_link_click";
}, Ny = (t, e) => {
  var l, a;
  t.listenSessionId || (t.listenSessionId = rs()), t.sessionCreatedAt || (t.sessionCreatedAt = Date.now());
  const i = ["without-local-storage", "none"].includes(t.analyticsConsent);
  i || localStorage.beyondwords || (localStorage.beyondwords = JSON.stringify(rs()));
  const n = t.adverts[t.advertIndex], o = t.content[t.contentIndex], s = t.duration ? t.currentTime / t.duration * 100 : 0;
  return {
    event_type: e,
    device_type: Hy(t),
    media_type: n ? "ad" : "content",
    media_variant: t.contentVariant,
    project_id: t.projectId,
    content_id: o == null ? void 0 : o.id,
    source_id: o == null ? void 0 : o.sourceId,
    analytics_id: t.analyticsId,
    ad_id: n == null ? void 0 : n.id,
    media_id: (l = t.loadedMedia) == null ? void 0 : l.id,
    media_format: (a = t.loadedMedia) == null ? void 0 : a.format,
    local_storage_id: i ? null : JSON.parse(localStorage.beyondwords),
    listen_session_id: t.listenSessionId,
    session_created_at: t.sessionCreatedAt,
    duration: t.duration,
    listen_length_seconds: t.currentTime,
    listen_length_percent: Math.max(0, Math.min(100, s)),
    speed: t.playbackRate,
    location: window.location.href,
    referrer: document.referrer,
    player_version: "1",
    player_npm_version: mo
  };
}, Ry = ({ event_type: t, listen_length_percent: e }) => {
  const i = Math.floor(e / 10) * 10;
  if (t === "load")
    return "Load";
  if (t === "play")
    return "Play";
  if (t === "play_progress" && i === 100)
    return "Complete";
  if (t === "play_progress")
    return `${i}% listened`;
  if (t === "ad_link_click")
    return "Advert Click";
}, Fy = (t) => {
  var n, o;
  let e = !1;
  if (t.advertIndex !== -1) {
    const s = ((n = t.adverts[t.advertIndex]) == null ? void 0 : n.id) || t.advertIndex;
    e = s !== t.prevAdvertId, t.prevAdvertId = s;
  } else {
    const s = ((o = t.content[t.contentIndex]) == null ? void 0 : o.id) || t.contentIndex;
    e = s !== t.prevContentId, t.prevContentId = s;
  }
  return e;
}, Uy = (t) => {
  if (t.introsOutrosIndex !== -1)
    return;
  const e = t.prevPercentage + 10, i = t.currentTime / t.duration * 100;
  if (i >= e)
    return t.prevPercentage = Math.floor(i / 10) * 10, !0;
}, Hy = (t) => t.analyticsDeviceType !== "auto" ? t.analyticsDeviceType : dr(499) ? "phone" : dr(999) ? "tablet" : "desktop", dr = (t) => window.matchMedia && window.matchMedia(`only screen and (max-device-width: ${t}px)`).matches, qy = /* @__PURE__ */ new Set(), Yy = (t, e = qy) => {
  const n = Object.keys(t.$$.props).filter((o) => !e.has(o)).map((o) => [o, t[o]]);
  return Object.fromEntries(n);
}, Zy = /* @__PURE__ */ new Set([
  "addEventListener",
  "removeEventListener",
  "mediaElement",
  "userInterface",
  "widgetInterface",
  "controller"
]);
var Tn;
const Bi = class Bi extends E3 {
  constructor(n) {
    var o = n, { target: e } = o, i = Fs(o, ["target"]);
    By(), Vy(i), Wy();
    const { newTarget: s, showUserInterface: l } = S3(e);
    s.classList.add("beyondwords-player", "bwp"), Bi._styleLoaded || (s.style.display = "none");
    const a = new _y(null, Bi);
    a.addEventListener("<any>", (u) => Dy(this, u));
    const r = Jt({ showUserInterface: l }, i);
    super({ target: s, props: en(Jt({ controller: a }, r), { initialProps: r }) }), a.player = this, Di(Bi, Tn).push(this);
  }
  static styleLoaded() {
    Bi.instances().forEach((e) => e.target.style.removeProperty("display")), Bi._styleLoaded = !0;
  }
  static get version() {
    return mo;
  }
  static get styleSrc() {
    return `https://proxy.beyondwords.io/npm/@beyondwords/player@${mo}/dist/style.js`;
  }
  static get hlsSrc() {
    return `https://proxy.beyondwords.io/npm/@beyondwords/player@${mo}/dist/hls.light.min.js`;
  }
  static instances() {
    return [...Di(Bi, Tn)];
  }
  static destroyAll() {
    Di(Bi, Tn).forEach((e) => e.destroy());
  }
  destroy() {
    this.$destroy(), jl(Bi, Tn, Di(Bi, Tn).filter((e) => e !== this));
  }
  get target() {
    return this.$$.root;
  }
  properties() {
    return Yy(this, Zy);
  }
};
Tn = new WeakMap(), Be(Bi, Tn, []);
let ms = Bi;
var gr;
typeof window != "undefined" && (window.BeyondWords || (window.BeyondWords = {}), (gr = window.BeyondWords).Player || (gr.Player = ms));
const Xy = { Player: ms };
export {
  Xy as default
};
//# sourceMappingURL=es.js.map
